// 5,000-location endless deck: every GeoNames national capital, the largest
// remaining cities by population, 80 historic locations, and 250 major islands.
// GeoNames data is licensed under CC BY 4.0: https://www.geonames.org/
export const CITIES = [
  [1816670,"Beijing","CN",39.9075,116.39723,"Beijing","city"],
  [2314302,"Kinshasa","CD",-4.32758,15.31357,"Kinshasa","city"],
  [3530597,"Mexico City","MX",19.42847,-99.12766,"Mexico City","city"],
  [524901,"Moscow","RU",55.75204,37.61781,"Moscow","city"],
  [1185241,"Dhaka","BD",23.7104,90.40744,"Dhaka Division","city"],
  [1835848,"Seoul","KR",37.566,126.9784,"Seoul","city"],
  [1850147,"Tokyo","JP",35.6895,139.69171,"Tokyo","city"],
  [360630,"Cairo","EG",30.06263,31.24967,"Cairo","city"],
  [2643743,"London","GB",51.50853,-0.12574,"England","city"],
  [1642911,"Jakarta","ID",-6.21462,106.84513,"Jakarta","city"],
  [1581130,"Hanoi","VN",21.0245,105.84117,"Hanoi","city"],
  [1668341,"Taipei","TW",25.05306,121.52639,"Taiwan","city"],
  [3936456,"Lima","PE",-12.04318,-77.02824,"Lima Province","city"],
  [3688689,"Bogotá","CO",4.60971,-74.08175,"Bogota D.C.","city"],
  [1819729,"Hong Kong","HK",22.27832,114.17469,"","city"],
  [98182,"Baghdad","IQ",33.34058,44.40088,"Baghdad","city"],
  [112931,"Tehran","IR",35.69439,51.42151,"Tehran","city"],
  [1880252,"Singapore","SG",1.28967,103.85007,"","city"],
  [1609350,"Bangkok","TH",13.75398,100.50144,"Bangkok","city"],
  [3871336,"Santiago","CL",-33.45694,-70.64827,"Santiago Metropolitan","city"],
  [1138958,"Kabul","AF",34.52813,69.17233,"Kabul","city"],
  [184745,"Nairobi","KE",-1.28333,36.81667,"Nairobi County","city"],
  [2460596,"Bamako","ML",12.60915,-7.97522,"Bamako","city"],
  [108410,"Riyadh","SA",24.68773,46.72185,"Riyadh Region","city"],
  [344979,"Addis Ababa","ET",9.02497,38.74689,"Addis Ababa","city"],
  [323786,"Ankara","TR",39.91987,32.85427,"Ankara","city"],
  [2950159,"Berlin","DE",52.52437,13.41053,"State of Berlin","city"],
  [3117735,"Madrid","ES",40.4165,-3.70256,"Madrid","city"],
  [1871859,"Pyongyang","KP",39.03385,125.75432,"Pyongyang","city"],
  [3646738,"Caracas","VE",10.48801,-66.87919,"Distrito Federal","city"],
  [703448,"Kyiv","UA",50.45466,30.5238,"Kyiv City","city"],
  [3435910,"Buenos Aires","AR",-34.61315,-58.37723,"Buenos Aires F.D.","city"],
  [3652462,"Quito","EC",-0.22985,-78.52495,"Pichincha","city"],
  [2240449,"Luanda","AO",-8.83682,13.23432,"Luanda","city"],
  [2352778,"Abuja","NG",9.05785,7.49508,"FCT","city"],
  [2253354,"Dakar","SN",14.6937,-17.44406,"Dakar","city"],
  [53654,"Mogadishu","SO",2.03711,45.34375,"Banaadir","city"],
  [2357048,"Ouagadougou","BF",12.36566,-1.53388,"Centre","city"],
  [2507480,"Algiers","DZ",36.73225,3.08746,"Algiers","city"],
  [587084,"Baku","AZ",40.37767,49.89201,"Baki","city"],
  [3169070,"Rome","IT",41.89193,12.51133,"Lazio","city"],
  [909137,"Lusaka","ZM",-15.40669,28.28713,"Lusaka Province","city"],
  [3469058,"Brasília","BR",-15.77972,-47.92972,"Federal District","city"],
  [3492908,"Santo Domingo","DO",18.47186,-69.89232,"Nacional","city"],
  [2365267,"Lomé","TG",6.12874,1.22154,"Maritime","city"],
  [3553478,"Havana","CU",23.13302,-82.38304,"Havana","city"],
  [2988507,"Paris","FR",48.85341,2.3488,"Île-de-France","city"],
  [964137,"Pretoria","ZA",-25.74486,28.18783,"Gauteng","city"],
  [2260535,"Brazzaville","CG",-4.26613,15.28318,"Brazzaville","city"],
  [1512569,"Tashkent","UZ",41.26465,69.21627,"Tashkent","city"],
  [379252,"Khartoum","SD",15.55177,32.53241,"Khartoum","city"],
  [2306104,"Accra","GH",5.55602,-0.1969,"Greater Accra","city"],
  [71137,"Sanaa","YE",15.35452,44.20646,"Amanat Alasimah","city"],
  [2422465,"Conakry","GN",9.53795,-13.67729,"Conakry","city"],
  [276781,"Beirut","LB",33.89332,35.50157,"Beirut","city"],
  [683506,"Bucharest","RO",44.43225,26.10626,"Bucharest","city"],
  [292968,"Abu Dhabi","AE",24.45118,54.39696,"Abu Dhabi","city"],
  [625144,"Minsk","BY",53.90019,27.56653,"Minsk City","city"],
  [3054643,"Budapest","HU",47.49835,19.04045,"Budapest","city"],
  [756135,"Warsaw","PL",52.22977,21.01178,"Mazovia","city"],
  [2761369,"Vienna","AT",48.20849,16.37208,"State of Vienna","city"],
  [232422,"Kampala","UG",0.31628,32.58219,"Central Region","city"],
  [2538475,"Rabat","MA",34.01325,-6.83255,"Rabat-Salé-Kénitra","city"],
  [1701668,"Manila","PH",14.6042,120.9822,"National Capital Region","city"],
  [1821306,"Phnom Penh","KH",11.56245,104.91601,"Phnom Penh","city"],
  [170654,"Damascus","SY",33.5102,36.29128,"Damascus Governorate","city"],
  [1526273,"Astana","KZ",51.1801,71.44598,"Astana","city"],
  [890299,"Harare","ZW",-17.82772,31.05337,"Harare","city"],
  [2274895,"Monrovia","LR",6.30054,-10.7969,"Montserrado County","city"],
  [2673730,"Stockholm","SE",59.32938,18.06871,"Stockholm","city"],
  [3439389,"Asunción","PY",-25.28646,-57.647,"Asuncion","city"],
  [1735161,"Kuala Lumpur","MY",3.1412,101.68653,"Kuala Lumpur","city"],
  [1283240,"Kathmandu","NP",27.70169,85.3206,"Bagmati Province","city"],
  [2427123,"N'Djamena","TD",12.10672,15.0444,"N’Djaména","city"],
  [1070940,"Antananarivo","MG",-18.91368,47.53613,"Analamanga","city"],
  [2440485,"Niamey","NE",13.51366,2.1098,"Niamey","city"],
  [2210247,"Tripoli","LY",32.88743,13.18733,"Tripoli","city"],
  [2220957,"Yaoundé","CM",3.86667,11.51667,"Centre","city"],
  [250441,"Amman","JO",31.95522,35.94503,"Amman","city"],
  [792680,"Belgrade","RS",44.80401,20.46513,"Central Serbia","city"],
  [3441575,"Montevideo","UY",-34.90328,-56.18816,"Montevideo Department","city"],
  [1040652,"Maputo","MZ",-25.96553,32.58322,"Maputo City","city"],
  [3718426,"Port-au-Prince","HT",18.54349,-72.33881,"Ouest","city"],
  [2377450,"Nouakchott","MR",18.08581,-15.9785,"","city"],
  [3067696,"Prague","CZ",50.08804,14.42076,"Prague","city"],
  [2618425,"Copenhagen","DK",55.67594,12.56553,"Capital Region","city"],
  [727011,"Sofia","BG",42.69751,23.32415,"Sofia-Capital","city"],
  [616052,"Yerevan","AM",40.17765,44.5126,"Yerevan","city"],
  [202061,"Kigali","RW",-1.94995,30.05885,"Kigali","city"],
  [927967,"Lilongwe","MW",-13.96692,33.78725,"Central Region","city"],
  [3143244,"Oslo","NO",59.91273,10.74609,"Oslo","city"],
  [611717,"Tbilisi","GE",41.69143,44.83412,"Tbilisi","city"],
  [162183,"Ashgabat","TM",37.95,58.38333,"Ashgabat","city"],
  [2964574,"Dublin","IE",53.33306,-6.24889,"Leinster","city"],
  [2800866,"Brussels","BE",50.85045,4.34878,"Brussels Capital","city"],
  [6094817,"Ottawa","CA",45.41117,-75.69812,"Ontario","city"],
  [3598132,"Guatemala City","GT",14.64072,-90.51327,"Guatemala","city"],
  [3617763,"Managua","NI",12.13282,-86.2504,"Managua Department","city"],
  [3489854,"Kingston","JM",17.99702,-76.79358,"Kingston","city"],
  [6611854,"Nay Pyi Taw","MM",19.745,96.12972,"Nay Pyi Taw","city"],
  [1528675,"Bishkek","KG",42.87,74.59,"Bishkek","city"],
  [3600949,"Tegucigalpa","HN",14.0818,-87.20681,"Francisco Morazán Department","city"],
  [2399697,"Libreville","GA",0.39241,9.45356,"Estuaire","city"],
  [2028462,"Ulan Bator","MN",47.90771,106.88324,"Ulaanbaatar","city"],
  [1651944,"Vientiane","LA",17.96667,102.6,"Vientiane Prefecture","city"],
  [2389853,"Bangui","CF",4.36122,18.55496,"Bangui","city"],
  [2409306,"Freetown","SL",8.48714,-13.2356,"Western Area","city"],
  [287286,"Muscat","OM",23.58413,58.40778,"Muscat","city"],
  [160196,"Dodoma","TZ",-6.17221,35.73947,"Dodoma","city"],
  [456172,"Riga","LV",56.946,24.10589,"Riga","city"],
  [2759794,"Amsterdam","NL",52.37403,4.88969,"North Holland","city"],
  [3191281,"Sarajevo","BA",43.84864,18.35644,"Federation of B&H","city"],
  [2464470,"Tunis","TN",36.81897,10.16579,"Tunis Governorate","city"],
  [4140963,"Washington","US",38.89511,-77.03637,"District of Columbia","city"],
  [1221874,"Dushanbe","TJ",38.53575,68.77905,"Dushanbe","city"],
  [264371,"Athens","GR",37.98376,23.72784,"Attica","city"],
  [3186886,"Zagreb","HR",45.81444,15.97798,"Zagreb","city"],
  [658225,"Helsinki","FI",60.16952,24.93545,"Uusimaa","city"],
  [1821274,"Macau","MO",22.20056,113.54611,"","city"],
  [1248991,"Colombo","LK",6.93548,79.84868,"Western Province","city"],
  [618426,"Chisinau","MD",47.00902,28.85938,"Chișinău Municipality","city"],
  [223817,"Djibouti","DJ",11.58901,43.14503,"Djibouti","city"],
  [1176615,"Islamabad","PK",33.72148,73.04329,"Islamabad","city"],
  [343300,"Asmara","ER",15.33805,38.93184,"Maekel","city"],
  [786714,"Pristina","XK",42.67272,21.16688,"Pristina","city"],
  [593116,"Vilnius","LT",54.68916,25.2798,"Vilnius","city"],
  [3583361,"San Salvador","SV",13.68935,-89.18718,"San Salvador Department","city"],
  [2267057,"Lisbon","PT",38.72509,-9.1498,"Lisbon","city"],
  [785842,"Skopje","MK",41.99646,21.43141,"Grad Skopje","city"],
  [373303,"Juba","SS",4.85165,31.58247,"Central Equatoria","city"],
  [2374775,"Bissau","GW",11.86357,-15.59767,"Bissau","city"],
  [3060972,"Bratislava","SK",48.14816,17.10674,"Bratislava Region","city"],
  [3183875,"Tirana","AL",41.32744,19.81866,"Tirana","city"],
  [4568127,"San Juan","PR",18.46633,-66.10572,"San Juan","city"],
  [3703443,"Panama City","PA",8.9936,-79.51973,"Panamá","city"],
  [588409,"Tallinn","EE",59.43696,24.75353,"Harjumaa","city"],
  [3352136,"Windhoek","NA",-22.55941,17.08323,"Khomas Region","city"],
  [2179537,"Wellington","NZ",-41.28664,174.77557,"Wellington Region","city"],
  [2172517,"Canberra","AU",-35.28346,149.12807,"Australian Capital Territory","city"],
  [932505,"Maseru","LS",-29.31667,27.48333,"Maseru District","city"],
  [290030,"Doha","QA",25.28545,51.53096,"Baladiyat ad Dawhah","city"],
  [3621849,"San José","CR",9.93388,-84.08489,"San José","city"],
  [1261481,"New Delhi","IN",28.62137,77.2148,"Delhi","city"],
  [2088122,"Port Moresby","PG",-9.47723,147.15089,"National Capital","city"],
  [2279755,"Yamoussoukro","CI",6.82055,-5.27674,"Lacs District","city"],
  [3196359,"Ljubljana","SI",46.05108,14.50513,"Ljubljana","city"],
  [2392087,"Porto-Novo","BJ",6.49646,2.60359,"Ouémé","city"],
  [933773,"Gaborone","BW",-24.65451,25.90859,"Gaborone","city"],
  [3193044,"Podgorica","ME",42.44124,19.26309,"Podgorica","city"],
  [3378644,"Georgetown","GY",6.80448,-58.15527,"Demerara-Mahaica","city"],
  [3571824,"Nassau","BS",25.05823,-77.34306,"New Providence","city"],
  [3903987,"Sucre","BO",-19.03332,-65.26274,"Chuquisaca Department","city"],
  [3383330,"Paramaribo","SR",5.86638,-55.16682,"Paramaribo District","city"],
  [146268,"Nicosia","CY",35.17284,33.35397,"Nicosia","city"],
  [934154,"Port Louis","MU",-20.16194,57.49889,"Port Louis","city"],
  [935264,"Saint-Denis","RE",-20.88231,55.4504,"Reunion","city"],
  [1645457,"Dili","TL",-8.55861,125.57361,"Dili Municipality","city"],
  [290340,"Manama","BH",26.22787,50.58565,"Manama","city"],
  [3374333,"Praia","CV",14.93152,-23.51254,"Praia","city"],
  [3513090,"Willemstad","CW",12.12246,-68.88641,"","city"],
  [2661552,"Bern","CH",46.94809,7.44744,"Bern","city"],
  [3413829,"Reykjavík","IS",64.13548,-21.89541,"Capital Region","city"],
  [1282027,"Male","MV",4.17521,73.50916,"Kaafu Atoll","city"],
  [1252416,"Thimphu","BT",27.46609,89.64191,"Thimphu District","city"],
  [3374036,"Bridgetown","BB",13.10732,-59.62021,"Saint Michael","city"],
  [2139521,"Nouméa","NC",-22.27407,166.44884,"South Province","city"],
  [3570675,"Fort-de-France","MQ",14.60365,-61.07418,"Martinique","city"],
  [2198148,"Suva","FJ",-18.13683,178.42531,"Central","city"],
  [2960316,"Luxembourg","LU",49.60982,6.13268,"Luxembourg","city"],
  [934985,"Mbabane","SZ",-26.31667,31.13333,"Hhohho Region","city"],
  [921772,"Moroni","KM",-11.70216,43.25506,"Grande Comore","city"],
  [426272,"Gitega","BI",-3.42708,29.92463,"Gitega","city"],
  [1820906,"Bandar Seri Begawan","BN",4.89035,114.94006,"Brunei-Muara District","city"],
  [3382160,"Cayenne","GF",4.9381,-52.33455,"Guyane","city"],
  [285787,"Kuwait City","KW",29.367,47.97429,"Al Asimah","city"],
  [2108502,"Honiara","SB",-9.43333,159.95,"Honiara","city"],
  [921815,"Mamoudzou","YT",-12.78234,45.22878,"Mamoudzou","city"],
  [2410763,"São Tomé","ST",0.33756,6.7299,"São Tomé Island","city"],
  [3576022,"Saint John’s","AG",17.12096,-61.84329,"Saint John Parish","city"],
  [3573890,"Port of Spain","TT",10.66668,-61.51889,"Port of Spain","city"],
  [7828758,"Saipan","MP",15.21233,145.7545,"Saipan","city"],
  [4035413,"Apia","WS",-13.83333,-171.76666,"Tuamasaga","city"],
  [2110257,"Tarawa","KI",1.3278,172.97696,"Gilbert Islands","city"],
  [2413876,"Banjul","GM",13.45274,-16.57803,"Banjul","city"],
  [2135171,"Port-Vila","VU",-17.73648,168.31366,"Shefa","city"],
  [2993458,"Monaco","MC",43.73718,7.42145,"Municipality of Monaco","city"],
  [3577154,"Oranjestad","AW",12.52398,-70.02703,"","city"],
  [3580661,"George Town","KY",19.2866,-81.37436,"George Town","city"],
  [3042091,"Saint Helier","JE",49.18804,-2.10491,"St Helier","city"],
  [2411585,"Gibraltar","GI",36.14474,-5.35257,"","city"],
  [4033936,"Papeete","PF",-17.5347,-149.56843,"Îles du Vent","city"],
  [3042237,"Douglas","IM",54.15,-4.48333,"Douglas","city"],
  [2113779,"Majuro","MH",7.08971,171.38027,"Majuro Atoll","city"],
  [3577887,"Kingstown","VC",13.15527,-61.22742,"Saint George Parish","city"],
  [241131,"Victoria","SC",-4.62001,55.45501,"La Rivière Anglaise","city"],
  [4032402,"Nuku‘alofa","TO",-21.13683,-175.20114,"Tongatapu","city"],
  [3041563,"Andorra la Vella","AD",42.50779,1.52109,"Andorra la Vella","city"],
  [3576812,"Castries","LC",13.9957,-61.00614,"Castries","city"],
  [4795467,"Charlotte Amalie","VI",18.3419,-64.9307,"Saint Thomas Island","city"],
  [3575635,"Roseau","DM",15.30174,-61.38808,"Saint George Parish","city"],
  [3042287,"Saint Peter Port","GG",49.45981,-2.53527,"St Peter Port","city"],
  [3421319,"Nuuk","GL",64.18347,-51.72157,"Sermersooq","city"],
  [3582672,"Belmopan","BZ",17.25376,-88.76401,"Cayo District","city"],
  [4035715,"Avarua","CK",-21.2075,-159.77546,"Rarotonga","city"],
  [2611396,"Tórshavn","FO",62.00973,-6.77164,"Streymoy","city"],
  [3575551,"Basseterre","KN",17.2955,-62.72499,"Saint George Basseterre","city"],
  [5881576,"Pago Pago","AS",-14.27806,-170.7025,"Eastern District","city"],
  [3579732,"Basse-Terre","GP",15.99714,-61.73214,"Guadeloupe","city"],
  [3041732,"Mariehamn","AX",60.09726,19.93481,"Mariehamn","city"],
  [3513563,"Kralendijk","BQ",12.15,-68.26667,"Bonaire","city"],
  [3577430,"Road Town","VG",18.42693,-64.62079,"","city"],
  [3579925,"Saint George's","GD",12.05288,-61.75226,"Saint George Parish","city"],
  [2081986,"Palikir","FM",6.92477,158.16109,"Pohnpei State","city"],
  [2562305,"Valletta","MT",35.89968,14.5148,"Valletta","city"],
  [2110394,"Funafuti","TV",-8.52425,179.19417,"Funafuti","city"],
  [3424934,"Saint-Pierre","PM",46.77914,-56.1773,"Saint-Pierre","city"],
  [3579132,"Gustavia","BL",17.89618,-62.84978,"","city"],
  [3578851,"Marigot","MF",18.06819,-63.08302,"","city"],
  [3042030,"Vaduz","LI",47.14151,9.52154,"Vaduz","city"],
  [3168070,"San Marino","SM",43.93667,12.44639,"San Marino","city"],
  [3576994,"Cockburn Town","TC",21.46122,-71.14188,"","city"],
  [2729907,"Longyearbyen","SJ",78.22334,15.64689,"Svalbard","city"],
  [3426691,"Stanley","FK",-51.69382,-57.85701,"","city"],
  [3573374,"The Valley","AI",18.21704,-63.05783,"The Valley","city"],
  [12226438,"Ciudad de la Paz","GQ",1.5925,10.82361,"Djibloho","city"],
  [3513392,"Philipsburg","SX",18.026,-63.04582,"","city"],
  [4034821,"Mata-Utu","WF",-13.28163,-176.17453,"Uvea","city"],
  [7626461,"Yaren","NR",-0.55085,166.9252,"Yaren District","city"],
  [4044012,"Hagåtña","GU",13.47567,144.74886,"Hagatna","city"],
  [3573197,"Hamilton","BM",32.2949,-64.78303,"Hamilton city","city"],
  [2161314,"Kingston","NF",-29.05459,167.96628,"","city"],
  [6691831,"Vatican City","VA",41.90268,12.45414,"","city"],
  [3370903,"Jamestown","SH",-15.92488,-5.71816,"Saint Helena","city"],
  [4036284,"Alofi","NU",-19.05294,-169.91957,"","city"],
  [2078127,"Flying Fish Cove","CX",-10.42172,105.67912,"","city"],
  [7304591,"West Island","CC",-12.15681,96.82251,"","city"],
  [4030723,"Adamstown","PN",-25.06597,-130.10147,"","city"],
  [1546102,"Port-aux-Français","TF",-49.34916,70.21937,"Kerguelen","city"],
  [3426466,"Grytviken","GS",-54.28111,-36.5092,"","city"],
  [3578069,"Plymouth","MS",16.70555,-62.21292,"Saint Anthony","city"],
  [8063361,"Ngerulmud","PW",7.50077,134.6238,"Melekeok","city"],
  [1796236,"Shanghai","CN",31.22222,121.45806,"Shanghai","city"],
  [1795565,"Shenzhen","CN",22.54554,114.0683,"Guangdong","city"],
  [1809858,"Guangzhou","CN",23.11667,113.25,"Guangdong","city"],
  [745044,"Istanbul","TR",41.01384,28.94966,"Istanbul","city"],
  [2332459,"Lagos","NG",6.45407,3.39467,"Lagos","city"],
  [1566083,"Ho Chi Minh City","VN",10.82302,106.62965,"Ho Chi Minh City (HCMC)","city"],
  [1815286,"Chengdu","CN",30.66667,104.06667,"Sichuan","city"],
  [1172451,"Lahore","PK",31.558,74.35071,"Punjab","city"],
  [1275339,"Mumbai","IN",19.07283,72.88261,"Maharashtra","city"],
  [3448439,"São Paulo","BR",-23.5475,-46.63611,"São Paulo","city"],
  [1174872,"Karachi","PK",24.8608,67.0104,"Sindh","city"],
  [1792947,"Tianjin","CN",39.14222,117.17667,"Tianjin","city"],
  [1273294,"Delhi","IN",28.65195,77.23149,"Delhi","city"],
  [1791247,"Wuhan","CN",30.58333,114.26667,"Hubei","city"],
  [1812545,"Dongguan","CN",23.01797,113.74866,"Guangdong","city"],
  [1790630,"Xi’an","CN",34.25833,108.92861,"Shaanxi","city"],
  [993800,"Johannesburg","ZA",-26.20227,28.04363,"Gauteng","city"],
  [1799962,"Nanjing","CN",32.06167,118.77778,"Jiangsu","city"],
  [1808926,"Hangzhou","CN",30.29365,120.16142,"Zhejiang","city"],
  [1811103,"Foshan","CN",23.02677,113.13148,"Guangdong","city"],
  [5128581,"New York City","US",40.71427,-74.00597,"New York","city"],
  [1277333,"Bengaluru","IN",12.97194,77.59369,"Karnataka","city"],
  [1814906,"Chongqing","CN",29.56026,106.55771,"Chongqing","city"],
  [1790842,"Wuzhong","CN",37.9867,106.201,"Ningxia","city"],
  [1797929,"Qingdao","CN",36.06488,120.38042,"Shandong","city"],
  [2034937,"Shenyang","CN",41.79222,123.43278,"Liaoning","city"],
  [1269843,"Hyderabad","IN",17.38405,78.45636,"Telangana","city"],
  [3451190,"Rio de Janeiro","BR",-22.90642,-43.18223,"Rio de Janeiro","city"],
  [1886760,"Suzhou","CN",31.30408,120.59538,"Jiangsu","city"],
  [11072148,"Puxi","CN",31.24414,121.46592,"Shanghai","city"],
  [1279233,"Ahmedabad","IN",23.02579,72.58727,"Gujarat","city"],
  [2293538,"Abidjan","CI",5.35444,-4.00167,"Abidjan Autonomous District","city"],
  [1798524,"Pudong","CN",31.23995,121.50094,"Shanghai","city"],
  [2147714,"Sydney","AU",-33.86785,151.20732,"New South Wales","city"],
  [2158177,"Melbourne","AU",-37.814,144.96332,"Victoria","city"],
  [160263,"Dar es Salaam","TZ",-6.82349,39.26951,"Dar es Salaam Region","city"],
  [498817,"Saint Petersburg","RU",59.93863,30.31413,"St.-Petersburg","city"],
  [361058,"Alexandria","EG",31.20176,29.91582,"Alexandria","city"],
  [2037013,"Harbin","CN",45.75,126.65,"Heilongjiang","city"],
  [1808722,"Hefei","CN",31.86389,117.28083,"Anhui","city"],
  [1814087,"Dalian","CN",38.91222,121.60222,"Liaoning","city"],
  [2335204,"Kano","NG",12.00012,8.51672,"Kano State","city"],
  [3369157,"Cape Town","ZA",-33.92584,18.42322,"Western Cape","city"],
  [1168197,"Peshawar","PK",34.008,71.57849,"Khyber Pakhtunkhwa","city"],
  [2038180,"Changchun","CN",43.88,125.32278,"Jilin","city"],
  [105343,"Jeddah","SA",21.49012,39.18624,"Mecca Region","city"],
  [1264527,"Chennai","IN",13.08784,80.27847,"Tamil Nadu","city"],
  [1275004,"Kolkata","IN",22.56263,88.36304,"West Bengal","city"],
  [1790645,"Xiamen","CN",24.47979,118.08187,"Fujian","city"],
  [1255364,"Surat","IN",21.19594,72.83023,"Gujarat","city"],
  [1298824,"Yangon","MM",16.80528,96.15611,"Yangon","city"],
  [13308620,"Bao'an","CN",22.55213,113.88288,"Guangdong","city"],
  [1790923,"Wuxi","CN",31.56887,120.28857,"Jiangsu","city"],
  [360995,"Giza","EG",30.00944,31.20861,"Giza","city"],
  [1805753,"Jinan","CN",36.66833,116.99722,"Shandong","city"],
  [1793511,"Taiyuan","CN",37.86944,112.56028,"Shanxi","city"],
  [1784658,"Zhengzhou","CN",34.75778,113.64861,"Henan","city"],
  [12908892,"New Taipei City","TW",25.06199,121.45703,"Taipei","city"],
  [12747063,"New Territories","HK",22.42441,114.11095,"","city"],
  [1795270,"Shijiazhuang","CN",38.04139,114.47861,"Hebei","city"],
  [1205733,"Chattogram","BD",22.3384,91.83168,"Chittagong","city"],
  [1804651,"Kunming","CN",25.03889,102.71833,"Yunnan","city"],
  [6986104,"Zhongshan","CN",22.52306,113.37912,"Guangdong","city"],
  [1799869,"Nanning","CN",22.81667,108.31667,"Guangxi","city"],
  [1795940,"Shantou","CN",23.35489,116.67876,"Guangdong","city"],
  [5368361,"Los Angeles","US",34.05223,-118.24368,"California","city"],
  [1179400,"Faisalabad","PK",31.41554,73.08969,"Punjab","city"],
  [292223,"Dubai","AE",25.07725,55.30927,"Dubai","city"],
  [1848354,"Yokohama","JP",35.43333,139.65,"Kanagawa","city"],
  [1810821,"Fuzhou","CN",26.06139,119.30611,"Fujian","city"],
  [1799397,"Ningbo","CN",29.87819,121.54945,"Zhejiang","city"],
  [2553604,"Casablanca","MA",33.58831,-7.61138,"Casablanca-Settat","city"],
  [2339354,"Ibadan","NG",7.37756,3.90591,"Oyo State","city"],
  [1798425,"Puyang","CN",29.45679,119.88872,"Zhejiang","city"],
  [1794903,"Shiyan","CN",32.6475,110.77806,"Hubei","city"],
  [1793346,"Tangshan","CN",39.64381,118.18319,"Hebei","city"],
  [1166993,"Rawalpindi","PK",33.59733,73.0479,"Punjab","city"],
  [13512505,"Lüliang","CN",37.5192,111.14436,"Shanxi","city"],
  [1007311,"Durban","ZA",-29.8579,31.0292,"KwaZulu-Natal","city"],
  [1815456,"Changzhou","CN",31.77359,119.95401,"Jiangsu","city"],
  [1838524,"Busan","KR",35.10168,129.03004,"Busan","city"],
  [1785286,"Zibo","CN",36.79056,118.06333,"Shandong","city"],
  [1259229,"Pune","IN",18.51957,73.85535,"Maharashtra","city"],
  [750269,"Bursa","TR",40.19559,29.06013,"Bursa Province","city"],
  [1815577,"Changsha","CN",28.19874,112.97087,"Hunan","city"],
  [1692192,"Quezon City","PH",14.6488,121.0509,"National Capital Region","city"],
  [1269515,"Jaipur","IN",26.91962,75.78781,"Rajasthan","city"],
  [1809461,"Guiyang","CN",26.58333,106.71667,"Guizhou","city"],
  [1529102,"Ürümqi","CN",43.80096,87.60046,"Xinjiang","city"],
  [1625822,"Surabaya","ID",-7.24917,112.75083,"East Java","city"],
  [1843564,"Incheon","KR",37.45646,126.70515,"Incheon","city"],
  [1804430,"Lanzhou","CN",36.05701,103.83987,"Gansu","city"],
  [311046,"İzmir","TR",38.41273,27.13838,"İzmir Province","city"],
  [1806776,"Huizhou","CN",23.11147,114.41523,"Guangdong","city"],
  [1809078,"Haikou","CN",20.03421,110.34651,"Hainan","city"],
  [1668399,"Taichung","TW",24.1469,120.6839,"Taiwan","city"],
  [1267995,"Kanpur","IN",26.46523,80.34975,"Uttar Pradesh","city"],
  [6167865,"Toronto","CA",43.70643,-79.39864,"Ontario","city"],
  [2174003,"Brisbane","AU",-27.46794,153.02809,"Queensland","city"],
  [1853909,"Osaka","JP",34.69379,135.50107,"Osaka","city"],
  [1803318,"Linyi","CN",35.06306,118.34278,"Shandong","city"],
  [1816971,"Baoding","CN",38.87288,115.46246,"Hebei","city"],
  [1673820,"Kaohsiung","TW",22.61626,120.31333,"Takao","city"],
  [5110302,"Brooklyn","US",40.6501,-73.94958,"New York","city"],
  [3657509,"Guayaquil","EC",-2.19616,-79.88621,"Guayas","city"],
  [3470127,"Belo Horizonte","BR",-19.92083,-43.93778,"Minas Gerais","city"],
  [1800480,"Minhang","CN",31.10881,121.37471,"Shanghai","city"],
  [11995100,"Bazhong","CN",31.8694,106.74432,"Sichuan","city"],
  [3450554,"Salvador","BR",-12.97563,-38.49096,"Bahia","city"],
  [1200109,"Gazipur","BD",23.99844,90.42234,"Dhaka Division","city"],
  [4887398,"Chicago","US",41.85003,-87.65005,"Illinois","city"],
  [1791388,"Wenzhou","CN",27.99942,120.66682,"Zhejiang","city"],
  [1649378,"Bekasi","ID",-6.2349,106.9896,"West Java","city"],
  [1581298,"Haiphong","VN",20.86481,106.68345,"Hai Phong","city"],
  [1785725,"Yunfu","CN",22.92787,112.03809,"Guangdong","city"],
  [6619347,"Navi Mumbai","IN",19.03681,73.01582,"Maharashtra","city"],
  [2298890,"Kumasi","GH",6.68848,-1.62443,"Ashanti","city"],
  [1650357,"Bandung","ID",-6.92222,107.60694,"West Java","city"],
  [1177662,"Gujranwala","PK",32.15567,74.18705,"Punjab","city"],
  [1797873,"Huai'an","CN",33.58861,119.01917,"Jiangsu","city"],
  [1214520,"Medan","ID",3.58333,98.66667,"North Sumatra","city"],
  [1264733,"Lucknow","IN",26.83928,80.92313,"Uttar Pradesh","city"],
  [1262180,"Nagpur","IN",21.14631,79.08491,"Maharashtra","city"],
  [3399415,"Fortaleza","BR",-3.71722,-38.54306,"Ceará","city"],
  [3687925,"Cali","CO",3.43054,-76.5199,"Valle del Cauca Department","city"],
  [2063523,"Perth","AU",-31.95224,115.8614,"Western Australia","city"],
  [1835329,"Daegu","KR",35.87028,128.59111,"Daegu","city"],
  [1800163,"Nanchang","CN",28.68396,115.85306,"Jiangxi","city"],
  [2036892,"Hohhot","CN",40.81056,111.65222,"Inner Mongolia","city"],
  [1856057,"Nagoya","JP",35.18147,136.90641,"Aichi","city"],
  [5133273,"Queens","US",40.68149,-73.83652,"New York","city"],
  [4699066,"Houston","US",29.76328,-95.36327,"Texas","city"],
  [124665,"Mashhad","IR",36.29807,59.60567,"Razavi Khorasan","city"],
  [1795855,"Shaoxing","CN",30.00237,120.57864,"Zhejiang","city"],
  [1799722,"Nantong","CN",32.03028,120.87472,"Jiangsu","city"],
  [1816917,"Baoshan","CN",31.40845,121.48956,"Shanghai","city"],
  [1819609,"Kowloon","HK",22.31667,114.18333,"","city"],
  [1787093,"Yantai","CN",37.47649,121.44081,"Shandong","city"],
  [314830,"Gaziantep","TR",37.05944,37.3825,"Gaziantep","city"],
  [922704,"Lubumbashi","CD",-11.66089,27.47938,"Haut-Katanga","city"],
  [3663517,"Manaus","BR",-3.10194,-60.025,"Amazonas","city"],
  [1790437,"Zhuhai","CN",22.27694,113.56778,"Guangdong","city"],
  [1169825,"Multan","PK",30.19679,71.47824,"Punjab","city"],
  [1645524,"Depok","ID",-6.4,106.81861,"West Java","city"],
  [2038432,"Baotou","CN",40.6516,109.84389,"Inner Mongolia","city"],
  [1273865,"Coimbatore","IN",11.00555,76.96612,"Tamil Nadu","city"],
  [12359313,"Qingyang","CN",35.70976,107.64455,"Gansu","city"],
  [2324774,"Port Harcourt","NG",4.77742,7.0134,"Rivers State","city"],
  [3860259,"Córdoba","AR",-31.40648,-64.18853,"Cordoba","city"],
  [209228,"Mbuji-Mayi","CD",-6.13603,23.58979,"East Kasai","city"],
  [170063,"Aleppo","SY",36.20124,37.16117,"Aleppo","city"],
  [1785623,"Kunshan","CN",31.37762,120.95431,"Jiangsu","city"],
  [99071,"Al Mawşil al Jadīdah","IQ",36.33271,43.10555,"Nineveh","city"],
  [1791681,"Weifang","CN",36.71,119.10194,"Shandong","city"],
  [1783621,"Zunyi","CN",27.68667,106.90722,"Guizhou","city"],
  [388349,"Al Başrah al Qadīmah","IQ",30.50316,47.81507,"Basra","city"],
  [3911925,"La Paz","BO",-16.5,-68.15,"La Paz Department","city"],
  [10859300,"Lianyungang","CN",34.59845,119.21556,"Jiangsu","city"],
  [3674962,"Medellín","CO",6.245,-75.57151,"Antioquia","city"],
  [1269743,"Indore","IN",22.71792,75.8333,"Madhya Pradesh","city"],
  [1810638,"Ganzhou","CN",25.84664,114.9326,"Jiangxi","city"],
  [1526384,"Almaty","KZ",43.25249,76.9115,"Almaty","city"],
  [2911298,"Hamburg","DE",53.55073,9.99302,"Hamburg","city"],
  [2128295,"Sapporo","JP",43.06667,141.35,"Hokkaido","city"],
  [1794035,"Songjiang","CN",31.03443,121.22326,"Shanghai","city"],
  [3464975,"Curitiba","BR",-25.42778,-49.27306,"Paraná","city"],
  [8347664,"Ordos","CN",39.6086,109.78157,"Inner Mongolia","city"],
  [1625084,"Tangerang","ID",-6.17806,106.63,"Banten","city"],
  [3981609,"Tijuana","MX",32.5027,-117.00371,"Baja California","city"],
  [1176734,"Hyderabad","PK",25.39689,68.37718,"Sindh","city"],
  [1797121,"Jieyang","CN",23.5418,116.36581,"Guangdong","city"],
  [2036502,"Jilin","CN",43.84652,126.5608,"Jilin","city"],
  [1806508,"Jiading","CN",31.38575,121.24465,"Shanghai","city"],
  [2422488,"Camayenne","GN",9.535,-13.68778,"Conakry","city"],
  [195272,"Kakamega","KE",0.28422,34.75229,"Kakamega County","city"],
  [1796134,"Shangqiu","CN",34.4143,115.65613,"Henan","city"],
  [1800146,"Nanchong","CN",30.79508,106.08473,"Sichuan","city"],
  [1668355,"Tainan","TW",22.99083,120.21333,"Taiwan","city"],
  [2037799,"Datong","CN",40.09361,113.29139,"Shanxi","city"],
  [2335727,"Kaduna","NG",10.52641,7.43879,"Kaduna State","city"],
  [365137,"Omdurman","SD",15.64453,32.47773,"Khartoum","city"],
  [1715348,"Davao","PH",7.07306,125.61278,"Davao Region","city"],
  [1254661,"Thāne","IN",19.19704,72.96355,"Maharashtra","city"],
  [3526683,"Iztapalapa","MX",19.35529,-99.06224,"Mexico City","city"],
  [316541,"Diyarbakır","TR",37.91363,40.21721,"Diyarbakır Province","city"],
  [3904906,"Santa Cruz de la Sierra","BO",-17.78629,-63.18117,"Santa Cruz Department","city"],
  [1253573,"Vadodara","IN",22.29941,73.20812,"Gujarat","city"],
  [325363,"Adana","TR",36.98615,35.32531,"Adana","city"],
  [1799629,"Nanyang","CN",33.00524,112.54659,"Henan","city"],
  [1633070,"Palembang","ID",-2.91673,104.7458,"South Sumatra","city"],
  [292672,"Sharjah","AE",25.3342,55.41221,"Sharjah","city"],
  [1275841,"Bhopal","IN",23.25469,77.40289,"Madhya Pradesh","city"],
  [1806299,"Jiangmen","CN",22.58333,113.08333,"Guangdong","city"],
  [2347283,"Benin City","NG",6.33815,5.62575,"Edo State","city"],
  [1815251,"Jiangyin","CN",31.91102,120.26302,"Jiangsu","city"],
  [1810845,"Fuyang","CN",32.9,115.81667,"Anhui","city"],
  [6077243,"Montréal","CA",45.50884,-73.58781,"Quebec","city"],
  [11838258,"Bayan Nur","CN",40.74143,107.38599,"Inner Mongolia","city"],
  [3633009,"Maracaibo","VE",10.64232,-71.61089,"Zulia","city"],
  [1815395,"Chaozhou","CN",23.65396,116.62262,"Guangdong","city"],
  [1797945,"Qingyuan","CN",23.7,113.03333,"Guangdong","city"],
  [1793724,"Tai’an","CN",36.18528,117.12,"Shandong","city"],
  [1258393,"Rasapūdipalem","IN",17.73308,83.31622,"Andhra Pradesh","city"],
  [7626690,"Pimpri-Chinchwad","IN",18.61867,73.80375,"Maharashtra","city"],
  [1720151,"Caloocan","PH",14.64953,120.96788,"National Capital Region","city"],
  [953781,"Soweto","ZA",-26.26781,27.85849,"Gauteng","city"],
  [1627896,"Semarang","ID",-6.99306,110.42083,"Central Java","city"],
  [3521081,"Puebla","MX",19.04778,-98.20723,"Puebla","city"],
  [3128760,"Barcelona","ES",41.38879,2.15899,"Catalonia","city"],
  [1260086,"Patna","IN",25.59408,85.13563,"Bihar","city"],
  [99072,"Mosul","IQ",36.335,43.11889,"Nineveh","city"],
  [12165956,"Kallakurichi","IN",11.73379,78.95925,"Tamil Nadu","city"],
  [1788852,"Xining","CN",36.62554,101.75739,"Qinghai","city"],
  [7283386,"Changshu","CN",31.64615,120.74221,"Jiangsu","city"],
  [1807681,"Huainan","CN",32.62639,116.99694,"Anhui","city"],
  [3390760,"Recife","BR",-8.05389,-34.88111,"Pernambuco","city"],
  [5308655,"Phoenix","US",33.44838,-112.07404,"Arizona","city"],
  [1793743,"Suzhou","CN",33.63611,116.97889,"Anhui","city"],
  [3529612,"Ecatepec de Morelos","MX",19.60492,-99.06064,"México","city"],
  [1802206,"Lu’an","CN",31.73561,116.51688,"Anhui","city"],
  [3625549,"Valencia","VE",10.16153,-68.00044,"Carabobo","city"],
  [1264728,"Ludhiana","IN",30.91204,75.85379,"Punjab","city"],
  [1787746,"Yancheng","CN",33.3575,120.1573,"Jiangsu","city"],
  [1496747,"Novosibirsk","RU",55.02259,82.93175,"Novosibirsk Oblast","city"],
  [95446,"Erbil","IQ",36.19117,44.00943,"Erbil","city"],
  [1863967,"Fukuoka","JP",33.6,130.41667,"Fukuoka","city"],
  [1793505,"Taizhou","CN",32.49069,119.90812,"Jiangsu","city"],
  [2037860,"Daqing","CN",46.58333,125,"Heilongjiang","city"],
  [1791236,"Wuhu","CN",31.35259,118.42947,"Anhui","city"],
  [3991164,"Santiago de Querétaro","MX",20.58806,-100.38806,"Querétaro","city"],
  [1813325,"Dazhou","CN",31.2106,107.46308,"Sichuan","city"],
  [1787227,"Yangzhou","CN",32.39722,119.43583,"Jiangsu","city"],
  [3998655,"León de los Aldama","MX",21.12183,-101.68253,"Guanajuato","city"],
  [104515,"Makkah","SA",21.42664,39.82563,"Mecca Region","city"],
  [4560349,"Philadelphia","US",39.95238,-75.16362,"Pennsylvania","city"],
  [1809498,"Guilin","CN",25.28022,110.29639,"Guangxi","city"],
  [1167528,"Quetta","PK",30.18414,67.00141,"Balochistan","city"],
  [1784853,"Zhaoqing","CN",23.04893,112.46091,"Guangdong","city"],
  [2326016,"Onitsha","NG",6.14978,6.78569,"Anambra","city"],
  [1800627,"Mianyang","CN",31.46784,104.68168,"Sichuan","city"],
  [2193733,"Auckland","NZ",-36.84853,174.76349,"Auckland","city"],
  [418863,"Isfahan","IR",32.65246,51.67462,"Isfahan","city"],
  [12358576,"Wanzhou","CN",30.76451,108.39586,"Chongqing","city"],
  [1798449,"Putian","CN",25.43944,119.01028,"Fujian","city"],
  [1859642,"Kawasaki","JP",35.52056,139.71722,"Kanagawa","city"],
  [3462377,"Goiânia","BR",-16.67861,-49.25389,"Goiás","city"],
  [4726206,"San Antonio","US",29.42412,-98.49363,"Texas","city"],
  [1859171,"Kobe","JP",34.6913,135.183,"Hyōgo","city"],
  [4013708,"Ciudad Juárez","MX",31.72024,-106.46084,"Chihuahua","city"],
  [1586203,"Cần Thơ","VN",10.03711,105.78825,"Can Tho City","city"],
  [2867714,"Munich","DE",48.13743,11.57549,"Bavaria","city"],
  [1336135,"Khulna","BD",22.80979,89.56439,"Khulna Division","city"],
  [3405870,"Belém","BR",-1.45583,-48.50444,"Pará","city"],
  [1486209,"Yekaterinburg","RU",56.85733,60.61529,"Sverdlovsk Oblast","city"],
  [3452925,"Porto Alegre","BR",-30.03283,-51.23019,"Rio Grande do Sul","city"],
  [1786657,"Yinchuan","CN",38.46806,106.27306,"Ningxia","city"],
  [5125771,"Manhattan","US",40.78343,-73.96625,"New York","city"],
  [1261731,"Nashik","IN",19.99727,73.79096,"Maharashtra","city"],
  [8400694,"Taizhou","CN",28.66266,121.43312,"Zhejiang","city"],
  [1814870,"Yiwu","CN",29.31506,120.07676,"Zhejiang","city"],
  [3979770,"Zapopan","MX",20.72111,-103.38742,"Jalisco","city"],
  [1622786,"Makassar","ID",-5.14861,119.43194,"South Sulawesi","city"],
  [2078025,"Adelaide","AU",-34.92866,138.59863,"South Australia","city"],
  [1797353,"Quanzhou","CN",24.91389,118.58583,"Fujian","city"],
  [1264521,"Madurai","IN",9.919,78.11953,"Tamil Nadu","city"],
  [1805528,"Jinhua","CN",29.10678,119.64421,"Zhejiang","city"],
  [1857910,"Kyoto","JP",35.02107,135.75385,"Kyoto","city"],
  [1806602,"Cixi","CN",30.1764,121.2457,"Zhejiang","city"],
  [1791121,"Changde","CN",29.03205,111.69844,"Hunan","city"],
  [308464,"Kayseri","TR",38.73222,35.48528,"Kayseri","city"],
  [1804879,"Kaifeng","CN",34.7986,114.30742,"Henan","city"],
  [2038632,"Anshan","CN",41.12361,122.99,"Liaoning","city"],
  [128747,"Karaj","IR",35.83266,50.99155,"Alborz Province","city"],
  [1835235,"Daejeon","KR",36.34913,127.38493,"Daejeon","city"],
  [10942359,"Baoji","CN",34.36775,107.23705,"Shaanxi","city"],
  [1793771,"Suqian","CN",33.94917,118.29583,"Jiangsu","city"],
  [1803300,"Liuzhou","CN",24.32405,109.40698,"Guangxi","city"],
  [1254361,"Tirunelveli","IN",8.72742,77.6838,"Tamil Nadu","city"],
  [306571,"Konya","TR",37.87135,32.48464,"Konya","city"],
  [1787331,"Zhangjiagang","CN",31.865,120.53889,"Jiangsu","city"],
  [1279259,"Agra","IN",27.18333,78.01667,"Uttar Pradesh","city"],
  [8581443,"South Tangerang","ID",-6.28862,106.71789,"Banten","city"],
  [113646,"Tabriz","IR",38.08,46.2919,"East Azerbaijan","city"],
  [706483,"Kharkiv","UA",49.98177,36.25475,"Kharkiv","city"],
  [1797658,"Jinjiang","CN",24.81978,118.57415,"Fujian","city"],
  [1271951,"Faridabad","IN",28.41124,77.31316,"Haryana","city"],
  [1816234,"Bozhou","CN",33.87722,115.77028,"Anhui","city"],
  [1797318,"Qujing","CN",25.48333,103.78333,"Yunnan","city"],
  [5391811,"San Diego","US",32.71571,-117.16472,"California","city"],
  [1841811,"Gwangju","KR",35.15472,126.91556,"Gwangju","city"],
  [1784990,"Zhanjiang","CN",21.23391,110.38749,"Guangdong","city"],
  [2037355,"Fushun","CN",41.88669,123.94363,"Liaoning","city"],
  [1258847,"Rājkot","IN",22.29161,70.79322,"Gujarat","city"],
  [1801792,"Luoyang","CN",34.67345,112.43684,"Henan","city"],
  [4005539,"Guadalajara","MX",20.67738,-103.34749,"Jalisco","city"],
  [5110266,"The Bronx","US",40.84985,-73.86641,"New York","city"],
  [1580240,"Huế","VN",16.4619,107.59546,"Thừa Thiên Huế Province","city"],
  [1802875,"Guankou","CN",28.15861,113.62709,"Hunan","city"],
  [3173435,"Milan","IT",45.46427,9.18951,"Lombardy","city"],
  [1262111,"Najafgarh","IN",28.60922,76.97982,"Delhi","city"],
  [1808963,"Handan","CN",36.60999,114.48764,"Hebei","city"],
  [1183460,"Bannu","PK",32.98527,70.60403,"Khyber Pakhtunkhwa","city"],
  [1786764,"Yichang","CN",30.71444,111.28472,"Hubei","city"],
  [1808198,"Heze","CN",35.23929,115.47358,"Shandong","city"],
  [2293521,"Abobo","CI",5.41613,-4.0159,"Abidjan Autonomous District","city"],
  [1269300,"Jamshedpur","IN",22.80278,86.18545,"Jharkhand","city"],
  [2232593,"Douala","CM",4.04827,9.70428,"Littoral","city"],
  [323777,"Antalya","TR",36.90812,30.69556,"Antalya","city"],
  [99532,"Basrah","IQ",30.50852,47.7804,"Basra","city"],
  [4684888,"Dallas","US",32.78306,-96.80667,"Texas","city"],
  [6940394,"Saitama","JP",35.90807,139.65657,"Saitama","city"],
  [1270926,"Gorakhpur","IN",29.44768,75.67206,"Haryana","city"],
  [8533133,"Liupanshui","CN",26.59444,104.83333,"Guizhou","city"],
  [1684308,"Taguig","PH",14.5243,121.0792,"National Capital Region","city"],
  [1801180,"Maoming","CN",21.66625,110.91364,"Guangdong","city"],
  [5913490,"Calgary","CA",51.05011,-114.08529,"Alberta","city"],
  [109223,"Madinah","SA",24.46861,39.61417,"Medina Region","city"],
  [6295587,"Batam","ID",1.14937,104.02491,"Riau","city"],
  [1797551,"Qinzhou","CN",21.98247,108.65061,"Guangxi","city"],
  [1801934,"Luohe","CN",33.57424,114.03261,"Henan","city"],
  [1790587,"Xiangyang","CN",32.0422,112.14479,"Hubei","city"],
  [1806408,"Yangjiang","CN",21.85563,111.96272,"Guangdong","city"],
  [1786760,"Yixing","CN",31.36059,119.82016,"Jiangsu","city"],
  [1259652,"Pimpri","IN",18.62292,73.80696,"Maharashtra","city"],
  [1583992,"Da Nang","VN",16.06778,108.22083,"Da Nang City","city"],
  [1723510,"Budta","PH",7.20417,124.43972,"Autonomous Region in Muslim Mindanao","city"],
  [1587923,"Biên Hòa","VN",10.94469,106.82432,"Dong Nai","city"],
  [1797798,"Qingpu","CN",31.15394,121.11408,"Shanghai","city"],
  [1788046,"Xuchang","CN",34.03189,113.86299,"Henan","city"],
  [1268295,"Kalyān","IN",19.2437,73.13554,"Maharashtra","city"],
  [1783745,"Zigong","CN",29.34162,104.77689,"Sichuan","city"],
  [520555,"Nizhniy Novgorod","RU",56.32867,44.00205,"Nizhny Novgorod Oblast","city"],
  [1642548,"Jepara","ID",-6.5924,110.671,"Central Java","city"],
  [10630003,"Xuzhou","CN",34.20442,117.28386,"Jiangsu","city"],
  [110336,"Dammam","SA",26.43442,50.10326,"Eastern Province","city"],
  [268743,"Ra’s Bayrūt","LB",33.9,35.48333,"Beirut","city"],
  [1799491,"Neijiang","CN",29.58354,105.06216,"Sichuan","city"],
  [115019,"Shiraz","IR",29.61031,52.53113,"Fars","city"],
  [1808316,"Heshan","CN",28.56938,112.34733,"Hunan","city"],
  [1272423,"Dombivali","IN",19.21667,73.08333,"Maharashtra","city"],
  [214481,"Kananga","CD",-5.89624,22.41659,"Kasai-Central","city"],
  [551487,"Kazan","RU",55.78874,49.12214,"Tatarstan Republic","city"],
  [1805518,"Jining","CN",35.405,116.58139,"Shandong","city"],
  [3648522,"Barquisimeto","VE",10.0647,-69.35703,"Lara","city"],
  [349076,"Shubrā al Khaymah","EG",30.12511,31.25053,"Qalyubia","city"],
  [1798439,"Putuo","CN",31.251,121.3897,"Shanghai","city"],
  [1835553,"Suwon","KR",37.29111,127.00889,"Gyeonggi-do","city"],
  [1788534,"Xinyang","CN",32.12278,114.06556,"Henan","city"],
  [1803834,"Liaocheng","CN",36.45064,116.00247,"Shandong","city"],
  [10942283,"Jinzhong","CN",37.68403,112.75471,"Shanxi","city"],
  [3946083,"Callao","PE",-12.05162,-77.13452,"Callao","city"],
  [1263214,"Meerut","IN",28.98002,77.70636,"Uttar Pradesh","city"],
  [1253133,"Virār","IN",19.45591,72.81136,"Maharashtra","city"],
  [1261162,"Nowrangapur","IN",19.23114,82.54826,"Odisha","city"],
  [94824,"Karbala","IQ",32.61603,44.02488,"Karbala","city"],
  [1808956,"Changzhi","CN",36.18389,113.10528,"Shanxi","city"],
  [1792892,"Tianshui","CN",34.57952,105.74238,"Gansu","city"],
  [7802746,"Sadr City","IQ",33.3889,44.4583,"Baghdad","city"],
  [1787375,"Yangpu","CN",31.26193,121.51904,"Shanghai","city"],
  [186301,"Mombasa","KE",-4.05466,39.66359,"Mombasa County","city"],
  [1311874,"Mandalay","MM",21.97473,96.08359,"Mandalay Region","city"],
  [1255634,"Srinagar","IN",34.08565,74.80555,"Jammu and Kashmir","city"],
  [3689147,"Barranquilla","CO",10.96854,-74.78132,"Atlántico","city"],
  [1508291,"Chelyabinsk","RU",55.1611,61.42877,"Chelyabinsk","city"],
  [3523349,"Mérida","MX",20.967,-89.62318,"Yucatán","city"],
  [1862415,"Hiroshima","JP",34.4,132.45,"Hiroshima","city"],
  [1518980,"Shymkent","KZ",42.30988,69.60042,"Shymkent","city"],
  [3492914,"Santiago de los Caballeros","DO",19.45036,-70.69085,"Santiago Province","city"],
  [1791636,"Weinan","CN",34.50355,109.50891,"Shaanxi","city"],
  [1271308,"Ghāziābād","IN",28.66535,77.43915,"Uttar Pradesh","city"],
  [1039854,"Matola","MZ",-25.96222,32.45889,"Maputo Province","city"],
  [1272979,"Dhanbad","IN",23.79759,86.42992,"Jharkhand","city"],
  [3947322,"Arequipa","PE",-16.39899,-71.53747,"Arequipa","city"],
  [12747064,"Hong Kong Island","HK",22.26302,114.18419,"","city"],
  [2548885,"Fes","MA",34.03313,-5.00028,"Fes-Meknes","city"],
  [3514674,"Gustavo Adolfo Madero","MX",19.49392,-99.11075,"Mexico City","city"],
  [212730,"Kisangani","CD",0.51528,25.19099,"Tshopo","city"],
  [1805953,"Jiaxing","CN",30.7522,120.75,"Zhejiang","city"],
  [1278149,"Aurangabad","IN",19.87757,75.34226,"Maharashtra","city"],
  [1784285,"Zhongwei","CN",37.51129,105.19067,"Ningxia","city"],
  [1496153,"Omsk","RU",54.99244,73.36859,"Omsk Oblast","city"],
  [2246678,"Pikine","SN",14.76457,-17.39071,"Dakar","city"],
  [3461786,"Guarulhos","BR",-23.46278,-46.53333,"São Paulo","city"],
  [1631761,"Pekanbaru","ID",0.51667,101.44167,"Riau","city"],
  [10794003,"Panjin","CN",41.121,122.0739,"Liaoning","city"],
  [1624917,"Bandar Lampung","ID",-5.42917,105.26111,"Lampung","city"],
  [1253405,"Varanasi","IN",25.31668,83.01041,"Uttar Pradesh","city"],
  [1805179,"Jiujiang","CN",29.70475,116.00206,"Jiangxi","city"],
  [499099,"Samara","RU",53.20767,50.13553,"Samara Oblast","city"],
  [2353151,"Aba","NG",5.10658,7.36667,"Abia State","city"],
  [1278710,"Amritsar","IN",31.62234,74.87534,"Punjab","city"],
  [2655603,"Birmingham","GB",52.48142,-1.89983,"England","city"],
  [1785294,"Anyang","CN",36.096,114.38278,"Henan","city"],
  [13405906,"Luohu District","CN",22.54721,114.13149,"Guangdong","city"],
  [1253184,"Vijayawada","IN",16.50745,80.6466,"Andhra Pradesh","city"],
  [13608002,"Fengxiang","CN",30.85841,121.46779,"Shanghai","city"],
  [1816373,"Bijie","CN",27.30193,105.28627,"Guizhou","city"],
  [3995465,"Monterrey","MX",25.68435,-100.31721,"Nuevo León","city"],
  [501175,"Rostov-on-Don","RU",47.21997,39.70769,"Rostov","city"],
  [1783763,"Zhuzhou","CN",27.83333,113.15,"Hunan","city"],
  [1978681,"Malingao","PH",7.16083,124.475,"Soccsksargen","city"],
  [2244322,"Touba","SN",14.86229,-15.87532,"Diourbel Region","city"],
  [479561,"Ufa","RU",54.74306,55.96779,"Bashkortostan Republic","city"],
  [1258526,"Ranchi","IN",23.34316,85.3094,"Jharkhand","city"],
  [1787858,"Shangrao","CN",28.45179,117.94287,"Jiangxi","city"],
  [1807700,"Huaibei","CN",33.97444,116.79167,"Anhui","city"],
  [2331447,"Maiduguri","NG",11.84692,13.15712,"Borno State","city"],
  [1787957,"Xuhui","CN",31.19594,121.44709,"Shanghai","city"],
  [1800818,"Meishan","CN",30.04392,103.83696,"Sichuan","city"],
  [152224,"Mwanza","TZ",-2.51667,32.9,"Mwanza","city"],
  [1833747,"Ulsan","KR",35.53722,129.31667,"Ulsan","city"],
  [2111149,"Sendai","JP",38.26667,140.86667,"Miyagi","city"],
  [1502026,"Krasnoyarsk","RU",56.03742,92.93136,"Krasnoyarsk Krai","city"],
  [1810820,"Fuzhou","CN",27.95999,116.33333,"Jiangxi","city"],
  [1809532,"Guigang","CN",23.11603,109.59472,"Guangxi","city"],
  [1269633,"Jabalpur","IN",23.16697,79.95006,"Madhya Pradesh","city"],
  [2337639,"Ilorin","NG",8.49664,4.54214,"Kwara State","city"],
  [415189,"Aden","YE",12.77957,45.03852,"Aden","city"],
  [1648473,"Bogor","ID",-6.59444,106.78917,"West Java","city"],
  [3530589,"Ciudad Nezahualcoyotl","MX",19.40061,-99.01483,"México","city"],
  [1808370,"Hengyang","CN",26.88946,112.61888,"Hunan","city"],
  [1278994,"Prayagraj","IN",25.44478,81.84322,"Uttar Pradesh","city"],
  [3691175,"Trujillo","PE",-8.11599,-79.02998,"La Libertad","city"],
  [1253102,"Visakhapatnam","IN",17.68009,83.20161,"Andhra Pradesh","city"],
  [1842485,"Goyang-si","KR",37.65639,126.835,"Gyeonggi-do","city"],
  [1785781,"Yulin","CN",22.6305,110.14686,"Guangxi","city"],
  [1268865,"Jodhpur","IN",26.26841,73.00594,"Rajasthan","city"],
  [1270583,"Gwalior","IN",26.22983,78.17337,"Madhya Pradesh","city"],
  [1805540,"Jingzhou","CN",30.35028,112.19028,"Hubei","city"],
  [964420,"Gqeberha","ZA",-33.96109,25.61494,"Eastern Cape","city"],
  [472045,"Voronezh","RU",51.66833,39.19204,"Voronezh Oblast","city"],
  [1788572,"Xinxiang","CN",35.19033,113.80151,"Henan","city"],
  [1786746,"Yichun","CN",27.83333,114.4,"Jiangxi","city"],
  [2322911,"Sokoto","NG",13.06269,5.24322,"Sokoto","city"],
  [2335953,"Jos","NG",9.92849,8.89212,"Plateau State","city"],
  [2530335,"Tangier","MA",35.76727,-5.79975,"Tanger-Tetouan-Al Hoceima","city"],
  [1254745,"Teni","IN",10.01115,77.47772,"Tamil Nadu","city"],
  [1790353,"Xianyang","CN",34.33778,108.70261,"Shaanxi","city"],
  [3996069,"Mexicali","MX",32.62781,-115.45446,"Baja California","city"],
  [2255414,"Pointe-Noire","CG",-4.77609,11.86352,"Pointe-Noire","city"],
  [3395981,"Maceió","BR",-9.66583,-35.73528,"Alagoas","city"],
  [3467865,"Campinas","BR",-22.90556,-47.06083,"São Paulo","city"],
  [1796556,"Sanya","CN",18.25435,109.50947,"Hainan","city"],
  [1185188,"Rangpur","BD",25.74664,89.25166,"Rangpur Division","city"],
  [94787,"Kirkuk","IQ",35.46806,44.39222,"Kirkuk","city"],
  [1795874,"Shaoguan","CN",24.8,113.58333,"Guangdong","city"],
  [1270396,"Howrah","IN",22.57688,88.31857,"West Bengal","city"],
  [1258980,"Raipur","IN",21.23333,81.63333,"Chhattisgarh","city"],
  [1846326,"Changwon","KR",35.22806,128.68111,"Gyeongsangnam-do","city"],
  [1802276,"Longyan","CN",25.07485,117.01775,"Fujian","city"],
  [2886242,"Köln","DE",50.93333,6.95,"North Rhine-Westphalia","city"],
  [1254388,"Tiruchirappalli","IN",10.8155,78.69651,"Tamil Nadu","city"],
  [1786217,"Yongzhou","CN",26.42389,111.61306,"Hunan","city"],
  [1679432,"Zamboanga","PH",6.91028,122.07389,"Zamboanga Peninsula","city"],
  [1806535,"Huzhou","CN",30.8703,120.0933,"Zhejiang","city"],
  [472757,"Volgograd","RU",48.71378,44.4976,"Volgograd Oblast","city"],
  [379251,"Khartoum North","SD",15.64925,32.53458,"Khartoum","city"],
  [5946768,"Edmonton","CA",53.55014,-113.46871,"Alberta","city"],
  [698740,"Odesa","UA",46.48572,30.74383,"Odesa","city"],
  [1803936,"Wuwei","CN",37.92672,102.63202,"Gansu","city"],
  [4160021,"Jacksonville","US",30.33218,-81.65565,"Florida","city"],
  [4691930,"Fort Worth","US",32.72541,-97.32085,"Texas","city"],
  [1808857,"Hanzhong","CN",33.07507,107.02214,"Shaanxi","city"],
  [7576887,"Hezhou","CN",24.40357,111.56675,"Guangxi","city"],
  [3046446,"Pest","HU",47.5,19.08333,"Budapest","city"],
  [1266049,"Kota","IN",25.18254,75.83907,"Rajasthan","city"],
  [6943660,"Shivaji Nagar","IN",18.53017,73.85263,"Maharashtra","city"],
  [7602670,"Zhu Cheng City","CN",35.99502,119.40259,"Shandong","city"],
  [1812101,"Dongying","CN",37.46271,118.49165,"Shandong","city"],
  [1801640,"Luzhou","CN",28.8903,105.42575,"Sichuan","city"],
  [5392171,"San Jose","US",37.33939,-121.89496,"California","city"],
  [1256436,"Sholapur","IN",17.67152,75.91044,"Maharashtra","city"],
  [2542997,"Marrakesh","MA",31.63416,-7.99994,"Marrakesh-Safi","city"],
  [1800779,"Meizhou","CN",24.28859,116.11768,"Guangdong","city"],
  [1927639,"Yueyang","CN",29.37455,113.09481,"Hunan","city"],
  [1804591,"Laiwu","CN",36.19278,117.65694,"Shandong","city"],
  [2038300,"Benxi","CN",41.28861,123.765,"Liaoning","city"],
  [747323,"Esenyurt","TR",41.02697,28.67732,"Istanbul","city"],
  [511196,"Perm","RU",58.01046,56.25017,"Perm Krai","city"],
  [2317765,"Zaria","NG",11.11128,7.7227,"Kaduna State","city"],
  [7033318,"Kennedy","CO",4.6165,-74.14597,"Bogota D.C.","city"],
  [2113015,"Chiba","JP",35.6,140.11667,"Chiba","city"],
  [1798827,"Pingdingshan","CN",33.73091,113.31554,"Henan","city"],
  [3645528,"Ciudad Guayana","VE",8.35122,-62.64102,"Bolívar","city"],
  [1166000,"Sargodha","PK",32.08586,72.67418,"Punjab","city"],
  [4671654,"Austin","US",30.26715,-97.74306,"Texas","city"],
  [1816440,"Bengbu","CN",32.94083,117.36083,"Anhui","city"],
  [2537763,"Salé","MA",34.0531,-6.79846,"Rabat-Salé-Kénitra","city"],
  [281184,"Jerusalem","IL",31.76904,35.21633,"Jerusalem","city"],
  [1274746,"Chandigarh","IN",30.73629,76.7884,"Chandigarh","city"],
  [709930,"Dnipro","UA",48.46664,35.04066,"Dnipropetrovsk","city"],
  [1717512,"Cebu City","PH",10.31672,123.89071,"Central Visayas","city"],
  [1796823,"Sanhe","CN",39.98049,117.06887,"Hebei","city"],
  [1254348,"Tiruppur","IN",11.11541,77.35456,"Tamil Nadu","city"],
  [1271476,"Guwahati","IN",26.1844,91.7458,"Assam","city"],
  [1790492,"Xiangtan","CN",27.85,112.9,"Hunan","city"],
  [1803567,"Linfen","CN",36.08889,111.51889,"Shanxi","city"],
  [1931681,"Victoria","HK",22.2875,114.14417,"Central and Western","city"],
  [1784642,"Zhenjiang","CN",32.21086,119.45508,"Jiangsu","city"],
  [2343279,"Enugu","NG",6.44132,7.49883,"Enugu State","city"],
  [3838583,"Rosario","AR",-32.94682,-60.63932,"Santa Fe","city"],
  [101760,"Sulţānah","SA",24.49258,39.58572,"Medina Region","city"],
  [2036662,"Huludao","CN",40.75243,120.83552,"Liaoning","city"],
  [1269920,"Hubballi","IN",15.34776,75.13378,"Karnataka","city"],
  [1633419,"Padang","ID",-0.94924,100.35427,"West Sumatra","city"],
  [1859307,"Kitakyushu","JP",33.85181,130.85034,"Fukuoka","city"],
  [70225,"Taiz","YE",13.57952,44.02091,"Ta‘izz","city"],
  [11790342,"Setagaya","JP",35.64188,139.64715,"Tokyo","city"],
  [1805701,"Jing’an","CN",31.22,121.41583,"Shanghai","city"],
  [1281673,"Baoshan","CN",25.11626,99.16366,"Yunnan","city"],
  [1797063,"Rui’an","CN",27.77605,120.65859,"Zhejiang","city"],
  [4014338,"Chihuahua","MX",28.63528,-106.08889,"Chihuahua","city"],
  [315202,"Eskişehir","TR",39.77667,30.52056,"Eskişehir","city"],
  [1262321,"Mysuru","IN",12.29791,76.63925,"Karnataka","city"],
  [1257629,"Salem","IN",11.65376,78.15538,"Tamil Nadu","city"],
  [3388368,"São Luís","BR",-2.52972,-44.30278,"Maranhão","city"],
  [1897000,"Seongnam-si","KR",37.43861,127.13778,"Gyeonggi-do","city"],
  [3687238,"Cartagena","CO",10.39817,-75.49328,"Bolívar","city"],
  [1730501,"Antipolo","PH",14.62578,121.12251,"Calabarzon","city"],
  [4509177,"Columbus","US",39.96118,-82.99879,"Ohio","city"],
  [1164909,"Sialkot","PK",32.49268,74.53134,"Punjab","city"],
  [4460243,"Charlotte","US",35.22709,-80.84313,"North Carolina","city"],
  [1804609,"Laibin","CN",23.74743,109.22222,"Guangxi","city"],
  [2319133,"Warri","NG",5.51737,5.75006,"Delta","city"],
  [3172394,"Naples","IT",40.85216,14.26811,"Campania","city"],
  [1790254,"Xiaogan","CN",30.92689,113.92221,"Hubei","city"],
  [3467747,"Campo Grande","BR",-20.44278,-54.64639,"Mato Grosso do Sul","city"],
  [1783683,"Ziyang","CN",30.12108,104.64811,"Sichuan","city"],
  [2362344,"Bobo-Dioulasso","BF",11.18064,-4.29489,"Hauts-Bassins","city"],
  [1183880,"Bahawalpur","PK",29.39779,71.6752,"Punjab","city"],
  [1797264,"Quzhou","CN",28.95944,118.86861,"Zhejiang","city"],
  [931755,"Blantyre","MW",-15.78499,35.00854,"Southern Region","city"],
  [709717,"Donetsk","UA",48.023,37.80224,"Donetsk","city"],
  [100077,"Abū Ghurayb","IQ",33.30563,44.18477,"Baghdad","city"],
  [119208,"Qom","IR",34.6401,50.8764,"Qom Province","city"],
  [1785453,"Zaozhuang","CN",34.86472,117.55417,"Shandong","city"],
  [542420,"Krasnodar","RU",45.04534,38.98178,"Krasnodar Krai","city"],
  [3394023,"Natal","BR",-5.795,-35.20944,"Rio Grande do Norte","city"],
  [1798654,"Pingxiang","CN",27.61672,113.85353,"Jiangxi","city"],
  [1636722,"Malang","ID",-7.9797,112.6304,"East Java","city"],
  [3531673,"Cancún","MX",21.17429,-86.84656,"Quintana Roo","city"],
  [4259418,"Indianapolis","US",39.76838,-86.15804,"Indiana","city"],
  [1270642,"Gurugram","IN",28.4601,77.02635,"Haryana","city"],
  [1275817,"Bhubaneswar","IN",20.27241,85.83385,"Odisha","city"],
  [1886762,"Zhoushan","CN",29.98869,122.20488,"Zhejiang","city"],
  [2035265,"Qiqihar","CN",47.33922,123.96154,"Heilongjiang","city"],
  [8307074,"Mulenvos","AO",-8.86695,13.3344,"Luanda","city"],
  [98463,"Sulaymaniyah","IQ",35.56496,45.4329,"Sulaymaniyah","city"],
  [2995469,"Marseille","FR",43.29695,5.38107,"Provence-Alpes-Côte d'Azur","city"],
  [1802940,"Puning","CN",23.31072,116.16869,"Guangdong","city"],
  [1275901,"Bhiwandi","IN",19.30023,73.05881,"Maharashtra","city"],
  [954013,"Soshanguve","ZA",-25.47288,28.09919,"Gauteng","city"],
  [3386496,"Teresina","BR",-5.08917,-42.80194,"Piauí","city"],
  [1789065,"Ankang","CN",32.68,109.01722,"Shaanxi","city"],
  [1268782,"Jalandhar","IN",31.32556,75.57917,"Punjab","city"],
  [2747891,"Rotterdam","NL",51.9225,4.47917,"South Holland","city"],
  [1804540,"Langfang","CN",39.52079,116.71471,"Hebei","city"],
  [2236500,"Viana","AO",-8.90553,13.37499,"Luanda","city"],
  [1805987,"Jiaozuo","CN",35.23925,113.23914,"Henan","city"],
  [1629001,"Samarinda","ID",-0.49167,117.14583,"East Kalimantan","city"],
  [12069922,"Rohini","IN",28.74322,77.06778,"Delhi","city"],
  [1791748,"Wanxian","CN",30.81601,108.37407,"Chongqing","city"],
  [1799194,"Guang’an","CN",30.47413,106.63696,"Sichuan","city"],
  [1732752,"Johor Bahru","MY",1.4655,103.7578,"Johor","city"],
  [1184370,"Arifwala","PK",30.29058,73.06574,"Punjab","city"],
  [7290466,"Pasig City","PH",14.58691,121.0614,"National Capital Region","city"],
  [1845604,"Cheongju-si","KR",36.63722,127.48972,"North Chungcheong","city"],
  [12501153,"Kanayannur","IN",9.96667,76.26667,"Kerala","city"],
  [1838716,"Bucheon-si","KR",37.49889,126.78306,"Gyeonggi-do","city"],
  [1566166,"Thanh Hóa","VN",19.8,105.76667,"Thanh Hóa Province","city"],
  [3165524,"Turin","IT",45.07049,7.68682,"Piedmont","city"],
  [292913,"Al Ain City","AE",24.19167,55.76056,"Abu Dhabi","city"],
  [498677,"Saratov","RU",51.54048,45.9901,"Saratov Oblast","city"],
  [1791673,"Weihai","CN",37.50914,122.11356,"Shandong","city"],
  [1821940,"Takeo","KH",10.99081,104.78498,"Takeo","city"],
  [3919968,"Cochabamba","BO",-17.38195,-66.15995,"Cochabamba","city"],
  [144448,"Ahvaz","IR",31.31901,48.6842,"Khuzestan","city"],
  [1785412,"Zhabei","CN",31.25861,121.45972,"Shanghai","city"],
  [1788508,"Xinyu","CN",27.80429,114.93335,"Jiangxi","city"],
  [965301,"Pietermaritzburg","ZA",-29.61679,30.39278,"KwaZulu-Natal","city"],
  [1786770,"Yibin","CN",28.7593,104.63994,"Sichuan","city"],
  [3522790,"Naucalpan de Juárez","MX",19.47851,-99.23963,"México","city"],
  [1771023,"Kampung Baru Subang","MY",3.15,101.53333,"Selangor","city"],
  [2290956,"Bouaké","CI",7.69385,-5.03031,"Vallée du Bandama District","city"],
  [1793703,"Taicang","CN",31.44778,121.09389,"Jiangsu","city"],
  [5391959,"San Francisco","US",37.77493,-122.41942,"California","city"],
  [1853195,"Sakai","JP",34.58216,135.46653,"Osaka","city"],
  [2509954,"Valencia","ES",39.47391,-0.37966,"Valencia","city"],
  [3456160,"Nova Iguaçu","BR",-22.75917,-43.45111,"Rio de Janeiro","city"],
  [13608000,"Jinshan","CN",30.83556,121.29373,"Shanghai","city"],
  [1815059,"Chenzhou","CN",25.8,113.03333,"Hunan","city"],
  [3464374,"Duque de Caxias","BR",-22.78556,-43.31167,"Rio de Janeiro","city"],
  [3397277,"João Pessoa","BR",-7.115,-34.86306,"Paraíba","city"],
  [217831,"Bukavu","CD",-2.49077,28.84281,"South Kivu","city"],
  [3094802,"Kraków","PL",50.06143,19.93658,"Lesser Poland","city"],
  [3648559,"Barcelona","VE",10.1384,-64.68769,"Anzoátegui","city"],
  [4004898,"Hermosillo","MX",29.08874,-110.96677,"Sonora","city"],
  [1276014,"Bhayandar","IN",19.30157,72.85107,"Maharashtra","city"],
  [4012176,"Culiacán","MX",24.80209,-107.39421,"Sinaloa","city"],
  [1735158,"Petaling Jaya","MY",3.10726,101.60671,"Selangor","city"],
  [1817993,"Anqing","CN",30.51365,117.04723,"Anhui","city"],
  [2485926,"Oran","DZ",35.69906,-0.63588,"Oran","city"],
  [3601782,"San Pedro Sula","HN",15.50585,-88.02588,"Cortés Department","city"],
  [1261809,"Narela","IN",28.85267,77.09288,"Delhi","city"],
  [1788927,"Xingtai","CN",37.06217,114.49272,"Hebei","city"],
  [1855431,"Niigata","JP",37.92259,139.04125,"Niigata","city"],
  [250090,"Zarqa","JO",32.07275,36.08796,"Zarqa","city"],
  [6955677,"Çankaya","TR",39.9179,32.86268,"Ankara","city"],
  [742394,"Küçükçekmece","TR",40.99104,28.77123,"Istanbul","city"],
  [1863289,"Hamamatsu","JP",34.7,137.73333,"Shizuoka","city"],
  [922773,"Kolwezi","CD",-10.71484,25.46674,"Lualaba","city"],
  [1562798,"Vinh","VN",18.67337,105.69232,"Nghệ An Province","city"],
  [1254163,"Thiruvananthapuram","IN",8.4855,76.94924,"Kerala","city"],
  [1784841,"Zhaotong","CN",27.31667,103.71667,"Yunnan","city"],
  [6929460,"Panzhihua","CN",26.58509,101.71276,"Sichuan","city"],
  [1814757,"Chuzhou","CN",32.32194,118.29778,"Anhui","city"],
  [5809844,"Seattle","US",47.60621,-122.33207,"Washington","city"],
  [358619,"Port Said","EG",31.26531,32.3019,"Port Said","city"],
  [3685533,"Cúcuta","CO",7.90745,-72.5049,"Norte de Santander Department","city"],
  [169577,"Homs","SY",34.72405,36.72559,"Homs","city"],
  [1788081,"Xuancheng","CN",30.9525,118.75528,"Anhui","city"],
  [74477,"Ibb","YE",13.96667,44.18333,"Ibb Governorate","city"],
  [1624647,"Tasikmalaya","ID",-7.3274,108.2207,"West Java","city"],
  [1033356,"Nampula","MZ",-15.11646,39.2666,"Nampula","city"],
  [1817720,"Shangyu","CN",30.01556,120.87111,"Zhejiang","city"],
  [425378,"Bujumbura","BI",-3.38193,29.36142,"Bujumbura Mairie","city"],
  [1488754,"Tyumen","RU",57.15222,65.52722,"Tyumen Oblast","city"],
  [315368,"Erzurum","TR",39.90861,41.27694,"Erzurum","city"],
  [1817968,"Anshun","CN",26.25,105.93333,"Guizhou","city"],
  [1185128,"Rajshahi","BD",24.374,88.60114,"Rajshahi Division","city"],
  [1180281,"Dera Ismail Khan","PK",31.83129,70.9017,"Khyber Pakhtunkhwa","city"],
  [1790840,"Wuzhou","CN",23.48054,111.28848,"Guangxi","city"],
  [1734634,"Ipoh","MY",4.5841,101.0829,"Perak","city"],
  [1797595,"Qinhuangdao","CN",39.94104,119.58936,"Hebei","city"],
  [88319,"Benghazi","LY",32.11486,20.06859,"Banghazi","city"],
  [1279017,"Alīgarh","IN",27.88145,78.07464,"Uttar Pradesh","city"],
  [1816920,"Shaoyang","CN",27.23818,111.46214,"Hunan","city"],
  [304922,"Malatya","TR",38.35018,38.31667,"Malatya","city"],
  [6183235,"Winnipeg","CA",49.8844,-97.14704,"Manitoba","city"],
  [8469289,"Ōta","JP",35.56126,139.71605,"Tokyo","city"],
  [1514588,"Andijon","UZ",40.78338,72.35067,"Andijan Region","city"],
  [1277013,"Bareilly","IN",28.36678,79.43167,"Uttar Pradesh","city"],
  [107304,"Buraydah","SA",26.32599,43.97497,"Al-Qassim Region","city"],
  [3449344,"São Bernardo do Campo","BR",-23.69389,-46.565,"São Paulo","city"],
  [2036986,"Hegang","CN",47.34727,130.29033,"Heilongjiang","city"],
  [3995402,"Morelia","MX",19.70078,-101.18443,"Michoacán","city"],
  [1721080,"Cagayan de Oro","PH",8.48222,124.64722,"Northern Mindanao","city"],
  [1801620,"Ma’anshan","CN",31.68579,118.51008,"Anhui","city"],
  [1732903,"Shah Alam","MY",3.08507,101.53281,"Selangor","city"],
  [751324,"Bağcılar","TR",41.03903,28.85671,"Istanbul","city"],
  [12324556,"Shizuishan","CN",38.98082,106.3892,"Ningxia","city"],
  [1858421,"Kumamoto","JP",32.80589,130.69181,"Kumamoto","city"],
  [2325200,"Oyo","NG",7.85367,3.93235,"Oyo State","city"],
  [1627549,"Serang","ID",-6.11528,106.15417,"Banten","city"],
  [3981254,"Torreón","MX",25.54389,-103.41898,"Coahuila","city"],
  [1812961,"Deyang","CN",31.13019,104.38198,"Sichuan","city"],
  [2352947,"Abeokuta","NG",7.15571,3.34509,"Ogun State","city"],
  [79415,"Al Ḩudaydah","YE",14.79781,42.95452,"Al Hudaydah","city"],
  [1787351,"Yangquan","CN",37.8575,113.56333,"Shanxi","city"],
  [2350841,"Akure","NG",7.25256,5.19312,"Ondo State","city"],
  [3448636,"São José dos Campos","BR",-23.17944,-45.88694,"São Paulo","city"],
  [5419384,"Denver","US",39.73915,-104.9847,"Colorado","city"],
  [3455775,"Osasco","BR",-23.5325,-46.79167,"São Paulo","city"],
  [7758790,"Kikolo","AO",-8.7815,13.33384,"Luanda","city"],
  [2239888,"Maianga","AO",-8.84693,13.23698,"Luanda","city"],
  [3514663,"Álvaro Obregón","MX",19.35867,-99.20329,"Mexico City","city"],
  [1865689,"Aihara","JP",35.6,139.31667,"Kanagawa","city"],
  [1004866,"Evaton","ZA",-26.53333,27.85,"Gauteng","city"],
  [1680102,"Valenzuela","PH",14.7,120.9667,"National Capital Region","city"],
  [1169607,"Muzaffarābād","PK",34.37002,73.47082,"Azad Kashmir","city"],
  [1854383,"Okayama","JP",34.65,133.93333,"Okayama","city"],
  [3985606,"San Luis Potosí","MX",22.15234,-100.97135,"San Luis Potosí","city"],
  [4019233,"Aguascalientes","MX",21.88262,-102.2843,"Aguascalientes","city"],
  [1713022,"General Santos","PH",6.11278,125.17167,"Soccsksargen","city"],
  [1783873,"Zhumadian","CN",32.98385,114.02586,"Henan","city"],
  [1262801,"Morādābād","IN",28.83893,78.77684,"Uttar Pradesh","city"],
  [11611609,"Sagamihara","JP",35.56707,139.24167,"Kanagawa","city"],
  [6075357,"Mississauga","CA",43.5789,-79.6583,"Ontario","city"],
  [702550,"Lviv","UA",49.83826,24.02324,"Lviv","city"],
  [1513157,"Namangan","UZ",40.9983,71.67257,"Namangan","city"],
  [3451328,"Ribeirão Preto","BR",-21.1775,-47.81028,"São Paulo","city"],
  [687700,"Zaporizhzhya","UA",47.85167,35.11714,"Zaporizhzhia","city"],
  [148730,"Zanzibar","TZ",-6.16394,39.19793,"Zanzibar Urban/West","city"],
  [3988086,"Saltillo","MX",25.42595,-100.97963,"Coahuila","city"],
  [173576,"Latakia","SY",35.53125,35.79088,"Latakia","city"],
  [8504423,"Subang Jaya","MY",3.04384,101.58062,"Selangor","city"],
  [1252948,"Warangal","IN",18,79.58333,"Telangana","city"],
  [1694781,"Paranaque City","PH",14.48156,121.01749,"National Capital Region","city"],
  [482283,"Tolyatti","RU",53.5303,49.3461,"Samara Oblast","city"],
  [7874116,"Santo Domingo Oeste","DO",18.5,-70,"Santo Domingo Province","city"],
  [1183105,"Battagram","PK",34.67719,73.02329,"Khyber Pakhtunkhwa","city"],
  [1272866,"Dhārāvi","IN",19.05,72.86667,"Maharashtra","city"],
  [8601412,"Santo Domingo Este","DO",18.48511,-69.84757,"Santo Domingo Province","city"],
  [359796,"Suez","EG",29.97371,32.52627,"Suez","city"],
  [1815463,"Changzhi","CN",35.20889,111.73861,"Shanxi","city"],
  [2561668,"Agadir","MA",30.42018,-9.59815,"Souss-Massa","city"],
  [11071717,"Edogawe","JP",35.69225,139.87308,"Tokyo","city"],
  [1650527,"Balikpapan","ID",-1.26753,116.82887,"East Kalimantan","city"],
  [10987897,"Adachi","JP",35.76318,139.80761,"Tokyo","city"],
  [1815611,"Changning","CN",31.21739,121.42105,"Shanghai","city"],
  [2347470,"Bauchi","NG",10.31032,9.84388,"Bauchi","city"],
  [1851717,"Shizuoka","JP",34.98333,138.38333,"Shizuoka","city"],
  [2033196,"Zhangjiakou","CN",40.78341,114.87139,"Hebei","city"],
  [4644585,"Nashville","US",36.16589,-86.78444,"Tennessee","city"],
  [2037346,"Fuxin","CN",42.01556,121.65889,"Liaoning","city"],
  [107968,"Ta’if","SA",21.27028,40.41583,"Mecca Region","city"],
  [1796989,"Changsha","CN",22.38124,112.68492,"Guangdong","city"],
  [1807234,"Huangshi","CN",30.24706,115.04814,"Hubei","city"],
  [2036113,"Liaoyang","CN",41.27194,123.17306,"Liaoning","city"],
  [8740157,"Hlaingthaya","MM",16.85,96.06667,"Yangon","city"],
  [1052373,"Beira","MZ",-19.84361,34.83889,"Sofala","city"],
  [1808090,"Hongkou","CN",31.25,121.48917,"Shanghai","city"],
  [3447399,"Sorocaba","BR",-23.50167,-47.45806,"São Paulo","city"],
  [3104324,"Zaragoza","ES",41.65606,-0.87734,"Aragon","city"],
  [2510911,"Sevilla","ES",37.38283,-5.97317,"Andalusia","city"],
  [1816269,"Baise","CN",23.89013,106.62684,"Guangxi","city"],
  [1630789,"Pontianak","ID",-0.03194,109.325,"West Kalimantan","city"],
  [1626801,"Situbondo","ID",-7.70623,114.00976,"East Java","city"],
  [2351943,"Agege","NG",6.61563,3.33337,"Lagos","city"],
  [1816336,"Binzhou","CN",37.36667,118.01667,"Shandong","city"],
  [4544349,"Oklahoma City","US",35.46756,-97.51643,"Oklahoma","city"],
  [1785738,"Yuncheng","CN",35.02306,110.99278,"Shanxi","city"],
  [1812955,"Dezhou","CN",37.44661,116.36706,"Shandong","city"],
  [2394819,"Cotonou","BJ",6.36536,2.41833,"Littoral","city"],
  [5520993,"El Paso","US",31.75872,-106.48693,"Texas","city"],
  [1270927,"Gorakhpur","IN",26.76628,83.36889,"Uttar Pradesh","city"],
  [4005492,"Guadalupe","MX",25.67663,-100.25907,"Nuevo León","city"],
  [3081368,"Wrocław","PL",51.10286,17.03006,"Lower Silesia","city"],
  [1645528,"Denpasar","ID",-8.65,115.21667,"Bali","city"],
  [1270668,"Guntur","IN",16.29974,80.45729,"Andhra Pradesh","city"],
  [2334802,"Katsina","NG",12.99082,7.60177,"Katsina State","city"],
  [1796669,"Sanmenxia","CN",34.78081,111.19287,"Henan","city"],
  [6642286,"E’zhou","CN",30.39607,114.88655,"Hubei","city"],
  [353225,"Madīnat an Naşr","EG",30.06667,31.3,"Cairo","city"],
  [2591957,"Camama","AO",-8.93611,13.26518,"Luanda","city"],
  [101628,"Tabuk","SA",28.3998,36.57151,"Tabuk Region","city"],
  [911148,"Kitwe","ZM",-12.80243,28.21323,"Copperbelt","city"],
  [894701,"Bulawayo","ZW",-20.15,28.58333,"Bulawayo","city"],
  [2035715,"Mudanjiang","CN",44.54804,129.62594,"Heilongjiang","city"],
  [3471872,"Aracaju","BR",-10.91111,-37.07167,"Sergipe","city"],
  [1804153,"Leshan","CN",29.56227,103.76386,"Sichuan","city"],
  [3449701,"Santo André","BR",-23.66389,-46.53833,"São Paulo","city"],
  [6173331,"Vancouver","CA",49.24966,-123.11934,"British Columbia","city"],
  [9072919,"Rizhao","CN",35.41414,119.52908,"Shandong","city"],
  [1845759,"Cheonan","KR",36.8065,127.1522,"Chungcheongnam-do","city"],
  [3533462,"Acapulco de Juárez","MX",16.84942,-99.90891,"Guerrero","city"],
  [1650213,"Banjarmasin","ID",-3.31987,114.59075,"South Kalimantan","city"],
  [1259425,"Puducherry","IN",11.93381,79.82979,"Puducherry","city"],
  [1793900,"Suining","CN",30.50802,105.57332,"Sichuan","city"],
  [5907364,"Brampton","CA",43.68341,-79.76633,"Ontario","city"],
  [2591953,"Golfe","AO",-8.86639,13.26173,"Luanda","city"],
  [9181182,"Puyang","CN",35.75641,115.04363,"Henan","city"],
  [3667905,"Soacha","CO",4.57937,-74.21682,"Cundinamarca","city"],
  [4930956,"Boston","US",42.35843,-71.05977,"Massachusetts","city"],
  [3515431,"Tlalnepantla","MX",19.54005,-99.19538,"México","city"],
  [10581114,"Jājmau","IN",26.4304,80.4095,"Uttar Pradesh","city"],
  [5746545,"Portland","US",45.52345,-122.67621,"Oregon","city"],
  [2242906,"Calumbo","AO",-9.14692,13.41936,"Bengo","city"],
  [3981461,"Tlaquepaque","MX",20.64121,-103.29342,"Jalisco","city"],
  [2925533,"Frankfurt am Main","DE",50.11552,8.68417,"Hesse","city"],
  [2523920,"Palermo","IT",38.1166,13.3636,"Sicily","city"],
  [554840,"Izhevsk","RU",56.85225,53.19862,"Udmurtiya Republic","city"],
  [3778045,"Maturín","VE",9.74569,-63.18323,"Monagas","city"],
  [1278718,"Amravati","IN",20.93333,77.75,"Maharashtra","city"],
  [4990729,"Detroit","US",42.33143,-83.04575,"Michigan","city"],
  [2325590,"Osogbo","NG",7.77104,4.55698,"Osun State","city"],
  [1863905,"Honchō","JP",35.70129,139.98648,"Chiba","city"],
  [1275665,"Bikaner","IN",28.01762,73.31495,"Rajasthan","city"],
  [6317344,"Jaboatão dos Guararapes","BR",-8.11278,-35.01472,"Pernambuco","city"],
  [13631351,"Hoji ya Henda","AO",-8.80523,13.2897,"Luanda","city"],
  [5506956,"Las Vegas","US",36.17497,-115.13722,"Nevada","city"],
  [4645421,"New South Memphis","US",35.08676,-90.05676,"Tennessee","city"],
  [1843847,"Hwaseong-si","KR",37.20682,126.8169,"Gyeonggi-do","city"],
  [2165087,"Gold Coast","AU",-28.00029,153.43088,"Queensland","city"],
  [3093133,"Łódź","PL",51.77058,19.47395,"Łódź Voivodeship","city"],
  [1845457,"Jeonju","KR",35.82194,127.14889,"Jeollabuk-do","city"],
  [13608003,"Chongming","CN",31.61852,121.69621,"","city"],
  [285839,"Al Aḩmadī","KW",29.07694,48.08389,"Al Aḩmadī","city"],
  [3658666,"Cuenca","EC",-2.8953,-78.9963,"Azuay","city"],
  [922741,"Likasi","CD",-10.98303,26.7384,"Haut-Katanga","city"],
  [1642858,"Jambi City","ID",-1.6,103.61667,"Jambi","city"],
  [1808770,"Hebi","CN",35.73231,114.28616,"Henan","city"],
  [1185186,"Comilla","BD",23.46186,91.18503,"Chittagong","city"],
  [204953,"Tshikapa","CD",-6.41621,20.79995,"Kasai","city"],
  [1180942,"Chunian","PK",30.96621,73.97908,"Punjab","city"],
  [1273874,"Kochi","IN",9.93988,76.26022,"Kerala","city"],
  [4641239,"Memphis","US",35.14953,-90.04898,"Tennessee","city"],
  [1805611,"Jingmen","CN",31.03361,112.20472,"Hubei","city"],
  [1510853,"Barnaul","RU",53.36199,83.72786,"Altai Krai","city"],
  [2037886,"Dandong","CN",40.12917,124.39472,"Liaoning","city"],
  [3693528,"Piura","PE",-5.18192,-80.65715,"Piura","city"],
  [1275971,"Bhilai","IN",21.20919,81.4285,"Chhattisgarh","city"],
  [901344,"Ndola","ZM",-12.95867,28.63659,"Copperbelt","city"],
  [3465624,"Contagem","BR",-19.93167,-44.05361,"Minas Gerais","city"],
  [479123,"Ulyanovsk","RU",54.32824,48.38657,"Ulyanovsk","city"],
  [2648579,"Glasgow","GB",55.86515,-4.25763,"Scotland","city"],
  [2035513,"Panshan","CN",41.18806,122.04944,"Liaoning","city"],
  [4299276,"Louisville","US",38.25424,-85.75941,"Kentucky","city"],
  [2023469,"Irkutsk","RU",52.29566,104.29076,"Irkutsk Oblast","city"],
  [1846918,"Ansan-si","KR",37.32361,126.82194,"Gyeonggi-do","city"],
  [360761,"Al Mansurah","EG",31.03637,31.38069,"Dakahlia","city"],
  [128226,"Kermanshah","IR",34.31417,47.065,"Kermanshah Province","city"],
  [3463478,"Feira de Santana","BR",-12.26667,-38.96667,"Bahia","city"],
  [1806096,"Jiaozhou","CN",36.28389,120.00333,"Shandong","city"],
  [2934246,"Düsseldorf","DE",51.22319,6.77927,"North Rhine-Westphalia","city"],
  [1793879,"Suizhou","CN",31.71111,113.36306,"Hubei","city"],
  [3587902,"Villa Nueva","GT",14.52512,-90.58544,"Guatemala","city"],
  [2022890,"Khabarovsk","RU",48.46204,135.0971,"Khabarovsk","city"],
  [3465038,"Cuiabá","BR",-15.59611,-56.09667,"Mato Grosso","city"],
  [161325,"Arusha","TZ",-3.36667,36.68333,"Arusha","city"],
  [1707174,"Las Piñas","PH",14.45056,120.98278,"National Capital Region","city"],
  [1814934,"Chizhou","CN",30.66134,117.47783,"Anhui","city"],
  [3530139,"Coyoacán","MX",19.3467,-99.16174,"Mexico City","city"],
  [2825297,"Stuttgart","DE",48.78232,9.17702,"Baden-Wurttemberg","city"],
  [1787816,"Ya'an","CN",29.98521,102.999,"Sichuan","city"],
  [1273780,"Cuttack","IN",20.46497,85.87927,"Odisha","city"],
  [1275248,"Borivli","IN",19.23496,72.85976,"Maharashtra","city"],
  [3698350,"Chiclayo","PE",-6.77008,-79.85495,"Lambayeque","city"],
  [468902,"Yaroslavl","RU",57.62987,39.87368,"Yaroslavl Oblast","city"],
  [2711537,"Gothenburg","SE",57.70716,11.96679,"Västra Götaland","city"],
  [1859730,"Kawaguchi","JP",35.80521,139.71072,"Saitama","city"],
  [13118225,"Bukit Rahman Putra","MY",3.21727,101.5608,"Selangor","city"],
  [1175892,"Jhang Sadr","PK",31.26981,72.31687,"Punjab","city"],
  [106281,"Ha'il","SA",27.52188,41.69073,"Ha'il Region","city"],
  [1276032,"Bhavnagar","IN",21.76287,72.15331,"Gujarat","city"],
  [1020098,"Benoni","ZA",-26.18848,28.32078,"Gauteng","city"],
  [2013348,"Vladivostok","RU",43.10562,131.87353,"Primorye","city"],
  [2036427,"Jinzhou","CN",41.10778,121.14167,"Liaoning","city"],
  [3515001,"Tuxtla","MX",16.75357,-93.11578,"Chiapas","city"],
  [703845,"Kryvyy Rih","UA",47.90572,33.39404,"Dnipropetrovsk","city"],
  [1796663,"Sanming","CN",26.24861,117.61861,"Fujian","city"],
  [1257416,"Sāngli","IN",16.85438,74.56417,"Maharashtra","city"],
  [1269317,"Jamnagar","IN",22.47292,70.06673,"Gujarat","city"],
  [3347762,"Lubango","AO",-14.91717,13.4925,"Huíla","city"],
  [1282898,"Pokhara","NP",28.26689,83.96851,"Gandaki Pradesh","city"],
  [2034786,"Shuangyashan","CN",46.67686,131.13273,"Heilongjiang","city"],
  [64021,"Borama","SO",9.93611,43.18278,"Awdal","city"],
  [7696679,"Pallabi","BD",23.825,90.37,"Dhaka Division","city"],
  [1802204,"Luancheng","CN",37.88452,114.64629,"Hebei","city"],
  [532096,"Makhachkala","RU",42.97782,47.50027,"Dagestan","city"],
  [1846898,"Anyang-si","KR",37.3925,126.92694,"Gyeonggi-do","city"],
  [3348313,"Huambo","AO",-12.77611,15.73917,"Huambo","city"],
  [1216265,"Samarkand","UZ",39.65456,66.96445,"Samarqand Region","city"],
  [13512502,"Mengzi","CN",23.36779,103.38212,"Yunnan","city"],
  [1860827,"Kagoshima","JP",31.56667,130.55,"Kagoshima","city"],
  [78754,"Mukalla","YE",14.54248,49.12424,"Muhafazat Hadramaout","city"],
  [118743,"Rasht","IR",37.27611,49.58862,"Gilan Province","city"],
  [3430863,"Mar del Plata","AR",-38.00042,-57.5562,"Buenos Aires","city"],
  [2928810,"Essen","DE",51.45657,7.01228,"North Rhine-Westphalia","city"],
  [360829,"Al Maḩallah al Kubrá","EG",30.97063,31.1669,"Gharbia","city"],
  [2514256,"Málaga","ES",36.72016,-4.42034,"Andalusia","city"],
  [1165221,"Shekhupura","PK",31.71287,73.98556,"Punjab","city"],
  [2033370,"Yingkou","CN",40.66472,122.23176,"Liaoning","city"],
  [1785018,"Zhangzhou","CN",24.51333,117.65556,"Fujian","city"],
  [3520339,"Reynosa","MX",26.08005,-98.28456,"Tamaulipas","city"],
  [12382296,"Thuận An","VN",10.9239,106.71428,"Ho Chi Minh City (HCMC)","city"],
  [2935517,"Dortmund","DE",51.51494,7.466,"North Rhine-Westphalia","city"],
  [11836117,"Suginami","JP",36.2013,140.28406,"Ibaraki","city"],
  [3458449,"Londrina","BR",-23.31028,-51.16278,"Paraná","city"],
  [4347778,"Baltimore","US",39.29038,-76.61219,"Maryland","city"],
  [1861321,"Itabashi","JP",35.74893,139.71497,"Tokyo","city"],
  [3489297,"New Kingston","JM",18.00747,-76.78319,"Saint Andrew Parish","city"],
  [1732747,"Pelentong","MY",1.5243,103.824,"Johor","city"],
  [1646448,"Cimahi","ID",-6.87222,107.5425,"West Java","city"],
  [3688465,"Bucaramanga","CO",7.125,-73.11895,"Santander Department","city"],
  [3176219,"Genoa","IT",44.40478,8.94439,"Liguria","city"],
  [1863440,"Hachiōji","JP",35.65583,139.32389,"Tokyo","city"],
  [1572151,"Nha Trang","VN",12.24507,109.19432,"Khanh Hoa","city"],
  [1734759,"Malacca","MY",2.196,102.2405,"Melaka","city"],
  [128234,"Kerman","IR",30.28321,57.07879,"Kerman","city"],
  [121801,"Orūmīyeh","IR",37.55274,45.07605,"West Azerbaijan","city"],
  [7627067,"Bahçelievler","TR",41.00231,28.8598,"Istanbul","city"],
  [347497,"Tanta","EG",30.78847,31.00192,"Gharbia","city"],
  [1269321,"Jammu","IN",32.73528,74.86167,"Jammu and Kashmir","city"],
  [10063567,"Iskandar Puteri","MY",1.39324,103.62322,"Johor","city"],
  [1720681,"Calamba","PH",14.21167,121.16528,"Calabarzon","city"],
  [3515428,"Tlalpan","MX",19.29513,-99.16206,"Mexico City","city"],
  [1140026,"Herāt","AF",34.34817,62.19967,"Herat","city"],
  [1177654,"Gujrat","PK",32.5742,74.07542,"Punjab","city"],
  [1489425,"Tomsk","RU",56.50049,84.98216,"Tomsk Oblast","city"],
  [3459505,"Juiz de Fora","BR",-21.76417,-43.35028,"Minas Gerais","city"],
  [738377,"Umraniye","TR",41.01643,29.12476,"Istanbul","city"],
  [1529195,"Shihezi","CN",44.3023,86.03694,"Xinjiang","city"],
  [4951305,"South Boston","US",42.33343,-71.04949,"Massachusetts","city"],
  [184622,"Nakuru","KE",-0.30719,36.07225,"Nakuru County","city"],
  [5969782,"Hamilton","CA",43.25011,-79.84963,"Ontario","city"],
  [248946,"Irbid","JO",32.55556,35.85,"Irbid","city"],
  [2643123,"Manchester","GB",53.48095,-2.23743,"England","city"],
  [1736376,"Kota Bharu","MY",6.12361,102.24333,"Kelantan","city"],
  [6159905,"Surrey","CA",49.10635,-122.82509,"British Columbia","city"],
  [2542715,"Meknes","MA",33.89352,-5.54727,"Fes-Meknes","city"],
  [3875024,"Puente Alto","CL",-33.61169,-70.57577,"Santiago Metropolitan","city"],
  [369004,"Nyala","SD",12.04888,24.88069,"Southern Darfur","city"],
  [2935022,"Dresden","DE",51.05089,13.73832,"Saxony","city"],
  [515003,"Orenburg","RU",51.76712,55.09883,"Orenburg Oblast","city"],
  [5454711,"Albuquerque","US",35.08449,-106.65114,"New Mexico","city"],
  [1275362,"Bokāro","IN",23.66934,86.15161,"Jharkhand","city"],
  [1164408,"Sukkur","PK",27.70323,68.85889,"Sindh","city"],
  [3445831,"Uberlândia","BR",-18.91861,-48.27722,"Minas Gerais","city"],
  [5263045,"Milwaukee","US",43.0389,-87.90647,"Wisconsin","city"],
  [1585330,"Chợ Lớn","VN",10.75,106.65,"Ho Chi Minh City (HCMC)","city"],
  [1791544,"Wenchang","CN",19.55158,110.80279,"Hainan","city"],
  [2338900,"Ile-Ife","NG",7.4824,4.56032,"Osun State","city"],
  [2340451,"Gombe","NG",10.28969,11.16729,"Gombe State","city"],
  [1877449,"Hamhŭng","KP",39.91833,127.53639,"South Hamgyong","city"],
  [1503901,"Kemerovo","RU",55.35417,86.10435,"Kuzbass","city"],
  [98854,"Nasiriyah","IQ",31.05799,46.25726,"Dhi Qar","city"],
  [1018725,"Bloemfontein","ZA",-29.12107,26.214,"Free State","city"],
  [2638077,"Sheffield","GB",53.38297,-1.4659,"England","city"],
  [3536729,"Santiago de Cuba","CU",20.02287,-75.82171,"Santiago de Cuba Province","city"],
  [2034714,"Siping","CN",43.16143,124.37785,"Jilin","city"],
  [3515807,"Cuautitlán Izcalli","MX",19.64388,-99.21598,"México","city"],
  [3351663,"Benguela","AO",-12.57674,13.40268,"Benguela","city"],
  [1814760,"Chuxiong","CN",25.03639,101.54556,"Yunnan","city"],
  [7648070,"Balbala","DJ",11.56194,43.10666,"Djibouti","city"],
  [1807689,"Huaihua","CN",27.56337,110.00404,"Hunan","city"],
  [1699076,"Muntinlupa","PH",14.39028,121.0475,"Calabarzon","city"],
  [1904564,"Bình Thạnh","VN",10.811,106.706,"Ho Chi Minh City (HCMC)","city"],
  [1159301,"Zahedan","IR",29.4963,60.8629,"Sistan and Baluchestan","city"],
  [1670029,"Banqiao","TW",25.01427,121.46719,"Taipei","city"],
  [1261977,"Nanded","IN",19.16023,77.31497,"Maharashtra","city"],
  [1265873,"Kozhikode","IN",11.24802,75.7804,"Kerala","city"],
  [8335361,"Ulanqab","CN",40.993,113.133,"Inner Mongolia","city"],
  [2243271,"Cabinda","AO",-5.56198,12.19476,"Cabinda","city"],
  [2566636,"Ajegunle","NG",6.45197,3.33115,"Lagos","city"],
  [2036581,"Jiamusi","CN",46.79711,130.31118,"Heilongjiang","city"],
  [1529376,"Korla","CN",41.76055,86.15231,"Xinjiang","city"],
  [1266285,"Kolhāpur","IN",16.69563,74.23167,"Maharashtra","city"],
  [3662762,"Porto Velho","BR",-8.76194,-63.90389,"Rondônia","city"],
  [3836873,"San Miguel de Tucumán","AR",-26.81601,-65.21051,"Tucuman","city"],
  [1735227,"Kuantan","MY",3.8077,103.326,"Pahang","city"],
  [694423,"Sevastopol","UA",44.60795,33.52134,"Sevastopol City","city"],
  [1261529,"Nellore","IN",14.44992,79.98697,"Andhra Pradesh","city"],
  [11395976,"Mirpur Model Thana","BD",23.80931,90.36093,"Dhaka Division","city"],
  [2944388,"Bremen","DE",53.07582,8.80717,"Bremen","city"],
  [1791779,"Wanning","CN",18.79931,110.3841,"Hainan","city"],
  [2325330,"Owerri","NG",5.48363,7.03325,"Imo State","city"],
  [6847550,"Kota Kuala Muda","MY",5.58822,100.37085,"Kedah","city"],
  [1735498,"Sungai Petani","MY",5.647,100.48772,"Kedah","city"],
  [1788450,"Xinzhou","CN",38.40917,112.73333,"Shanxi","city"],
  [11209896,"Kotō","JP",32.77856,130.74537,"Kumamoto","city"],
  [1270752,"Kalaburagi","IN",17.33583,76.83757,"Karnataka","city"],
  [5318313,"Tucson","US",32.22174,-110.92648,"Arizona","city"],
  [7795834,"Selayang Baru Utara","MY",3.2549,101.6668,"Selangor","city"],
  [1279159,"Ajmer","IN",26.4521,74.63867,"Rajasthan","city"],
  [1798821,"Pingdu","CN",36.78444,119.94639,"Shandong","city"],
  [5350937,"Fresno","US",36.74773,-119.77237,"California","city"],
  [154380,"Mbeya","TZ",-8.9,33.45,"Mbeya","city"],
  [2346229,"Calabar","NG",4.95893,8.32695,"Cross River State","city"],
  [2540483,"Oujda","MA",34.68139,-1.90858,"Oriental","city"],
  [1496990,"Novokuznetsk","RU",53.75752,87.13599,"Kuzbass","city"],
  [500096,"Ryazan’","RU",54.62696,39.70415,"Ryazan Oblast","city"],
  [1806445,"Ji’an","CN",27.11716,114.97927,"Jiangxi","city"],
  [1166547,"Sahiwal","PK",31.97386,72.33109,"Punjab","city"],
  [1166548,"Sahiwal","PK",30.66595,73.10186,"Punjab","city"],
  [304531,"Mersin","TR",36.81196,34.63886,"Mersin","city"],
  [10346824,"Nilüfer","TR",40.21401,28.91567,"Bursa Province","city"],
  [2644688,"Leeds","GB",53.79648,-1.54785,"England","city"],
  [3088171,"Poznań","PL",52.40692,16.92993,"Greater Poland","city"],
  [1809412,"Guli","CN",28.88162,120.03308,"Zhejiang","city"],
  [1529660,"Aqsu","CN",41.18418,80.27921,"Xinjiang","city"],
  [2344082,"Ebute Ikorodu","NG",6.60086,3.48818,"Lagos","city"],
  [1793424,"Tanggu","CN",39.02111,117.64694,"Tianjin","city"],
  [1732722,"Pasir Gudang","MY",1.462,103.9053,"Johor","city"],
  [580497,"Astrakhan","RU",46.34968,48.04076,"Astrakhan Oblast","city"],
  [1168718,"Okara","PK",30.81029,73.45155,"Punjab","city"],
  [10943053,"Nansana","UG",0.36389,32.52861,"Central Region","city"],
  [1842943,"Kimhae","KR",35.23417,128.88111,"Gyeongsangnam-do","city"],
  [172955,"Ar Raqqah","SY",35.95283,39.00788,"Raqqa","city"],
  [6325494,"Québec","CA",46.81228,-71.21454,"Quebec","city"],
  [3827409,"Cuauhtémoc","MX",19.44506,-99.14612,"Mexico City","city"],
  [1796068,"Shangluo","CN",33.86667,109.93056,"Shaanxi","city"],
  [1862627,"Himeji","JP",34.81667,134.7,"Hyōgo","city"],
  [3680656,"Ibagué","CO",4.43573,-75.20289,"Tolima Department","city"],
  [2803138,"Antwerp","BE",51.22047,4.40026,"Flanders","city"],
  [359783,"Assiut","EG",27.18096,31.18368,"Asyut","city"],
  [132144,"Hamadān","IR",34.79922,48.51456,"Hamadan Province","city"],
  [1806488,"Qionghai","CN",19.2425,110.46417,"Hainan","city"],
  [1816080,"Cangzhou","CN",38.31124,116.85334,"Hebei","city"],
  [1194041,"Mohammadpur","BD",24.89843,88.52844,"Rajshahi Division","city"],
  [1625812,"Surakarta","ID",-7.55611,110.83167,"Central Java","city"],
  [1816705,"Beihai","CN",21.48349,109.11549,"Guangxi","city"],
  [298117,"Van","TR",38.49457,43.38323,"Van","city"],
  [5389489,"Sacramento","US",38.58157,-121.4944,"California","city"],
  [1565019,"Thủ Đức","VN",10.84863,106.77209,"Ho Chi Minh City (HCMC)","city"],
  [738329,"Üsküdar","TR",41.02274,29.01366,"Istanbul","city"],
  [511565,"Penza","RU",53.19568,45.01075,"Penza Oblast","city"],
  [1133616,"Mazār-e Sharīf","AF",36.70904,67.11087,"Balkh","city"],
  [1138336,"Kandahār","AF",31.61332,65.71013,"Kandahar","city"],
  [1808392,"Hengshui","CN",37.73908,115.68348,"Hebei","city"],
  [1273313,"Dehradun","IN",30.32443,78.03392,"Uttarakhand","city"],
  [1272013,"Erode","IN",11.3428,77.72741,"Tamil Nadu","city"],
  [2996944,"Lyon","FR",45.74906,4.84789,"Rhône-Alpes","city"],
  [3838233,"Salta","AR",-24.80645,-65.41999,"Salta","city"],
  [3447779,"Serra","BR",-20.12861,-40.30778,"Espírito Santo","city"],
  [747340,"Esenler","TR",41.0435,28.87619,"Istanbul","city"],
  [12446699,"Daxing’anling","CN",52.33385,124.71242,"Heilongjiang","city"],
  [1568574,"Qui Nhon","VN",13.77648,109.22367,"Gia Lai","city"],
  [361320,"Al Fayyum","EG",29.30995,30.8418,"Faiyum","city"],
  [1272175,"Durgapur","IN",23.51583,87.30801,"West Bengal","city"],
  [1849053,"Utsunomiya","JP",36.56667,139.88333,"Tochigi","city"],
  [4011743,"Victoria de Durango","MX",24.02032,-104.65756,"Durango","city"],
  [1167460,"Rahim Yar Khan","PK",28.41987,70.30345,"Punjab","city"],
  [1253894,"Ulhasnagar","IN",19.21667,73.15,"Maharashtra","city"],
  [1806466,"Guangyuan","CN",32.44201,105.823,"Sichuan","city"],
  [1264773,"Loni","IN",28.75143,77.29023,"Uttar Pradesh","city"],
  [1256525,"Siliguri","IN",26.71004,88.42851,"West Bengal","city"],
  [2861650,"Nuremberg","DE",49.45421,11.07752,"Bavaria","city"],
  [1253914,"Ujjain","IN",23.18239,75.77643,"Madhya Pradesh","city"],
  [2910831,"Hannover","DE",52.37052,9.73322,"Lower Saxony","city"],
  [2650225,"Edinburgh","GB",55.95206,-3.19648,"Scotland","city"],
  [3396016,"Macapá","BR",0.03889,-51.06639,"Amapá","city"],
  [1790396,"Xianning","CN",29.84347,114.32201,"Hubei","city"],
  [2972315,"Toulouse","FR",43.60426,1.44367,"Occitanie","city"],
  [949880,"Thembisa","ZA",-25.99636,28.2268,"Gauteng","city"],
  [6201369,"Carrefour","HT",18.53333,-72.4,"Ouest","city"],
  [1926099,"Matsuyama","JP",33.83916,132.76574,"Ehime","city"],
  [3467693,"Campos dos Goytacazes","BR",-21.75227,-41.33044,"Rio de Janeiro","city"],
  [1275610,"Bilimora","IN",20.76957,72.96134,"Gujarat","city"],
  [1174625,"Kasur","PK",31.11866,74.45025,"Punjab","city"],
  [4180439,"Atlanta","US",33.749,-84.38798,"Georgia","city"],
  [6316406,"Aparecida de Goiânia","BR",-16.82333,-49.24389,"Goiás","city"],
  [3523466,"Heroica Matamoros","MX",25.87972,-97.50417,"Tamaulipas","city"],
  [1703417,"Makati City","PH",14.55027,121.03269,"National Capital Region","city"],
  [3054667,"Buda","HU",47.5,19.03333,"Budapest","city"],
  [12492662,"Mianzhu, Deyang, Sichuan","CN",31.33786,104.22057,"Sichuan","city"],
  [2034414,"Tonghua","CN",41.71972,125.92639,"Jilin","city"],
  [523750,"Naberezhnyye Chelny","RU",55.73718,52.41961,"Tatarstan Republic","city"],
  [535121,"Lipetsk","RU",52.5876,39.55151,"Lipetsk Oblast","city"],
  [2314705,"Kikwit","CD",-5.04098,18.81619,"Kwilu","city"],
  [3463237,"Florianópolis","BR",-27.59667,-48.54917,"Santa Catarina","city"],
  [1909733,"Banan","CN",29.37861,106.54,"Chongqing","city"],
  [2155472,"Newcastle","AU",-32.92953,151.7801,"New South Wales","city"],
  [1818446,"Tuen Mun","HK",22.39175,113.97157,"Tuen Mun","city"],
  [1785036,"Zhangye","CN",38.93417,100.45167,"Gansu","city"],
  [548408,"Kirov","RU",58.59809,49.65783,"Kirov Oblast","city"],
  [1280849,"Kashgar","CN",39.46718,75.98675,"Xinjiang","city"],
  [12750654,"Mukim Pulai","MY",1.53333,103.66667,"Johor","city"],
  [103630,"Najrān","SA",17.49326,44.12766,"Najran Region","city"],
  [1267696,"Karol Bāgh","IN",28.65136,77.19072,"Delhi","city"],
  [1784130,"Zhoukou","CN",33.63333,114.63333,"Henan","city"],
  [2879139,"Leipzig","DE",51.33962,12.37129,"Saxony","city"],
  [1798760,"Pingliang","CN",35.53917,106.68611,"Gansu","city"],
  [8307452,"Huangpu","CN",31.2378,121.4781,"Shanghai","city"],
  [8504951,"Kalininskiy","RU",59.99675,30.3899,"St.-Petersburg","city"],
  [2934691,"Duisburg","DE",51.43247,6.76516,"North Rhine-Westphalia","city"],
  [1278314,"Āsansol","IN",23.68333,86.98333,"West Bengal","city"],
  [143127,"Arāk","IR",34.09493,49.69809,"Markazi","city"],
  [3880980,"Maipú","CL",-33.51421,-70.7651,"Santiago Metropolitan","city"],
  [627907,"Homyel'","BY",52.4345,30.9754,"Homyel’ Voblasc’","city"],
  [610611,"Aktobe","KZ",50.27969,57.20718,"Aktobe","city"],
  [1733432,"Kota Kinabalu","MY",5.9749,116.0724,"Sabah","city"],
  [1176358,"Jalalpur Pirwala","PK",29.5051,71.22202,"Punjab","city"],
  [12514556,"Kota Damansara","MY",3.15454,101.58022,"Selangor","city"],
  [1732724,"Kampung Larkin Lama","MY",1.5024,103.744,"Johor","city"],
  [2591976,"Talatona","AO",-8.91783,13.18562,"Luanda","city"],
  [1263780,"Mangaluru","IN",12.91723,74.85603,"Karnataka","city"],
  [1783988,"Zhucheng","CN",35.99472,119.3975,"Shandong","city"],
  [3668605,"Santa Marta","CO",11.23855,-74.19427,"Magdalena Department","city"],
  [1857553,"Matsudo","JP",35.77995,139.90144,"Chiba","city"],
  [1462674,"Hāthazāri","BD",22.50515,91.81339,"Chittagong","city"],
  [1707267,"Lapu-Lapu City","PH",10.31028,123.94944,"Central Visayas","city"],
  [609655,"Karagandy","KZ",49.80187,73.10211,"Karaganda","city"],
  [1802238,"Loudi","CN",27.73444,111.99444,"Hunan","city"],
  [2644210,"Liverpool","GB",53.41058,-2.97794,"England","city"],
  [11837657,"Ichikawa","JP",35.73413,139.9065,"Chiba","city"],
  [1185270,"Bāndarban","BD",22.19534,92.21946,"Chittagong","city"],
  [1818920,"Sha Tin","HK",22.38333,114.18333,"Sha Tin","city"],
  [1180289,"Dera Ghazi Khan","PK",30.04587,70.64029,"Punjab","city"],
  [1862752,"Higashiosaka","JP",34.66667,135.58333,"Osaka","city"],
  [1168021,"Pindi Bhattian","PK",31.89844,73.27339,"Punjab","city"],
  [569696,"Cheboksary","RU",56.13218,47.246,"Chuvash Republic","city"],
  [1839071,"Pohang","KR",36.02917,129.36481,"Gyeongsangbuk-do","city"],
  [1795928,"Shanwei","CN",22.78199,115.3475,"Guangdong","city"],
  [3674453,"Montería","CO",8.75081,-75.87823,"Córdoba","city"],
  [181032,"Ruiru","KE",-1.14665,36.96087,"Kiambu County","city"],
  [3666304,"Valledupar","CO",10.46538,-73.2531,"Cesar Department","city"],
  [1276533,"Belagavi","IN",15.85212,74.50447,"Karnataka","city"],
  [292932,"Ajman","AE",25.40177,55.47878,"Ajman","city"],
  [9931406,"Jianshui","CN",24.2774,101.224,"Yunnan","city"],
  [7628420,"Sancaktepe","TR",41.00244,29.23187,"Istanbul","city"],
  [377039,"Port Sudan","SD",19.61745,37.21644,"Red Sea","city"],
  [3515302,"Toluca","MX",19.28786,-99.65324,"México","city"],
  [3532624,"Ciudad López Mateos","MX",19.55793,-99.25675,"México","city"],
  [360890,"Al Khuşūş","EG",30.15293,31.31501,"Qalyubia","city"],
  [1846266,"Jeju City","KR",33.50972,126.52194,"Jeju-do","city"],
  [3099434,"Gdańsk","PL",54.35227,18.64912,"Pomerania","city"],
  [4164138,"Miami","US",25.77427,-80.19366,"Florida","city"],
  [5074472,"Omaha","US",41.25626,-95.94043,"Nebraska","city"],
  [1855207,"Nishinomiya","JP",34.71562,135.33199,"Hyōgo","city"],
  [2593460,"Masina","CD",-4.38361,15.39139,"Kinshasa","city"],
  [1257806,"Sahāranpur","IN",29.9679,77.54522,"Uttar Pradesh","city"],
  [1253286,"Vellore","IN",12.9184,79.13255,"Tamil Nadu","city"],
  [1858311,"Kurashiki","JP",34.58333,133.76667,"Okayama","city"],
  [1730737,"Angeles City","PH",15.15,120.58333,"Central Luzon","city"],
  [1276058,"Bhātpāra","IN",22.86643,88.40113,"West Bengal","city"],
  [333795,"Jijiga","ET",9.35,42.8,"Somali","city"],
  [480562,"Tula","RU",54.19609,37.61822,"Tula Oblast","city"],
  [98860,"Najaf","IQ",32.02594,44.34625,"Najaf","city"],
  [4487042,"Raleigh","US",35.7721,-78.63861,"North Carolina","city"],
  [1710914,"Imus","PH",14.42972,120.93667,"Calabarzon","city"],
  [1789647,"Xichang","CN",27.89642,102.26341,"Sichuan","city"],
  [1264115,"Malegaon","IN",20.54966,74.53462,"Maharashtra","city"],
  [3448639,"São José do Rio Preto","BR",-20.81972,-49.37944,"São Paulo","city"],
  [7701384,"Karabağlar","TR",38.382,27.132,"İzmir Province","city"],
  [2327220,"Okene","NG",7.55122,6.23589,"Kogi State","city"],
  [1833788,"Uijeongbu-si","KR",37.7415,127.0474,"Gyeonggi-do","city"],
  [2654675,"Bristol","GB",51.45523,-2.59665,"England","city"],
  [1006984,"East London","ZA",-33.01529,27.91162,"Eastern Cape","city"],
  [13527052,"Chéngguān Qū","CN",29.63842,91.04441,"Tibet","city"],
  [111822,"Yazd","IR",31.89722,54.3675,"Yazd Province","city"],
  [57289,"Hargeysa","SO",9.56,44.065,"Woqooyi Galbeed","city"],
  [1854487,"Ōita","JP",33.23333,131.6,"Oita","city"],
  [3457381,"Mauá","BR",-23.66778,-46.46139,"São Paulo","city"],
  [1805741,"Jincheng","CN",35.50222,112.83278,"Shanxi","city"],
  [6696918,"Taoyuan","TW",24.99368,121.29696,"Taiwan","city"],
  [198629,"Eldoret","KE",0.52036,35.26993,"Uasin Gishu County","city"],
  [4393217,"Kansas City","US",39.09973,-94.57857,"Missouri","city"],
  [1787765,"Yan’an","CN",36.59889,109.49167,"Shaanxi","city"],
  [554234,"Kaliningrad","RU",54.70639,20.51102,"Kaliningrad Oblast","city"],
  [2057087,"Kupang","ID",-10.17083,123.60694,"East Nusa Tenggara","city"],
  [944385,"Vereeniging","ZA",-26.67313,27.92615,"Gauteng","city"],
  [2747373,"The Hague","NL",52.07667,4.29861,"South Holland","city"],
  [5367929,"Long Beach","US",33.76696,-118.18923,"California","city"],
  [1271439,"Gaya","IN",24.79686,85.00385,"Bihar","city"],
  [1711005,"Iloilo","PH",10.69694,122.56444,"Western Visayas","city"],
  [1794794,"Shouguang","CN",36.88,118.7375,"Shandong","city"],
  [1805680,"Jingdezhen","CN",29.2947,117.20789,"Jiangxi","city"],
  [2513416,"Murcia","ES",37.98704,-1.13004,"Murcia","city"],
  [5304391,"Mesa","US",33.42227,-111.82264,"Arizona","city"],
  [6324729,"Halifax","CA",44.64269,-63.57688,"Nova Scotia","city"],
  [153220,"Morogoro","TZ",-6.82102,37.66122,"Morogoro","city"],
  [1700925,"Marikina City","PH",14.6481,121.1133,"National Capital Region","city"],
  [2544571,"Kenitra","MA",34.26101,-6.5802,"Rabat-Salé-Kénitra","city"],
  [288967,"Seeb","OM",23.67027,58.18911,"Muscat","city"],
  [1809061,"Jiaojiang","CN",28.69844,121.47331,"Zhejiang","city"],
  [1646511,"Cilegon","ID",-6.0144,106.0542,"Banten","city"],
  [700569,"Mykolayiv","UA",46.97625,31.99296,"Mykolaiv","city"],
  [1863917,"Fukuyama","JP",34.48333,133.36667,"Hiroshima","city"],
  [5139568,"Staten Island","US",40.56233,-74.13986,"New York","city"],
  [1799846,"Nanping","CN",26.645,118.17361,"Fujian","city"],
  [3672486,"Pereira","CO",4.81428,-75.69488,"Risaralda Department","city"],
  [4018390,"Ciudad Apodaca","MX",25.78143,-100.18911,"Nuevo León","city"],
  [3448877,"São João de Meriti","BR",-22.80389,-43.37222,"Rio de Janeiro","city"],
  [1278840,"Ambattur","IN",13.09818,80.16152,"Tamil Nadu","city"],
  [3470142,"Belford Roxo","BR",-22.76417,-43.39944,"Rio de Janeiro","city"],
  [1860243,"Kanazawa","JP",36.6,136.61667,"Ishikawa","city"],
  [336014,"Gonder","ET",12.6,37.46667,"Amhara","city"],
  [1701966,"Mandaluyong City","PH",14.5832,121.0409,"National Capital Region","city"],
  [3592519,"Mixco","GT",14.63077,-90.60711,"Guatemala","city"],
  [2036109,"Longshan","CN",42.88545,125.1367,"Jilin","city"],
  [2338325,"Ikare","NG",7.52591,5.75342,"Ondo State","city"],
  [11592397,"Nova Vida","AO",-8.90552,13.22213,"Luanda","city"],
  [1562414,"Vũng Tàu","VN",10.34599,107.08426,"Ho Chi Minh City (HCMC)","city"],
  [3632998,"Maracay","VE",10.24972,-67.59475,"Aragua","city"],
  [2294877,"Tamale","GH",9.40079,-0.8393,"Northern","city"],
  [1786112,"Heyuan","CN",23.73333,114.68333,"Guangdong","city"],
  [1583518,"Dĩ An","VN",10.90682,106.7694,"Ho Chi Minh City (HCMC)","city"],
  [231165,"Kira","UG",0.4,32.63333,"Central Region","city"],
  [355449,"Esna","EG",25.29336,32.55402,"Qena","city"],
  [3459712,"Joinville","BR",-26.30444,-48.84556,"Santa Catarina","city"],
  [1792359,"Huangshan","CN",29.71139,118.3125,"Anhui","city"],
  [170017,"Ḩamāh","SY",35.13179,36.75783,"Hama","city"],
  [1269407,"Jalgaon","IN",21.00292,75.56602,"Maharashtra","city"],
  [1265491,"Kurnool","IN",15.82887,78.03602,"Andhra Pradesh","city"],
  [2318044,"Yola","NG",9.20839,12.48146,"Adamawa","city"],
  [1568510,"Rạch Giá","VN",10.01245,105.08091,"An Giang","city"],
  [1865387,"Amagasaki","JP",34.71667,135.41667,"Hyōgo","city"],
  [1636544,"Manado","ID",1.48218,124.84892,"North Sulawesi","city"],
  [3651297,"Santo Domingo de los Colorados","EC",-0.25368,-79.17628,"Santo Domingo de los Tsáchilas","city"],
  [163345,"Ţarţūs","SY",34.88902,35.88659,"Tartus","city"],
  [331180,"Mek'ele","ET",13.49667,39.47528,"Tigray","city"],
  [330186,"Nazrēt","ET",8.55,39.26667,"Oromiya","city"],
  [5417598,"Colorado Springs","US",38.83388,-104.82136,"Colorado","city"],
  [3456283,"Niterói","BR",-22.88333,-43.10361,"Rio de Janeiro","city"],
  [3939459,"Huancayo","PE",-12.06866,-75.21027,"Junin","city"],
  [99347,"Al Hillah","IQ",32.46367,44.41963,"Babil","city"],
  [2312895,"Mbandaka","CD",0.04865,18.26034,"Équateur","city"],
  [1873757,"Namp’o","KP",38.7375,125.40778,"Nampo","city"],
  [2239862,"Malanje","AO",-9.54015,16.34096,"Malanje","city"],
  [4005867,"Ciudad General Escobedo","MX",25.79663,-100.31767,"Nuevo León","city"],
  [1729564,"Bacolod City","PH",10.66667,122.95,"Western Visayas","city"],
  [4791259,"Virginia Beach","US",36.85293,-75.97799,"Virginia","city"],
  [1792260,"Wafangdian","CN",39.61833,122.00806,"Liaoning","city"],
  [1701500,"Mansilingan","PH",10.63111,122.97889,"Western Visayas","city"],
  [158597,"Kahama","TZ",-3.83333,32.6,"Shinyanga","city"],
  [1675151,"Hsinchu","TW",24.80361,120.96861,"Taiwan","city"],
  [8469284,"Katsushika","JP",35.73333,139.85,"Tokyo","city"],
  [1258662,"Rāmgundam","IN",18.80084,79.45206,"Telangana","city"],
  [321836,"Batman","TR",37.88738,41.13221,"Batman","city"],
  [1784818,"Yongji","CN",34.86611,110.44028,"Shanxi","city"],
  [1803245,"Lishui","CN",28.46042,119.91029,"Zhejiang","city"],
  [1253986,"Udaipur","IN",24.58584,73.71346,"Rajasthan","city"],
  [326282,"Warder","ET",6.97444,45.34083,"Somali","city"],
  [1591527,"Bắc Giang","VN",21.27307,106.1946,"Bac Ninh","city"],
  [449504,"Eslamshahr","IR",35.55222,51.23504,"Tehran","city"],
  [8074174,"Muratpaşa","TR",36.89157,30.76498,"Antalya","city"],
  [8505006,"Wenshan City","CN",23.36306,104.25047,"Yunnan","city"],
  [298333,"Şanlıurfa","TR",37.16708,38.79392,"Şanlıurfa","city"],
  [2038087,"Chengde","CN",40.9519,117.95883,"Hebei","city"],
  [538560,"Kursk","RU",51.72689,36.18457,"Kursk Oblast","city"],
  [1348843,"Maheshtala","IN",22.50862,88.25322,"West Bengal","city"],
  [1573517,"Nam Định","VN",20.43389,106.17729,"Ninh Binh","city"],
  [2501152,"Constantine","DZ",36.365,6.61472,"Constantine","city"],
  [1260107,"Patiāla","IN",30.33625,76.3922,"Punjab","city"],
  [1017780,"Boksburg","ZA",-26.21197,28.25958,"Gauteng","city"],
  [1816858,"Basuo","CN",19.10267,108.66565,"Hainan","city"],
  [4006702,"Ensenada","MX",31.87149,-116.60071,"Baja California","city"],
  [315808,"Elazığ","TR",38.67431,39.22321,"Elazığ","city"],
  [3459462,"Jundiaí","BR",-23.18639,-46.88417,"São Paulo","city"],
  [3514450,"Xochimilco","MX",19.25465,-99.10356,"Mexico City","city"],
  [1256409,"Shyamnagar","IN",22.83333,88.36667,"West Bengal","city"],
  [1715430,"Dasmariñas","PH",14.32944,120.93667,"Calabarzon","city"],
  [1813171,"Zhangjiajie","CN",29.12944,110.47833,"Hunan","city"],
  [1635882,"Mataram","ID",-8.58333,116.11667,"West Nusa Tenggara","city"],
  [2286304,"Korhogo","CI",9.45803,-5.62961,"Savanes District","city"],
  [1864092,"Fujisawa","JP",35.34926,139.47666,"Kanagawa","city"],
  [1734052,"Sandakan","MY",5.8402,118.1179,"Sabah","city"],
  [1308465,"Mawlamyine","MM",16.49051,97.62825,"Mon","city"],
  [6050610,"Laval","CA",45.56995,-73.692,"Quebec","city"],
  [2512989,"Palma","ES",39.56939,2.65024,"Balearic Islands","city"],
  [1869012,"Sunch’ŏn","KP",39.43167,125.93278,"South Pyongan","city"],
  [7628416,"Sultangazi","TR",41.10652,28.86847,"Istanbul","city"],
  [2319480,"Uyo","NG",5.05127,7.9335,"Akwa Ibom State","city"],
  [2038365,"Bei’an","CN",48.26667,126.6,"Heilongjiang","city"],
  [1273368,"Davangere","IN",14.46693,75.92694,"Karnataka","city"],
  [2352379,"Ado-Ekiti","NG",7.62329,5.22087,"Ekiti State","city"],
  [3675443,"Manizales","CO",5.0668,-75.50684,"Caldas Department","city"],
  [1841246,"Masan","KR",35.12725,126.83149,"Gwangju","city"],
  [1586896,"Buôn Ma Thuột","VN",12.66747,108.03775,"Dak Lak","city"],
  [3407669,"Ananindeua","BR",-1.36556,-48.37222,"Pará","city"],
  [487846,"Stavropol","RU",45.03442,41.9642,"Stavropol Kray","city"],
  [1794328,"Shuozhou","CN",39.31583,112.4225,"Shanxi","city"],
  [3449433,"Santos","BR",-23.96083,-46.33361,"São Paulo","city"],
  [1859924,"Kashiwa","JP",35.86224,139.97732,"Chiba","city"],
  [2327735,"Ogbomoso","NG",8.13373,4.24014,"Oyo State","city"],
  [293397,"Tel Aviv","IL",32.08088,34.78057,"Tel Aviv","city"],
  [216281,"Goma","CD",-1.67409,29.22845,"North Kivu","city"],
  [3688452,"Buenaventura","CO",3.58333,-77,"Valle del Cauca Department","city"],
  [940909,"Welkom","ZA",-27.97742,26.73506,"Free State","city"],
  [1818953,"Sham Shui Po","HK",22.33023,114.15945,"Sham Shui Po District","city"],
  [1857871,"Machida","JP",35.54028,139.45083,"Tokyo","city"],
  [3827407,"Venustiano Carranza","MX",19.44361,-99.10499,"Mexico City","city"],
  [359493,"Zagazig","EG",30.58768,31.502,"Sharqia","city"],
  [689558,"Vinnytsya","UA",49.2322,28.46871,"Vinnytsia","city"],
  [361055,"Ismailia","EG",30.60427,32.27225,"Ismailia","city"],
  [1806097,"Ningde","CN",26.66167,119.52278,"Fujian","city"],
  [1279105,"Akola","IN",20.70957,76.9981,"Maharashtra","city"],
  [13608165,"Kima Kieza","AO",-8.83411,13.29517,"Luanda","city"],
  [3941584,"Cusco","PE",-13.53188,-71.96701,"Cuzco Department","city"],
  [1279945,"Jiuquan","CN",39.74318,98.51736,"Gansu","city"],
  [3514783,"Veracruz","MX",19.18095,-96.1429,"Veracruz","city"],
  [7303419,"East Jerusalem","PS",31.78336,35.23388,"West Bank","city"],
  [571476,"Bryansk","RU",53.27096,34.32143,"Bryansk Oblast","city"],
  [741763,"Maltepe","TR",40.93567,29.15507,"Istanbul","city"],
  [584923,"Sumgayit","AZ",40.58972,49.66861,"Sumqayit","city"],
  [1163964,"Tando Bago","PK",24.78914,68.96535,"Sindh","city"],
  [1734705,"Kuala Terengganu","MY",5.3302,103.1408,"Terengganu","city"],
  [1849814,"Toyota","JP",35.08333,137.15,"Aichi","city"],
  [2313002,"Matadi","CD",-5.83861,13.46306,"Bas-Congo","city"],
  [109353,"Al Kharj","SA",24.15541,47.33457,"Riyadh Region","city"],
  [1818304,"Wong Tai Sin","HK",22.35,114.18333,"Wong Tai Sin District","city"],
  [13118244,"Mandaluyong","PH",14.57837,121.03522,"National Capital Region","city"],
  [2330100,"Minna","NG",9.61524,6.54776,"Niger State","city"],
  [3526617,"Xalapa de Enríquez","MX",19.53124,-96.91589,"Veracruz","city"],
  [1255783,"Rajpur Sonarpur","IN",22.4382,88.43205,"West Bengal","city"],
  [12557764,"Taman Petaling","MY",3.19916,101.64983,"Kuala Lumpur","city"],
  [1852139,"Shinagawa","JP",33.63627,133.00572,"Ehime","city"],
  [173811,"Al Ḩasakah","SY",36.50237,40.74772,"Al-Hasakah","city"],
  [360502,"Luxor","EG",25.69893,32.6421,"Luxor","city"],
  [6058560,"London","CA",42.98339,-81.23304,"Ontario","city"],
  [343137,"Awasa","ET",7.06205,38.47635,"Sidama Region","city"],
  [1049261,"Chimoio","MZ",-19.11639,33.48333,"Manica","city"],
  [1163965,"Tando Allahyar","PK",25.4605,68.71745,"Sindh","city"],
  [2290486,"Daloa","CI",6.87735,-6.45022,"Sassandra-Marahoue","city"],
  [1812749,"Dingxi","CN",35.57088,104.62303,"Gansu","city"],
  [2234974,"Bamenda","CM",5.9597,10.14597,"North-West","city"],
  [480060,"Tver","RU",56.85836,35.90057,"Tver Oblast","city"],
  [1566319,"Thái Nguyên","VN",21.59422,105.84817,"Thai Nguyen","city"],
  [3664980,"Boa Vista","BR",2.81972,-60.67333,"Roraima","city"],
  [3662574,"Rio Branco","BR",-9.97472,-67.81,"Acre","city"],
  [5378538,"Oakland","US",37.80437,-122.2708,"California","city"],
  [2192362,"Christchurch","NZ",-43.53333,172.63333,"Canterbury","city"],
  [1266122,"Korba","IN",22.3458,82.69633,"Chhattisgarh","city"],
  [1851100,"Takamatsu","JP",34.33333,134.05,"Kagawa","city"],
  [1819607,"Kowloon City","HK",22.33047,114.19222,"Kowloon City","city"],
  [1736309,"Alor Setar","MY",6.12104,100.36014,"Kedah","city"],
  [7064006,"Tongchuan","CN",34.8988,108.95056,"Shaanxi","city"],
  [1694611,"Pasay","PH",14.53748,121.00144,"National Capital Region","city"],
  [3522551,"Nuevo Laredo","MX",27.47629,-99.51639,"Tamaulipas","city"],
  [1849876,"Toyama","JP",36.7,137.21667,"Toyama","city"],
  [2528910,"Tétouan","MA",35.57845,-5.36837,"Tanger-Tetouan-Al Hoceima","city"],
  [2657896,"Zürich","CH",47.36667,8.55,"Zurich","city"],
  [6947640,"Beylikdüzü","TR",40.982,28.6399,"Istanbul","city"],
  [1562820,"Việt Trì","VN",21.32274,105.40198,"Phu Tho","city"],
  [3532497,"Azcapotzalco","MX",19.48698,-99.18594,"Mexico City","city"],
  [4174757,"Tampa","US",27.94752,-82.45843,"Florida","city"],
  [3456814,"Montes Claros","BR",-16.735,-43.86167,"Minas Gerais","city"],
  [234179,"Bunamwaya","UG",0.25344,32.55723,"Central Region","city"],
  [532288,"Magnitogorsk","RU",53.39808,59.0066,"Chelyabinsk","city"],
  [4553433,"Tulsa","US",36.15398,-95.99277,"Oklahoma","city"],
  [1269006,"Jhānsi","IN",25.45887,78.57994,"Uttar Pradesh","city"],
  [1818506,"Tseung Kwan O","HK",22.32789,114.24992,"Sai Kung District","city"],
  [3645532,"Ciudad Bolívar","VE",8.12366,-63.54694,"Bolívar","city"],
  [1762110,"Kampung Kangkar Teberau","MY",1.532,103.7549,"Johor","city"],
  [2285853,"Koumassi","CI",5.29716,-3.96753,"Abidjan Autonomous District","city"],
  [3985241,"San Nicolás de los Garza","MX",25.74167,-100.30222,"Nuevo León","city"],
  [1809152,"Guyuan","CN",36.00667,106.28083,"Ningxia","city"],
  [2911285,"Wandsbek","DE",53.58334,10.08305,"Hamburg","city"],
  [5037649,"Minneapolis","US",44.97997,-93.26384,"Minnesota","city"],
  [2082600,"Jayapura","ID",-2.53371,140.71813,"Papua","city"],
  [8629640,"Thoothukudi","IN",8.76735,78.13425,"Tamil Nadu","city"],
  [143083,"Ardabīl","IR",38.2498,48.2933,"Ardabil Province","city"],
  [1276509,"Ballari","IN",15.14205,76.92398,"Karnataka","city"],
  [2038120,"Chaoyang","CN",41.57028,120.45861,"Liaoning","city"],
  [281133,"Gaza","PS",31.50161,34.46672,"Gaza Strip","city"],
  [1848313,"Yokosuka","JP",35.28361,139.66722,"Kanagawa","city"],
  [353802,"Kom Ombo","EG",24.47669,32.94626,"Aswan","city"],
  [6722148,"Saltivka","UA",50.02207,36.34901,"Kharkiv","city"],
  [1856177,"Nagasaki","JP",32.75,129.88333,"Nagasaki","city"],
  [1281019,"Gujangbagh","CN",37.10927,79.93433,"Xinjiang","city"],
  [3981369,"Tonalá","MX",20.62263,-103.24168,"Jalisco","city"],
  [3453643,"Piracicaba","BR",-22.72528,-47.64917,"São Paulo","city"],
  [204405,"Uvira","CD",-3.39534,29.13779,"South Kivu","city"],
  [1862540,"Hirakata","JP",34.81352,135.64914,"Osaka","city"],
  [555312,"Ivanovo","RU",56.99988,40.97257,"Ivanovo Oblast","city"],
  [3644768,"Cumaná","VE",10.4639,-64.17859,"Sucre","city"],
  [971421,"Newcastle","ZA",-27.75796,29.9318,"KwaZulu-Natal","city"],
  [1842225,"Gumi","KR",36.1136,128.336,"Gyeongsangbuk-do","city"],
  [2036389,"Jixi","CN",45.29322,130.96217,"Heilongjiang","city"],
  [1735634,"Kuching","MY",1.55,110.33333,"Sarawak","city"],
  [1863641,"Gifu","JP",35.42291,136.76039,"Gifu","city"],
  [3402655,"Caruaru","BR",-8.28333,-35.97611,"Pernambuco","city"],
  [1792621,"Tongling","CN",30.95,117.78333,"Anhui","city"],
  [1682812,"Tarlac City","PH",15.48017,120.59794,"Central Luzon","city"],
  [1849837,"Toyonaka","JP",34.78244,135.46932,"Osaka","city"],
  [372753,"Kassala","SD",15.45099,36.39998,"Kassala","city"],
  [1856717,"Miyazaki","JP",31.91667,131.41667,"Miyazaki","city"],
  [7732748,"Lekki","NG",6.44632,3.47717,"Lagos","city"],
  [3899539,"Antofagasta","CL",-23.65094,-70.39752,"Antofagasta","city"],
  [11785389,"Wah Cantt","PK",33.77094,72.75116,"Punjab","city"],
  [1276300,"Bhāgalpur","IN",25.24446,86.97183,"Bihar","city"],
  [1279290,"Agartala","IN",23.83605,91.27939,"Tripura","city"],
  [2347209,"Bida","NG",9.08044,6.0099,"Niger State","city"],
  [292261,"Dayrah","AE",25.27143,55.30207,"Dubai","city"],
  [7498240,"West Jerusalem","IL",31.78199,35.21961,"Jerusalem","city"],
  [217695,"Bunia","CD",1.55941,30.25224,"Ituri","city"],
  [323779,"Antakya","TR",36.20655,36.15722,"Hatay","city"],
  [9645085,"Quận Mười","VN",10.76823,106.66632,"Ho Chi Minh City (HCMC)","city"],
  [10630449,"Sunshine Coast","AU",-26.65682,153.07955,"Queensland","city"],
  [191245,"Kisumu","KE",-0.10221,34.76171,"Kisumu County","city"],
  [702658,"Luhansk","UA",48.56814,39.30553,"Luhansk","city"],
  [1649150,"Bengkulu","ID",-3.80044,102.26554,"Bengkulu","city"],
  [3648546,"Barinas","VE",8.62064,-70.23105,"Barinas","city"],
  [4281730,"Wichita","US",37.69224,-97.33754,"Kansas","city"],
  [2558545,"Al Hoceïma","MA",35.25165,-3.93723,"Tanger-Tetouan-Al Hoceima","city"],
  [3083829,"Szczecin","PL",53.42894,14.55302,"West Pomerania","city"],
  [3726786,"Delmas","HT",18.54478,-72.30036,"Ouest","city"],
  [3445026,"Vila Velha","BR",-20.32972,-40.2925,"Espírito Santo","city"],
  [3181928,"Bologna","IT",44.49381,11.33875,"Emilia-Romagna","city"],
  [11523293,"Sejong","KR",36.59245,127.29223,"Sejong-si","city"],
  [2591949,"Cazenga","AO",-8.83796,13.28399,"Luanda","city"],
  [740264,"Samsun","TR",41.27976,36.3361,"Samsun","city"],
  [149606,"Tanga","TZ",-5.06893,39.09875,"Tanga","city"],
  [379003,"El Obeid","SD",13.18421,30.21669,"North Kordofan","city"],
  [3464739,"Diadema","BR",-23.68611,-46.62278,"São Paulo","city"],
  [3347939,"Lobito","AO",-12.3644,13.53601,"Benguela","city"],
  [145531,"Saurimo","AO",-9.66078,20.39155,"Lunda Sul","city"],
  [3688928,"Bello","CO",6.33732,-75.55795,"Antioquia","city"],
  [3672778,"Pasto","CO",1.21456,-77.27846,"Nariño","city"],
  [1810458,"Gaomi","CN",36.38333,119.75278,"Shandong","city"],
  [3836277,"Santa Fe","AR",-31.64881,-60.70868,"Santa Fe","city"],
  [2282006,"San-Pédro","CI",4.74851,-6.6363,"Bas-Sassandra District","city"],
  [2331140,"Makurdi","NG",7.73375,8.52139,"Benue State","city"],
  [1633034,"Palu","ID",-0.90833,119.87083,"Central Sulawesi","city"],
  [2294915,"Takoradi","GH",4.89816,-1.76029,"Western","city"],
  [1606590,"Samut Prakan","TH",13.5976,100.5972,"Samut Prakan","city"],
  [4671240,"Arlington","US",32.73569,-97.10807,"Texas","city"],
  [105072,"Khamis Mushait","SA",18.3,42.73333,"'Asir Region","city"],
  [3660689,"Ambato","EC",-1.24908,-78.61675,"Tungurahua Province","city"],
  [3466998,"Carapicuíba","BR",-23.52272,-46.835,"São Paulo","city"],
  [3392242,"Petrolina","BR",-9.39861,-40.50083,"Pernambuco","city"],
  [3827598,"Ojo de Agua","MX",19.68028,-99.01,"México","city"],
  [2395914,"Abomey-Calavi","BJ",6.44852,2.35566,"Atlantique","city"],
  [2947416,"Bochum","DE",51.48165,7.21648,"North Rhine-Westphalia","city"],
  [1851483,"Suita","JP",34.76143,135.51567,"Osaka","city"],
  [11048319,"Sector 3","RO",44.4234,26.16874,"Bucharest","city"],
  [6957079,"Benito Juárez","MX",19.3727,-99.1564,"Mexico City","city"],
  [1175748,"Chak Jhumra","PK",31.56808,73.18317,"Punjab","city"],
  [310859,"Kahramanmaraş","TR",37.5847,36.92641,"Kahramanmaraş","city"],
  [12159964,"Chongzuo","CN",22.38161,107.3683,"Guangxi","city"],
  [11962371,"Grajaú","BR",-23.76979,-46.67112,"São Paulo","city"],
  [1854376,"Okazaki","JP",34.95,137.16667,"Aichi","city"],
  [3514519,"Xico","MX",19.27032,-98.95088,"México","city"],
  [3526700,"Iztacalco","MX",19.39528,-99.09778,"Mexico City","city"],
  [1268561,"Kākināda","IN",16.96036,82.23809,"Andhra Pradesh","city"],
  [3470044,"Betim","BR",-19.96778,-44.19833,"Minas Gerais","city"],
  [2515270,"Las Palmas de Gran Canaria","ES",28.10178,-15.41573,"Canary Islands","city"],
  [1716771,"Cotabato","PH",7.22361,124.24639,"Autonomous Region in Muslim Mindanao","city"],
  [288764,"Bawshar","OM",23.57769,58.39982,"Muscat","city"],
  [1265014,"Latur","IN",18.39721,76.56784,"Maharashtra","city"],
  [1913154,"Tanzhou","CN",22.25503,113.46692,"Guangdong","city"],
  [3996322,"Mazatlán","MX",23.22163,-106.41885,"Sinaloa","city"],
  [3466537,"Caxias do Sul","BR",-29.16806,-51.17944,"Rio Grande do Sul","city"],
  [520494,"Nizhny Tagil","RU",57.91944,59.965,"Sverdlovsk Oblast","city"],
  [4004330,"Irapuato","MX",20.671,-101.35577,"Guanajuato","city"],
  [1861949,"Ichinomiya","JP",35.3,136.8,"Aichi","city"],
  [359792,"Aswān","EG",24.09082,32.89942,"Aswan","city"],
  [3078610,"Brno","CZ",49.19522,16.60796,"South Moravian","city"],
  [3470279,"Bauru","BR",-22.31472,-49.06056,"São Paulo","city"],
  [675810,"Iaşi","RO",47.16667,27.6,"Iași County","city"],
  [986822,"Krugersdorp","ZA",-26.08577,27.77515,"Gauteng","city"],
  [1260482,"Pānihāti","IN",22.69089,88.37404,"West Bengal","city"],
  [1185107,"Shibganj","BD",25.00146,89.32266,"Rajshahi Division","city"],
  [3696183,"Iquitos","PE",-3.74814,-73.2529,"Loreto","city"],
  [1849846,"Toyohashi","JP",34.76667,137.38333,"Aichi","city"],
  [1808212,"Hechuan","CN",29.99228,106.26461,"Chongqing","city"],
  [3719028,"Pétionville","HT",18.5125,-72.28528,"Ouest","city"],
  [2745912,"Utrecht","NL",52.09083,5.12222,"Utrecht","city"],
  [1258932,"Rajamahendravaram","IN",17.00517,81.77784,"Andhra Pradesh","city"],
  [1621177,"Yogyakarta","ID",-7.80139,110.36472,"Yogyakarta","city"],
  [1272691,"Dhule","IN",20.9013,74.77737,"Maharashtra","city"],
  [1852383,"Minato","JP",34.2152,135.1501,"Wakayama","city"],
  [1749822,"Puchong","MY",3,101.61667,"Selangor","city"],
  [2326171,"Ondo","NG",7.09316,4.83528,"Ondo State","city"],
  [1258076,"Rohtak","IN",28.89447,76.58917,"Haryana","city"],
  [1182682,"Bhawana","PK",31.56884,72.64917,"Punjab","city"],
  [958724,"Rustenburg","ZA",-25.66756,27.24208,"North West","city"],
  [5325738,"Bakersfield","US",35.37329,-119.01871,"California","city"],
  [2033574,"Xuanhua","CN",40.61205,115.06463,"Hebei","city"],
  [939270,"Emalahleni","ZA",-25.87133,29.23323,"Mpumalanga","city"],
  [2235189,"Bafoussam","CM",5.47775,10.41759,"West","city"],
  [1565022,"Thủ Dầu Một","VN",10.9804,106.6519,"Ho Chi Minh City (HCMC)","city"],
  [1851002,"Takasaki","JP",36.33333,139.01667,"Gunma","city"],
  [1734810,"Seremban","MY",2.7297,101.9381,"Negeri Sembilan","city"],
  [3827408,"Miguel Hidalgo","MX",19.43411,-99.20024,"Mexico City","city"],
  [1856215,"Nagano","JP",36.65,138.18333,"Nagano","city"],
  [1734199,"Tawau","MY",4.24482,117.89115,"Sabah","city"],
  [2653822,"Cardiff","GB",51.48,-3.18,"Wales","city"],
  [1814544,"Dachang","CN",31.30873,121.41526,"Shanghai","city"],
  [8616121,"Đống Đa","VN",21.013,105.825,"Hanoi","city"],
  [1106542,"Chitungwiza","ZW",-18.01274,31.07555,"Harare","city"],
  [2320576,"Umuahia","NG",5.52491,7.49461,"Abia State","city"],
  [3629672,"Puerto La Cruz","VE",10.21382,-64.6328,"Anzoátegui","city"],
  [7304020,"Fenghuang","CN",27.93557,109.59961,"Hunan","city"],
  [298299,"Uşak","TR",38.67351,29.4058,"Uşak","city"],
  [1283613,"Bharatpur","NP",27.68027,84.43647,"Bagmati Province","city"],
  [3460644,"Itaquaquecetuba","BR",-23.48611,-46.34833,"São Paulo","city"],
  [7483813,"Natore","BD",24.41112,88.98673,"Rajshahi Division","city"],
  [353219,"6th of October City","EG",29.81667,31.05,"Giza","city"],
  [2644668,"Leicester","GB",52.6386,-1.13169,"England","city"],
  [13546519,"Desna","UA",50.52207,30.68228,"Kyiv City","city"],
  [11048323,"Sector 6","RO",44.43579,26.01649,"Bucharest","city"],
  [7535637,"Avellaneda","AR",-34.66018,-58.36744,"Buenos Aires","city"],
  [1855612,"Nara-shi","JP",34.68505,135.80485,"Nara","city"],
  [3176959,"Florence","IT",43.77925,11.24626,"Tuscany","city"],
  [1279228,"Ahilyanagar","IN",19.09457,74.73843,"Maharashtra","city"],
  [1259091,"Kollam","IN",8.88113,76.58469,"Kerala","city"],
  [8537264,"Huanggang","CN",30.45143,114.87035,"Hubei","city"],
  [3393536,"Olinda","BR",-8.00889,-34.85528,"Pernambuco","city"],
  [2654993,"Bradford","GB",53.79391,-1.75206,"England","city"],
  [1626381,"Sukabumi","ID",-6.91806,106.92667,"West Java","city"],
  [1275637,"Bilāspur","IN",22.08005,82.15543,"Chhattisgarh","city"],
  [1703320,"Malabon","PH",14.67333,120.93972,"National Capital Region","city"],
  [5150529,"Cleveland","US",41.4995,-81.69541,"Ohio","city"],
  [2337181,"Iseyin","NG",7.97022,3.59626,"Oyo State","city"],
  [2318123,"Yenagoa","NG",4.92675,6.26764,"Bayelsa State","city"],
  [2341374,"Gboko","NG",7.32275,9.00108,"Benue State","city"],
  [5950268,"Etobicoke","CA",43.64415,-79.56985,"Ontario","city"],
  [13546342,"Samba","AO",-8.88001,13.19617,"Luanda","city"],
  [1838343,"Pyeongtaek","KR",36.99472,127.08889,"Gyeonggi-do","city"],
  [3630297,"Petare","VE",10.47679,-66.80786,"Miranda","city"],
  [1588060,"Bến Cát","VN",11.15,106.6,"Ho Chi Minh City (HCMC)","city"],
  [1817990,"Anqiu","CN",36.43417,119.1925,"Shandong","city"],
  [324190,"Alanya","TR",36.54375,31.99982,"Antalya","city"],
  [1172128,"Larkana","PK",27.55898,68.21204,"Sindh","city"],
  [379062,"Al Qadarif","SD",14.03493,35.38344,"Al Qaḑārif","city"],
  [627904,"Hrodna","BY",53.6758,23.82887,"Grodnenskaya","city"],
  [1647003,"Cibinong","ID",-6.48167,106.85417,"West Java","city"],
  [1169116,"Nawabshah","PK",26.23939,68.40369,"Sindh","city"],
  [4335045,"New Orleans","US",29.95465,-90.07507,"Louisiana","city"],
  [1678228,"Keelung","TW",25.13089,121.74094,"Taiwan","city"],
  [2692969,"Malmö","SE",55.60587,13.00073,"Skåne","city"],
  [1805029,"Jizhou","CN",37.55054,115.56871,"Hebei","city"],
  [2187404,"Manukau City","NZ",-36.99282,174.87986,"Auckland","city"],
  [3469968,"Blumenau","BR",-26.91944,-49.06611,"Santa Catarina","city"],
  [2441291,"Maradi","NE",13.5,7.10174,"Maradi Region","city"],
  [1182092,"Burewala","PK",30.16667,72.65,"Punjab","city"],
  [6947637,"Ataşehir","TR",40.9833,29.1167,"Istanbul","city"],
  [1799823,"Nanqiao","CN",30.91611,121.44944,"Shanghai","city"],
  [1170395,"Mingora","PK",34.7795,72.36265,"Khyber Pakhtunkhwa","city"],
  [2805753,"Wuppertal","DE",51.25627,7.14816,"North Rhine-Westphalia","city"],
  [2014407,"Ulan-Ude","RU",51.82648,107.59979,"Buryatiya Republic","city"],
  [11694038,"Huocheng","CN",44.05305,80.87173,"Xinjiang","city"],
  [2338400,"Ijebu Ode","NG",6.81944,3.91731,"Ogun State","city"],
  [1275960,"Bhilwara","IN",25.34707,74.64081,"Rajasthan","city"],
  [5412347,"Aurora","US",39.72943,-104.83192,"Colorado","city"],
  [620127,"Vitebsk","BY",55.1904,30.2049,"Vitebsk","city"],
  [3463011,"Franca","BR",-20.53861,-47.40083,"São Paulo","city"],
  [7628419,"Sultanbeyli","TR",40.96072,29.27067,"Istanbul","city"],
  [1516905,"Taraz","KZ",42.89799,71.37334,"Zhambyl","city"],
  [1832828,"Yangsan","KR",35.34199,129.03358,"Gyeongsangnam-do","city"],
  [13546518,"Dniprovskyi","UA",50.45366,30.60146,"Kyiv City","city"],
  [1689395,"San Jose del Monte","PH",14.81389,121.04528,"Central Luzon","city"],
  [13631407,"Abū al-Kahṣīb","IQ",30.4431,47.87802,"Basra","city"],
  [1948005,"Gwangmyeong","KR",37.47722,126.86639,"Gyeonggi-do","city"],
  [111453,"Zanjan","IR",36.67642,48.49628,"Zanjan","city"],
  [3673899,"Neiva","CO",2.93001,-75.27973,"Huila Department","city"],
  [2112539,"Iwaki","JP",37.05,140.88333,"Fukushima","city"],
  [473247,"Vladimir","RU",56.13854,40.39976,"Vladimir Oblast","city"],
  [1026014,"Tete","MZ",-16.15639,33.58667,"Tete","city"],
  [1729524,"Bacoor","PH",14.45896,120.93851,"Calabarzon","city"],
  [1926004,"Wakayama","JP",34.23333,135.16667,"Wakayama","city"],
  [1275198,"Brahmapur","IN",19.31151,84.7929,"Odisha","city"],
  [1673816,"Fengshan","TW",22.62659,120.36126,"Takao","city"],
  [747158,"Fatih","TR",41.0225,28.94083,"Istanbul","city"],
  [3402429,"Caucaia","BR",-3.73611,-38.65306,"Ceará","city"],
  [2214846,"Misratah","LY",32.37535,15.09254,"Misratah","city"],
  [3348078,"Cuíto","AO",-12.38333,16.93333,"Bíe","city"],
  [3827406,"Benito Juarez","MX",19.3984,-99.15766,"Mexico City","city"],
  [1519922,"Kyzylorda","KZ",44.85278,65.50917,"Kyzylorda","city"],
  [1164776,"Sinjhoro","PK",26.03008,68.80867,"Sindh","city"],
  [1859740,"Kawagoe","JP",35.90861,139.48528,"Saitama","city"],
  [1850910,"Takatsuki","JP",34.84833,135.61678,"Osaka","city"],
  [1262330,"Muzaffarpur","IN",26.12259,85.39055,"Bihar","city"],
  [3516266,"Tapachula","MX",14.90541,-92.25891,"Chiapas","city"],
  [8067345,"Lhoka","CN",29.24301,91.77239,"Tibet","city"],
  [3514670,"Villahermosa","MX",17.98625,-92.93928,"Tabasco","city"],
  [3466954,"Cariacica","BR",-20.26389,-40.42,"Espírito Santo","city"],
  [1735162,"Setapak","MY",3.207,101.727,"Selangor","city"],
  [625665,"Mahilyow","BY",53.90876,30.34044,"Mogilev","city"],
  [141681,"Bandar Abbas","IR",27.1865,56.2808,"Hormozgan","city"],
  [13580034,"Pravyi Bereh","UA",47.11498,37.58519,"Donetsk","city"],
  [1512296,"Yunusobod","UZ",41.37139,69.27944,"Tashkent","city"],
  [291074,"Ras Al Khaimah","AE",25.78953,55.9432,"Ras Al Khaimah","city"],
  [3647651,"Cabimas","VE",10.39907,-71.45206,"Zulia","city"],
  [1640344,"Kendari","ID",-3.9778,122.51507,"Southeast Sulawesi","city"],
  [5856195,"Honolulu","US",21.30694,-157.85833,"Hawaii","city"],
  [5323810,"Anaheim","US",33.83529,-117.9145,"California","city"],
  [299817,"Tarsus","TR",36.91766,34.89277,"Mersin","city"],
  [1259239,"Punāsa","IN",22.23507,76.39335,"Madhya Pradesh","city"],
  [1798900,"Pengze","CN",29.89885,116.54572,"Jiangxi","city"],
  [342884,"Bahir Dar","ET",11.59364,37.39077,"Amhara","city"],
  [8764562,"Diepsloot","ZA",-25.93312,28.01213,"Gauteng","city"],
  [99100,"Al Maḩmūdīyah","IQ",33.06221,44.36564,"Baghdad","city"],
  [8054802,"Xilinhot","CN",43.93889,116.07021,"Inner Mongolia","city"],
  [3452465,"Praia Grande","BR",-24.00583,-46.40278,"São Paulo","city"],
  [1028434,"Quelimane","MZ",-17.87861,36.88833,"Zambezia Province","city"],
  [581049,"Arkhangel’sk","RU",64.5461,40.55183,"Arkhangelskaya","city"],
  [1262332,"Muzaffarnagar","IN",29.47091,77.70332,"Uttar Pradesh","city"],
  [12548253,"Hulunbuir","CN",49.21141,119.75582,"Inner Mongolia","city"],
  [1645133,"Dumai","ID",1.66711,101.44316,"Riau","city"],
  [11790353,"Shinjuku","JP",35.69115,139.70854,"Tokyo","city"],
  [2451185,"Sikasso","ML",11.31755,-5.66654,"Sikasso","city"],
  [117574,"Sanandaj","IR",35.31495,46.99883,"Kurdistan Province","city"],
  [2025339,"Chita","RU",52.04311,113.49171,"Zabaykalskiy (Transbaikal) Kray","city"],
  [1688749,"San Pedro","PH",14.3595,121.0473,"Calabarzon","city"],
  [3403642,"Campina Grande","BR",-7.23056,-35.88111,"Paraíba","city"],
  [2521978,"Alicante","ES",38.34517,-0.48149,"Valencia","city"],
  [2388873,"Bimbo","CF",4.25671,18.41583,"Ombella-M'Poko","city"],
  [1321218,"Kalemyo","MM",23.19014,94.06405,"Sagaing Region","city"],
  [2655984,"Belfast","GB",54.59682,-5.92541,"Northern Ireland","city"],
  [1564064,"Long Bien","VN",21.03333,105.9,"Hanoi","city"],
  [3566067,"Camagüey","CU",21.38083,-77.91694,"Camagüey","city"],
  [1813206,"Daye","CN",30.08333,114.95,"Hubei","city"],
  [3128026,"Bilbao","ES",43.26271,-2.92528,"Basque Country","city"],
  [1651531,"Ambon","ID",-3.69583,128.18333,"Maluku","city"],
  [629634,"Brest","BY",52.10894,23.71749,"Brest","city"],
  [2038067,"Chifeng","CN",42.26833,118.96361,"Inner Mongolia","city"],
  [8310663,"Central Coast","AU",-33.42979,151.37144,"New South Wales","city"],
  [3435217,"Corrientes","AR",-27.46784,-58.8344,"Corrientes","city"],
  [1877030,"Hŭngnam","KP",39.84198,127.63206,"South Hamgyong","city"],
  [1278130,"Avadi","IN",13.1147,80.10981,"Tamil Nadu","city"],
  [12277239,"Yunlong","CN",34.25281,117.25167,"Jiangsu","city"],
  [1858729,"Koshigaya","JP",35.89035,139.78916,"Saitama","city"],
  [2652221,"Coventry","GB",52.40656,-1.51217,"England","city"],
  [578072,"Belgorod","RU",50.60343,36.58091,"Belgorod Oblast","city"],
  [1053384,"Toamasina","MG",-18.1492,49.40234,"Atsinanana","city"],
  [7281838,"Logan City","AU",-27.63917,153.10944,"Queensland","city"],
  [1853574,"Ōtsu","JP",35,135.86667,"Shiga","city"],
  [371760,"Kosti","SD",13.1629,32.66347,"White Nile","city"],
  [2035261,"Qitaihe","CN",45.768,130.9953,"Heilongjiang","city"],
  [1273800,"Kadapa","IN",14.47995,78.82346,"Andhra Pradesh","city"],
  [8715035,"Nakano","JP",35.70449,139.66946,"Tokyo","city"],
  [1646170,"Cirebon","ID",-6.7063,108.557,"West Java","city"],
  [3625829,"Turmero","VE",10.22856,-67.47421,"Aragua","city"],
  [1850181,"Tokorozawa","JP",35.79916,139.46903,"Saitama","city"],
  [1721906,"Cabanatuan City","PH",15.48586,120.96648,"Central Luzon","city"],
  [1785716,"Pizhou","CN",34.31139,117.95028,"Jiangsu","city"],
  [13580095,"Darnytsya","UA",50.41596,30.69534,"Kyiv City","city"],
  [338832,"Dire Dawa","ET",9.59306,41.86611,"Dire Dawa","city"],
  [2506999,"Annaba","DZ",36.9,7.76667,"Annaba","city"],
  [2990440,"Nice","FR",43.70313,7.26608,"Provence-Alpes-Côte d'Azur","city"],
  [1711084,"Iligan","PH",8.2289,124.24344,"Northern Mindanao","city"],
  [3667849,"Soledad","CO",10.91843,-74.76459,"Atlántico","city"],
  [2529013,"Temara","MA",33.92866,-6.90656,"Rabat-Salé-Kénitra","city"],
  [1795060,"Shiqi","CN",22.51682,113.38521,"Guangdong","city"],
  [3392740,"Paulista","BR",-7.94083,-34.87306,"Pernambuco","city"],
  [2566633,"Obalende","NG",6.44694,3.41528,"Lagos","city"],
  [1265767,"Kukatpally","IN",17.48486,78.41376,"Telangana","city"],
  [1794479,"Laixi","CN",36.85917,120.52694,"Shandong","city"],
  [96994,"Dihok","IQ",36.86608,42.9879,"Duhok","city"],
  [553915,"Kaluga","RU",54.53063,36.27,"Kaluga Oblast","city"],
  [13405933,"Bắc Từ Liêm","VN",21.06532,105.74661,"Hanoi","city"],
  [4014875,"Celaya","MX",20.52181,-100.81399,"Guanajuato","city"],
  [2411989,"Serekunda","GM",13.43833,-16.67806,"Banjul","city"],
  [1199503,"Kafrul","BD",23.78822,90.37359,"Dhaka Division","city"],
  [308988,"Karşıyaka","TR",38.45772,27.1142,"İzmir Province","city"],
  [356436,"Ḩadā’iq al Qubbah","EG",30.08843,31.28351,"Cairo","city"],
  [702320,"Makiyivka","UA",48.04782,37.92576,"Donetsk","city"],
  [4498303,"West Raleigh","US",35.78682,-78.66389,"North Carolina","city"],
  [3529947,"Cuernavaca","MX",18.9261,-99.23075,"Morelos","city"],
  [6066513,"Markham","CA",43.86682,-79.2663,"Ontario","city"],
  [1876373,"Kaesŏng","KP",37.97083,126.55444,"Kaesong","city"],
  [3445839,"Uberaba","BR",-19.74833,-47.93194,"Minas Gerais","city"],
  [1185098,"Tungi","BD",23.89154,90.40232,"Dhaka Division","city"],
  [8504952,"Krasnogvargeisky","RU",59.97305,30.47607,"St.-Petersburg","city"],
  [963241,"Randburg","ZA",-26.0941,28.00123,"Gauteng","city"],
  [2537881,"Safi","MA",32.29939,-9.23718,"Marrakesh-Safi","city"],
  [693805,"Simferopol","UA",44.95719,34.11079,"Crimea","city"],
  [765876,"Lublin","PL",51.25058,22.57009,"Lublin","city"],
  [4167147,"Orlando","US",28.53834,-81.37924,"Florida","city"],
  [3868121,"Viña del Mar","CL",-33.02457,-71.55183,"Valparaiso","city"],
  [2034439,"Tieling","CN",42.29306,123.84139,"Liaoning","city"],
  [119505,"Qazvin","IR",36.26877,50.0041,"Qazvin Province","city"],
  [2130629,"Asahikawa","JP",43.77063,142.36489,"Hokkaido","city"],
  [1268257,"Kāmārhāti","IN",22.67111,88.37472,"West Bengal","city"],
  [3981941,"Tepic","MX",21.50733,-104.89332,"Nayarit","city"],
  [1833105,"Wŏnju","KR",37.35139,127.94528,"Gangwon-do","city"],
  [364103,"Wad Medani","SD",14.40118,33.51989,"Al Jazirah","city"],
  [9645084,"Quận Mười Một","VN",10.76383,106.64355,"Ho Chi Minh City (HCMC)","city"],
  [601294,"Nukus","UZ",42.45861,59.60576,"Karakalpakstan","city"],
  [306641,"Konak","TR",38.4,27.1,"İzmir Province","city"],
  [1857843,"Maebashi","JP",36.4,139.08333,"Gunma","city"],
  [8469285,"Kita","JP",35.75264,139.73348,"Tokyo","city"],
  [3530580,"Ciudad Victoria","MX",23.74061,-99.14364,"Tamaulipas","city"],
  [3982912,"Soledad de Graciano Sánchez","MX",22.18912,-100.93792,"San Luis Potosí","city"],
  [1859146,"Kochi","JP",33.55,133.53333,"Kochi","city"],
  [2949186,"Bielefeld","DE",52.03333,8.53333,"North Rhine-Westphalia","city"],
  [2503769,"Blida","DZ",36.47004,2.8277,"Blida","city"],
  [1819595,"Kwai Chung","HK",22.36828,114.13877,"Kwai Tsing District","city"],
  [1701947,"Mandaue City","PH",10.32361,123.92222,"Central Visayas","city"],
  [586523,"Ganja","AZ",40.68157,46.36134,"Gǝncǝ","city"],
  [127319,"Khorramshahr","IR",30.44079,48.18428,"Khuzestan","city"],
  [2946447,"Bonn","DE",50.73438,7.09549,"North Rhine-Westphalia","city"],
  [1263364,"Mathura","IN",27.5035,77.67215,"Uttar Pradesh","city"],
  [12358476,"Hechi","CN",24.69285,108.08376,"Guangxi","city"],
  [3102014,"Bydgoszcz","PL",53.1235,18.00762,"Kujawsko-Pomorskie","city"],
  [491687,"Smolensk","RU",54.77826,32.05088,"Smolensk Oblast","city"],
  [608668,"Oral","KZ",51.24601,51.42558,"West Kazakhstan","city"],
  [3448136,"São Vicente","BR",-23.96306,-46.39194,"São Paulo","city"],
  [127349,"Khorramabad","IR",33.48778,48.35583,"Lorestan Province","city"],
  [3451353,"Ribeirão das Neves","BR",-19.76694,-44.08667,"Minas Gerais","city"],
  [3583096,"Soyapango","SV",13.71024,-89.13989,"San Salvador Department","city"],
  [1787824,"Tongshan","CN",34.18045,117.15707,"Jiangsu","city"],
  [2595778,"Guédiawaye","SN",14.77446,-17.40212,"Dakar","city"],
  [3448632,"São José dos Pinhais","BR",-25.5302,-49.20836,"Paraná","city"],
  [728193,"Plovdiv","BG",42.15387,24.75001,"Plovdiv","city"],
  [4013704,"Ciudad Obregón","MX",27.48642,-109.94079,"Sonora","city"],
  [1866923,"Wŏnsan","KP",39.15278,127.44361,"Kangwŏn-do","city"],
  [2654789,"Brent","GB",51.55306,-0.3023,"England","city"],
  [1520240,"Pavlodar","KZ",52.27601,76.96881,"Pavlodar Region","city"],
  [1274693,"Chānda","IN",19.95076,79.29523,"Maharashtra","city"],
  [3467467,"Canoas","BR",-29.91778,-51.18361,"Rio Grande do Sul","city"],
  [2112141,"Kōriyama","JP",37.4,140.38333,"Fukushima","city"],
  [491422,"Sochi","RU",43.59699,39.72477,"Krasnodar Krai","city"],
  [324496,"Aksaray","TR",38.37255,34.02537,"Aksaray","city"],
  [1275701,"Vijayapura","IN",16.82442,75.71537,"Karnataka","city"],
  [918702,"Chipata","ZM",-13.63333,32.65,"Eastern Province","city"],
  [2044757,"Chongjin","KP",41.79556,129.77583,"North Hamgyong","city"],
  [2033467,"Yanji","CN",42.88825,129.50241,"Jilin","city"],
  [936374,"Roodepoort","ZA",-26.1625,27.8725,"Gauteng","city"],
  [3693345,"Pucallpa","PE",-8.37915,-74.55387,"Ucayali","city"],
  [3457001,"Mogi das Cruzes","BR",-23.52278,-46.18833,"São Paulo","city"],
  [2519240,"Córdoba","ES",37.89155,-4.77275,"Andalusia","city"],
  [2655613,"Birkenhead","GB",53.39337,-3.01479,"England","city"],
  [2990969,"Nantes","FR",47.21725,-1.55336,"Pays de la Loire","city"],
  [2337704,"Ilesa","NG",7.62789,4.74161,"Osun State","city"],
  [1631766,"Pekalongan","ID",-6.8886,109.6753,"Central Java","city"],
  [1209106,"Bhatara","BD",23.8,90.45,"Dhaka Division","city"],
  [660158,"Espoo","FI",60.2052,24.6522,"Uusimaa","city"],
  [192126,"Kikuyu","KE",-1.24627,36.66291,"Kiambu County","city"],
  [1732811,"Kluang","MY",2.03046,103.31689,"Johor","city"],
  [1803590,"Lincang","CN",23.87972,100.09455,"Yunnan","city"],
  [2641170,"Nottingham","GB",52.9536,-1.15047,"England","city"],
  [13631350,"Ramiros","AO",-9.06259,13.0456,"Luanda","city"],
  [99608,"Al ‘Amārah","IQ",31.83561,47.14483,"Maysan","city"],
  [472231,"Volzhsky","RU",48.78583,44.77973,"Volgograd Oblast","city"],
  [6173577,"Vaughan","CA",43.8361,-79.49827,"Ontario","city"],
  [1807566,"Xingyi","CN",25.09617,104.90639,"Guizhou","city"],
  [3461789,"Guarujá","BR",-23.99306,-46.25639,"São Paulo","city"],
  [1256515,"Shivamogga","IN",13.93157,75.56791,"Karnataka","city"],
  [1278946,"Alwar","IN",27.56246,76.625,"Rajasthan","city"],
  [2236568,"Uíge","AO",-7.60874,15.06131,"Uíge","city"],
  [3526682,"Ixtapaluca","MX",19.31556,-98.88284,"México","city"],
  [1527534,"Osh","KG",40.52828,72.7985,"Osh Region","city"],
  [3652941,"Portoviejo","EC",-1.05764,-80.45145,"Manabí","city"],
  [3665900,"Villavicencio","CO",4.13238,-73.62564,"Meta Department","city"],
  [1874533,"Man’gyŏngdae-ri","KP",38.99182,125.65871,"Pyongyang","city"],
  [3701329,"San Miguelito","PA",9.05032,-79.47068,"Panamá","city"],
  [3454244,"Pelotas","BR",-31.76997,-52.34101,"Rio Grande do Sul","city"],
  [1256728,"Shāhjānpur","IN",27.88165,79.90918,"Uttar Pradesh","city"],
  [4297983,"Lexington","US",37.98869,-84.47772,"Kentucky","city"],
  [6958518,"Tantou","CN",22.75121,113.83496,"Guangdong","city"],
  [3472287,"Anápolis","BR",-16.32667,-48.95278,"Goiás","city"],
  [1876401,"Kaech’ŏn","KP",39.70056,125.89333,"South Pyongan","city"],
  [1268773,"Jūnāgadh","IN",21.51966,70.45981,"Gujarat","city"],
  [2646003,"Islington","GB",51.53622,-0.10304,"England","city"],
  [3556969,"Holguín","CU",20.88722,-76.26306,"Holguín Province","city"],
  [1520316,"Ust-Kamenogorsk","KZ",49.97143,82.60586,"East Kazakhstan","city"],
  [1818209,"Tsuen Wan","HK",22.37137,114.11329,"Tsuen Wan","city"],
  [2437798,"Zinder","NE",13.80716,8.9881,"Zinder Region","city"],
  [498698,"Saransk","RU",54.18485,45.17166,"Mordoviya Republic","city"],
  [99762,"Al Diwaniyah","IQ",31.99289,44.92552,"Al-Qadisiyah","city"],
  [726050,"Varna","BG",43.21912,27.91024,"Varna","city"],
  [1177384,"Hafizabad","PK",32.07095,73.68802,"Punjab","city"],
  [12278193,"Marne La Vallée","FR",48.83584,2.64241,"Île-de-France","city"],
  [1633118,"Palangkaraya","ID",-2.20833,113.91667,"Central Kalimantan","city"],
  [358448,"Damanhur","EG",31.03408,30.46823,"Beheira","city"],
  [1181096,"Chiniot","PK",31.72091,72.97836,"Punjab","city"],
  [3671916,"Popayán","CO",2.43823,-76.61316,"Cauca Department","city"],
  [2639577,"Reading","GB",51.45625,-0.97113,"England","city"],
  [159908,"Geita","TZ",-2.8725,32.2325,"Geita","city"],
  [3446682,"Taubaté","BR",-23.02639,-45.55528,"São Paulo","city"],
  [680963,"Constanţa","RO",44.18073,28.63432,"Constanța County","city"],
  [734077,"Thessaloníki","GR",40.64072,22.93493,"Central Macedonia","city"],
  [2244802,"Thiès","SN",14.78944,-16.92602,"Thies","city"],
  [1856035,"Naha","JP",26.213,127.67851,"Okinawa","city"],
  [5387877,"Riverside","US",33.95335,-117.39616,"California","city"],
  [2038569,"Baicheng","CN",45.61751,122.83302,"Jilin","city"],
  [3698304,"Chimbote","PE",-9.07508,-78.59373,"Ancash","city"],
  [3182351,"Bari","IT",41.12066,16.86982,"Apulia","city"],
  [3470353,"Barueri","BR",-23.51056,-46.87611,"São Paulo","city"],
  [4683416,"Corpus Christi","US",27.80058,-97.39638,"Texas","city"],
  [1254187,"Thrissur","IN",10.51667,76.21667,"Kerala","city"],
  [569223,"Cherepovets","RU",59.13333,37.9,"Vologda Oblast","city"],
  [3658192,"Eloy Alfaro","EC",-2.16919,-79.83987,"Guayas","city"],
  [8354626,"Hamburg-Nord","DE",53.58935,9.984,"Hamburg","city"],
  [99131,"Al-Kut","IQ",32.5128,45.81817,"Wasit","city"],
  [1732869,"Muar","MY",2.0442,102.5689,"Johor","city"],
  [739549,"Şişli","TR",41.06046,28.98717,"Istanbul","city"],
  [3445451,"Várzea Grande","BR",-15.64667,-56.1325,"Mato Grosso","city"],
  [4297999,"Lexington-Fayette","US",38.0498,-84.45855,"Kentucky","city"],
  [2228373,"Maroua","CM",10.59095,14.31593,"Far North","city"],
  [2645425,"Kingston upon Hull","GB",53.7446,-0.33525,"England","city"],
  [2639912,"Preston","GB",53.76282,-2.70452,"England","city"],
  [2036434,"Lianshan","CN",40.76432,120.85327,"Liaoning","city"],
  [317109,"Denizli","TR",37.77417,29.0875,"Denizli","city"],
  [2338313,"Ikeja","NG",6.59651,3.34205,"Lagos","city"],
  [7799991,"New Cairo","EG",30.03,31.47,"Cairo","city"],
  [8134081,"Al Qāhirah al Jadīdah","EG",30.04214,31.44446,"","city"],
  [3444924,"Vitória","BR",-20.31944,-40.33778,"Espírito Santo","city"],
  [3673164,"Palmira","CO",3.53944,-76.30361,"Valle del Cauca Department","city"],
  [472459,"Vologda","RU",59.2239,39.88398,"Vologda Oblast","city"],
  [1711082,"Iligan City","PH",8.25,124.4,"Soccsksargen","city"],
  [3457671,"Maringá","BR",-23.42528,-51.93861,"Paraná","city"],
  [2525068,"Catania","IT",37.49223,15.07041,"Sicily","city"],
  [11962408,"Jardim Angela","BR",-23.71636,-46.76872,"São Paulo","city"],
  [1261258,"Nizāmābād","IN",18.67154,78.0988,"Telangana","city"],
  [4508722,"Cincinnati","US",39.12711,-84.51439,"Ohio","city"],
  [1214189,"Percut","ID",3.6253,98.864,"North Sumatra","city"],
  [3530517,"Coatzacoalcos","MX",18.14905,-94.4447,"Veracruz","city"],
  [5392900,"Santa Ana","US",33.74557,-117.86783,"California","city"],
  [1870883,"Sariwŏn-si","KP",38.50722,125.75583,"North Hwanghae","city"],
  [1016670,"Botshabelo","ZA",-29.26737,26.72595,"Free State","city"],
  [1722186,"Butuan","PH",8.94917,125.54361,"Caraga","city"],
  [143860,"Shahrīār","IR",35.65884,51.05775,"Tehran","city"],
  [120292,"Qods","IR",35.7214,51.109,"Tehran","city"],
  [9871722,"Gia Lâm","VN",21.02,105.939,"Hanoi","city"],
  [1501321,"Kurgan","RU",55.44905,65.34344,"Kurgan Oblast","city"],
  [3516355,"Tampico","MX",22.28519,-97.87777,"Tamaulipas","city"],
  [2566696,"Akowonjo","NG",6.61012,3.30968,"Lagos","city"],
  [1721281,"Cabuyao","PH",14.2726,121.1262,"Calabarzon","city"],
  [149658,"Tabora","TZ",-5.01622,32.82663,"Tabora","city"],
  [1859891,"Kasugai","JP",35.24762,136.97229,"Aichi","city"],
  [1594308,"An Nhơn","VN",13.88579,109.10823,"Gia Lai","city"],
  [2566676,"Alimosho","NG",6.60656,3.30235,"Lagos","city"],
  [4003757,"Ciudad Benito Juárez","MX",25.6466,-100.09142,"Nuevo León","city"],
  [2867543,"Münster","DE",51.96236,7.62571,"North Rhine-Westphalia","city"],
  [2873891,"Mannheim","DE",49.4891,8.46694,"Baden-Wurttemberg","city"],
  [1641134,"Karawang","ID",-6.30525,107.3197,"West Java","city"],
  [2113126,"Akita","JP",39.71667,140.11667,"Akita","city"],
  [3447212,"Suzano","BR",-23.5425,-46.31083,"São Paulo","city"],
  [1254089,"Tumkūr","IN",13.34136,77.1022,"Karnataka","city"],
  [1846052,"Chinju","KR",35.19278,128.08472,"Gyeongsangnam-do","city"],
  [1260341,"Parbhani","IN",19.26855,76.77081,"Maharashtra","city"],
  [1270022,"Hisar","IN",29.15394,75.72294,"Haryana","city"],
  [1843491,"Iksan","KR",35.94389,126.95444,"Jeollabuk-do","city"],
  [1271885,"Fīrozābād","IN",27.15092,78.39781,"Uttar Pradesh","city"],
  [3474574,"Palmas","BR",-10.16745,-48.32766,"Tocantins","city"],
  [473249,"Vladikavkaz","RU",43.04101,44.66986,"North Ossetia–Alania","city"],
  [3718420,"Port-de-Paix","HT",19.93984,-72.83037,"Nord-Ouest","city"],
  [358048,"Damietta","EG",31.41648,31.81332,"Damietta","city"],
  [3429886,"Posadas","AR",-27.39184,-55.92379,"Misiones","city"],
  [1016181,"Brakpan","ZA",-26.23656,28.36938,"Gauteng","city"],
  [5399020,"Stockton","US",37.9577,-121.29078,"California","city"],
  [1848373,"Yokkaichi","JP",34.96667,136.61667,"Mie","city"],
  [1265711,"Kulti","IN",23.73166,86.84372,"West Bengal","city"],
  [3515463,"Tláhuac","MX",19.28689,-99.00507,"Mexico City","city"],
  [2323675,"Sapele","NG",5.89405,5.67666,"Delta","city"],
  [128476,"Kashan","IR",33.98237,51.42769,"Isfahan","city"],
  [6861211,"Kāshān","IR",34.00228,51.43879,"Isfahan","city"],
  [5206379,"Pittsburgh","US",40.44062,-79.99589,"Pennsylvania","city"],
  [3689560,"Armenia","CO",4.53656,-75.67263,"Quindío Department","city"],
  [3984583,"Santa Catarina","MX",25.67325,-100.45813,"Nuevo León","city"],
  [149703,"Sumbawanga","TZ",-7.96667,31.61667,"Rukwa","city"],
  [515012,"Orël","RU",52.96879,36.0791,"Oryol oblast","city"],
  [1847966,"Akashi","JP",34.65524,135.00687,"Hyōgo","city"],
  [8616127,"Hai Bà Trưng","VN",21.01341,105.84772,"Hanoi","city"],
  [1858088,"Kurume","JP",33.31667,130.51667,"Fukuoka","city"],
  [2778067,"Graz","AT",47.06733,15.44197,"Styria","city"],
  [5045360,"Saint Paul","US",44.94441,-93.09327,"Minnesota","city"],
  [1572532,"Nghi Sơn","VN",19.32746,105.82145,"Thanh Hóa Province","city"],
  [1267708,"Karnāl","IN",29.69197,76.98448,"Haryana","city"],
  [1815482,"Changyi","CN",36.85361,119.39083,"Shandong","city"],
  [3439101,"Ciudad del Este","PY",-25.5036,-54.65067,"Alto Paraná Department","city"],
  [350203,"Rosetta","EG",31.39951,30.41718,"Beheira","city"],
  [1277029,"Barddhamān","IN",23.25572,87.85691,"West Bengal","city"],
  [8572994,"Toshima","JP",35.76126,139.74491,"Tokyo","city"],
  [1640660,"Kediri","ID",-7.81667,112.01667,"East Java","city"],
  [897045,"Solwezi","ZM",-12.1688,26.38938,"North-Western","city"],
  [2911288,"Hamburg-Mitte","DE",53.55,10.01667,"Hamburg","city"],
  [2954172,"Augsburg","DE",48.37154,10.89851,"Bavaria","city"],
  [6697759,"South Dublin","IE",53.29026,-6.34151,"Leinster","city"],
  [3106672,"Valladolid","ES",41.65541,-4.72353,"Castille and León","city"],
  [1738050,"Miri","MY",4.39928,113.99163,"Sarawak","city"],
  [1789262,"Xinyi","CN",34.38424,118.34617,"Jiangsu","city"],
  [1170880,"Mardan","PK",34.19794,72.04965,"Khyber Pakhtunkhwa","city"],
  [1490624,"Surgut","RU",61.25757,73.41775,"Khanty-Mansia","city"],
  [2636432,"Swansea","GB",51.62079,-3.94323,"Wales","city"],
  [1688830,"San Pablo","PH",14.0683,121.3256,"Calabarzon","city"],
  [2641673,"Newcastle upon Tyne","GB",54.97328,-1.61396,"England","city"],
  [11679708,"Gundupālaiyam","IN",11.94096,79.80294,"Puducherry","city"],
  [5959974,"Gatineau","CA",45.47723,-75.70164,"Quebec","city"],
  [1171305,"Malir Cantonment","PK",24.94343,67.20591,"Sindh","city"],
  [1725115,"Biñan","PH",14.34267,121.08071,"Calabarzon","city"],
  [1787323,"Yangshuo","CN",24.78081,110.48967,"Guangxi","city"],
  [3632308,"Mérida","VE",8.57899,-71.16922,"Mérida","city"],
  [363807,"Winejok","SS",9.01222,27.57081,"Northern Bahr al Ghazal","city"],
  [442301,"Batikent","TR",39.96833,32.73083,"Ankara","city"],
  [1803364,"Linqu","CN",36.51556,118.53972,"Shandong","city"],
  [3980760,"Uruapan","MX",19.41677,-102.05842,"Michoacán","city"],
  [1282931,"Pātan","NP",27.67658,85.31417,"Bagmati Province","city"],
  [1514019,"Fergana","UZ",40.38421,71.78432,"Fergana","city"],
  [3865086,"Bahía Blanca","AR",-38.7176,-62.26545,"Buenos Aires","city"],
  [1687687,"Santol","PH",15.16222,120.5675,"Central Luzon","city"],
  [2250805,"Kaolack","SN",14.15197,-16.07259,"Kaolack","city"],
  [1642588,"Jember","ID",-8.17211,113.69953,"East Java","city"],
  [2130658,"Aomori","JP",40.81667,140.73333,"Aomori","city"],
  [1277065,"Bārāsat","IN",22.72154,88.48198,"West Bengal","city"],
  [12165955,"Mulugu","IN",18.191,79.943,"Telangana","city"],
  [1275716,"Bihār Sharīf","IN",25.20084,85.52389,"Bihar","city"],
  [1624494,"Tegal","ID",-6.8694,109.1402,"Central Java","city"],
  [558418,"Grozny","RU",43.31195,45.68895,"Chechnya","city"],
  [2316702,"Boma","CD",-5.85098,13.05364,"Bas-Congo","city"],
  [1277539,"Bāli","IN",22.64859,88.34115,"West Bengal","city"],
  [1794209,"Pu'er","CN",22.78863,100.97481,"Yunnan","city"],
  [1258599,"Rāmpur","IN",28.81014,79.02699,"Uttar Pradesh","city"],
  [1273491,"Darbhanga","IN",26.15216,85.89707,"Bihar","city"],
  [1260476,"Panipat","IN",29.38747,76.96825,"Haryana","city"],
  [776069,"Białystok","PL",53.13333,23.16433,"Podlasie","city"],
  [8461573,"Mwene","CD",-9.81697,22.87023,"Lualaba","city"],
  [2246512,"Rufisque","SN",14.71542,-17.27334,"Dakar","city"],
  [524305,"Murmansk","RU",68.96778,33.09922,"Murmansk","city"],
  [1254360,"Tirupati","IN",13.63551,79.41989,"Andhra Pradesh","city"],
  [2637433,"Southend-on-Sea","GB",51.53782,0.71433,"England","city"],
  [5072006,"Lincoln","US",40.8,-96.66696,"Nebraska","city"],
  [8531735,"Phu Quoc","VN",10.22409,103.97156,"An Giang","city"],
  [1817240,"Baiyin","CN",36.54696,104.17023,"Gansu","city"],
  [2112923,"Fukushima","JP",37.75,140.46667,"Fukushima","city"],
  [3161732,"Bergen","NO",60.39299,5.32415,"Vestland","city"],
  [6954929,"Greater Noida","IN",28.49615,77.53601,"Uttar Pradesh","city"],
  [7279746,"Noida","IN",28.58,77.33,"Uttar Pradesh","city"],
  [484646,"Tambov","RU",52.73632,41.44102,"Tambov Oblast","city"],
  [3105976,"Vigo","ES",42.23282,-8.72264,"Galicia","city"],
  [1279186,"Aizawl","IN",23.72894,92.71791,"Mizoram","city"],
  [1650217,"Banjarbaru","ID",-3.4406,114.8365,"South Kalimantan","city"],
  [8616118,"Thanh Xuân","VN",20.99472,105.79977,"Hanoi","city"],
  [109571,"Al Hufūf","SA",25.36467,49.58764,"Eastern Province","city"],
  [3530757,"Cholula","MX",19.06406,-98.30352,"Puebla","city"],
  [1271715,"Gandhinagar","IN",23.21667,72.68333,"Gujarat","city"],
  [1519422,"Semey","KZ",50.42064,80.25025,"Abai Region","city"],
  [8616113,"Cầu Giấy","VN",21.03228,105.80073,"Hanoi","city"],
  [1272543,"Dindigul","IN",10.36896,77.98036,"Tamil Nadu","city"],
  [3453186,"Ponta Grossa","BR",-25.095,-50.16194,"Paraná","city"],
  [1810295,"Gaozhou","CN",21.91965,110.85678,"Guangdong","city"],
  [1175088,"Kamoke","PK",31.97526,74.22304,"Punjab","city"],
  [3458575,"Limeira","BR",-22.56472,-47.40167,"São Paulo","city"],
  [1254649,"Thanjavur","IN",10.78523,79.13909,"Tamil Nadu","city"],
  [946877,"Kariega","ZA",-33.75562,25.40074,"Eastern Cape","city"],
  [325330,"Adıyaman","TR",37.76441,38.27629,"Adıyaman Province","city"],
  [109101,"Al Mubarraz","SA",25.40768,49.59028,"Eastern Province","city"],
  [3429577,"Resistencia","AR",-27.46363,-58.98665,"Chaco","city"],
  [2111834,"Morioka","JP",39.7,141.15,"Iwate","city"],
  [610529,"Atyrau","KZ",47.1048,51.88427,"Atyrau Oblisi","city"],
  [11048318,"Sector 2","RO",44.4528,26.13321,"Bucharest","city"],
  [1788245,"Xiuying","CN",20.00073,110.29359,"Hainan","city"],
  [3628473,"San Cristóbal","VE",7.76593,-72.23576,"Táchira","city"],
  [1646494,"Cileungsir","ID",-6.39472,106.95917,"West Java","city"],
  [1267755,"Karīmnagar","IN",18.43915,79.12856,"Telangana","city"],
  [6174041,"Victoria","CA",48.4359,-123.35155,"British Columbia","city"],
  [5879400,"Anchorage","US",61.21806,-149.90028,"Alaska","city"],
  [1273066,"Dewas","IN",22.96585,76.05526,"Madhya Pradesh","city"],
  [2505572,"Batna","DZ",35.55597,6.17414,"Batna","city"],
  [598316,"Kaunas","LT",54.90156,23.90909,"Kaunas","city"],
  [1255744,"Sonīpat","IN",28.99478,77.01937,"Haryana","city"],
  [3654533,"Machala","EC",-3.25886,-79.95876,"El Oro","city"],
  [2809346,"Wiesbaden","DE",50.08601,8.24435,"Hesse","city"],
  [4300488,"Meads","US",38.41258,-82.70905,"Kentucky","city"],
  [916095,"Kabwe","ZM",-14.4469,28.44644,"Central Province","city"],
  [2040893,"Sinŭiju","KP",40.10056,124.39806,"P'yŏngan-bukto","city"],
  [11790374,"Meguro","JP",35.6322,139.70174,"Tokyo","city"],
  [11048320,"Sector 4","RO",44.37571,26.12085,"Bucharest","city"],
  [1851454,"Sumida","JP",35.73289,139.82085,"Tokyo","city"],
  [1862033,"Ibaraki","JP",34.81641,135.56828,"Osaka","city"],
  [1591449,"Bắc Ninh","VN",21.18608,106.07631,"Bac Ninh","city"],
  [1269834,"Ichalkaranji","IN",16.69117,74.46054,"Maharashtra","city"],
  [2911287,"Marienthal","DE",53.56667,10.08333,"Hamburg","city"],
  [1570357,"Phú Mỹ","VN",10.63333,107.06667,"Ho Chi Minh City (HCMC)","city"],
  [3466489,"Ceilândia","BR",-15.8091,-48.13096,"Federal District","city"],
  [3096472,"Katowice","PL",50.2597,19.02173,"Silesia","city"],
  [752850,"Adapazarı","TR",40.78056,30.40333,"Sakarya","city"],
  [681290,"Cluj-Napoca","RO",46.76667,23.6,"Cluj County","city"],
  [1842030,"Gunpo","KR",37.3675,126.94694,"Gyeonggi-do","city"],
  [877401,"Songea","TZ",-10.68333,35.65,"Ruvuma","city"],
  [217562,"Butembo","CD",0.14164,29.29117,"North Kivu","city"],
  [3928128,"Tacna","PE",-18.01465,-70.25362,"Tacna","city"],
  [1818558,"Tin Shui Wai","HK",22.45679,114.00234,"Yuen Long","city"],
  [3447259,"Sumaré","BR",-22.82194,-47.26694,"São Paulo","city"],
  [1575627,"Long Xuyên","VN",10.38639,105.43518,"An Giang","city"],
  [1349452,"Savar","BD",23.84858,90.25002,"Dhaka Division","city"],
  [1276070,"Bathinda","IN",30.20747,74.93893,"Punjab","city"],
  [5505411,"Henderson","US",36.0397,-114.98194,"Nevada","city"],
  [1269395,"Jālna","IN",19.84102,75.88636,"Maharashtra","city"],
  [11808941,"Sekondi","GH",4.93422,-1.71454,"Western","city"],
  [10858926,"Kyengera","UG",0.29517,32.50159,"Central Region","city"],
  [4469146,"Greensboro","US",36.07264,-79.79198,"North Carolina","city"],
  [294801,"Haifa","IL",32.81303,34.99928,"Haifa","city"],
  [2624652,"Århus","DK",56.15674,10.21076,"Central Jutland","city"],
  [3445156,"Viamão","BR",-30.08111,-51.02333,"Rio Grande do Sul","city"],
  [1812990,"Dengzhou","CN",32.68273,112.08873,"Henan","city"],
  [1281743,"Artux","CN",39.70842,76.17971,"Xinjiang","city"],
  [1845136,"Chuncheon","KR",37.87472,127.73417,"Gangwon-do","city"],
  [3487903,"Alto Barinas","VE",8.5931,-70.2261,"Barinas","city"],
  [2248477,"Mbour","SN",14.42196,-16.96375,"Thies","city"],
  [2654710,"Brighton","GB",50.82838,-0.13947,"England","city"],
  [2892794,"Karlsruhe","DE",49.00937,8.40444,"Baden-Wurttemberg","city"],
  [3450083,"Santa Maria","BR",-29.68417,-53.80694,"Rio Grande do Sul","city"],
  [360686,"Minya","EG",28.09193,30.75813,"Minya","city"],
  [4719457,"Plano","US",33.01984,-96.69889,"Texas","city"],
  [2112664,"Ichihara","JP",35.51667,140.08333,"Chiba","city"],
  [1798097,"Qibao","CN",31.15267,121.35688,"Shanghai","city"],
  [10263153,"Kirāri Sulemānnagar","IN",28.69736,77.0648,"Delhi","city"],
  [1720840,"Cainta","PH",14.5786,121.1222,"Calabarzon","city"],
  [1257022,"Satna","IN",24.57726,80.82719,"Madhya Pradesh","city"],
  [2165798,"Geelong","AU",-38.14711,144.36069,"Victoria","city"],
  [710735,"Chernihiv","UA",51.50541,31.28656,"Chernihiv Oblast","city"],
  [1529046,"Xinyuan","CN",43.42649,83.24959,"Xinjiang","city"],
  [1588129,"Ba Vì","VN",21.08333,105.38333,"Hanoi","city"],
  [3868626,"Valparaíso","CL",-33.036,-71.62963,"Valparaiso","city"],
  [3938527,"Ica","PE",-14.07538,-75.73422,"Ica","city"],
  [1259166,"Purnia","IN",25.77895,87.47422,"Bihar","city"],
  [5101798,"Newark","US",40.73566,-74.17237,"New Jersey","city"],
  [3680450,"Itagüí","CO",6.18461,-75.59913,"Antioquia","city"],
  [3522732,"Nicolás Romero","MX",19.64177,-99.3068,"México","city"],
  [747014,"Gebze","TR",40.80276,29.43068,"Kocaeli","city"],
  [1043893,"Lichinga","MZ",-13.31278,35.24056,"Niassa Province","city"],
  [1185117,"Narsingdi","BD",23.92298,90.71768,"Dhaka Division","city"],
  [737071,"Zeytinburnu","TR",40.99441,28.90417,"Istanbul","city"],
  [2467454,"Sfax","TN",34.74056,10.76028,"Sfax Governorate","city"],
  [3513966,"Zumpango","MX",19.7967,-99.09946,"México","city"],
  [11238838,"Merkezefendi","TR",37.80544,29.04236,"Denizli","city"],
  [5261457,"Madison","US",43.07305,-89.40123,"Wisconsin","city"],
  [1217662,"Bukhara","UZ",39.77026,64.43069,"Bukhara","city"],
  [2171507,"Wollongong","AU",-34.424,150.89345,"New South Wales","city"],
  [3444876,"Volta Redonda","BR",-22.52306,-44.10417,"Rio de Janeiro","city"],
  [3068799,"Ostrava","CZ",49.83465,18.28204,"Moravian-Silesian Region","city"],
  [4407066,"St. Louis","US",38.62727,-90.19789,"Missouri","city"],
  [696643,"Poltava","UA",49.58925,34.55367,"Poltava","city"],
  [2343983,"Efon-Alaaye","NG",7.65649,4.92235,"Ekiti State","city"],
  [1215355,"Binjai","ID",3.6001,98.4854,"North Sumatra","city"],
  [1214204,"Pematangsiantar","ID",2.9595,99.0687,"North Sumatra","city"],
  [509820,"Petrozavodsk","RU",61.78491,34.34691,"Karelia","city"],
  [1811720,"Enshi","CN",30.3,109.48333,"Hubei","city"],
  [484907,"Taganrog","RU",47.23627,38.9053,"Rostov","city"],
  [3627047,"Santa Teresa del Tuy","VE",10.23291,-66.66474,"Miranda","city"],
  [1568770,"Quảng Ngãi","VN",15.12047,108.79232,"Quang Ngai","city"],
  [1216311,"Qarshi","UZ",38.86056,65.78905,"Qashqadaryo","city"],
  [1793419,"Tanghe","CN",32.68545,112.83234,"Henan","city"],
  [3530569,"Coacalco","MX",19.62923,-99.10689,"México","city"],
  [3667983,"Sincelejo","CO",9.3045,-75.3905,"Sucre Department","city"],
  [1783633,"Zoucheng","CN",35.40056,116.96556,"Shandong","city"],
  [418710,"Khomeynī Shahr","IR",32.6856,51.53609,"Isfahan","city"],
  [543878,"Kostroma","RU",57.76638,40.92828,"Kostroma Oblast","city"],
  [1269771,"Imphal","IN",24.80805,93.9442,"Manipur","city"],
  [2288829,"Gagnoa","CI",6.13193,-5.9506,"Goh-Djiboua","city"],
  [1880159,"Ulu Bedok","SG",1.33333,103.93333,"","city"],
  [1884382,"Bedok New Town","SG",1.32639,103.94167,"","city"],
  [2325314,"Owo","NG",7.1962,5.58681,"Ondo State","city"],
  [1835648,"Suncheon","KR",34.9505,127.48784,"Jeollanam-do","city"],
  [12269572,"Fangchenggang","CN",21.76945,108.35661,"Guangxi","city"],
  [2021851,"Komsomolsk-on-Amur","RU",50.55034,137.00995,"Khabarovsk","city"],
  [1185056,"Abbottabad","PK",34.1463,73.21168,"Khyber Pakhtunkhwa","city"],
  [1804866,"Kaili","CN",26.58583,107.97972,"Guizhou","city"],
  [2130188,"Hakodate","JP",41.77583,140.73667,"Hokkaido","city"],
  [2505854,"Bab Ezzouar","DZ",36.72615,3.18291,"Algiers","city"],
  [2973783,"Strasbourg","FR",48.58392,7.74553,"Grand Est","city"],
  [1257845,"Saugor","IN",23.83877,78.73874,"Madhya Pradesh","city"],
  [1671467,"Neihu","TW",25.0815,121.58809,"Taiwan","city"],
  [1849796,"Tsu","JP",34.73333,136.51667,"Mie","city"],
  [8594670,"Xingning","CN",24.1483,115.72272,"Guangdong","city"],
  [1803331,"Linxia Chengguanzhen","CN",35.60028,103.20639,"Gansu","city"],
  [706369,"Khmelnytskyi","UA",49.41835,26.97936,"Khmelnytskyi","city"],
  [12032137,"Kushinagar","IN",26.74134,83.88689,"Uttar Pradesh","city"],
  [1166652,"Saddiqabad","PK",28.3091,70.12652,"Punjab","city"],
  [3654667,"Loja","EC",-3.99313,-79.20422,"Loja","city"],
  [1818673,"Tai Po","HK",22.45007,114.16877,"Tai Po","city"],
  [1514896,"Isfara","TJ",40.12649,70.62526,"Sughd","city"],
  [3347719,"Luena","AO",-11.78333,19.91667,"Moxico","city"],
  [3447186,"Taboão da Serra","BR",-23.62611,-46.79167,"São Paulo","city"],
  [1220253,"Istaravshan","TJ",39.9142,69.00328,"Sughd","city"],
  [1529114,"Turpan","CN",42.94769,89.17886,"Xinjiang","city"],
  [1258315,"Rourkela","IN",22.22496,84.86414,"Odisha","city"],
  [1848522,"Yao","JP",34.61667,135.6,"Osaka","city"],
  [359173,"Banī Suwayf","EG",29.07441,31.09785,"Beni Suweif","city"],
  [1193745,"Nagar Naluākot","BD",24.15608,90.7728,"Dhaka Division","city"],
  [3557689,"Guantánamo","CU",20.14444,-75.20917,"Guantánamo Province","city"],
  [1728930,"Baguio","PH",16.41639,120.59306,"Cordillera","city"],
  [3454031,"Petrópolis","BR",-22.505,-43.17861,"Rio de Janeiro","city"],
  [289888,"Ar Rayyān","QA",25.29194,51.42444,"Baladiyat ar Rayyan","city"],
  [965289,"Polokwane","ZA",-23.90449,29.46885,"Limpopo","city"],
  [1139715,"Jalālābād","AF",34.42647,70.45153,"Nangarhar","city"],
  [170794,"Deir ez-Zor","SY",35.33588,40.14084,"Deir ez-Zor","city"],
  [3121424,"Gijón","ES",43.53573,-5.66152,"Asturias","city"],
  [106297,"Hafar Al-Batin","SA",28.43279,45.97077,"Eastern Province","city"],
  [1860704,"Kakogawachō-honmachi","JP",34.76943,134.82905,"Hyōgo","city"],
  [11048322,"Sector 5","RO",44.38808,26.07144,"Bucharest","city"],
  [9645072,"Quận Sáu","VN",10.7468,106.64903,"Ho Chi Minh City (HCMC)","city"],
  [11962376,"Capao Redondo","BR",-23.66877,-46.78051,"São Paulo","city"],
  [1574023,"Mỹ Tho","VN",10.36004,106.35996,"Dong Thap","city"],
  [2111901,"Mito","JP",36.35,140.45,"Ibaraki","city"],
  [2651347,"Derby","GB",52.92277,-1.47663,"England","city"],
  [339219,"Dessie","ET",11.13333,39.63333,"Amhara","city"],
  [3448744,"São José","BR",-27.61528,-48.6275,"Santa Catarina","city"],
  [1580410,"Hạ Long","VN",20.95045,107.07336,"Quảng Ninh","city"],
  [2921466,"Gelsenkirchen","DE",51.50508,7.09654,"North Rhine-Westphalia","city"],
  [12492660,"Longling County","CN",24.58663,98.68934,"Yunnan","city"],
  [710791,"Cherkasy","UA",49.44452,32.05738,"Cherkasy","city"],
  [1702540,"Malolos","PH",14.8443,120.81039,"Central Luzon","city"],
  [2637487,"Southampton","GB",50.90395,-1.40428,"England","city"],
  [1732901,"Kapar","MY",3.13333,101.38333,"Selangor","city"],
  [748879,"Çorum","TR",40.54889,34.95333,"Çorum","city"],
  [1529435,"Ghulja","CN",43.91515,81.32151,"Xinjiang","city"],
  [2911293,"Eimsbüttel","DE",53.57416,9.95679,"Hamburg","city"],
  [3430697,"Merlo","AR",-34.66536,-58.72744,"Buenos Aires","city"],
  [1884138,"Yeosu","KR",34.76062,127.66215,"Jeollanam-do","city"],
  [1272181,"Durg","IN",21.19147,81.27619,"Chhattisgarh","city"],
  [1810979,"Fuling","CN",29.70997,107.39391,"Chongqing","city"],
  [1841066,"Mokpo","KR",34.81282,126.39181,"Jeollanam-do","city"],
  [1283581,"Birgañj","NP",27.01736,84.88047,"Madhesh","city"],
  [466806,"Yoshkar-Ola","RU",56.63877,47.89078,"Mariy-El Republic","city"],
  [7838895,"Russeifa","JO",32.01778,36.04639,"Zarqa","city"],
  [1215502,"Banda Aceh","ID",5.54167,95.33333,"Aceh","city"],
  [349158,"Shibīn al Kawm","EG",30.55258,31.00904,"Monufia","city"],
  [6317872,"Parauapebas","BR",-6.0675,-49.90222,"Pará","city"],
  [1170295,"Mirpur Khas","PK",25.5276,69.01255,"Sindh","city"],
  [7289760,"Sengkang New Town","SG",1.39167,103.89444,"","city"],
  [3682385,"Floridablanca","CO",7.06222,-73.08644,"Santander Department","city"],
  [1850158,"Tokushima","JP",34.06667,134.56667,"Tokushima","city"],
  [487495,"Sterlitamak","RU",53.63793,55.9533,"Bashkortostan Republic","city"],
  [1278672,"Anantapur","IN",14.67784,77.60813,"Andhra Pradesh","city"],
  [3392998,"Parnamirim","BR",-5.91556,-35.26278,"Rio Grande do Norte","city"],
  [1841598,"Gyeongsan-si","KR",35.82333,128.73778,"Gyeongsangbuk-do","city"],
  [347796,"Sohag","EG",26.55695,31.69478,"Sohag","city"],
  [1856199,"Nagaoka","JP",37.45,138.85,"Niigata","city"],
  [6318632,"Sapopemba","BR",-23.59556,-46.52472,"São Paulo","city"],
  [3717588,"Saint-Marc","HT",19.11136,-72.70078,"Artibonite","city"],
  [6544100,"Eixample","ES",41.38896,2.16179,"Catalonia","city"],
  [1185281,"Bagerhat","BD",22.65657,89.79123,"Khulna Division","city"],
  [1581047,"Hà Tĩnh","VN",18.34282,105.90569,"Hà Tĩnh Province","city"],
  [6141256,"Saskatoon","CA",52.13238,-106.66892,"Saskatchewan","city"],
  [1786640,"Chengzhong","CN",30.94454,113.55284,"Hubei","city"],
  [2500017,"Djelfa","DZ",34.67279,3.263,"Djelfa","city"],
  [5336899,"Chula Vista","US",32.64005,-117.0842,"California","city"],
  [1852225,"Shimonoseki","JP",33.95548,130.93713,"Yamaguchi","city"],
  [5174035,"Toledo","US",41.66394,-83.55521,"Ohio","city"],
  [158027,"Kibaha","TZ",-6.76667,38.91667,"Pwani","city"],
  [2036670,"Hulan Ergi","CN",47.20417,123.63333,"Heilongjiang","city"],
  [1880216,"Tampines Estate","SG",1.35806,103.94028,"","city"],
  [3031582,"Bordeaux","FR",44.84124,-0.58046,"New Aquitaine","city"],
  [3247449,"Aachen","DE",50.77664,6.08342,"North Rhine-Westphalia","city"],
  [2797656,"Gent","BE",51.05,3.71667,"Flanders","city"],
  [3462089,"Gravataí","BR",-29.94218,-50.99278,"Rio Grande do Sul","city"],
  [1701472,"Mantampay","PH",8.16667,124.21667,"Northern Mindanao","city"],
  [1258342,"Ratlām","IN",23.33033,75.04032,"Madhya Pradesh","city"],
  [4004886,"Nogales","MX",31.30862,-110.94217,"Sonora","city"],
  [380148,"El Daein","SD",11.46186,26.12583,"Eastern Darfur","city"],
  [136256,"Dezful","IR",32.38114,48.40581,"Khuzestan","city"],
  [1812521,"Donghai","CN",22.94593,115.64204,"Guangdong","city"],
  [1842025,"Gunsan","KR",35.97861,126.71139,"Jeollabuk-do","city"],
  [3394682,"Mossoró","BR",-5.1875,-37.34417,"Rio Grande do Norte","city"],
  [1258451,"Rānipet","IN",12.92471,79.33331,"Tamil Nadu","city"],
  [1336142,"Brāhmanbāria","BD",23.97464,91.11228,"Chittagong","city"],
  [710719,"Chernivtsi","UA",48.29045,25.93241,"Chernivtsi","city"],
  [5099836,"Jersey City","US",40.72816,-74.07764,"New Jersey","city"],
  [3654410,"Manta","EC",-0.94937,-80.73137,"Manabí","city"],
  [5511077,"Reno","US",39.52963,-119.8138,"Nevada","city"],
  [2389422,"Bégoua","CF",4.45437,18.53475,"Ombella-M'Poko","city"],
  [3652350,"Riobamba","EC",-1.66506,-78.65887,"Chimborazo Province","city"],
  [300619,"Sivas","TR",39.74833,37.01611,"Sivas","city"],
  [2633691,"Wolverhampton","GB",52.58547,-2.12296,"England","city"],
  [1632228,"Pasarkemis","ID",-6.17028,106.53028,"West Java","city"],
  [1819873,"Fanling","HK",22.49487,114.13949,"North District","city"],
  [1678836,"Chiayi City","TW",23.47917,120.44889,"Taiwan","city"],
  [1812228,"Dongtai","CN",32.85231,120.30947,"Jiangsu","city"],
  [11611632,"Fuchū","JP",35.67452,139.48216,"Tokyo","city"],
  [1881953,"Jurong Town","SG",1.33417,103.72278,"","city"],
  [124877,"Marāgheh","IR",37.39206,46.23909,"East Azerbaijan","city"],
  [124878,"Marāgheh","IR",35.82916,59.63324,"Razavi Khorasan","city"],
  [3429652,"Quilmes","AR",-34.72065,-58.25454,"Buenos Aires","city"],
  [1863985,"Fukui-shi","JP",36.06443,136.22257,"Fukui","city"],
  [7302826,"Lal Bahadur Nagar","IN",17.34769,78.55757,"Telangana","city"],
  [2869894,"Mönchengladbach","DE",51.18539,6.44172,"North Rhine-Westphalia","city"],
  [13060482,"Bagong Silang","PH",14.7783,121.04487,"National Capital Region","city"],
  [686967,"Zhytomyr","UA",50.26235,28.67913,"Zhytomyr Oblast","city"],
  [1529401,"Karamay","CN",45.58473,84.88724,"Xinjiang","city"],
  [11962429,"Sacomã","BR",-23.63083,-46.59817,"São Paulo","city"],
  [1278483,"Arrah","IN",25.55629,84.66335,"Bihar","city"],
  [2034400,"Tongliao","CN",43.6125,122.26528,"Inner Mongolia","city"],
  [161218,"Bariadi","TZ",-2.8,33.98333,"Simiyu","city"],
  [1069166,"Antsirabe","MG",-19.86586,47.03333,"Vakinankaratra","city"],
  [5289282,"Chandler","US",33.30616,-111.84125,"Arizona","city"],
  [363619,"Yei","SS",4.09444,30.67639,"Central Equatoria","city"],
  [1514230,"Chilanzar","UZ",41.28194,69.18111,"Tashkent","city"],
  [634963,"Tampere","FI",61.49911,23.78712,"Pirkanmaa","city"],
  [1062663,"Mahajanga","MG",-15.71667,46.31667,"Boeny","city"],
  [13353696,"Minato City","JP",35.6581,139.7515,"Tokyo","city"],
  [4920423,"Fort Wayne","US",41.1306,-85.12886,"Indiana","city"],
  [2640194,"Plymouth","GB",50.37153,-4.14305,"England","city"],
  [1799471,"Nianbo","CN",36.48,102.41639,"Qinghai","city"],
  [1277082,"Baranagar","IN",22.64132,88.37727,"West Bengal","city"],
  [1164709,"Skardu","PK",35.29787,75.63372,"Gilgit-Baltistan","city"],
  [1701053,"Marawi City","PH",8.0034,124.28395,"Autonomous Region in Muslim Mindanao","city"],
  [1882115,"Tampines New Town","SG",1.34917,103.94972,"","city"],
  [1512979,"Qo‘qon","UZ",40.52861,70.9425,"Fergana","city"],
  [11962427,"Jardim Sao Luis","BR",-23.68073,-46.7394,"São Paulo","city"],
  [1684712,"Tacloban","PH",11.24333,125.00472,"Eastern Visayas","city"],
  [3450909,"Rondonópolis","BR",-16.47083,-54.63556,"Mato Grosso","city"],
  [1815669,"Changle","CN",36.70583,118.8275,"Shandong","city"],
  [7302833,"Gajuwaka","IN",17.7,83.21667,"Andhra Pradesh","city"],
  [2036458,"Jining","CN",41.0275,113.10583,"Inner Mongolia","city"],
  [2185964,"North Shore","NZ",-36.8,174.75,"Auckland","city"],
  [293703,"Rishon LeTsiyyon","IL",31.97102,34.78939,"Central District","city"],
  [1862462,"Hiratsuka","JP",35.32785,139.33735,"Kanagawa","city"],
  [2636841,"Stoke-on-Trent","GB",53.00415,-2.18538,"England","city"],
  [3463030,"Foz do Iguaçu","BR",-25.54778,-54.58806,"Paraná","city"],
  [5110629,"Buffalo","US",42.88645,-78.87837,"New York","city"],
  [3164527,"Verona","IT",45.43854,10.9938,"Veneto","city"],
  [1584071,"Ðà Lạt","VN",11.94646,108.44193,"Lam Dong","city"],
  [3836564,"San Salvador de Jujuy","AR",-24.1928,-65.29342,"Jujuy","city"],
  [4464368,"Durham","US",35.99403,-78.89862,"North Carolina","city"],
  [1271987,"Etāwah","IN",26.77615,79.02133,"Uttar Pradesh","city"],
  [3104499,"Gasteiz / Vitoria","ES",42.84998,-2.67268,"Basque Country","city"],
  [10942183,"Rugao","CN",32.37035,120.57649,"Jiangsu","city"],
  [4005775,"Gómez Palacio","MX",25.56871,-103.4996,"Durango","city"],
  [3466779,"Cascavel","BR",-24.95583,-53.45528,"Paraná","city"],
  [4171563,"St. Petersburg","US",27.77086,-82.67927,"Florida","city"],
  [3120619,"L'Hospitalet de Llobregat","ES",41.35967,2.10028,"Catalonia","city"],
  [3099424,"Gdynia","PL",54.51889,18.53188,"Pomerania","city"],
  [1646559,"Cilacap","ID",-7.72639,109.00944,"Central Java","city"],
  [5359777,"Irvine","US",33.66946,-117.82311,"California","city"],
  [5992996,"Kitchener","CA",43.42537,-80.5112,"Ontario","city"],
  [1793899,"Suicheng","CN",33.8963,117.93307,"Jiangsu","city"],
  [1800234,"Nada","CN",19.52134,109.57895,"Hainan","city"],
  [6544489,"Latina","ES",40.38897,-3.74569,"Madrid","city"],
  [3997479,"Los Mochis","MX",25.79097,-108.99825,"Sinaloa","city"],
  [2051523,"Bratsk","RU",56.1325,101.61417,"Irkutsk Oblast","city"],
  [3522210,"Pachuca de Soto","MX",20.11697,-98.73329,"Hidalgo","city"],
  [919009,"Chingola","ZM",-12.52897,27.88382,"Copperbelt","city"],
  [692194,"Sumy","UA",50.91741,34.79906,"Sumy","city"],
  [2642465,"Milton Keynes","GB",52.04172,-0.75583,"England","city"],
  [3461311,"Indaiatuba","BR",-23.08842,-47.2119,"São Paulo","city"],
  [4705349,"Laredo","US",27.50641,-99.50754,"Texas","city"],
  [12170526,"Vila Flor","AO",-8.98007,13.30781,"Luanda","city"],
  [1002108,"Germiston","ZA",-26.23481,28.17665,"Gauteng","city"],
  [3878431,"Ñuñoa","CL",-33.44735,-70.58279,"Santiago Metropolitan","city"],
  [2392204,"Parakou","BJ",9.33716,2.63031,"Borgou","city"],
  [215771,"Isiro","CD",2.77391,27.61603,"Haut-Uele","city"],
  [116996,"Sari","IR",36.56332,53.06009,"Māzandarān","city"],
  [1624725,"Tarakan","ID",3.31332,117.59152,"North Kalimantan","city"],
  [2407790,"Kenema","SL",7.87687,-11.19025,"Eastern Province","city"],
  [3522507,"Oaxaca","MX",17.06025,-96.72544,"Oaxaca","city"],
  [3347019,"Mossamedes","AO",-15.19611,12.15222,"Namibe","city"],
  [99106,"Al Madīnah","IQ",30.96324,47.26998,"Basra","city"],
  [2163355,"Hobart","AU",-42.87936,147.32941,"Tasmania","city"],
  [2338106,"Ikot Ekpene","NG",5.18194,7.71481,"Akwa Ibom State","city"],
  [1787031,"Yanzhou","CN",35.55278,116.82861,"Shandong","city"],
  [1882316,"Woodlands","SG",1.43801,103.78877,"","city"],
  [1897007,"Hanam","KR",37.54,127.20556,"Gyeonggi-do","city"],
  [1608133,"Mueang Nonthaburi","TH",13.86075,100.51477,"Nonthaburi","city"],
  [1169692,"Muridke","PK",31.80258,74.25772,"Punjab","city"],
  [2246452,"Saint-Louis","SN",16.01793,-16.48962,"Saint-Louis","city"],
  [1735166,"Batu Caves","MY",3.238,101.682,"Selangor","city"],
  [3456068,"Novo Hamburgo","BR",-29.67833,-51.13056,"Rio Grande do Sul","city"],
  [1881955,"Jurong West","SG",1.35028,103.72278,"","city"],
  [1626916,"Singkawang","ID",0.90925,108.98463,"West Kalimantan","city"],
  [1336134,"Cox’s Bāzār","BD",21.43973,92.00955,"Chittagong","city"],
  [6544493,"Carabanchel","ES",40.39094,-3.7242,"Madrid","city"],
  [3465284,"Cotia","BR",-23.60389,-46.91917,"São Paulo","city"],
  [293918,"Petaẖ Tiqva","IL",32.08707,34.88747,"Central District","city"],
  [1513243,"Marg‘ilon","UZ",40.47237,71.72463,"Fergana","city"],
  [1278903,"Ambarnath","IN",19.2,73.16667,"Maharashtra","city"],
  [2394092,"Godomè","BJ",6.38948,2.34581,"Atlantique","city"],
  [1262131,"Naihāti","IN",22.89396,88.41521,"West Bengal","city"],
  [683844,"Braşov","RO",45.64861,25.60613,"Brașov County","city"],
  [1560565,"Xuân Lộc","VN",10.93333,107.23333,"Dong Nai","city"],
  [3444914,"Vitória da Conquista","BR",-14.86611,-40.83944,"Bahia","city"],
  [1804386,"Laohekou","CN",32.38583,111.66778,"Hubei","city"],
  [962367,"Richards Bay","ZA",-28.78301,32.03768,"KwaZulu-Natal","city"],
  [350550,"Qina","EG",26.16418,32.72671,"Qena","city"],
  [1276128,"Bharatpur","IN",27.21731,77.49009,"Rajasthan","city"],
  [632453,"Vantaa","FI",60.29414,25.04099,"Uusimaa","city"],
  [2735943,"Porto","PT",41.1485,-8.61097,"Porto","city"],
  [2891122,"Kiel","DE",54.32133,10.13489,"Schleswig-Holstein","city"],
  [379555,"El Fasher","SD",13.62793,25.34936,"Northern Darfur","city"],
  [2244799,"Thiès Nones","SN",14.78333,-16.96667,"Thies","city"],
  [2034655,"Suihua","CN",46.64814,126.96656,"Heilongjiang","city"],
  [3633622,"Los Teques","VE",10.34954,-67.04266,"Miranda","city"],
  [3835869,"Santiago del Estero","AR",-27.80047,-64.26285,"Santiago del Estero","city"],
  [2481700,"Sétif","DZ",36.19112,5.41373,"Sétif","city"],
  [1276609,"Begusarai","IN",25.41853,86.13389,"Bihar","city"],
  [140044,"Borūjerd","IR",33.8973,48.7516,"Lorestan Province","city"],
  [32767,"Qarchak","IR",35.42873,51.57757,"Tehran","city"],
  [325303,"Afyonkarahisar","TR",38.75667,30.54333,"Afyonkarahisar Province","city"],
  [311111,"İskenderun","TR",36.58718,36.17347,"Hatay","city"],
  [3928245,"Santiago de Surco","PE",-12.13588,-77.00742,"Lima region","city"],
  [2325457,"Ota","NG",6.68867,3.23202,"Ogun State","city"],
  [179330,"Thika","KE",-1.03326,37.06933,"Nairobi County","city"],
  [1690039,"San Fernando","PH",15.03425,120.68445,"Central Luzon","city"],
  [3347353,"Menongue","AO",-14.6585,17.69099,"Cubango","city"],
  [248583,"Ḩayy Khildā","JO",31.99202,35.84002,"Amman","city"],
  [333772,"Jimma","ET",7.67344,36.83441,"Oromiya","city"],
  [3462315,"Governador Valadares","BR",-18.85111,-41.94944,"Minas Gerais","city"],
  [665087,"Timişoara","RO",45.75372,21.22571,"Timiș County","city"],
  [3464305,"Embu das Artes","BR",-23.64889,-46.85222,"São Paulo","city"],
  [3537906,"Santa Clara","CU",22.40711,-79.96581,"Villa Clara Province","city"],
  [2336905,"Iwo","NG",7.63527,4.18156,"Osun State","city"],
  [3119841,"A Coruña","ES",43.37135,-8.396,"Galicia","city"],
  [1706684,"Libertad","PH",8.94417,125.50194,"Caraga","city"],
  [2911296,"Altona","DE",53.55,9.93333,"Hamburg","city"],
  [4000900,"La Paz","MX",24.14231,-110.31316,"Baja California Sur","city"],
  [366847,"Singa","SD",13.1483,33.93117,"Sennar","city"],
  [7280708,"Colonia del Valle","MX",19.38611,-99.16204,"Mexico City","city"],
  [787657,"Niš","RS",43.32472,21.90333,"Central Serbia","city"],
  [95005,"Kelar","IQ",34.62805,45.31852,"Sulaymaniyah","city"],
  [3872348,"San Bernardo","CL",-33.59217,-70.6996,"Santiago Metropolitan","city"],
  [1851604,"Sōka","JP",35.83643,139.79957,"Saitama","city"],
  [925475,"Mzuzu","MW",-11.46556,34.02071,"Northern Region","city"],
  [1697846,"Navotas","PH",14.66667,120.95,"National Capital Region","city"],
  [1254320,"Tiruvottiyūr","IN",13.15823,80.30181,"Tamil Nadu","city"],
  [11962392,"Cidade Ademar","BR",-23.67379,-46.65681,"São Paulo","city"],
  [5911606,"Burnaby","CA",49.26636,-122.95263,"British Columbia","city"],
  [5525577,"Lubbock","US",33.57786,-101.85517,"Texas","city"],
  [1582497,"Thị Trấn Đông Triều","VN",21.08242,106.5138,"Quảng Ninh","city"],
  [107991,"Thuqbah","SA",26.26022,50.20486,"Eastern Province","city"],
  [2110556,"Yamagata","JP",38.23333,140.36667,"Yamagata","city"],
  [3516109,"Tehuacán","MX",18.46422,-97.39735,"Puebla","city"],
  [3640049,"Guarenas","VE",10.47027,-66.61934,"Miranda","city"],
  [2992166,"Montpellier","FR",43.61093,3.87635,"Occitanie","city"],
  [2336056,"Jimeta","NG",9.27949,12.45819,"Adamawa","city"],
  [3100946,"Częstochowa","PL",50.79646,19.12409,"Silesia","city"],
  [1271717,"Gāndhīdhām","IN",23.08333,70.13333,"Gujarat","city"],
  [1816790,"Beibei","CN",29.82739,106.43645,"Chongqing","city"],
  [1321937,"Insein","MM",16.88874,96.10257,"Yangon","city"],
  [2634341,"City of Westminster","GB",51.4975,-0.1357,"England","city"],
  [5295903,"Gilbert","US",33.35283,-111.78903,"Arizona","city"],
  [2940132,"Chemnitz","DE",50.8357,12.92922,"Saxony","city"],
  [3841956,"Paraná","AR",-31.73271,-60.52897,"Entre Rios","city"],
  [3583446,"San Miguel","SV",13.48261,-88.18211,"San Miguel Department","city"],
  [1916862,"Shijie","CN",23.09546,113.79195,"Guangdong","city"],
  [145778,"Chitato","AO",-7.3,20.73333,"Luanda Norte","city"],
  [514734,"Orsk","RU",51.23206,58.48802,"Orenburg Oblast","city"],
  [944986,"Vanderbijlpark","ZA",-26.71171,27.83795,"Gauteng","city"],
  [3645213,"Coro","VE",11.40769,-69.67822,"Falcón","city"],
  [3472343,"Americana","BR",-22.73917,-47.33139,"São Paulo","city"],
  [3465927,"Colombo","BR",-25.29167,-49.22417,"Paraná","city"],
  [1529484,"Hami","CN",42.83393,93.50601,"Xinjiang","city"],
  [353229,"Al ‘Āshir min Ramaḑān","EG",30.29636,31.74633,"Sharqia","city"],
  [1263311,"Mau","IN",25.94167,83.56111,"Uttar Pradesh","city"],
  [3874960,"Puerto Montt","CL",-41.4693,-72.94237,"Los Lagos Region","city"],
  [2641430,"Northampton","GB",52.25,-0.88333,"England","city"],
  [3937513,"Juliaca","PE",-15.5,-70.13333,"Puno","city"],
  [1864134,"Fuji","JP",35.16667,138.68333,"Shizuoka","city"],
  [1841603,"Gyeongju","KR",35.84278,129.21167,"Gyeongsangbuk-do","city"],
  [2281606,"Sinfra","CI",6.62103,-5.91144,"Zanzan District","city"],
  [485239,"Syktyvkar","RU",61.66393,50.8163,"Komi","city"],
  [132892,"Gorgān","IR",36.8427,54.44391,"Golestan","city"],
  [1497543,"Nizhnevartovsk","RU",60.9344,76.5531,"Khanty-Mansia","city"],
  [1165569,"Shahkot","PK",31.5709,73.48531,"Punjab","city"],
  [2755251,"Groningen","NL",53.21917,6.56667,"Groningen","city"],
  [1283582,"Biratnagar","NP",26.45505,87.27007,"Koshi","city"],
  [2945024,"Braunschweig","DE",52.26594,10.52673,"Lower Saxony","city"],
  [3625542,"Valera","VE",9.31778,-70.60361,"Trujillo","city"],
  [3388441,"São José de Ribamar","BR",-2.55572,-44.05992,"Maranhão","city"],
  [1256320,"Sīkar","IN",27.61206,75.13996,"Rajasthan","city"],
  [1300466,"Bago","MM",17.33521,96.48135,"Bago Region","city"],
  [2874545,"Magdeburg","DE",52.13129,11.63189,"Saxony-Anhalt","city"],
  [3648439,"Baruta","VE",10.43424,-66.87558,"Miranda","city"],
  [3112737,"Puente de Vallecas","ES",40.39354,-3.662,"Madrid","city"],
  [3458142,"Magé","BR",-22.65278,-43.04056,"Rio de Janeiro","city"],
  [738648,"Trabzon","TR",41.005,39.72694,"Trabzon","city"],
  [7289169,"Tri-Cities","US",46.2454,-119.19617,"Washington","city"],
  [1336140,"Jessore","BD",23.16971,89.21371,"Khulna Division","city"],
  [304827,"Manisa","TR",38.61202,27.42647,"Manisa","city"],
  [695594,"Rivne","UA",50.62036,26.23695,"Rivne Oblast","city"],
  [1214369,"Padangsidempuan","ID",1.37952,99.27146,"North Sumatra","city"],
  [1630634,"Probolinggo","ID",-7.7543,113.2159,"East Java","city"],
  [118063,"Sabzevar","IR",36.2126,57.68191,"Razavi Khorasan","city"],
  [3407327,"Arapiraca","BR",-9.7525,-36.66111,"Alagoas","city"],
  [12042053,"Musaffah","AE",24.35893,54.48267,"Abu Dhabi","city"],
  [11962395,"Brasilandia","BR",-23.44859,-46.68839,"São Paulo","city"],
  [1852899,"Sasebo","JP",33.16834,129.72502,"Nagasaki","city"],
  [2027667,"Angarsk","RU",52.55968,103.91413,"Irkutsk Oblast","city"],
  [529237,"Mar’ino","RU",55.65,37.71667,"Moscow","city"],
  [8347656,"Ramagundam","IN",18.755,79.474,"Telangana","city"],
  [1270393,"Hāpur","IN",28.72985,77.78068,"Uttar Pradesh","city"],
  [1864624,"Chigasaki","JP",35.33638,139.40434,"Kanagawa","city"],
  [1623502,"Toli-Toli","ID",1.04018,120.81764,"Central Sulawesi","city"],
  [1864518,"Chōfu","JP",35.65924,139.54837,"Tokyo","city"],
  [1806988,"Huayin","CN",34.56528,110.06639,"Shaanxi","city"],
  [64435,"Berbera","SO",10.43959,45.01432,"Woqooyi Galbeed","city"],
  [1805012,"Jiyuan","CN",35.08912,112.58815,"Henan","city"],
  [11611478,"Yamato","JP",35.47276,139.45101,"Kanagawa","city"],
  [2284647,"Man","CI",7.41251,-7.55383,"Montagnes","city"],
  [1183883,"Bahawalnagar","PK",29.99835,73.25272,"Punjab","city"],
  [1332083,"Bahawalnagar","PK",30.55083,73.39083,"Punjab","city"],
  [518255,"Novorossiysk","RU",44.73188,37.76176,"Krasnodar Krai","city"],
  [2110681,"Tsukuba","JP",36.08333,140.11667,"Ibaraki","city"],
  [3899361,"Arica","CL",-18.47552,-70.30058,"Arica y Parinacota Region","city"],
  [3876682,"Peñalolén","CL",-33.46836,-70.53411,"Santiago Metropolitan","city"],
  [1581326,"Hải Dương","VN",20.94099,106.33302,"Hai Phong","city"],
  [4499612,"Winston-Salem","US",36.09986,-80.24422,"North Carolina","city"],
  [1271942,"Farrukhābād","IN",27.39134,79.5793,"Uttar Pradesh","city"],
  [1857519,"Matsumoto","JP",36.23333,137.96667,"Nagano","city"],
  [1278985,"Alappuzha","IN",9.49004,76.3264,"Kerala","city"],
  [3460718,"Itapevi","BR",-23.54889,-46.93417,"São Paulo","city"],
  [1267480,"Katihar","IN",25.53852,87.57044,"Bihar","city"],
  [3457692,"Marília","BR",-22.21389,-49.94583,"São Paulo","city"],
  [3688451,"Buenaventura","CO",3.8801,-77.03116,"Valle del Cauca Department","city"],
  [3645527,"Ciudad Ojeda","VE",10.20161,-71.3148,"Zulia","city"],
  [1809571,"Gucun","CN",31.34933,121.39341,"Shanghai","city"],
  [5295985,"Glendale","US",33.53865,-112.18599,"Arizona","city"],
  [13607978,"Navegantes","AO",-12.58997,13.39123,"Benguela","city"],
  [11790632,"Bunkyo","JP",35.5331,139.4217,"Kanagawa","city"],
  [3460950,"Itaboraí","BR",-22.74444,-42.85944,"Rio de Janeiro","city"],
  [1732905,"Klang","MY",3.03667,101.44333,"Selangor","city"],
  [32900,"Golestān","IR",35.5183,51.1819,"Tehran","city"],
  [3569175,"Almendares","CU",23.11012,-82.42322,"Havana","city"],
  [688758,"Vyhurivshchyna-Troyeshchyna","UA",50.51137,30.60251,"Kyiv City","city"],
  [550280,"Khimki","RU",55.9001,37.42848,"Moscow Oblast","city"],
  [707753,"Horlivka","UA",48.29986,38.01709,"Donetsk","city"],
  [1035025,"Nacala","MZ",-14.56257,40.68538,"Nampula","city"],
  [8519916,"Obolon","UA",50.5132,30.5055,"Kyiv City","city"],
  [1790371,"Xiantao","CN",30.3708,113.44294,"Hubei","city"],
  [523523,"Nalchik","RU",43.49806,43.61889,"Kabardino-Balkariya Republic","city"],
  [2130203,"Hachinohe","JP",40.5,141.5,"Aomori","city"],
  [1839652,"Osan","KR",37.15222,127.07056,"Gyeonggi-do","city"],
  [3121969,"Fuencarral","ES",40.5,-3.68333,"Madrid","city"],
  [2998324,"Lille","FR",50.63391,3.05512,"Hauts-de-France","city"],
  [6697563,"Neyagawa","JP",34.76615,135.62759,"Osaka","city"],
  [1697018,"Ormoc","PH",11.00639,124.6075,"Eastern Visayas","city"],
  [3523760,"Magdalena Contreras","MX",19.33212,-99.21118,"Mexico City","city"],
  [1185159,"Nāgarpur","BD",24.05783,89.87696,"Dhaka Division","city"],
  [158214,"Kasulu","TZ",-4.57667,30.1025,"Kigoma","city"],
  [2224827,"Ngaoundéré","CM",7.32765,13.58472,"Adamaoua","city"],
  [707471,"Ivano-Frankivsk","UA",48.92312,24.71248,"Ivano-Frankivsk","city"],
  [3468615,"Cabo Frio","BR",-22.88717,-42.02622,"Rio de Janeiro","city"],
  [322165,"Balıkesir","TR",39.64917,27.88611,"Balıkesir","city"],
  [3870011,"Temuco","CL",-38.73628,-72.59738,"Araucania","city"],
  [4776222,"Norfolk","US",36.84681,-76.28522,"Virginia","city"],
  [2884509,"Krefeld","DE",51.33645,6.55381,"North Rhine-Westphalia","city"],
  [2911522,"Halle (Saale)","DE",51.48158,11.97947,"Saxony-Anhalt","city"],
  [3397154,"Juazeiro","BR",-9.41167,-40.49861,"Bahia","city"],
  [1271685,"Sri Ganganagar","IN",29.92009,73.87496,"Rajasthan","city"],
  [1329221,"Amarapura","MM",21.90709,96.04894,"Mandalay Region","city"],
  [10402606,"Kilamba","AO",-8.84861,13.275,"Luanda","city"],
  [143534,"Āmol","IR",36.46961,52.35072,"Māzandarān","city"],
  [2925177,"Freiburg","DE",47.9959,7.85222,"Baden-Wurttemberg","city"],
  [3370356,"Athlone","ZA",-33.96722,18.50214,"Western Cape","city"],
  [1726280,"Batangas","PH",13.7567,121.0584,"Calabarzon","city"],
  [109435,"Al Jubayl","SA",27.0174,49.62251,"Eastern Province","city"],
  [1868144,"Tŏkch’ŏn","KP",39.75261,126.25798,"South Pyongan","city"],
  [2641022,"Oldham","GB",53.54051,-2.1183,"England","city"],
  [1328421,"Pathein","MM",16.77919,94.73212,"Ayeyarwady","city"],
  [4158476,"Hialeah","US",25.8576,-80.27811,"Florida","city"],
  [1172657,"Kunri","PK",25.17874,69.56572,"Sindh","city"],
  [1185099,"Sylhet","BD",24.89904,91.87198,"Sylhet Division","city"],
  [3363094,"Paarl","ZA",-33.73378,18.97523,"Western Cape","city"],
  [4693003,"Garland","US",32.91262,-96.63888,"Texas","city"],
  [5313457,"Scottsdale","US",33.50921,-111.89903,"Arizona","city"],
  [4700168,"Irving","US",32.81402,-96.94889,"Texas","city"],
  [1105777,"Centurion","ZA",-25.85891,28.18577,"Gauteng","city"],
  [1786731,"Qingzhou","CN",36.69667,118.47972,"Shandong","city"],
  [9478811,"Pākdasht","IR",35.47854,51.6834,"Tehran","city"],
  [10941913,"Kajang","MY",2.99424,101.78875,"Selangor","city"],
  [3467722,"Campo Limpo","BR",-23.63634,-46.76565,"São Paulo","city"],
  [1785974,"Yuci","CN",37.68028,112.73194,"Shanxi","city"],
  [6544105,"Sant Martí","ES",41.41814,2.19933,"Catalonia","city"],
  [2756253,"Eindhoven","NL",51.44083,5.47778,"North Brabant","city"],
  [5586437,"Boise","US",43.6135,-116.20345,"Idaho","city"],
  [1258182,"Rewa","IN",24.53256,81.29234,"Madhya Pradesh","city"],
  [2013159,"Yakutsk","RU",62.03114,129.72288,"Sakha","city"],
  [8521718,"Bole","CN",44.89334,82.06993,"Xinjiang","city"],
  [1169605,"Muzaffargarh","PK",30.07258,71.19379,"Punjab","city"],
  [4752186,"Chesapeake","US",36.81904,-76.27494,"Virginia","city"],
  [1253880,"Uluberiya","IN",22.4756,88.09898,"West Bengal","city"],
  [1814093,"Dali","CN",25.58474,100.21229,"Yunnan","city"],
  [418606,"Najafābād","IR",32.63464,51.36525,"Isfahan","city"],
  [8594709,"Thành Phố Bà Rịa","VN",10.49626,107.1685,"Ho Chi Minh City (HCMC)","city"],
  [55671,"Kismayo","SO",-0.35817,42.54536,"Lower Juba","city"],
  [5509403,"North Las Vegas","US",36.19886,-115.1175,"Nevada","city"],
  [2518559,"Elche","ES",38.26218,-0.70107,"Valencia","city"],
  [1255947,"Sivakasi","IN",9.44999,77.79797,"Tamil Nadu","city"],
  [212902,"Kindu","CD",-2.94373,25.92237,"Maniema","city"],
  [1179837,"Digri","PK",25.15657,69.11098,"Sindh","city"],
  [3395473,"Maracanaú","BR",-3.87667,-38.62556,"Ceará","city"],
  [521118,"Nizhnekamsk","RU",55.63794,51.81502,"Tatarstan Republic","city"],
  [3461655,"Hortolândia","BR",-22.85833,-47.22,"São Paulo","city"],
  [1267648,"Karur","IN",10.95771,78.08095,"Tamil Nadu","city"],
  [1637158,"Lubuklinggau","ID",-3.2945,102.8614,"South Sumatra","city"],
  [680332,"Craiova","RO",44.31667,23.8,"Dolj","city"],
  [1259012,"Rāichūr","IN",16.20546,77.35567,"Karnataka","city"],
  [1260692,"Pallāvaram","IN",12.96796,80.15025,"Tamil Nadu","city"],
  [3612907,"Danlí","HN",14.03333,-86.58333,"El Paraíso Department","city"],
  [1665221,"Yongkang","TW",23.02444,120.25556,"Taiwan","city"],
  [2410048,"Bo","SL",7.96472,-11.73833,"Southern Province","city"],
  [2517117,"Granada","ES",37.18817,-3.60667,"Andalusia","city"],
  [1253993,"Ooty","IN",11.4134,76.69521,"Tamil Nadu","city"],
  [1853303,"Saga","JP",33.23333,130.3,"Saga","city"],
  [1684269,"Magugpo Poblacion","PH",7.4475,125.8046,"Davao Region","city"],
  [563708,"Dzerzhinsk","RU",56.24422,43.45543,"Nizhny Novgorod Oblast","city"],
  [1028918,"Pemba","MZ",-12.97395,40.51775,"Cabo Delgado Province","city"],
  [11101805,"Geoje","KR",34.81379,128.70556,"Gyeongsangnam-do","city"],
  [1735459,"Teluk Intan","MY",4.02219,101.02083,"Perak","city"],
  [149879,"Singida","TZ",-4.81629,34.74358,"Singida","city"],
  [157738,"Kigoma","TZ",-4.87694,29.62667,"Kigoma","city"],
  [5350734,"Fremont","US",37.54827,-121.98857,"California","city"],
  [1771298,"Kampong Baharu Cheras Batu Sebelas","MY",3.05,101.76667,"Selangor","city"],
  [1280957,"Jiayuguan","CN",39.81121,98.28618,"Gansu","city"],
  [145459,"Abadan","IR",30.3392,48.3043,"Khuzestan","city"],
  [1682598,"Taytay","PH",14.55883,121.13285,"Calabarzon","city"],
  [13589354,"Phổ Yên","VN",21.41978,105.8899,"Thai Nguyen","city"],
  [3843123,"Neuquén","AR",-38.95078,-68.0592,"Neuquen","city"],
  [3464688,"Divinópolis","BR",-20.14355,-44.89065,"Minas Gerais","city"],
  [1219649,"Türkmenabat","TM",39.07328,63.57861,"Lebap","city"],
  [11808021,"Shibuya","JP",35.6589,139.70665,"Tokyo","city"],
  [1567621,"Sơn Tây","VN",21.14053,105.50686,"Hanoi","city"],
  [1571951,"Ninh Hòa","VN",12.49187,109.12495,"Khanh Hoa","city"],
  [1736372,"Pasir Mas","MY",6.04934,102.13987,"Kelantan","city"],
  [1630328,"Purwokerto","ID",-7.42139,109.23444,"Central Java","city"],
  [12076997,"José C. Paz","AR",-34.51541,-58.76813,"Buenos Aires","city"],
  [54225,"Marka","SO",1.71594,44.77166,"Lower Shabeelle","city"],
  [1260716,"Pāli","IN",25.77276,73.32335,"Rajasthan","city"],
  [2349019,"Atani","NG",6.01277,6.74768,"Anambra","city"],
  [355795,"Ḩalwān","EG",29.84144,31.30084,"Cairo","city"],
  [701822,"Mariupol","UA",47.09514,37.54131,"Donetsk","city"],
  [7843638,"Changzheng","CN",31.23913,121.36779,"Shanghai","city"],
  [1859884,"Kasukabe","JP",35.98308,139.74966,"Saitama","city"],
  [2970479,"Paris 15 Vaugirard","FR",48.8412,2.3003,"Île-de-France","city"],
  [6182962,"Windsor","CA",42.30008,-83.01654,"Ontario","city"],
  [1269934,"Hosūr","IN",12.73647,77.83264,"Tamil Nadu","city"],
  [5811696,"Spokane","US",47.65966,-117.42908,"Washington","city"],
  [266826,"Tripoli","LB",34.43352,35.84415,"North Lebanon","city"],
  [6059891,"Longueuil","CA",45.5152,-73.46818,"Quebec","city"],
  [741100,"Ordu","TR",40.97782,37.89047,"Ordu","city"],
  [3805673,"San Fernando de Apure","VE",7.88963,-67.47181,"Apure","city"],
  [3727135,"Croix-des-Bouquets","HT",18.57677,-72.22625,"Ouest","city"],
  [1705357,"Lucena","PH",13.93139,121.61722,"Calabarzon","city"],
  [3461144,"Ipatinga","BR",-19.46833,-42.53667,"Minas Gerais","city"],
  [1882155,"Yishun New Town","SG",1.43333,103.83111,"","city"],
  [1253084,"Vizianagaram","IN",18.11692,83.41148,"Andhra Pradesh","city"],
  [1805733,"Jinchang","CN",38.50062,102.19379,"Gansu","city"],
  [1571058,"Phan Thiết","VN",10.92889,108.10208,"Lam Dong","city"],
  [102651,"Şabyā","SA",17.1495,42.62537,"Jazan Region","city"],
  [294071,"Netanya","IL",32.33291,34.85992,"Central District","city"],
  [3124964,"Ciudad Lineal","ES",40.44505,-3.65132,"Madrid","city"],
  [1699802,"Meycauayan","PH",14.73694,120.96083,"Central Luzon","city"],
  [2350434,"Aliayabiagba","NG",6.45,3.33333,"Lagos","city"],
  [2655775,"Bexley","GB",51.44162,0.14866,"England","city"],
  [3437056,"San Lorenzo","PY",-25.33968,-57.50879,"Central Department","city"],
  [2983990,"Rennes","FR",48.11109,-1.67431,"Brittany","city"],
  [2542051,"Mohammedia","MA",33.68607,-7.38298,"Casablanca-Settat","city"],
  [3639898,"Guatire","VE",10.474,-66.54241,"Miranda","city"],
  [1624863,"Tanjung Pinang","ID",0.91667,104.45833,"Riau Islands","city"],
  [1881948,"Hougang New Town","SG",1.35667,103.89083,"","city"],
  [4315588,"Baton Rouge","US",30.44332,-91.18747,"Louisiana","city"],
  [3447624,"Sete Lagoas","BR",-19.46583,-44.24667,"Minas Gerais","city"],
  [3085128,"Sosnowiec","PL",50.28682,19.10385,"Silesia","city"],
  [6956648,"Diez de Octubre","CU",23.0881,-82.3597,"Havana","city"],
  [1517945,"Turkistan","KZ",43.29458,68.25685,"Turkistan","city"],
  [989921,"Klerksdorp","ZA",-26.85213,26.66672,"North West","city"],
  [5142036,"Upper West Side","US",40.78705,-73.97542,"New York","city"],
  [487928,"Staryy Oskol","RU",51.3025,37.84613,"Belgorod Oblast","city"],
  [1865714,"Ageo","JP",35.97145,139.61382,"Saitama","city"],
  [2339937,"Gusau","NG",12.17024,6.66412,"Zamfara State","city"],
  [2864072,"Neue Neustadt","DE",52.15,11.63333,"Saxony-Anhalt","city"],
  [709932,"Kamyanske","UA",48.51716,34.60617,"Dnipropetrovsk","city"],
  [295629,"Ashdod","IL",31.79213,34.64966,"Southern District","city"],
  [760778,"Radom","PL",51.40253,21.14714,"Mazovia","city"],
  [13100478,"Paya Terubong","MY",5.37278,100.27972,"Penang","city"],
  [4781708,"Richmond","US",37.55376,-77.46026,"Virginia","city"],
  [1583478,"Điện Bàn","VN",15.88853,108.25447,"Da Nang City","city"],
  [1679136,"Chang-hua","TW",24.07327,120.56276,"Taiwan","city"],
  [1993459,"Changhua","TW",24.0692,120.5512,"Taiwan","city"],
  [1851012,"Takarazuka","JP",34.79936,135.35697,"Hyōgo","city"],
  [2416969,"Nzérékoré","GN",7.75624,-8.8179,"Nzérékoré Region","city"],
  [6119109,"Regina","CA",50.45008,-104.6178,"Saskatchewan","city"],
  [1586443,"Cà Mau","VN",9.17682,105.15242,"Ca Mau","city"],
  [1256422,"Shrīrāmpur","IN",22.75278,88.34222,"West Bengal","city"],
  [2035225,"Fendou","CN",46.64142,124.86283,"Heilongjiang","city"],
  [1632654,"Pangkalpinang","ID",-2.12914,106.11377,"Bangka–Belitung Islands","city"],
  [1807508,"Huanggang","CN",23.67704,116.99961,"Guangdong","city"],
  [7302845,"Quthbullapur","IN",17.50107,78.45818,"Telangana","city"],
  [2329821,"Mubi","NG",10.26858,13.26701,"Adamawa","city"],
  [3451055,"Rio Verde","BR",-17.79806,-50.92806,"Goiás","city"],
  [6316328,"Águas Lindas de Goiás","BR",-15.76194,-48.28167,"Goiás","city"],
  [3452324,"Presidente Prudente","BR",-22.12556,-51.38889,"São Paulo","city"],
  [112214,"Varāmīn","IR",35.3242,51.6457,"Tehran","city"],
  [11048317,"Sector 1","RO",44.49239,26.04831,"Bucharest","city"],
  [1649824,"Batu","ID",-7.87,112.52833,"East Java","city"],
  [6951112,"Somerset West","ZA",-34.08401,18.82113,"Western Cape","city"],
  [2643339,"Luton","GB",51.87967,-0.41748,"England","city"],
  [691650,"Ternopil","UA",49.55404,25.59067,"Ternopil","city"],
  [3397147,"Juazeiro do Norte","BR",-7.21306,-39.31528,"Ceará","city"],
  [1648637,"Bitung","ID",1.44059,125.12824,"North Sulawesi","city"],
  [1185162,"Mymensingh","BD",24.75636,90.40646,"Mymensingh Division","city"],
  [2026609,"Blagoveshchensk","RU",50.27593,127.52637,"Amur Oblast","city"],
  [1262292,"Nadiād","IN",22.69385,72.86157,"Gujarat","city"],
  [2229752,"Kumba","CM",4.6363,9.4469,"South-West","city"],
  [724443,"Košice","SK",48.71441,21.25802,"Košice Region","city"],
  [704147,"Kremenchuk","UA",49.06253,33.40484,"Poltava","city"],
  [1805618,"Jingling","CN",30.65,113.1,"Hubei","city"],
  [1262204,"Nāgercoil","IN",8.17899,77.43227,"Tamil Nadu","city"],
  [884979,"Mutare","ZW",-18.9707,32.67086,"Manicaland","city"],
  [1853677,"Ōta","JP",36.3,139.36667,"Gunma","city"],
  [10265057,"Karāwalnagar","IN",28.72712,77.27047,"Delhi","city"],
  [3991328,"Puerto Vallarta","MX",20.617,-105.23018,"Jalisco","city"],
  [1857144,"Minamirinkan","JP",35.49527,139.44279,"Kanagawa","city"],
  [2965140,"Cork","IE",51.89797,-8.47061,"Munster","city"],
  [1847963,"Atsugi","JP",35.44272,139.36931,"Kanagawa","city"],
  [2036973,"Heihe","CN",50.24413,127.49016,"Heilongjiang","city"],
  [13353441,"Mango","IN",22.8275,86.21639,"Jharkhand","city"],
  [1639850,"Klungkung","ID",-8.53333,115.4,"Bali","city"],
  [1185155,"Narayanganj","BD",23.61352,90.50298,"Dhaka Division","city"],
  [1680116,"NIA Valencia","PH",7.90639,125.09417,"Northern Mindanao","city"],
  [1795196,"Tongchuanshi","CN",35.07474,109.08495,"Shaanxi","city"],
  [3893894,"Concepción","CL",-36.82699,-73.04977,"Biobio","city"],
  [98717,"Ramadi","IQ",33.42056,43.30778,"Anbar","city"],
  [5509952,"Paradise","US",36.09719,-115.14666,"Nevada","city"],
  [5812944,"Tacoma","US",47.25288,-122.44429,"Washington","city"],
  [2874225,"Mainz","DE",49.98185,8.28008,"Rheinland-Pfalz","city"],
  [519336,"Velikiy Novgorod","RU",58.52131,31.27104,"Novgorod Oblast","city"],
  [1735153,"Sungai Buloh","MY",3.21,101.561,"Selangor","city"],
  [1692685,"Puerto Princesa","PH",9.73917,118.73528,"Mimaropa","city"],
  [1788618,"Xintai","CN",35.90056,117.75194,"Shandong","city"],
  [3641351,"El Tigre","VE",8.88902,-64.2527,"Anzoátegui","city"],
  [1877615,"Haeju","KP",38.04056,125.71472,"South Hwanghae","city"],
  [3433899,"Formosa","AR",-26.18489,-58.17313,"Formosa","city"],
  [2338273,"Ikire","NG",7.36983,4.1863,"Osun State","city"],
  [3608248,"La Ceiba","HN",15.75971,-86.78221,"Atlántida Department","city"],
  [2746301,"Tilburg","NL",51.55551,5.0913,"North Brabant","city"],
  [7289846,"Ba Dinh","VN",21.03652,105.82684,"Hanoi","city"],
  [1262395,"Murwāra","IN",23.83776,80.39405,"Madhya Pradesh","city"],
  [153209,"Moshi","TZ",-3.35,37.33333,"Kilimanjaro","city"],
  [1268159,"Kanchipuram","IN",12.83515,79.70006,"Tamil Nadu","city"],
  [2464915,"Sousse","TN",35.82539,10.63699,"Sousse Governorate","city"],
  [3666645,"Tuluá","CO",4.08466,-76.19536,"Valle del Cauca Department","city"],
  [2236967,"Soyo","AO",-6.1349,12.36894,"Zaire","city"],
  [1567788,"Sóc Trăng","VN",9.59995,105.97193,"Can Tho City","city"],
  [2419992,"Kankan","GN",10.38542,-9.30568,"Kankan Region","city"],
  [496015,"Shakhty","RU",47.71916,40.21603,"Rostov","city"],
  [229268,"Mbarara","UG",-0.60467,30.64851,"Western Region","city"],
  [1697175,"Olongapo","PH",14.82917,120.28278,"Central Luzon","city"],
  [3655673,"Ibarra","EC",0.34881,-78.12462,"Imbabura","city"],
  [3204541,"Banja Luka","BA",44.77879,17.20629,"Srpska","city"],
  [11101625,"Rufisque est","SN",14.7162,-17.27283,"Dakar","city"],
  [122285,"Neyshābūr","IR",36.21329,58.79575,"Razavi Khorasan","city"],
  [116667,"Sāveh","IR",35.0213,50.3566,"Markazi","city"],
  [1790894,"Wuxue","CN",29.85058,115.5525,"Hubei","city"],
  [1585489,"Chí Linh","VN",21.06667,106.31667,"Hai Phong","city"],
  [3531732,"Campeche","MX",19.84073,-90.51676,"Campeche","city"],
  [9645086,"Quận Ba","VN",10.77494,106.68628,"Ho Chi Minh City (HCMC)","city"],
  [7279754,"Singrauli","IN",24.19973,82.67535,"Madhya Pradesh","city"],
  [8285534,"Fuencarral-El Pardo","ES",40.4984,-3.7314,"Madrid","city"],
  [13546521,"Shevchenkivskyi","UA",50.46408,30.46576,"Kyiv City","city"],
  [1262995,"Mirzāpur","IN",25.1449,82.56534,"Uttar Pradesh","city"],
  [3114711,"Oviedo","ES",43.36029,-5.84476,"Asturias","city"],
  [13118272,"Bandar Seri Alam","MY",1.50434,103.87525,"Johor","city"],
  [1626542,"Sorong","ID",-0.87956,131.26104,"Southwest Papua","city"],
  [2524170,"Messina","IT",38.19394,15.55256,"Sicily","city"],
  [1234569,"Dehiwala-Mount Lavinia","LK",6.84019,79.87116,"Western Province","city"],
  [705812,"Kropyvnytskyi","UA",48.50834,32.26618,"Kirovohrad","city"],
  [1266976,"Kharagpur","IN",22.33971,87.32501,"West Bengal","city"],
  [215527,"Kabinda","CD",-6.13791,24.48179,"Lomami","city"],
  [1176515,"Jacobabad","PK",28.28187,68.43761,"Sindh","city"],
  [149402,"Tunduma","TZ",-9.3,32.76667,"Songwe","city"],
  [1725094,"Binangonan","PH",14.4646,121.1929,"Calabarzon","city"],
  [2860410,"Oberhausen","DE",51.47805,6.8625,"North Rhine-Westphalia","city"],
  [1611110,"Chon Buri","TH",13.3622,100.98345,"Chon Buri","city"],
  [3450144,"Santa Luzia","BR",-19.76972,-43.85139,"Minas Gerais","city"],
  [1494114,"Prokop’yevsk","RU",53.91518,86.71891,"Kuzbass","city"],
  [12432979,"Samambaia","BR",-15.88231,-48.10428,"Federal District","city"],
  [2929670,"Erfurt","DE",50.97734,11.03536,"Thuringia","city"],
  [3657990,"Esmeraldas","EC",0.9592,-79.65397,"Esmeraldas","city"],
  [3108286,"Terrassa","ES",41.56667,2.01667,"Catalonia","city"],
  [2656333,"Barking","GB",51.53333,0.08333,"England","city"],
  [1791249,"Wuhai","CN",39.68442,106.81583,"Inner Mongolia","city"],
  [1173664,"Khuzdar","PK",27.81193,66.61096,"Balochistan","city"],
  [3398269,"Imperatriz","BR",-5.52639,-47.49167,"Maranhão","city"],
  [2454268,"Koutiala","ML",12.38723,-5.46507,"Sikasso","city"],
  [1272051,"Eluru","IN",16.71311,81.10437,"Andhra Pradesh","city"],
  [10524295,"Rāniganj","IN",17.42841,78.49361,"Telangana","city"],
  [3493032,"San Pedro de Macorís","DO",18.4539,-69.30864,"San Pedro de Macorís","city"],
  [677697,"Galaţi","RO",45.43687,28.05028,"Galați County","city"],
  [3129028,"Badalona","ES",41.45004,2.24741,"Catalonia","city"],
  [764484,"Mokotów","PL",52.1934,21.03487,"Mazovia","city"],
  [1734586,"Taiping","MY",4.85,100.73333,"Perak","city"],
  [12358616,"Yintai","CN",35.11524,109.09702,"Shaanxi","city"],
  [1252797,"Yamuna Nagar","IN",30.12796,77.28371,"Haryana","city"],
  [3404545,"Cabo de Santo Agostinho","BR",-8.28773,-35.02925,"Pernambuco","city"],
  [10968247,"Arakawa","JP",35.73825,139.78047,"Tokyo","city"],
  [5122520,"Jamaica","US",40.69149,-73.80569,"New York","city"],
  [3827606,"Buenavista","MX",19.60833,-99.16944,"México","city"],
  [1178338,"Gilgit","PK",35.91869,74.31245,"Gilgit-Baltistan","city"],
  [500004,"Rybinsk","RU",58.04562,38.83811,"Yaroslavl Oblast","city"],
  [1687894,"Santa Rosa","PH",14.31222,121.11139,"Calabarzon","city"],
  [3133880,"Trondheim","NO",63.43049,10.39506,"Trøndelag","city"],
  [13308246,"Raurkela Industrial Township","IN",22.19994,84.86176,"Odisha","city"],
  [3629965,"Porlamar","VE",10.95771,-63.86971,"Nueva Esparta","city"],
  [5391710,"San Bernardino","US",34.10834,-117.28977,"California","city"],
  [4013728,"Ciudad Acuña","MX",29.32322,-100.95217,"Coahuila","city"],
  [643492,"Oulu","FI",65.01236,25.46816,"North Ostrobothnia","city"],
  [6318696,"Sinop","BR",-11.86417,-55.5025,"Mato Grosso","city"],
  [1275738,"Bidar","IN",17.90802,77.51524,"Karnataka","city"],
  [470451,"Vykhino-Zhulebino","RU",55.70196,37.81178,"Moscow","city"],
  [702569,"Lutsk","UA",50.75784,25.35024,"Volyn","city"],
  [8556321,"La Ceiba","HN",15.76667,-86.83333,"Atlántida Department","city"],
  [3519537,"San Cristóbal de las Casas","MX",16.73006,-92.63825,"Chiapas","city"],
  [463829,"Zelenograd","RU",55.9825,37.18139,"Moscow","city"],
  [11777624,"Archway","GB",51.56733,-0.13415,"England","city"],
  [12750606,"Wangsa Maju","MY",3.20056,101.73972,"Kuala Lumpur","city"],
  [5780993,"Salt Lake City","US",40.76078,-111.89105,"Utah","city"],
  [1510018,"Biysk","RU",52.53423,85.19661,"Altai Krai","city"],
  [3194360,"Novi Sad","RS",45.25167,19.83694,"Vojvodina","city"],
  [1805298,"Jinzhou","CN",39.1,121.71667,"Liaoning","city"],
  [3526485,"Jiutepec","MX",18.88139,-99.17778,"Morelos","city"],
  [1802656,"Longgang","CN",22.72289,114.26326,"Guangdong","city"],
  [3995523,"Monclova","MX",26.90687,-101.42056,"Coahuila","city"],
  [1567069,"Tân An","VN",10.53589,106.41366,"Tay Ninh","city"],
  [1819400,"Ma On Shan","HK",22.40613,114.24079,"Sha Tin","city"],
  [7090983,"Commonwealth","PH",14.6969,121.08006,"National Capital Region","city"],
  [4068590,"Huntsville","US",34.7304,-86.58594,"Alabama","city"],
  [11962390,"Jabaquara","BR",-23.65055,-46.64591,"São Paulo","city"],
  [2243940,"Ziguinchor","SN",12.56801,-16.27326,"Ziguinchor","city"],
  [1221194,"Kŭlob","TJ",37.91459,69.78454,"Khatlon Province","city"],
  [1646034,"Citeureup","ID",-6.48556,106.88194,"West Java","city"],
  [8504960,"Centralniy","RU",59.93111,30.36072,"St.-Petersburg","city"],
  [1568212,"Sa Dec","VN",10.29085,105.75635,"Dong Thap","city"],
  [1858296,"Kure","JP",34.23222,132.56658,"Hiroshima","city"],
  [2323411,"Shagamu","NG",6.8485,3.64633,"Ogun State","city"],
  [295514,"Bnei Brak","IL",32.08074,34.8338,"Tel Aviv","city"],
  [2544248,"Khouribga","MA",32.88108,-6.9063,"Beni Mellal-Khenifra","city"],
  [1786577,"Yingtan","CN",28.23333,117,"Jiangxi","city"],
  [4853828,"Des Moines","US",41.60054,-93.60911,"Iowa","city"],
  [320257,"Çiğli","TR",38.49645,27.07029,"İzmir Province","city"],
  [2595323,"Marcory","CI",5.31198,-3.99363,"Abidjan Autonomous District","city"],
  [1178231,"Gojra","PK",31.14926,72.68323,"Punjab","city"],
  [2520058,"Cartagena","ES",37.60197,-0.98397,"Murcia","city"],
  [3652567,"Quevedo","EC",-1.02881,-79.46264,"Los Ríos","city"],
  [6092122,"Oakville","CA",43.45011,-79.68292,"Ontario","city"],
  [1632033,"Pasuruan","ID",-7.6453,112.9075,"East Java","city"],
  [122438,"Naz̧arābād","IR",35.95411,50.60607,"Alborz Province","city"],
  [1262482,"Munger","IN",25.37459,86.47455,"Bihar","city"],
  [3460370,"Jacareí","BR",-23.30528,-45.96583,"São Paulo","city"],
  [2516326,"Jerez de la Frontera","ES",36.68645,-6.13606,"Andalusia","city"],
  [2550078,"El Jadida","MA",33.25682,-8.50882,"Casablanca-Settat","city"],
  [1783700,"Zitong","CN",30.1782,105.82991,"Chongqing","city"],
  [1637510,"Loa Janan","ID",-0.58295,117.09503,"East Kalimantan","city"],
  [665004,"Târgu Mureş","RO",46.54245,24.55747,"Mureș County","city"],
  [5349755,"Fontana","US",34.09223,-117.43505,"California","city"],
  [1677112,"Zhubei","TW",24.83833,121.00778,"Taiwan","city"],
  [3873775,"Rancagua","CL",-34.1691,-70.74053,"O'Higgins Region","city"],
  [352951,"Mallawī","EG",27.73264,30.84129,"Minya","city"],
  [2302357,"Cape Coast","GH",5.10535,-1.2466,"Central","city"],
  [1735079,"Bukit Mertajam","MY",5.36301,100.4667,"Penang","city"],
  [1706090,"Lipa City","PH",13.9411,121.1631,"Calabarzon","city"],
  [3432135,"Lanús","AR",-34.70757,-58.39132,"Buenos Aires","city"],
  [2875601,"Lübeck","DE",53.86893,10.68729,"Schleswig-Holstein","city"],
  [1801909,"Luojiang","CN",31.30497,104.50484,"Sichuan","city"],
  [1734821,"Sepang","MY",2.6931,101.7498,"Selangor","city"],
  [3598119,"Cobán","GT",15.47025,-90.37455,"Alta Verapaz","city"],
  [3457708,"Maricá","BR",-22.91944,-42.81861,"Rio de Janeiro","city"],
  [1586151,"Cao Lãnh","VN",10.46017,105.63294,"Dong Thap","city"],
  [1861436,"Isesaki","JP",36.31667,139.2,"Gunma","city"],
  [3111199,"Sabadell","ES",41.54329,2.10942,"Catalonia","city"],
  [3460103,"Jaraguá","BR",-23.44077,-46.73774,"São Paulo","city"],
  [11790369,"Taito","JP",35.70749,139.7788,"Tokyo","city"],
  [1261927,"Nandyāl","IN",15.47799,78.4836,"Andhra Pradesh","city"],
  [2511174,"Santa Cruz de Tenerife","ES",28.46824,-16.25462,"Canary Islands","city"],
  [6690108,"Panchkula","IN",30.69461,76.8504,"Haryana","city"],
  [5373900,"Modesto","US",37.6391,-120.99688,"California","city"],
  [1695804,"Panabo","PH",7.30806,125.68417,"Davao Region","city"],
  [1813253,"Lijiang","CN",26.86879,100.22072,"Yunnan","city"],
  [1514891,"Konibodom","TJ",40.29414,70.43122,"Sughd","city"],
  [2037078,"Hailar","CN",49.2,119.7,"Inner Mongolia","city"],
  [3460634,"Itaquera","BR",-23.53194,-46.44417,"São Paulo","city"],
  [1709968,"Kabankalan","PH",9.9839,122.81423,"Western Visayas","city"],
  [110690,"Abha","SA",18.21639,42.50528,"'Asir Region","city"],
  [1275068,"Burhānpur","IN",21.30868,76.23026,"Madhya Pradesh","city"],
  [1624041,"Ternate","ID",0.79065,127.38424,"North Maluku","city"],
  [732770,"Burgas","BG",42.50651,27.46886,"Burgas","city"],
  [504341,"Pskov","RU",57.81922,28.33181,"Pskov Oblast","city"],
  [1262775,"Morvi","IN",22.81731,70.8377,"Gujarat","city"],
  [1814082,"Daliang","CN",22.84067,113.2503,"Guangdong","city"],
  [3874212,"Quilicura","CL",-33.36799,-70.71388,"Santiago Metropolitan","city"],
  [2555745,"Beni Mellal","MA",32.33725,-6.34983,"Beni Mellal-Khenifra","city"],
  [1212405,"Ashuganj City","BD",24.04016,91.0117,"Chittagong","city"],
  [2481007,"Sidi Bel Abbes","DZ",35.18994,-0.63085,"Sidi Bel Abbès","city"],
  [3568342,"Arroyo Naranjo","CU",23.03811,-82.37703,"Havana","city"],
  [11524601,"Jebel Ali","AE",25.00255,55.10811,"Dubai","city"],
  [1337233,"Bogra","BD",24.85098,89.37108,"Rajshahi Division","city"],
  [1519928,"Kostanay","KZ",53.21435,63.62463,"Kostanay","city"],
  [6122085,"Richmond","CA",49.17003,-123.13683,"British Columbia","city"],
  [5134086,"Rochester","US",43.15478,-77.61556,"New York","city"],
  [1650234,"Banjar","ID",-7.1955,107.4313,"West Java","city"],
  [2043572,"Kanggye","KP",40.96946,126.58523,"Chagang","city"],
  [1845033,"Chungju","KR",36.97666,127.9287,"North Chungcheong","city"],
  [1278685,"Anand","IN",22.55251,72.9552,"Gujarat","city"],
  [3448622,"São Leopoldo","BR",-29.76028,-51.14722,"Rio Grande do Sul","city"],
  [1670909,"Bade","TW",24.92981,121.28372,"Taiwan","city"],
  [3458329,"Luziânia","BR",-16.2525,-47.95028,"Goiás","city"],
  [3909234,"Oruro","BO",-17.97153,-67.0932,"Oruro","city"],
  [1817848,"Bachuan","CN",29.84863,106.05046,"Chongqing","city"],
  [3500957,"La Romana","DO",18.42332,-68.96635,"La Romana","city"],
  [328689,"Shashamane","ET",7.2,38.6,"Oromiya","city"],
  [1808931,"Hangu","CN",39.24889,117.78917,"Tianjin","city"],
  [1261045,"Ongole","IN",15.50357,80.04454,"Andhra Pradesh","city"],
  [3114472,"Pamplona","ES",42.81687,-1.64323,"Navarre","city"],
  [5303929,"Maryvale","US",33.50199,-112.17765,"Arizona","city"],
  [1843137,"Gangneung","KR",37.75266,128.87239,"Gangwon-do","city"],
  [2639996,"Portsmouth","GB",50.79899,-1.09125,"England","city"],
  [216449,"Gandajika","CD",-6.74504,23.95328,"Lomami","city"],
  [1809380,"Gunan","CN",29.0231,106.648,"Chongqing","city"],
  [1571067,"Phan Rang-Tháp Chàm","VN",11.56432,108.98858,"Khanh Hoa","city"],
  [1646194,"Ciputat","ID",-6.2375,106.69556,"West Java","city"],
  [232110,"Kasangati","UG",0.43803,32.60246,"Central Region","city"],
  [4744709,"Arlington","US",38.88101,-77.10428,"Virginia","city"],
  [339666,"Bishoftu","ET",8.75225,38.97846,"Oromiya","city"],
  [1850692,"Nishi-Tokyo-shi","JP",35.72526,139.5383,"Tokyo","city"],
  [2045220,"Changam-ch’on","KP",40.60611,128.78194,"South Hamgyong","city"],
  [712165,"Bila Tserkva","UA",49.7994,30.1165,"Kyiv Oblast","city"],
  [5380184,"Oxnard","US",34.1975,-119.17705,"California","city"],
  [1647383,"Ciampea","ID",-6.55472,106.70083,"West Java","city"],
  [361291,"Hurghada","EG",27.25738,33.81291,"Red Sea","city"],
  [3116025,"Móstoles","ES",40.32234,-3.86496,"Madrid","city"],
  [4188985,"Columbus","US",32.46098,-84.98771,"Georgia","city"],
  [3547932,"Mantilla","CU",23.06794,-82.34143,"Havana","city"],
  [3685095,"Dosquebradas","CO",4.83916,-75.66727,"Risaralda Department","city"],
  [1681602,"Toledo","PH",10.3773,123.6386,"Central Visayas","city"],
  [633679,"Turku","FI",60.45148,22.26869,"Southwest Finland","city"],
  [4956184,"Worcester","US",42.26259,-71.80229,"Massachusetts","city"],
  [1696710,"Pagadian","PH",7.8257,123.437,"Zamboanga Peninsula","city"],
  [1085510,"Epworth","ZW",-17.89,31.1475,"Harare","city"],
  [3628423,"San Felipe","VE",10.3401,-68.74297,"Yaracuy","city"],
  [1203891,"Dinajpur","BD",25.62745,88.63779,"Rangpur Division","city"],
  [1269935,"Hosapete","IN",15.26954,76.3871,"Karnataka","city"],
  [1562818,"Việt Yên","VN",21.26667,106.13333,"Bac Ninh","city"],
  [159492,"Ifakara","TZ",-8.13333,36.68333,"Morogoro","city"],
  [3346015,"Sumbe","AO",-11.20605,13.84371,"Kwanza Sul","city"],
  [2451478,"Ségou","ML",13.44032,-6.25947,"Ségou","city"],
  [1578500,"Kon Tum","VN",14.35451,108.00759,"Quang Ngai","city"],
  [3460949,"Itabuna","BR",-14.78556,-39.28028,"Bahia","city"],
  [3654870,"Latacunga","EC",-0.93424,-78.6152,"Cotopaxi","city"],
  [1261913,"Nāngloi Jāt","IN",28.67957,77.06799,"Delhi","city"],
  [1859383,"Kishiwada","JP",34.46667,135.36667,"Osaka","city"],
  [1785710,"Jinghong","CN",22.00265,100.7697,"Yunnan","city"],
  [977432,"Mdantsane","ZA",-32.93324,27.77656,"Eastern Cape","city"],
  [630468,"Bobruysk","BY",53.14676,29.20548,"Mogilev","city"],
  [1643837,"Gorontalo","ID",0.5375,123.0625,"Gorontalo","city"],
  [6317317,"Itaim Paulista","BR",-23.50308,-46.38566,"São Paulo","city"],
  [3449319,"São Carlos","BR",-22.0175,-47.89083,"São Paulo","city"],
  [120695,"Qā’em Shahr","IR",36.46306,52.86007,"Māzandarān","city"],
  [1165108,"Shikarpur","PK",27.95558,68.63823,"Sindh","city"],
  [6958503,"Gongheyong","CN",22.75923,113.79452,"Guangdong","city"],
  [2772400,"Linz","AT",48.30639,14.28611,"Upper Austria","city"],
  [1283467,"Dhangaḍhi̇̄","NP",28.70159,80.58991,"Sudurpashchim Pradesh","city"],
  [8544703,"Nanchuan","CN",29.15201,107.10335,"Chongqing","city"],
  [3530240,"Córdoba","MX",18.8842,-96.92559,"Veracruz","city"],
  [1816329,"Bishan","CN",29.59491,106.22476,"Chongqing","city"],
  [2503826,"Biskra","DZ",34.85038,5.72805,"Biskra","city"],
  [1675393,"Xizhi","TW",25.06615,121.65985,"Taipei","city"],
  [1787592,"Yanghang","CN",31.37022,121.43742,"Shanghai","city"],
  [1810437,"Gaoping","CN",30.77576,106.10294,"Sichuan","city"],
  [153176,"Mpanda","TZ",-6.34379,31.06951,"Katavi","city"],
  [3165185,"Trieste","IT",45.64953,13.77678,"Friuli Venezia Giulia","city"],
  [5374732,"Moreno Valley","US",33.93752,-117.23059,"California","city"],
  [1256922,"Secunderabad","IN",17.50427,78.54263,"Telangana","city"],
  [1880348,"Punggol","SG",1.41444,103.90694,"","city"],
  [7910079,"Sodo","ET",6.86,37.76159,"South Ethiopia Regional State","city"],
  [2208485,"Zliten","LY",32.46739,14.56874,"Misratah","city"],
  [3171728,"Padua","IT",45.40797,11.88586,"Veneto","city"],
  [8299875,"Karnaphuli","BD",22.69056,92.23472,"Chittagong","city"],
  [3550598,"Las Tunas","CU",20.96135,-76.95192,"Las Tunas Province","city"],
  [1857550,"Matsue","JP",35.48333,133.05,"Shimane","city"],
  [4562831,"Bayamón","PR",18.39856,-66.15572,"Bayamón","city"],
  [1842936,"Gimpo-si","KR",37.62361,126.71417,"Gyeonggi-do","city"],
  [6317464,"Lauro de Freitas","BR",-12.89444,-38.32722,"Bahia","city"],
  [1273241,"Deoghar","IN",24.48983,86.69902,"Jharkhand","city"],
  [1064890,"Fianarantsoa","MG",-21.45267,47.08569,"Upper Matsiatra","city"],
  [8504949,"Vasyl'evsky Ostrov","RU",59.94091,30.25377,"St.-Petersburg","city"],
  [3387296,"Sobral","BR",-3.68611,-40.34972,"Ceará","city"],
  [1207337,"Chāndpur","BD",23.22714,90.65433,"Chittagong","city"],
  [2306079,"Atsiaman","GH",5.69775,-0.32824,"Greater Accra","city"],
  [2317397,"Bandundu Province","CD",-3.31687,17.38063,"Kwilu","city"],
  [303195,"Osmaniye","TR",37.07417,36.24778,"Osmaniye","city"],
  [142363,"Bābol","IR",36.55102,52.6786,"Māzandarān","city"],
  [3985710,"Cabo San Lucas","MX",22.89088,-109.91238,"Baja California Sur","city"],
  [4119403,"Little Rock","US",34.74648,-92.28959,"Arkansas","city"],
  [748893,"Çorlu","TR",41.16069,27.80093,"Tekirdağ","city"],
  [1636930,"Madiun","ID",-7.6298,111.5239,"East Java","city"],
  [159071,"Iringa","TZ",-7.76667,35.7,"Iringa","city"],
  [721472,"Debrecen","HU",47.53167,21.62444,"Hajdú-Bihar","city"],
  [1274353,"Chāpra","IN",25.78031,84.74709,"Bihar","city"],
  [13589478,"Motijheel","BD",23.72772,90.41919,"Dhaka Division","city"],
  [1336137,"Barishal","BD",22.70497,90.37013,"Barisal Division","city"],
  [6122091,"Richmond Hill","CA",43.87111,-79.43725,"Ontario","city"],
  [4466033,"Fayetteville","US",35.05266,-78.87836,"North Carolina","city"],
  [2219905,"Al Khums","LY",32.64861,14.26191,"Al Marqab","city"],
  [5358705,"Huntington Beach","US",33.6603,-117.99923,"California","city"],
  [8063098,"Favoriten","AT",48.16116,16.38233,"State of Vienna","city"],
  [1708522,"Koronadal","PH",6.50306,124.84694,"Soccsksargen","city"],
  [2660646,"Geneva","CH",46.20222,6.14569,"Geneva","city"],
  [4174715,"Tallahassee","US",30.43826,-84.28073,"Florida","city"],
  [2636389,"Swindon","GB",51.55797,-1.78116,"England","city"],
  [1629710,"Rengasdengklok","ID",-6.15917,107.29806,"West Java","city"],
  [3451234,"Rio Claro","BR",-22.41139,-47.56139,"São Paulo","city"],
  [3699088,"Cajamarca","PE",-7.16378,-78.50027,"Cajamarca Department","city"],
  [2146142,"Townsville","AU",-19.26639,146.80569,"Queensland","city"],
  [8656376,"Thanh Khê","VN",16.0706,108.19102,"Da Nang City","city"],
  [7281017,"La Pintana","CL",-33.58331,-70.63419,"Santiago Metropolitan","city"],
  [601734,"Daşoguz","TM",41.83625,59.96661,"Dasoguz","city"],
  [5145215,"Yonkers","US",40.9304,-73.89789,"New York","city"],
  [5352423,"Glendale","US",34.14251,-118.25508,"California","city"],
  [1180809,"Dadu","PK",26.73033,67.7769,"Sindh","city"],
  [343663,"Arba Minch","ET",6.03333,37.55,"South Ethiopia Regional State","city"],
  [1520172,"Petropavl","KZ",54.87343,69.15065,"North Kazakhstan","city"],
  [1214658,"Lhokseumawe","ID",5.1801,97.1507,"Aceh","city"],
  [4684724,"Cypress","US",29.96911,-95.69717,"Texas","city"],
  [1267031,"Khandwa","IN",21.82427,76.35086,"Madhya Pradesh","city"],
  [4883817,"Aurora","US",41.76058,-88.32007,"Illinois","city"],
  [1259184,"Puri","IN",19.79825,85.82494,"Odisha","city"],
  [1262771,"Morena","IN",26.49892,77.99534,"Madhya Pradesh","city"],
  [3181554,"Brescia","IT",45.53558,10.21472,"Lombardy","city"],
  [13405749,"Nasimshahr","IR",35.56528,51.1583,"Tehran","city"],
  [6672634,"Nasīm Shahr","IR",35.56504,51.16332,"Tehran","city"],
  [2320831,"Ugep","NG",5.80865,8.08098,"Cross River State","city"],
  [214614,"Kamina","CD",-8.73508,24.99798,"Haut-Lomami","city"],
  [100425,"Yanbu","SA",24.08954,38.0618,"Medina Region","city"],
  [1856184,"Nagareyama","JP",35.8563,139.90266,"Chiba","city"],
  [2800481,"Charleroi","BE",50.41136,4.44448,"Wallonia","city"],
  [1576633,"Lạng Sơn","VN",21.85264,106.76101,"Lạng Sơn Province","city"],
  [1164045,"Talhar","PK",24.88454,68.81437,"Sindh","city"],
  [10920963,"Salé Al Jadida","MA",33.99722,-6.74047,"Rabat-Salé-Kénitra","city"],
  [11054411,"Bandar Sunway","MY",3.0693,101.6074,"Selangor","city"],
  [1167648,"Qadirpur Ran","PK",30.29184,71.67164,"Punjab","city"],
  [1180752,"Dajal","PK",29.55769,70.37614,"Punjab","city"],
  [12129605,"Chakwama","NG",11.55965,9.66407,"Jigawa State","city"],
  [1270576,"Gyānpur","IN",25.33268,82.46637,"Uttar Pradesh","city"],
  [13118277,"Bandar Utama","MY",3.14818,101.61407,"Kuala Lumpur","city"],
  [13118362,"Bukit Jalil","MY",3.04913,101.68036,"Kuala Lumpur","city"],
  [13512708,"Nyingchi","CN",29.64885,94.35509,"Tibet","city"],
  [13561808,"Rayon KTZ","UA",49.94349,36.36959,"Kharkiv","city"],
  [1626103,"Sumedang","ID",-6.85861,107.91639,"West Java","city"],
  [1818222,"Yuen Long San Hui","HK",22.43333,114.03333,"Yuen Long","city"],
  [1818225,"Yuen Long","HK",22.44518,114.02621,"Yuen Long","city"],
  [2218970,"Az Zāwīyah","LY",32.7571,12.72764,"Az Zawiyah","city"],
  [3448742,"São José","BR",-28.21344,-49.16383,"Santa Catarina","city"],
  [496348,"Severnyy","RU",55.93583,37.54889,"Moscow","city"],
  [60149,"El Dibir","SO",11.76667,51.21667,"Bari","city"],
  [1803551,"Beiliu","CN",22.70722,110.34917,"Guangxi","city"],
  [114259,"Sirjan","IR",29.45137,55.6809,"Kerman","city"],
  [3887127,"Iquique","CL",-20.21326,-70.15027,"Tarapacá","city"],
  [1565047,"Thuận Thanh","VN",21.046,106.079,"Bac Ninh","city"],
  [579492,"Balakovo","RU",52.02639,47.79671,"Saratov Oblast","city"],
  [580922,"Armavir","RU",44.99849,41.11472,"Krasnodar Krai","city"],
  [6822182,"Yachiyo","JP",35.73531,140.12445,"Chiba","city"],
  [6545349,"Saidpur","BD",25.77769,88.89169,"Rangpur Division","city"],
  [9645071,"Quận Bốn","VN",10.76684,106.70574,"Ho Chi Minh City (HCMC)","city"],
  [361546,"Arīsh","EG",31.13159,33.79844,"North Sinai","city"],
  [1735150,"Rawang","MY",3.3213,101.5767,"Selangor","city"],
  [2650839,"Dudley","GB",52.5,-2.08333,"England","city"],
  [2329660,"Mushin","NG",6.52799,3.35411,"Lagos","city"],
  [2119441,"Yuzhno-Sakhalinsk","RU",46.9543,142.73559,"Sakhalin Oblast","city"],
  [2912621,"Hagen","DE",51.36081,7.47168,"North Rhine-Westphalia","city"],
  [1629131,"Salatiga","ID",-7.33194,110.49278,"Central Java","city"],
  [3640465,"Guacara","VE",10.22609,-67.877,"Carabobo","city"],
  [6318856,"Valparaíso de Goiás","BR",-16.06583,-47.97861,"Goiás","city"],
  [126972,"Khūy","IR",38.5503,44.9521,"West Azerbaijan","city"],
  [3099230,"Gliwice","PL",50.29761,18.67658,"Silesia","city"],
  [1529569,"Changji","CN",44.00782,87.30461,"Xinjiang","city"],
  [11611930,"Kodaira","JP",35.72603,139.48508,"Tokyo","city"],
  [13512576,"Plano Piloto","BR",-15.79411,-47.8825,"Federal District","city"],
  [5516233,"Amarillo","US",35.222,-101.8313,"Texas","city"],
  [1275120,"Bulandshahr","IN",28.40392,77.85773,"Uttar Pradesh","city"],
  [13512674,"Lusail","QA",25.4175,51.5075,"Al Daayen","city"],
  [2657832,"Aberdeen","GB",57.14369,-2.09814,"Scotland","city"],
  [3165926,"Taranto","IT",40.46438,17.24707,"Apulia","city"],
  [3439214,"Capiatá","PY",-25.3552,-57.44545,"Central Department","city"],
  [11592398,"Zango","AO",-9.01212,13.38437,"Luanda","city"],
  [1811764,"Duyun","CN",26.26667,107.51667,"Guizhou","city"],
  [184707,"Naivasha","KE",-0.71383,36.43261,"Nakuru County","city"],
  [1804850,"Kaiyuan","CN",23.69767,103.30372,"Yunnan","city"],
  [759734,"Rzeszów","PL",50.04132,21.99901,"Subcarpathia","city"],
  [2844588,"Rostock","DE",54.0887,12.14049,"Mecklenburg-Vorpommern","city"],
  [3171457,"Parma","IT",44.79935,10.32618,"Emilia-Romagna","city"],
  [1735902,"Sibu","MY",2.3,111.81667,"Sarawak","city"],
  [751868,"Arnavutköy","TR",41.18355,28.7402,"Istanbul","city"],
  [1861310,"Itami","JP",34.78427,135.40126,"Hyōgo","city"],
  [1800657,"Mentougou","CN",39.93819,116.09307,"Beijing","city"],
  [1275926,"Bhind","IN",26.56671,78.78728,"Madhya Pradesh","city"],
  [5145476,"Akron","US",41.08144,-81.51901,"Ohio","city"],
  [3870294,"Talca","CL",-35.4232,-71.64974,"Maule Region","city"],
  [2892518,"Kassel","DE",51.31667,9.5,"Hesse","city"],
  [3530594,"Ciudad Madero","MX",22.2475,-97.83665,"Tamaulipas","city"],
  [1628453,"Sawangan","ID",-6.40278,106.77444,"West Java","city"],
  [2315728,"Gemena","CD",3.25651,19.77234,"Sud-Ubangi","city"],
  [10263167,"Bhālswa Jahangirpur","IN",28.73558,77.16682,"Delhi","city"],
  [13512503,"Lushui","CN",25.8232,98.85853,"Yunnan","city"],
  [140463,"Bīrjand","IR",32.86628,59.22114,"South Khorasan Province","city"],
  [3083271,"Toruń","PL",53.01375,18.59814,"Kujawsko-Pomorskie","city"],
  [2521886,"Almería","ES",36.83814,-2.45974,"Andalusia","city"],
  [1805798,"Jijiang","CN",29.28993,106.25001,"Chongqing","city"],
  [1184845,"Ahmadpur East","PK",29.14269,71.25771,"Punjab","city"],
  [3696417,"Huánuco","PE",-9.92882,-76.23989,"Huánuco Department","city"],
  [11611627,"Higashihiroshima","JP",34.40861,132.73682,"Hiroshima","city"],
  [745028,"İzmit","TR",40.76499,29.92928,"Kocaeli","city"],
  [2984114,"Reims","FR",49.26526,4.02853,"Grand Est","city"],
  [1808950,"Hanfeng","CN",31.16946,108.4031,"Chongqing","city"],
  [5814616,"Vancouver","US",45.63873,-122.66149,"Washington","city"],
  [4049979,"Birmingham","US",33.52066,-86.80249,"Alabama","city"],
  [2462881,"Laayoune","EH",27.1418,-13.18797,"","city"],
  [1267076,"Khammam","IN",17.24767,80.14368,"Telangana","city"],
  [294751,"H̱olon","IL",32.01034,34.77918,"Tel Aviv","city"],
  [976361,"Middelburg","ZA",-25.77507,29.46482,"Mpumalanga","city"],
  [1843702,"Icheon-si","KR",37.27917,127.4425,"Gyeonggi-do","city"],
  [585915,"Khirdalan","AZ",40.44808,49.75502,"Abşeron","city"],
  [1607508,"Phra Pradaeng","TH",13.65855,100.53362,"Samut Prakan","city"],
  [2427455,"Moundou","TD",8.57437,16.07722,"Logone Occidental","city"],
  [1257540,"Sambhal","IN",28.58498,78.56959,"Uttar Pradesh","city"],
  [1275899,"Bhiwāni","IN",28.79304,76.13968,"Haryana","city"],
  [563464,"Engels","RU",51.48389,46.10528,"Saratov Oblast","city"],
  [4026082,"Ciudad Lázaro Cárdenas","MX",17.96256,-102.19887,"Michoacán","city"],
  [1024694,"Mocuba","MZ",-16.8375,36.98556,"Zambezia Province","city"],
  [1283339,"Hetauda","NP",27.42839,85.03219,"Bagmati Province","city"],
  [3185728,"Durrës","AL",41.32355,19.45469,"Durrës County","city"],
  [1851348,"Suzuka","JP",34.88333,136.58333,"Mie","city"],
  [12524485,"Hub","PK",25.02555,66.88534,"Balochistan","city"],
  [3432043,"La Plata","AR",-34.92126,-57.95442,"Buenos Aires","city"],
  [1283318,"Janakpur","NP",26.72882,85.92628,"Madhesh","city"],
  [1860437,"Kamirenjaku","JP",35.69423,139.55495,"Tokyo","city"],
  [1260434,"Panvel","IN",18.98878,73.11013,"Maharashtra","city"],
  [1798972,"Peicheng","CN",34.73611,116.92472,"Jiangsu","city"],
  [1236854,"Maharagama","LK",6.848,79.9265,"Western Province","city"],
  [4076784,"Montgomery","US",32.36681,-86.29997,"Alabama","city"],
  [2792413,"Liège","BE",50.63373,5.56749,"Wallonia","city"],
  [1858428,"Kumagaya","JP",36.13497,139.39004,"Saitama","city"],
  [1841988,"Guri-si","KR",37.5986,127.1394,"Gyeonggi-do","city"],
  [1278860,"Ambāla","IN",30.36099,76.79782,"Haryana","city"],
  [4994358,"Grand Rapids","US",42.96336,-85.66809,"Michigan","city"],
  [3169921,"Prato","IT",43.8805,11.09699,"Tuscany","city"],
  [8223943,"Kumarapalayam","IN",11.44495,77.71102,"Tamil Nadu","city"],
  [1283562,"Butwāl","NP",27.69121,83.45251,"Lumbini Province","city"],
  [8986037,"Dhirkot","PK",34.03917,73.57694,"Azad Kashmir","city"],
  [2455518,"Kayes","ML",14.44776,-11.44393,"Kayes","city"],
  [1648186,"Bontang","ID",0.1324,117.4854,"East Kalimantan","city"],
  [354502,"Kafr ash Shaykh","EG",31.11174,30.93991,"Kafr el-Sheikh","city"],
  [2477461,"Tébessa","DZ",35.40417,8.12417,"Tébessa","city"],
  [1732676,"Kuala Kubu Baharu","MY",3.5638,101.6581,"Selangor","city"],
  [193624,"Karuri","KE",-1.17641,36.7564,"Kiambu County","city"],
  [193627,"Karuri","KE",-0.7,37.18333,"Murang'A","city"],
  [2417786,"Manéah","GN",9.73333,-13.41667,"Kindia","city"],
  [496285,"Severodvinsk","RU",64.55825,39.82971,"Arkhangelskaya","city"],
  [13308632,"Kowloon City Centre","HK",22.32979,114.18889,"Kowloon City","city"],
  [187269,"Matuga","KE",-4.168,39.57068,"Kwale County","city"],
  [747764,"Düzce","TR",40.83889,31.16389,"Düzce","city"],
  [2328765,"Nnewi","NG",6.01962,6.91729,"Anambra","city"],
  [1848689,"Yamaguchi","JP",34.18333,131.46667,"Yamaguchi","city"],
  [3130616,"Alcalá de Henares","ES",40.48205,-3.35996,"Madrid","city"],
  [6947639,"Başakşehir","TR",41.106,28.791,"Istanbul","city"],
  [1811619,"Ezhou","CN",30.4,114.83333,"Hubei","city"],
  [1784712,"Zhengding","CN",38.14501,114.56556,"Hebei","city"],
  [139889,"Būkān","IR",36.521,46.2089,"West Azerbaijan","city"],
  [6698121,"Taguatinga","BR",-15.83326,-48.05506,"Federal District","city"],
  [2742032,"Braga","PT",41.5514,-8.42311,"Braga","city"],
  [1174376,"Garhi Khairo","PK",28.05717,67.97898,"Sindh","city"],
  [909863,"Luanshya","ZM",-13.13667,28.41661,"Copperbelt","city"],
  [1963770,"Padalarang","ID",-6.83778,107.47278,"West Java","city"],
  [7026720,"Bang Khae","TH",13.69301,100.40755,"Bangkok","city"],
  [1729085,"Bago City","PH",10.53333,122.83333,"Western Visayas","city"],
  [1786378,"Yongchuan","CN",29.35376,105.89392,"Chongqing","city"],
  [1849372,"Uji","JP",34.89044,135.80325,"Kyoto","city"],
  [1264637,"Machilīpatnam","IN",16.18747,81.13888,"Andhra Pradesh","city"],
  [1803842,"Hepu","CN",21.65921,109.20011,"Guangxi","city"],
  [2038670,"Aihui","CN",49.97946,127.48119,"Heilongjiang","city"],
  [2043837,"Hyesan","KP",41.40167,128.17778,"Yanggang-do","city"],
  [3567597,"Bayamo","CU",20.37368,-76.64272,"Granma Province","city"],
  [769250,"Kielce","PL",50.87033,20.62752,"Świętokrzyskie","city"],
  [1192366,"Pār Naogaon","BD",24.80418,88.94875,"Rajshahi Division","city"],
  [1792585,"Fuding","CN",27.32734,120.21399,"Fujian","city"],
  [3456223,"Nossa Senhora do Socorro","BR",-10.855,-37.12611,"Sergipe","city"],
  [3402591,"Castanhal","BR",-1.29389,-47.92639,"Pará","city"],
  [11962424,"Cidade Tiradentes","BR",-23.58481,-46.40084,"São Paulo","city"],
  [3080985,"Zabrze","PL",50.32492,18.78576,"Silesia","city"],
  [2190324,"Hamilton","NZ",-37.78333,175.28333,"Waikato Region","city"],
  [140380,"Bojnūrd","IR",37.47473,57.32903,"North Khorasan","city"],
  [2322733,"Surulere","NG",6.50153,3.35808,"Lagos","city"],
  [1806696,"Humen","CN",22.81899,113.67306,"Guangdong","city"],
  [2240937,"Benfica","AO",-8.94432,13.16431,"Luanda","city"],
  [1610780,"Hat Yai","TH",7.00836,100.47668,"Songkhla","city"],
  [2037086,"Haicheng","CN",40.85158,122.74754,"Liaoning","city"],
  [1645895,"Curug","ID",-6.26583,106.55639,"Banten","city"],
  [3689169,"Barrancabermeja","CO",7.06528,-73.85472,"Santander Department","city"],
  [462444,"Zlatoust","RU",55.17182,59.65471,"Chelyabinsk","city"],
  [1514581,"Angren","UZ",41.01667,70.14361,"Tashkent Region","city"],
  [228853,"Mukono","UG",0.35333,32.75528,"Central Region","city"],
  [3530599,"Ciudad del Carmen","MX",18.64592,-91.82991,"Campeche","city"],
  [3456166,"Nova Friburgo","BR",-22.28194,-42.53111,"Rio de Janeiro","city"],
  [1162004,"Khairpur Mir’s","PK",27.52948,68.75915,"Sindh","city"],
  [13118432,"Business Bay","AE",25.18544,55.26969,"Dubai","city"],
  [1514879,"Khujand","TJ",40.28256,69.62216,"Sughd","city"],
  [5308480,"Peoria","US",33.5806,-112.23738,"Arizona","city"],
  [2304121,"Ashaiman","GH",5.69951,-0.03484,"Greater Accra","city"],
  [1213547,"Tanjungbalai","ID",2.96667,99.8,"North Sumatra","city"],
  [5224151,"Providence","US",41.82399,-71.41283,"Rhode Island","city"],
  [1264389,"Mahesāna","IN",23.59864,72.38472,"Gujarat","city"],
  [4634946,"Knoxville","US",35.96064,-83.92074,"Tennessee","city"],
  [13546341,"Rangel","AO",-8.82644,13.26285,"Luanda","city"],
  [3121960,"Fuenlabrada","ES",40.28419,-3.79415,"Madrid","city"],
  [1862599,"Hino","JP",35.67306,139.40028,"Tokyo","city"],
  [1175864,"Jhelum","PK",32.93448,73.73102,"Punjab","city"],
  [1264407,"Mahbūbnagar","IN",16.74385,77.98597,"Telangana","city"],
  [2038342,"Beipiao","CN",41.79194,120.77917,"Liaoning","city"],
  [1608048,"Pak Kret","TH",13.91179,100.49774,"Nonthaburi","city"],
  [1586360,"Cẩm Phả","VN",21.01004,107.27345,"Quảng Ninh","city"],
  [99454,"Al Fallūjah","IQ",33.34913,43.78599,"Anbar","city"],
  [1529651,"Jinshanlu","CN",47.8505,88.13286,"Xinjiang","city"],
  [2337207,"Ise-Ekiti","NG",7.46478,5.42333,"Ekiti State","city"],
  [1859100,"Kofu","JP",35.66667,138.56667,"Yamanashi","city"],
  [1854902,"Numazu","JP",35.1,138.86667,"Shizuoka","city"],
  [6825489,"Jōetsu","JP",37.14828,138.23642,"Niigata","city"],
  [11184422,"Planaltina","BR",-15.61791,-47.64874,"Federal District","city"],
  [5513343,"Sunrise Manor","US",36.21108,-115.07306,"Nevada","city"],
  [1257542,"Sambalpur","IN",21.46527,83.97573,"Odisha","city"],
  [484972,"Syzran","RU",53.1585,48.4681,"Samara Oblast","city"],
  [1667982,"Danshui","TW",25.17196,121.4429,"Taipei","city"],
  [3101950,"Bytom","PL",50.34802,18.93282,"Silesia","city"],
  [207570,"Mwene-Ditu","CD",-7.00906,23.45278,"Lomami","city"],
  [1695743,"Panalanoy","PH",11.25111,125.00639,"Eastern Visayas","city"],
  [3389353,"Santarém","BR",-2.44306,-54.70833,"Pará","city"],
  [1809467,"Guixi","CN",30.33355,107.34545,"Chongqing","city"],
  [1854747,"Odawara","JP",35.25556,139.15972,"Kanagawa","city"],
  [3468031,"Camaçari","BR",-12.6975,-38.32417,"Bahia","city"],
  [1638868,"Labuan Bajo","ID",-8.4964,119.8877,"East Nusa Tenggara","city"],
  [1865294,"Anjō","JP",34.95828,137.08054,"Aichi","city"],
  [6956647,"Boyeros","CU",23.0072,-82.4017,"Havana","city"],
  [1002145,"George","ZA",-33.963,22.46173,"Western Cape","city"],
  [1849892,"Tottori-shi","JP",35.5,134.23333,"Tottori","city"],
  [3118594,"Leganés","ES",40.32718,-3.7635,"Madrid","city"],
  [3649833,"Acarigua","VE",9.55451,-69.19564,"Portuguesa","city"],
  [334609,"Hosa’ina","ET",7.54978,37.85374,"Central Ethiopia Regional State","city"],
  [7026886,"Sai Mai","TH",13.92068,100.64552,"Bangkok","city"],
  [1285693,"Yawnghwe","MM",20.65973,96.93376,"Shan State","city"],
  [1704703,"Mabalacat City","PH",15.22303,120.57117,"Central Luzon","city"],
  [3670745,"Riohacha","CO",11.54444,-72.90722,"La Guajira Department","city"],
  [1804578,"Laizhou","CN",37.18073,119.94217,"Shandong","city"],
  [3450404,"Santa Bárbara d'Oeste","BR",-22.75361,-47.41361,"São Paulo","city"],
  [3451138,"Rio Grande","BR",-32.035,-52.09861,"Rio Grande do Sul","city"],
  [4694482,"Grand Prairie","US",32.74596,-96.99778,"Texas","city"],
  [1685755,"Sorsogon","PH",12.97389,123.99333,"Bicol Region","city"],
  [10374934,"Ait Melloul","MA",30.34164,-9.50356,"Souss-Massa","city"],
  [2636503,"Sutton","GB",51.35,-0.2,"England","city"],
  [4341513,"Shreveport","US",32.52515,-93.75018,"Louisiana","city"],
  [1884737,"Choa Chu Kang New Town","SG",1.3825,103.74972,"","city"],
  [3121437,"Getafe","ES",40.30571,-3.73295,"Madrid","city"],
  [9645073,"Quận Năm","VN",10.75567,106.66745,"Ho Chi Minh City (HCMC)","city"],
  [1275778,"Bhusawal","IN",21.04365,75.78506,"Maharashtra","city"],
  [3934876,"Miraflores","PE",-12.11331,-77.03274,"Lima region","city"],
  [3454865,"Alvorada","BR",-30.00018,-51.07632,"Rio Grande do Sul","city"],
  [3530870,"Chilpancingo","MX",17.55228,-99.50124,"Guerrero","city"],
  [3468376,"Cachoeiro de Itapemirim","BR",-20.84889,-41.11278,"Espírito Santo","city"],
  [11903636,"Donaustadt","AT",48.2333,16.46002,"State of Vienna","city"],
  [3544091,"Pinar del Río","CU",22.41649,-83.69657,"Pinar del Río","city"],
  [8416933,"Huixing","CN",29.68403,106.61486,"Chongqing","city"],
  [307654,"Kırıkkale","TR",39.84528,33.50639,"Kırıkkale","city"],
  [615532,"Batumi","GE",41.64077,41.6306,"Adjara","city"],
  [5911592,"Burlington","CA",43.38621,-79.83713,"Ontario","city"],
  [1336143,"Pābna","BD",24.00644,89.2372,"Rajshahi Division","city"],
  [4676740,"Brownsville","US",25.90175,-97.49748,"Texas","city"],
  [1815477,"Changyuan","CN",29.40499,105.58827,"Chongqing","city"],
  [3564124,"Cienfuegos","CU",22.14681,-80.4481,"Cienfuegos Province","city"],
  [295530,"Beersheba","IL",31.25181,34.7913,"Southern District","city"],
  [2497411,"El Oued","DZ",33.35608,6.86319,"El Oued","city"],
  [4276873,"Overland Park","US",38.98223,-94.67079,"Kansas","city"],
  [1259064,"Raebareli","IN",26.2309,81.23315,"Uttar Pradesh","city"],
  [7910932,"Shangri-La","CN",27.82511,99.70779,"Yunnan","city"],
  [952865,"Springs","ZA",-26.25,28.4,"Gauteng","city"],
  [4776024,"Newport News","US",36.98038,-76.42975,"Virginia","city"],
  [8417605,"Yangcheng","CN",29.99968,106.25604,"Chongqing","city"],
  [2453348,"Mopti","ML",14.4843,-4.18296,"Mopti","city"],
  [248460,"Khuraybat as Sūq","JO",31.87913,35.92098,"Amman","city"],
  [2216885,"Zawiya","LY",32.75222,12.72778,"Az Zawiyah","city"],
  [3979802,"Zamora de Hidalgo","MX",19.98404,-102.28634,"Michoacán","city"],
  [1270351,"Haridwar","IN",29.94791,78.16025,"Uttarakhand","city"],
  [380174,"Ad-Damazin","SD",11.7891,34.3592,"Blue Nile","city"],
  [1529531,"Dunhuang","CN",40.16667,94.68333,"Gansu","city"],
  [1805704,"Jing’an","CN",22.21072,113.29218,"Guangdong","city"],
  [3003796,"Le Havre","FR",49.49346,0.10785,"Normandy","city"],
  [13607660,"Verhunskyi","UA",48.58573,39.37158,"Luhansk","city"],
  [11127930,"Phusro","IN",23.75644,86.0051,"Jharkhand","city"],
  [3110044,"Donostia / San Sebastián","ES",43.31283,-1.97499,"Basque Country","city"],
  [3521168,"Poza Rica de Hidalgo","MX",20.53315,-97.45946,"Veracruz","city"],
  [358840,"Bilbeis","EG",30.42039,31.56223,"Sharqia","city"],
  [1691444,"Roxas City","PH",11.58528,122.75111,"Western Visayas","city"],
  [2994540,"Paris 20 Ménilmontant","FR",48.8646,2.3984,"Île-de-France","city"],
  [305268,"Kütahya","TR",39.42417,29.98333,"Kütahya","city"],
  [1633037,"Palopo","ID",-2.9925,120.19694,"South Sulawesi","city"],
  [2852458,"Potsdam","DE",52.39886,13.06566,"Brandenburg","city"],
  [3173331,"Modena","IT",44.64783,10.92539,"Emilia-Romagna","city"],
  [750516,"Bolu","TR",40.73583,31.60611,"Bolu","city"],
  [1849845,"Toyokawa","JP",34.81667,137.4,"Aichi","city"],
  [1279335,"Adoni","IN",15.62788,77.27495,"Andhra Pradesh","city"],
  [1861107,"Izumi","JP",34.48333,135.43333,"Osaka","city"],
  [12157007,"Santa Anita - Los Ficus","PE",-12.05048,-76.97335,"Lima region","city"],
  [1785462,"Zaoyang","CN",32.12722,112.75417,"Hubei","city"],
  [9827976,"Paltan","BD",23.73625,90.41426,"Dhaka Division","city"],
  [11204237,"Ivory Park","ZA",-25.9957,28.1971,"Gauteng","city"],
  [173377,"Al Qāmishlī","SY",37.05215,41.23142,"Al-Hasakah","city"],
  [1512236,"Abakan","RU",53.7154,91.42593,"Khakasiya Republic","city"],
  [1631648,"Pemalang","ID",-6.89193,109.38263,"Central Java","city"],
  [2758401,"Breda","NL",51.58656,4.77596,"North Brabant","city"],
  [1214724,"Langsa","ID",4.4683,97.9683,"Aceh","city"],
  [1562773,"Vĩnh Châu","VN",9.32439,105.98006,"Can Tho City","city"],
  [2038584,"Baishan","CN",41.93853,126.41965,"Jilin","city"],
  [1255560,"Sūjāngarh","IN",27.7,74.46667,"Rajasthan","city"],
  [11611487,"Tachikawa","JP",35.7091,139.41891,"Tokyo","city"],
  [8555643,"Cergy-Pontoise","FR",49.03894,2.07805,"Île-de-France","city"],
  [101732,"Unaizah","SA",26.1,44,"Al-Qassim Region","city"],
  [4076598,"Mobile","US",30.69436,-88.04305,"Alabama","city"],
  [2638785,"St Helens","GB",53.45,-2.73333,"England","city"],
  [4155966,"Fort Lauderdale","US",26.12231,-80.14338,"Florida","city"],
  [1638063,"Lembang","ID",-6.81167,107.6175,"West Java","city"],
  [3029374,"Paris 18 Buttes-Montmartre","FR",48.8925,2.3444,"Île-de-France","city"],
  [6544104,"Sants-Montjuïc","ES",41.37263,2.1546,"Catalonia","city"],
  [671768,"Oradea","RO",47.0458,21.91833,"Bihor County","city"],
  [2842647,"Saarbrücken","DE",49.23262,7.00982,"Saarland","city"],
  [160892,"Bunda","TZ",-2.02153,33.87109,"Mara","city"],
  [2479536,"Skikda","DZ",36.87617,6.90921,"Skikda","city"],
  [124082,"Mīāneh","IR",37.421,47.715,"East Azerbaijan","city"],
  [1215957,"Tirmiz","UZ",37.22417,67.27833,"Surxondaryo Region","city"],
  [3460102,"Jaraguá do Sul","BR",-26.48611,-49.06667,"Santa Catarina","city"],
  [1626899,"Singosari","ID",-7.8924,112.6658,"East Java","city"],
  [3644918,"Cúa","VE",10.16245,-66.88248,"Miranda","city"],
  [1256052,"Sirsa","IN",29.53489,75.02898,"Haryana","city"],
  [1504826,"Kamensk-Ural’skiy","RU",56.40626,61.93347,"Sverdlovsk Oblast","city"],
  [11962375,"Cidade Dutra","BR",-23.72576,-46.7024,"São Paulo","city"],
  [2523630,"Reggio Calabria","IT",38.11047,15.66129,"Calabria","city"],
  [13156932,"Dinapur Nizamat","IN",25.63847,85.05118,"Bihar","city"],
  [5393049,"Santa Clarita","US",34.39166,-118.54259,"California","city"],
  [1014073,"Carletonville","ZA",-26.36094,27.39767,"Gauteng","city"],
  [2421535,"Dubréka","GN",9.79111,-13.52333,"Kindia","city"],
  [1635283,"Metro","ID",-5.11306,105.30667,"Lampung","city"],
  [359280,"Banhā","EG",30.45977,31.1842,"Qalyubia","city"],
  [1277799,"Bahraigh","IN",27.57429,81.59474,"Uttar Pradesh","city"],
  [98622,"Ash Shaţrah","IQ",31.40906,46.1727,"Dhi Qar","city"],
  [3169694,"Quarto Oggiaro","IT",45.51314,9.14343,"Lombardy","city"],
  [1818483,"Tsing Yi Town","HK",22.35,114.1,"Kwai Tsing District","city"],
  [3461879,"Guarapuava","BR",-25.39048,-51.46541,"Paraná","city"],
  [1308522,"Monywa","MM",22.10856,95.13583,"Sagaing Region","city"],
  [3726540,"Dessalines","HT",19.26177,-72.51611,"Artibonite","city"],
  [185131,"Mwala","KE",-1.35255,37.45482,"Machakos County","city"],
  [1267885,"Kāraikkudi","IN",10.06615,78.76784,"Tamil Nadu","city"],
  [3649017,"Araure","VE",9.58144,-69.23851,"Portuguesa","city"],
  [13157013,"Sultan Pur Majra","IN",28.68966,77.07648,"Delhi","city"],
  [1784617,"Zhenping","CN",33.03457,112.22763,"Henan","city"],
  [2038650,"Anda","CN",46.44867,125.30161,"Heilongjiang","city"],
  [3015772,"Paris 13 Gobelins","FR",48.8322,2.3561,"Île-de-France","city"],
  [2122104,"Petropavlovsk-Kamchatsky","RU",53.06393,158.62751,"Kamchatka","city"],
  [246013,"Wādī as Sīr","JO",31.9545,35.81831,"Amman","city"],
  [6657205,"Fardīs","IR",35.7555,50.9967,"Tehran","city"],
  [4612862,"Chattanooga","US",35.04563,-85.30968,"Tennessee","city"],
  [1270711,"Guna","IN",24.64691,77.3113,"Madhya Pradesh","city"],
  [2615876,"Odense","DK",55.39594,10.38831,"South Denmark","city"],
  [3906194,"Sacaba","BO",-17.39799,-66.03825,"Cochabamba","city"],
  [3590979,"Quetzaltenango","GT",14.84462,-91.52316,"Quetzaltenango","city"],
  [1274784,"Chandannagar","IN",22.86225,88.36796,"West Bengal","city"],
  [1277820,"Baharampur","IN",24.10473,88.25155,"West Bengal","city"],
  [670474,"Ploieşti","RO",44.95,26.01667,"Prahova","city"],
  [3436043,"Berazategui","AR",-34.76531,-58.21278,"Buenos Aires","city"],
  [12501195,"Shahuwadi","IN",16.90993,73.94654,"Maharashtra","city"],
  [1264621,"Madanapalle","IN",13.5503,78.50288,"Andhra Pradesh","city"],
  [1336144,"Tangail","BD",24.24984,89.91655,"Dhaka Division","city"],
  [1668875,"Shulin","TW",24.99085,121.42199,"Taipei","city"],
  [747712,"Edirne","TR",41.67719,26.55597,"Edirne","city"],
  [12492669,"Pingwu County","CN",32.40732,104.52738,"Sichuan","city"],
  [1316752,"Kyaukpyu","MM",19.42793,93.55134,"Rakhine","city"],
  [1570656,"Phúc Yên","VN",21.23695,105.70483,"Phu Tho","city"],
  [468809,"Yasenevo","RU",55.60686,37.51991,"Moscow","city"],
  [6087029,"Nepean","CA",45.33619,-75.7225,"Ontario","city"],
  [1256451,"Shivpuri","IN",25.42378,77.66223,"Madhya Pradesh","city"],
  [1832847,"Yangju","KR",37.83311,127.06169,"Gyeonggi-do","city"],
  [11778464,"Borshchahivka","UA",50.4316,30.3899,"Kyiv City","city"],
  [6545348,"Praga Południe","PL",52.24424,21.08545,"Mazovia","city"],
  [7614932,"Pirituba","BR",-23.48982,-46.7322,"São Paulo","city"],
  [912764,"Kasama","ZM",-10.21289,31.18084,"Northern Province","city"],
  [1255349,"Surendranagar","IN",22.72706,71.64856,"Gujarat","city"],
  [1023374,"Alexandra","ZA",-26.10528,28.09884,"Gauteng","city"],
  [2296606,"Obuase","GH",6.20228,-1.66796,"Ashanti","city"],
  [13608465,"Desnyanskyi","UA",51.50631,31.3168,"Chernihiv Oblast","city"],
  [13608468,"Novozavodskyi","UA",51.4893,31.25634,"Chernihiv Oblast","city"],
  [13607722,"Tsentralnyi","UA",47.09833,37.54838,"Donetsk","city"],
  [3454857,"Passo Fundo","BR",-28.26278,-52.40667,"Rio Grande do Sul","city"],
  [1706889,"Legaspi","PH",13.14125,123.74073,"Bicol Region","city"],
  [12253704,"Phú Quốc","VN",10.28715,104.01047,"An Giang","city"],
  [508101,"Podolsk","RU",55.42419,37.55472,"Moscow Oblast","city"],
  [1630341,"Purwakarta","ID",-6.55694,107.44333,"West Java","city"],
  [1513886,"Jizzax","UZ",40.13351,67.82956,"Jizzakh Region","city"],
  [3463422,"Ferraz de Vasconcelos","BR",-23.54083,-46.36861,"São Paulo","city"],
  [1584242,"Thị Trấn Đại Từ","VN",21.63384,105.63766,"Thai Nguyen","city"],
  [2337765,"Ila Orangun","NG",8.01714,4.90421,"Osun State","city"],
  [1261473,"Neyveli","IN",11.60877,79.4994,"Tamil Nadu","city"],
  [3472177,"Angra dos Reis","BR",-23.00667,-44.31806,"Rio de Janeiro","city"],
  [1786067,"Qianjiang","CN",30.421,112.8919,"Hubei","city"],
  [2911240,"Hamm","DE",51.68033,7.82089,"North Rhine-Westphalia","city"],
  [1606250,"Si Racha","TH",13.17283,100.93159,"Chon Buri","city"],
  [2476897,"Tiaret","DZ",35.37103,1.31699,"Tiaret","city"],
  [3848950,"La Rioja","AR",-29.41328,-66.85637,"La Rioja","city"],
  [1256287,"Silchar","IN",24.82733,92.79787,"Assam","city"],
  [2271772,"Amadora","PT",38.75382,-9.23083,"Lisbon","city"],
  [3529986,"Cuautitlán","MX",19.67052,-99.17989,"México","city"],
  [2646057,"Ipswich","GB",52.05917,1.15545,"England","city"],
  [227812,"Njeru","UG",0.44166,33.17917,"Central Region","city"],
  [1055429,"Toliara","MG",-23.35,43.66667,"Atsimo-Andrefana","city"],
  [3029372,"Paris 19 Buttes-Chaumont","FR",48.8817,2.3822,"Île-de-France","city"],
  [2323390,"Saki","NG",8.66762,3.39393,"Oyo State","city"],
  [2498611,"Chlef","DZ",36.16525,1.33452,"Chlef","city"],
  [3558729,"Fontanar","CU",23.02389,-82.408,"Havana","city"],
  [6621166,"Seogwipo","KR",33.25333,126.56181,"Jeju-do","city"],
  [1716995,"Concepcion","PH",15.32546,120.65723,"Central Luzon","city"],
  [5115843,"East Flatbush","US",40.65371,-73.93042,"New York","city"],
  [5512909,"Spring Valley","US",36.10803,-115.245,"Nevada","city"],
  [910111,"Livingstone","ZM",-17.84194,25.85425,"Southern Province","city"],
  [964349,"Potchefstroom","ZA",-26.71667,27.1,"North West","city"],
  [5393287,"Santa Rosa","US",38.44047,-122.71443,"California","city"],
  [3746181,"Ciudad Camilo Cienfuegos","CU",23.16076,-82.32798,"Havana","city"],
  [12808673,"Paris 13e Arrondissement","FR",48.8262,2.35986,"Île-de-France","city"],
  [13546343,"Sambizanga","AO",-8.78883,13.27506,"Luanda","city"],
  [1259312,"Proddatūr","IN",14.7502,78.54813,"Andhra Pradesh","city"],
  [1295765,"Sittwe","MM",20.14624,92.89835,"Rakhine","city"],
  [145757,"Dundo","AO",-7.36643,20.81557,"Luanda Norte","city"],
  [2661604,"Basel","CH",47.55839,7.57327,"Basel-City","city"],
  [1309793,"Meiktila","MM",20.87776,95.85844,"Mandalay Region","city"],
  [233346,"Gulu","UG",2.77457,32.29899,"Northern Region","city"],
  [2750053,"Nijmegen","NL",51.8425,5.85278,"Gelderland","city"],
  [355628,"Idkū","EG",31.3073,30.2981,"Beheira","city"],
  [2666199,"Uppsala","SE",59.85882,17.63889,"Uppsala","city"],
  [1269910,"Hugli","IN",22.90877,88.39674,"West Bengal","city"],
  [10263066,"Hashtsāl","IN",28.63406,77.05771,"Delhi","city"],
  [3469092,"Bragança Paulista","BR",-22.9527,-46.54418,"São Paulo","city"],
  [3446606,"Teresópolis","BR",-22.4167,-42.97822,"Rio de Janeiro","city"],
  [3985604,"San Luis Río Colorado","MX",32.4555,-114.77037,"Sonora","city"],
  [3583334,"Santa Ana","SV",13.98827,-89.55685,"Santa Ana Department","city"],
  [5725846,"Eugene","US",44.05207,-123.08675,"Oregon","city"],
  [2541479,"Nador","MA",35.16813,-2.93352,"Oriental","city"],
  [290332,"Al Muharraq","BH",26.25722,50.61194,"Muharraq","city"],
  [3103402,"Bielsko-Biala","PL",49.82245,19.04686,"Silesia","city"],
  [352733,"Marsá Maţrūḩ","EG",31.3529,27.23725,"Matruh","city"],
  [2759879,"Almere Stad","NL",52.37025,5.21413,"Flevoland","city"],
  [3127461,"Burgos","ES",42.34106,-3.70184,"Castille and León","city"],
  [1842966,"Gijang","KR",35.24417,129.21389,"Busan","city"],
  [3637012,"Lander","VE",10.18333,-66.7,"Miranda","city"],
  [2980291,"Saint-Étienne","FR",45.43389,4.39,"Rhône-Alpes","city"],
  [1278708,"Amroha","IN",28.90314,78.46984,"Uttar Pradesh","city"],
  [11612347,"Narashino","JP",35.68184,140.04152,"Chiba","city"],
  [2505329,"Béjaïa","DZ",36.75587,5.08433,"Béjaïa","city"],
  [1784580,"Zhenzhou","CN",32.28034,119.16999,"Jiangsu","city"],
  [5317058,"Tempe","US",33.41477,-111.90931,"Arizona","city"],
  [1789137,"Xindi","CN",29.81667,113.46667,"Hubei","city"],
  [5378771,"Oceanside","US",33.19587,-117.37948,"California","city"],
  [3511550,"Bella Vista","DO",18.45539,-69.9454,"Nacional","city"],
  [8416626,"Fengcheng","CN",29.82587,107.06019,"Chongqing","city"],
  [5750162,"Salem","US",44.9429,-123.0351,"Oregon","city"],
  [2633948,"Wigan","GB",53.54296,-2.63706,"England","city"],
  [5351515,"Garden Grove","US",33.77391,-117.94145,"California","city"],
  [309527,"Karaman","TR",37.18111,33.215,"Karaman","city"],
  [6094578,"Oshawa","CA",43.90012,-78.84957,"Ontario","city"],
  [300614,"Siverek","TR",37.75503,39.31667,"Şanlıurfa","city"],
  [3455478,"Palhoça","BR",-27.64528,-48.66778,"Santa Catarina","city"],
  [5385955,"Rancho Cucamonga","US",34.1064,-117.59311,"California","city"],
  [4149962,"Cape Coral","US",26.56285,-81.94953,"Florida","city"],
  [1567032,"Tân Châu","VN",10.79832,105.23887,"An Giang","city"],
  [1990589,"Teluknaga","ID",-6.09889,106.63806,"West Java","city"],
  [2036401,"Jiutai","CN",44.15127,125.82975,"Jilin","city"],
  [1274304,"Chhindwāra","IN",22.05697,78.93958,"Madhya Pradesh","city"],
  [94591,"Khānaqīn","IQ",34.3482,45.39065,"Diyala","city"],
  [1698829,"Naga","PH",13.61917,123.18139,"Bicol Region","city"],
  [2127733,"Tomakomai","JP",42.63694,141.60333,"Hokkaido","city"],
  [1255062,"Tambaram","IN",12.9246,80.12707,"Tamil Nadu","city"],
  [3985344,"San Miguel de Allende","MX",20.91528,-100.74389,"Guanajuato","city"],
  [1647142,"Cianjur","ID",-6.82222,107.13944,"West Java","city"],
  [1632937,"Pamulang","ID",-6.34278,106.73833,"West Java","city"],
  [2112708,"Hitachi","JP",36.6,140.65,"Ibaraki","city"],
  [3386361,"Timon","BR",-5.09417,-42.83667,"Maranhão","city"],
  [1275984,"Bhetia","IN",22.79321,86.14098,"Jharkhand","city"],
  [1260137,"Pathānkot","IN",32.27484,75.65287,"Punjab","city"],
  [1163967,"Tando Adam","PK",25.76818,68.66196,"Sindh","city"],
  [1277976,"Badlapur","IN",19.15516,73.26553,"Maharashtra","city"],
  [1985663,"Cikupa","ID",-6.23639,106.50833,"West Java","city"],
  [3629706,"Puerto Cabello","VE",10.47306,-68.0125,"Carabobo","city"],
  [11071484,"Latkrabang","TH",13.72784,100.74609,"Bangkok","city"],
  [2111220,"Sakura","JP",35.71667,140.23333,"Chiba","city"],
  [1849498,"Ube","JP",33.94306,131.25111,"Yamaguchi","city"],
  [3658501,"Daule","EC",-1.86032,-79.97683,"Guayas","city"],
  [97783,"Bayjī","IQ",34.92915,43.48878,"Salah ad Din","city"],
  [1273802,"Cuddalore","IN",11.75617,79.76693,"Tamil Nadu","city"],
  [3109718,"Santander","ES",43.46589,-3.80493,"Cantabria","city"],
  [2475687,"Tlemcen","DZ",34.87833,-1.315,"Tlemcen","city"],
  [1256237,"Shimla","IN",31.10442,77.16662,"Himachal Pradesh","city"],
  [417472,"Shāhīn Shahr","IR",32.85788,51.5529,"Isfahan","city"],
  [2651817,"Croydon","GB",51.38333,-0.1,"England","city"],
  [1309611,"Myeik","MM",12.43954,98.60028,"Tanintharyi Region","city"],
  [5115985,"East New York","US",40.66677,-73.88236,"New York","city"],
  [281124,"Khān Yūnis","PS",31.34018,34.30627,"Gaza Strip","city"],
  [1283460,"Dharān","NP",26.81436,87.27972,"Koshi","city"],
  [2522258,"Albacete","ES",38.99424,-1.85643,"Castille-La Mancha","city"],
  [2867838,"Mülheim","DE",51.43218,6.87967,"North Rhine-Westphalia","city"],
  [2310046,"Bata","GQ",1.86391,9.76582,"Litoral","city"],
  [1860672,"Kamakura","JP",35.31085,139.54698,"Kanagawa","city"],
  [3530937,"Chicoloapan","MX",19.41687,-98.90202,"México","city"],
  [8740017,"Gadag-Betageri","IN",15.4167,75.6167,"Karnataka","city"],
  [1803791,"Licheng","CN",23.29549,113.82465,"Guangdong","city"],
  [1861084,"Izumo","JP",35.36667,132.76667,"Shimane","city"],
  [1271850,"Gadag","IN",15.42977,75.62971,"Karnataka","city"],
  [189723,"Ongata Rongai","KE",-1.3953,36.764,"Kajiado County","city"],
  [8449763,"Lang'ata","KE",-1.3666,36.73324,"Nairobi County","city"],
  [3666608,"Tunja","CO",5.54481,-73.35756,"Boyacá","city"],
  [3906791,"Quillacollo","BO",-17.39228,-66.27838,"Cochabamba","city"],
  [3130564,"Alcorcón","ES",40.34582,-3.82487,"Madrid","city"],
  [202905,"Gisenyi","RW",-1.70278,29.25639,"Western Province","city"],
  [311073,"Isparta","TR",37.76444,30.55222,"Isparta","city"],
  [2634739,"Warrington","GB",53.39254,-2.58024,"England","city"],
  [598098,"Klaipėda","LT",55.7068,21.13912,"Klaipėda County","city"],
  [2634853,"Walsall","GB",52.58528,-1.98396,"England","city"],
  [2905891,"Herne","DE",51.5388,7.22572,"North Rhine-Westphalia","city"],
  [532535,"Lyublino","RU",55.67738,37.76005,"Moscow","city"],
  [2643097,"Mansfield","GB",53.13333,-1.2,"England","city"],
  [3169522,"Reggio nell'Emilia","IT",44.69825,10.63125,"Emilia-Romagna","city"],
  [2519752,"Castelló de la Plana","ES",39.98567,-0.04935,"Valencia","city"],
  [1319364,"Kēng Tung","MM",21.63093,99.92676,"Shan State","city"],
  [5231851,"Sioux Falls","US",43.54369,-96.72796,"South Dakota","city"],
  [786712,"Prizren","XK",42.21389,20.73972,"Prizren","city"],
  [2037620,"Dongling","CN",41.81444,123.57583,"Liaoning","city"],
  [1622636,"Ungaran","ID",-7.13972,110.405,"Central Java","city"],
  [1849186,"Urayasu","JP",35.65879,139.90055,"Chiba","city"],
  [9075789,"Long Khánh","VN",10.92655,107.24783,"Dong Nai","city"],
  [1716198,"Dagupan","PH",16.04313,120.33325,"Ilocos","city"],
  [5379439,"Ontario","US",34.06334,-117.65089,"California","city"],
  [7027003,"Watthana","TH",13.72978,100.58536,"Bangkok","city"],
  [1253237,"Verāval","IN",20.9077,70.36786,"Gujarat","city"],
  [1261653,"Navsari","IN",20.94237,72.92467,"Gujarat","city"],
  [1926134,"Imabari","JP",34.07001,133.00023,"Ehime","city"],
  [907770,"Mansa","ZM",-11.19976,28.89431,"Luapula Province","city"],
  [5577147,"Fort Collins","US",40.58526,-105.08442,"Colorado","city"],
  [1588275,"Bảo Lộc","VN",11.54798,107.80772,"Lam Dong","city"],
  [1734393,"Kulim","MY",5.36499,100.56177,"Kedah","city"],
  [2325592,"Oshodi","NG",6.55504,3.34363,"Lagos","city"],
  [293788,"Ramat Gan","IL",32.08227,34.81065,"Tel Aviv","city"],
  [1277835,"Bahadurgarh","IN",28.69287,76.93555,"Haryana","city"],
  [1344377,"Haldia","IN",22.06046,88.10975,"West Bengal","city"],
  [1518262,"Temirtau","KZ",50.05197,72.95497,"Karaganda","city"],
  [12747032,"East Helsinki","FI",60.21043,25.08289,"Uusimaa","city"],
  [3461563,"Ibirité","BR",-20.02194,-44.05889,"Minas Gerais","city"],
  [4563243,"Carolina","PR",18.38078,-65.95739,"Carolina","city"],
  [1259009,"Rāiganj","IN",25.61281,88.12449,"West Bengal","city"],
  [125185,"Malāyer","IR",34.30158,48.82166,"Hamadan Province","city"],
  [4409896,"Springfield","US",37.21533,-93.29824,"Missouri","city"],
  [2636531,"Sunderland","GB",54.90465,-1.38222,"England","city"],
  [1851032,"Takaoka","JP",36.75,137.01667,"Toyama","city"],
  [1269723,"Malda","IN",25.00447,88.14573,"West Bengal","city"],
  [630429,"Baranovichi","BY",53.13255,26.00775,"Brest","city"],
  [4005509,"Guadalupe","MX",22.74678,-102.5188,"Zacatecas","city"],
  [3471859,"Araçatuba","BR",-21.20889,-50.43278,"São Paulo","city"],
  [1855189,"Nishio","JP",34.86667,137.05,"Aichi","city"],
  [3837056,"San Luis","AR",-33.2914,-66.32467,"San Luis","city"],
  [2485801,"Ouargla","DZ",31.94932,5.32502,"Ouargla","city"],
  [763166,"Olsztyn","PL",53.78376,20.49272,"Warmia-Masuria","city"],
  [922806,"Kipushi","CD",-11.76097,27.25135,"Haut-Katanga","city"],
  [1818223,"Yuen Long Kau Hui","HK",22.44831,114.03199,"Yuen Long","city"],
  [1804586,"Laiyang","CN",36.97583,120.71361,"Shandong","city"],
  [1269135,"Jaunpur","IN",25.75356,82.68689,"Uttar Pradesh","city"],
  [13494069,"Khlong Sam Wa","TH",13.87139,100.73719,"Bangkok","city"],
  [2910685,"Harburg","DE",53.46057,9.98388,"Hamburg","city"],
  [13353695,"Chūō","JP",35.67004,139.77544,"Tokyo","city"],
  [905395,"Mufulira","ZM",-12.54982,28.24071,"Copperbelt","city"],
  [10263232,"Deoli","IN",28.50254,77.23117,"Delhi","city"],
  [1242833,"Jaffna","LK",9.66845,80.00742,"Northern Province","city"],
  [686254,"Arad","RO",46.18333,21.31667,"Arad County","city"],
  [3531023,"Chetumal","MX",18.51957,-88.30397,"Quintana Roo","city"],
  [1276100,"Bharūch","IN",21.69482,72.9805,"Gujarat","city"],
  [1045512,"Gurúè","MZ",-15.46694,36.97778,"Zambezia Province","city"],
  [7645166,"San Miguel","AR",-34.54335,-58.71229,"Buenos Aires","city"],
  [2130057,"Hirosaki","JP",40.59306,140.4725,"Aomori","city"],
  [3068160,"Pilsen","CZ",49.74747,13.37759,"Plzeň Region","city"],
  [3531200,"Chalco","MX",19.26174,-98.89775,"México","city"],
  [2972328,"Toulon","FR",43.12442,5.92836,"Provence-Alpes-Côte d'Azur","city"],
  [11962431,"Vila Andrade","BR",-23.62623,-46.72828,"São Paulo","city"],
  [1269937,"Hoshiārpur","IN",31.53723,75.91269,"Punjab","city"],
  [3453303,"Poços de Caldas","BR",-21.78778,-46.56139,"Minas Gerais","city"],
  [3647444,"Calabozo","VE",8.92416,-67.42929,"Guárico","city"],
  [281129,"Jabālyā","PS",31.5272,34.48347,"Gaza Strip","city"],
  [4012406,"Cuauhtémoc","MX",28.4063,-106.86667,"Chihuahua","city"],
  [3471766,"Araraquara","BR",-21.79444,-48.17556,"São Paulo","city"],
  [3665688,"Yopal","CO",5.33573,-72.3939,"Casanare Department","city"],
  [3433360,"Ituzaingó","AR",-27.58504,-56.68707,"Corrientes","city"],
  [121110,"Piranshahr","IR",36.701,45.1413,"West Azerbaijan","city"],
  [125446,"Mahābād","IR",36.7631,45.7222,"West Azerbaijan","city"],
  [3682426,"Florencia","CO",1.61549,-75.60412,"Caquetá","city"],
  [3452640,"Porto Seguro","BR",-16.44972,-39.06472,"Bahia","city"],
  [1566566,"Tây Hồ","VN",21.06895,105.81053,"Hanoi","city"],
  [1234633,"Moratuwa","LK",6.773,79.8816,"Western Province","city"],
  [3037656,"Angers","FR",47.47156,-0.55202,"Pays de la Loire","city"],
  [2646277,"Ilford","GB",51.55765,0.07278,"England","city"],
  [1177042,"Hasilpur","PK",29.69221,72.54566,"Punjab","city"],
  [3451205,"Rio das Ostras","BR",-22.52694,-41.945,"Rio de Janeiro","city"],
  [6544103,"Horta-Guinardó","ES",41.41849,2.1677,"Catalonia","city"],
  [255683,"Pátra","GR",38.2462,21.73508,"West Greece","city"],
  [13561146,"Rutchenkivskyi","UA",47.97597,37.69677,"Donetsk","city"],
  [1582436,"Đồng Xoài","VN",11.53495,106.88324,"Dong Nai","city"],
  [1185106,"Jamālpur","BD",24.91965,89.94812,"Mymensingh Division","city"],
  [2129376,"Kushiro","JP",42.975,144.37472,"Hokkaido","city"],
  [577206,"Berezniki","RU",59.4091,56.8204,"Perm Krai","city"],
  [2348773,"Awka","NG",6.21269,7.07199,"Anambra","city"],
  [472761,"Volgodonsk","RU",47.51141,42.15269,"Rostov","city"],
  [5357527,"Hollywood","US",34.09834,-118.32674,"California","city"],
  [1853483,"Oyama","JP",36.3,139.8,"Tochigi","city"],
  [2338385,"Ijero-Ekiti","NG",7.81514,5.06716,"Ekiti State","city"],
  [1268907,"Jīnd","IN",29.31577,76.31502,"Haryana","city"],
  [1498894,"Miass","RU",55.04552,60.10756,"Chelyabinsk","city"],
  [13546531,"Fortechnyi","UA",48.49865,32.25365,"Kirovohrad","city"],
  [1680932,"Tuguegarao","PH",17.61577,121.72285,"Cagayan Valley","city"],
  [3646382,"Carúpano","VE",10.66516,-63.25387,"Sucre","city"],
  [1265683,"Kumbakonam","IN",10.96209,79.39124,"Tamil Nadu","city"],
  [1630997,"Plumbon","ID",-6.705,108.47278,"West Java","city"],
  [2938913,"Darmstadt","DE",49.87167,8.65027,"Hesse","city"],
  [1218667,"Mary","TM",37.59378,61.83031,"Mary","city"],
  [518970,"Novocherkassk","RU",47.4222,40.09373,"Rostov","city"],
  [5346111,"Elk Grove","US",38.4088,-121.37162,"California","city"],
  [6992326,"Mohali","IN",30.67995,76.72211,"Punjab","city"],
  [3458498,"Linhares","BR",-19.39111,-40.07222,"Espírito Santo","city"],
  [1628884,"Sampit","ID",-2.5315,112.9496,"Central Kalimantan","city"],
  [4613868,"Clarksville","US",36.52977,-87.35945,"Tennessee","city"],
  [1818379,"Wan Chai","HK",22.28142,114.17258,"Wan Chai","city"],
  [2694762,"Linköping","SE",58.41086,15.62157,"Östergötland","city"],
  [1861171,"Iwata","JP",34.7,137.85,"Shizuoka","city"],
  [1175156,"Kamalia","PK",30.72708,72.64607,"Punjab","city"],
  [4168139,"Pembroke Pines","US",26.00315,-80.22394,"Florida","city"],
  [3675657,"Maicao","CO",11.37837,-72.2395,"La Guajira Department","city"],
  [2128815,"Obihiro","JP",42.91722,143.20444,"Hokkaido","city"],
  [1271912,"Fatehpur","IN",25.92774,80.81266,"Uttar Pradesh","city"],
  [2856883,"Osnabrück","DE",52.27264,8.0498,"Lower Saxony","city"],
  [3897347,"Calama","CL",-22.45667,-68.92371,"Antofagasta","city"],
  [6252065,"Nou Barris","ES",41.44163,2.17727,"Catalonia","city"],
  [6941099,"Nepalgunj","NP",28.05,81.61667,"Lumbini Province","city"],
  [3530367,"Comitán","MX",16.24004,-92.13668,"Chiapas","city"],
  [3631412,"Ocumare del Tuy","VE",10.1182,-66.77513,"Miranda","city"],
  [6822138,"Niiza","JP",35.82088,139.55791,"Saitama","city"],
  [5964700,"Greater Sudbury","CA",46.49,-80.99001,"Ontario","city"],
  [2034312,"Ulanhot","CN",46.08333,122.08333,"Inner Mongolia","city"],
  [109323,"Khobar","SA",26.27944,50.20833,"Eastern Province","city"],
  [1794060,"Songcheng","CN",26.88194,120.00111,"Fujian","city"],
  [5292387,"Deer Valley","US",33.68393,-112.13488,"Arizona","city"],
  [3449324,"São Caetano do Sul","BR",-23.62306,-46.55111,"São Paulo","city"],
  [1619485,"Bang Khun Thian","TH",13.66302,100.43416,"Bangkok","city"],
  [4644312,"Murfreesboro","US",35.84562,-86.39027,"Tennessee","city"],
  [3453837,"Pindamonhangaba","BR",-22.92389,-45.46167,"São Paulo","city"],
  [139817,"Bushehr","IR",28.96887,50.83657,"Bushehr","city"],
  [2552615,"Dar Bouazza","MA",33.51535,-7.81677,"Casablanca-Settat","city"],
  [1254241,"Tonk","IN",26.16638,75.78824,"Rajasthan","city"],
  [117392,"Saqqez","IR",36.24992,46.2735,"Kurdistan Province","city"],
  [2505530,"Béchar","DZ",31.61667,-2.21667,"Béchar","city"],
  [1567148,"Tam Kỳ","VN",15.57364,108.47403,"Da Nang City","city"],
  [314133,"Gölbaşı","TR",39.79043,32.80903,"Ankara","city"],
  [3462980,"Francisco Morato","BR",-23.28167,-46.74528,"São Paulo","city"],
  [1648759,"Bima","ID",-8.46006,118.72667,"West Nusa Tenggara","city"],
  [1308318,"Mu-se","MM",23.99742,97.90109,"Shan State","city"],
  [1253952,"Udupi","IN",13.33467,74.74617,"Karnataka","city"],
  [135423,"Shahrud","IR",36.41819,54.97628,"Semnan","city"],
  [1650227,"Banjaran","ID",-7.04528,107.58778,"West Java","city"],
  [1254757,"Thenali","IN",16.24253,80.63982,"Andhra Pradesh","city"],
  [946058,"Mthatha","ZA",-31.58893,28.78443,"Eastern Cape","city"],
  [2036920,"Hengshan","CN",45.20837,130.89808,"Heilongjiang","city"],
  [2637627,"Slough","GB",51.50949,-0.59541,"England","city"],
  [3351599,"Bocoio","AO",-12.47017,14.13688,"Benguela","city"],
  [3458930,"Lages","BR",-27.81611,-50.32611,"Santa Catarina","city"],
  [2864695,"Neukölln","DE",52.47719,13.43126,"State of Berlin","city"],
  [4169171,"Port Saint Lucie","US",27.29393,-80.35033,"Florida","city"],
  [1255969,"Sītāpur","IN",27.56192,80.68265,"Uttar Pradesh","city"],
  [1279064,"Alandur","IN",13.0025,80.20611,"Tamil Nadu","city"],
  [3186573,"Zenica","BA",44.20169,17.90397,"Federation of B&H","city"],
  [11962389,"Lajeado","BR",-23.53361,-46.40866,"São Paulo","city"],
  [2831580,"Solingen","DE",51.17343,7.0845,"North Rhine-Westphalia","city"],
  [1582926,"Ðông Hà","VN",16.81625,107.10031,"Quang Tri","city"],
  [5339631,"Corona","US",33.87529,-117.56644,"California","city"],
  [285629,"Ḩawallī","KW",29.33278,48.02861,"Hawalli","city"],
  [152451,"Musoma","TZ",-1.5,33.8,"Mara","city"],
  [2337490,"Inisa","NG",7.84855,4.32981,"Osun State","city"],
  [523064,"Nazran","RU",43.22597,44.77323,"Ingushetiya Republic","city"],
  [3470636,"Barra Mansa","BR",-22.54417,-44.17139,"Rio de Janeiro","city"],
  [1711146,"Ilagan","PH",17.14854,121.88924,"Cagayan Valley","city"],
  [2396518,"Port-Gentil","GA",-0.71933,8.78151,"Ogooué-Maritime","city"],
  [1276321,"Bhadrāvati","IN",13.84846,75.70502,"Karnataka","city"],
  [1863431,"Hadano","JP",35.37111,139.22361,"Kanagawa","city"],
  [255274,"Piraeus","GR",37.94203,23.64619,"Attica","city"],
  [7279741,"Vapi","IN",20.37175,72.90493,"Gujarat","city"],
  [2655095,"Bournemouth","GB",50.72048,-1.8795,"England","city"],
  [11962405,"Pedreira","BR",-23.70675,-46.64982,"São Paulo","city"],
  [268064,"Sidon","LB",33.55751,35.37148,"South Governorate","city"],
  [287830,"‘Ibrī","OM",23.22573,56.51572,"Ad Dhahirah","city"],
  [195915,"Jomvu","KE",-3.98623,39.6082,"Mombasa County","city"],
  [197745,"Garissa","KE",-0.45275,39.64601,"Garissa County","city"],
  [1262951,"Moga","IN",30.81383,75.16878,"Punjab","city"],
  [2640354,"Peterborough","GB",52.57364,-0.24777,"England","city"],
  [3672328,"Piedecuesta","CO",6.98789,-73.04953,"Santander Department","city"],
  [1792520,"Tongzhou","CN",39.90395,116.66183,"Beijing","city"],
  [2875376,"Ludwigshafen am Rhein","DE",49.48121,8.44641,"Rheinland-Pfalz","city"],
  [6957690,"Lat Krabang","TH",13.72197,100.78473,"Bangkok","city"],
  [286621,"Şalālah","OM",17.01505,54.09237,"Dhofar","city"],
  [6947641,"Büyükçekmece","TR",41.02072,28.58502,"Istanbul","city"],
  [1258831,"Rāj-Nāndgaon","IN",21.09687,81.0289,"Chhattisgarh","city"],
  [322830,"Aydın","TR",37.84501,27.83963,"Aydın","city"],
  [3682631,"Envigado","CO",6.17591,-75.59174,"Antioquia","city"],
  [379303,"Al-Junaynah","SD",13.45262,22.44725,"Western Darfur","city"],
  [1818116,"Anbu","CN",23.44895,116.68092,"Guangdong","city"],
  [4710178,"McKinney","US",33.19762,-96.61527,"Texas","city"],
  [2487134,"Mostaganem","DZ",35.93115,0.08918,"Mostaganem","city"],
  [1514210,"Chirchiq","UZ",41.46889,69.58222,"Tashkent Region","city"],
  [141663,"Bandar-e Māhshahr","IR",30.55655,49.18852,"Khuzestan","city"],
  [2779469,"Floridsdorf","AT",48.25,16.4,"State of Vienna","city"],
  [2878234,"Leverkusen","DE",51.0303,6.98432,"North Rhine-Westphalia","city"],
  [1695462,"Pandi","PH",14.865,120.95722,"Central Luzon","city"],
  [1718722,"Capas","PH",15.33117,120.5898,"Central Luzon","city"],
  [1799389,"Ning’er","CN",23.04053,101.03683,"Yunnan","city"],
  [2755003,"Haarlem","NL",52.38084,4.63683,"North Holland","city"],
  [2759661,"Arnhem","NL",51.98,5.91111,"Gelderland","city"],
  [2223763,"Nkongsamba","CM",4.9547,9.9404,"Littoral","city"],
  [3641099,"El Vigía","VE",8.6135,-71.65702,"Mérida","city"],
  [1258109,"Robertsonpet","IN",12.95629,78.27539,"Karnataka","city"],
  [3464460,"Dourados","BR",-22.22111,-54.80556,"Mato Grosso do Sul","city"],
  [191220,"Kitale","KE",1.01572,35.00622,"Trans Nzoia","city"],
  [2322794,"Suleja","NG",9.18059,7.17939,"Niger State","city"],
  [2529317,"Taza","MA",34.21,-4.01,"Fes-Meknes","city"],
  [2640729,"Oxford","GB",51.75222,-1.25596,"England","city"],
  [360716,"Al Maţarīyah","EG",31.18287,32.03108,"Dakahlia","city"],
  [3465196,"Criciúma","BR",-28.6775,-49.36972,"Santa Catarina","city"],
  [1135689,"Kunduz","AF",36.72895,68.857,"Kunduz","city"],
  [1811200,"Fengcheng","CN",34.70388,116.58717,"Jiangsu","city"],
  [1564046,"Trảng Bàng","VN",11.02987,106.35751,"Tay Ninh","city"],
  [1253747,"Unnāo","IN",26.54706,80.48781,"Uttar Pradesh","city"],
  [3120635,"Hortaleza","ES",40.47444,-3.6411,"Madrid","city"],
  [2239076,"N'dalatando","AO",-9.29782,14.91162,"Cuanza Norte","city"],
  [1275163,"Budaun","IN",28.03811,79.12668,"Uttar Pradesh","city"],
  [1854703,"Ōgaki","JP",35.35,136.61667,"Gifu","city"],
  [2641598,"Newport","GB",51.58774,-2.99835,"Wales","city"],
  [3893629,"Coquimbo","CL",-29.95332,-71.33947,"Coquimbo Region","city"],
  [1649541,"Baubau","ID",-5.4633,122.6024,"Southeast Sulawesi","city"],
  [1582173,"Đưc Trọng","VN",11.73559,108.3733,"Lam Dong","city"],
  [1648580,"Blitar","ID",-8.0983,112.1681,"East Java","city"],
  [952734,"KwaDukuza","ZA",-29.32816,31.28954,"KwaZulu-Natal","city"],
  [1856775,"Miyakonojō","JP",31.73333,131.06667,"Miyazaki","city"],
  [1264543,"Madhyamgram","IN",22.68944,88.44594,"West Bengal","city"],
  [5364940,"Lancaster","US",34.69804,-118.13674,"California","city"],
  [1493467,"Rubtsovsk","RU",51.51473,81.20613,"Altai Krai","city"],
  [1529167,"Tacheng","CN",46.74535,82.95847,"Xinjiang","city"],
  [2419533,"Kindia","GN",10.05692,-12.86576,"Kindia","city"],
  [2208032,"Tauranga","NZ",-37.68611,176.16667,"Bay of Plenty","city"],
  [214974,"Kalemie","CD",-5.94749,29.19471,"Tanganyika","city"],
  [7026785,"Chatuchak","TH",13.82895,100.55931,"Bangkok","city"],
  [3628053,"San Juan de los Morros","VE",9.91246,-67.35398,"Guárico","city"],
  [1907146,"Sayama","JP",35.85295,139.41212,"Saitama","city"],
  [3691674,"Sullana","PE",-4.90389,-80.68528,"Piura","city"],
  [2747351,"'s-Hertogenbosch","NL",51.69917,5.30417,"North Brabant","city"],
  [715429,"Szeged","HU",46.253,20.14824,"Csongrád","city"],
  [370737,"Malakal","SS",9.53342,31.66049,"Upper Nile","city"],
  [1274033,"Chittoor","IN",13.21055,79.0956,"Andhra Pradesh","city"],
  [3988214,"Salamanca","MX",20.56979,-101.1977,"Guanajuato","city"],
  [1618177,"Ban Khlong Prawet","TH",13.71904,100.68146,"Bangkok","city"],
  [1577995,"La Gi","VN",10.65993,107.77206,"Lam Dong","city"],
  [2803201,"Anderlecht","BE",50.83619,4.31454,"Brussels Capital","city"],
  [523812,"Mytishchi","RU",55.91099,37.72964,"Moscow Oblast","city"],
  [3530049,"Delegación Cuajimalpa de Morelos","MX",19.3692,-99.29089,"Mexico City","city"],
  [285066,"Hebron","PS",31.52935,35.0938,"West Bank","city"],
  [3584399,"Mejicanos","SV",13.72397,-89.188,"San Salvador Department","city"],
  [1563926,"Trà Vinh","VN",9.94719,106.34225,"Vinh Long","city"],
  [1632353,"Parepare","ID",-4.0135,119.6255,"South Sulawesi","city"],
  [1269280,"Jāmuria","IN",23.70468,87.07872,"West Bengal","city"],
  [2358946,"Koudougou","BF",12.25188,-2.36694,"Centre-Ouest","city"],
  [3466296,"Chapecó","BR",-27.09639,-52.61833,"Santa Catarina","city"],
  [700022,"Nyzhnodniprovsk","UA",48.47546,35.1167,"Dnipropetrovsk","city"],
  [1293960,"Taunggyi","MM",20.78919,97.03776,"Shan State","city"],
  [76184,"Dhamār","YE",14.54274,44.40514,"Dhamār","city"],
  [11048853,"Dubai Investments Park","AE",25.00827,55.15682,"Dubai","city"],
  [91057,"Ash Sharqāt","IQ",35.51722,43.22806,"Salah ad Din","city"],
  [3021372,"Dijon","FR",47.31344,5.01391,"Bourgogne","city"],
  [499292,"Salavat","RU",53.3828,55.91094,"Bashkortostan Republic","city"],
  [2344053,"Ede","NG",7.73635,4.43536,"Osun State","city"],
  [2464960,"Sukrah","TN",36.87744,10.2468,"Ariana Governorate","city"],
  [3996663,"Manzanillo","MX",19.11695,-104.34214,"Colima","city"],
  [3595237,"Jalapa","GT",14.63542,-89.99112,"Jalapa","city"],
  [1873014,"Paech’ŏn-ŭp","KP",37.99306,126.30139,"South Hwanghae","city"],
  [4459467,"Cary","US",35.79154,-78.78112,"North Carolina","city"],
  [3470583,"Barreiras","BR",-12.15278,-44.99,"Bahia","city"],
  [1732745,"Skudai","MY",1.53741,103.65779,"Johor","city"],
  [2439376,"Tahoua","NE",14.8888,5.2692,"Tahoua Region","city"],
  [4744091,"Alexandria","US",38.80484,-77.04692,"Virginia","city"],
  [3518723,"Tuxtepec","MX",18.0883,-96.12535,"Oaxaca","city"],
  [7483743,"Puthia","BD",24.36537,88.83431,"Rajshahi Division","city"],
  [6087790,"Newton","CA",49.13333,-122.85,"British Columbia","city"],
  [2988394,"Paris 16 Passy","FR",48.8637,2.2769,"Île-de-France","city"],
  [1784554,"Zhicheng","CN",30.29556,111.50472,"Hubei","city"],
  [1884365,"Ang Mo Kio New Town","SG",1.38028,103.83972,"","city"],
  [189386,"Limuru","KE",-1.1136,36.64205,"Kiambu County","city"],
  [3538803,"San Miguel del Padrón","CU",23.09544,-82.32669,"Havana","city"],
  [3903320,"Tarija","BO",-21.53549,-64.72956,"Tarija Department","city"],
  [3454783,"Patos de Minas","BR",-18.57889,-46.51806,"Minas Gerais","city"],
  [2857458,"Oldenburg","DE",53.14039,8.21479,"Lower Saxony","city"],
  [3034610,"Paris 17 Batignolles-Monceau","FR",48.8835,2.3219,"Île-de-France","city"],
  [11468431,"Matsusaka","JP",34.57895,136.53706,"Mie","city"],
  [3837702,"Catamarca","AR",-28.46957,-65.78524,"Catamarca","city"],
  [1850311,"Tochigi","JP",36.38333,139.73333,"Tochigi","city"],
  [549479,"Khoroshëvo-Mnevniki","RU",55.78363,37.47137,"Moscow","city"],
  [576432,"Bibirevo","RU",55.88333,37.6,"Moscow","city"],
  [2503701,"Bordj Bou Arreridj","DZ",36.07389,4.76139,"Bordj Bou Arréridj","city"],
  [338998,"Dīla","ET",6.41667,38.31667,"South Ethiopia Regional State","city"],
  [7284820,"Jaigaon","IN",26.84766,89.37558,"West Bengal","city"],
  [1276720,"Batāla","IN",31.80921,75.20294,"Punjab","city"],
  [3014728,"Grenoble","FR",45.17869,5.71479,"Rhône-Alpes","city"],
  [3460748,"Itapecerica da Serra","BR",-23.71694,-46.84917,"São Paulo","city"],
  [91597,"Sāmarrā’","IQ",34.1959,43.88568,"Salah ad Din","city"],
  [5317071,"Tempe Junction","US",33.41421,-111.94348,"Arizona","city"],
  [5380698,"Palmdale","US",34.57943,-118.11646,"California","city"],
  [1735106,"George Town","MY",5.41123,100.33543,"Penang","city"],
  [2498766,"El Achir","DZ",36.06386,4.62744,"Bordj Bou Arréridj","city"],
  [5355933,"Hayward","US",37.66882,-122.0808,"California","city"],
  [1261039,"Orai","IN",25.99023,79.45334,"Uttar Pradesh","city"],
  [1565136,"Thốt Nốt","VN",10.27213,105.5338,"Can Tho City","city"],
  [890422,"Gweru","ZW",-19.45,29.81667,"Midlands Province","city"],
  [3408424,"Abaetetuba","BR",-1.71806,-48.8825,"Pará","city"],
  [3746183,"Centro Habana","CU",23.13488,-82.36893,"Havana","city"],
  [13631347,"Panguíla","AO",-8.69335,13.44914,"Bengo","city"],
  [1881921,"Bukit Batok New Town","SG",1.35903,103.76368,"","city"],
  [7026787,"Chom Thong","TH",13.67717,100.48407,"Bangkok","city"],
  [560465,"Gol’yanovo","RU",55.82299,37.81306,"Moscow","city"],
  [1213614,"Sunggal","ID",3.5765,98.6151,"North Sumatra","city"],
  [8504953,"Admiralteisky","RU",59.923,30.3,"St.-Petersburg","city"],
  [3460728,"Itapetininga","BR",-23.59167,-48.05306,"São Paulo","city"],
  [2252309,"Diourbel","SN",14.64792,-16.24363,"Diourbel Region","city"],
  [1849429,"Ueda","JP",36.40265,138.28161,"Nagano","city"],
  [1819757,"Aberdeen","HK",22.24802,114.15289,"Southern District","city"],
  [12167218,"Avtozavodskyi","UA",49.09753,33.43206,"Poltava","city"],
  [5391295,"Salinas","US",36.67774,-121.6555,"California","city"],
  [6544488,"San Blas-Canillejas","ES",40.43893,-3.61537,"Madrid","city"],
  [3529982,"Cuautla","MX",18.8106,-98.93525,"Morelos","city"],
  [2766824,"Salzburg","AT",47.79941,13.04399,"State of Salzburg","city"],
  [1214191,"Perbaungan","ID",3.5679,98.956,"North Sumatra","city"],
  [1608258,"Nong Chok","TH",13.85585,100.86216,"Bangkok","city"],
  [2014006,"Ussuriysk","RU",43.80467,131.95734,"Primorye","city"],
  [11250625,"Arif Wala","PK",26.32478,66.29587,"Balochistan","city"],
  [2035644,"Nanpiao","CN",41.09822,120.74792,"Liaoning","city"],
  [3174659,"Livorno","IT",43.54427,10.32615,"Tuscany","city"],
  [3838874,"Río Cuarto","AR",-33.13044,-64.35272,"Cordoba","city"],
  [335035,"Harar","ET",9.31387,42.11815,"Harari","city"],
  [617239,"Tiraspol","MD",46.84275,29.6284,"Transnistria","city"],
  [3402383,"Caxias","BR",-4.85889,-43.35611,"Maranhão","city"],
  [2649997,"Enfield Town","GB",51.65147,-0.08497,"England","city"],
  [940316,"Westonaria","ZA",-26.31905,27.6486,"Gauteng","city"],
  [8416218,"Lizhi","CN",29.70317,107.39521,"Chongqing","city"],
  [6822096,"Hitachi-Naka","JP",36.39659,140.53479,"Ibaraki","city"],
  [1257804,"Saharsa","IN",25.87498,86.59611,"Bihar","city"],
  [350789,"Qalyub","EG",30.17922,31.2056,"Qalyubia","city"],
  [3595803,"Escuintla","GT",14.30097,-90.78816,"Escuintla","city"],
  [2514169,"Marbella","ES",36.51543,-4.88583,"Andalusia","city"],
  [315498,"Ereğli","TR",37.51333,34.04672,"Konya","city"],
  [1732687,"Batu Pahat","MY",1.8548,102.9325,"Johor","city"],
  [1735453,"Sitiawan","MY",4.2168,100.6996,"Perak","city"],
  [1700868,"Mariveles","PH",14.43385,120.48569,"Central Luzon","city"],
  [3518135,"San Pablo de las Salinas","MX",19.66658,-99.09477,"México","city"],
  [1152473,"Lampang","TH",18.29232,99.49277,"Lampang","city"],
  [2633352,"York","GB",53.95763,-1.08271,"England","city"],
  [1591474,"Bạc Liêu","VN",9.29414,105.72776,"Ca Mau","city"],
  [8299780,"Juja","KE",-1.10148,37.0132,"Kiambu County","city"],
  [2548880,"Fès al Bali","MA",34.0701,-4.95473,"Fes-Meknes","city"],
  [330118,"Nek’emtē","ET",9.08333,36.55,"Oromiya","city"],
  [2686657,"Örebro","SE",59.27412,15.2066,"Örebro","city"],
  [2112312,"Katsuta","JP",36.38333,140.53333,"Ibaraki","city"],
  [99062,"Al Miqdādīyah","IQ",33.97861,44.93694,"Diyala","city"],
  [2309527,"Malabo","GQ",3.75578,8.78166,"Bioko Norte","city"],
  [1253200,"Vidisha","IN",23.52604,77.81092,"Madhya Pradesh","city"],
  [1563281,"Tuy Hòa","VN",13.09546,109.32094,"Dak Lak","city"],
  [1797632,"Yizhou","CN",24.5,108.66667,"Guangxi","city"],
  [1788669,"Xinqiao","CN",31.065,121.3075,"Shanghai","city"],
  [5400075,"Sunnyvale","US",37.36883,-122.03635,"California","city"],
  [2294700,"Tema","GH",5.6698,-0.01657,"Greater Accra","city"],
  [3403741,"Camaragibe","BR",-8.02167,-34.98111,"Pernambuco","city"],
  [2033413,"Yichun","CN",47.72143,128.87529,"Heilongjiang","city"],
  [1582190,"Đức Phổ","VN",14.81355,108.95931,"Quang Ngai","city"],
  [3518407,"San Martin Texmelucan de Labastida","MX",19.28431,-98.43885,"Puebla","city"],
  [3460845,"Itajaí","BR",-26.90778,-48.66194,"Santa Catarina","city"],
  [250336,"Ar Ramthā","JO",32.55873,36.00816,"Irbid","city"],
  [1270407,"Hanumāngarh","IN",29.58182,74.32938,"Rajasthan","city"],
  [6318546,"São Mateus","BR",-23.60583,-46.47889,"São Paulo","city"],
  [783920,"Zemun","RS",44.8458,20.40116,"Central Serbia","city"],
  [3345439,"Telford","GB",52.67659,-2.44926,"England","city"],
  [2334327,"Kisi","NG",9.08297,3.85196,"Oyo State","city"],
  [3461408,"Ilhéus","BR",-14.79909,-39.03228,"Bahia","city"],
  [3587923,"Villa Canales","GT",14.48285,-90.53425,"Guatemala","city"],
  [1712051,"Guyong","PH",14.8361,120.97844,"Central Luzon","city"],
  [2537406,"Settat","MA",33.00103,-7.61662,"Casablanca-Settat","city"],
  [1176241,"Jampur","PK",29.64235,70.59518,"Punjab","city"],
  [1859675,"Kawanishi","JP",34.81667,135.41667,"Hyōgo","city"],
  [1254657,"Thānesar","IN",29.97323,76.83214,"Haryana","city"],
  [361179,"Al Ḩawāmidīyah","EG",29.9,31.25,"Giza","city"],
  [1270239,"Hassan","IN",13.00715,76.0962,"Karnataka","city"],
  [1919014,"Lianghu","CN",29.99152,120.89845,"Zhejiang","city"],
  [3108118,"Tetuán de las Victorias","ES",40.45975,-3.6975,"Madrid","city"],
  [1266486,"Kishangarh","IN",26.59006,74.85397,"Rajasthan","city"],
  [6254843,"Birendranagar","NP",28.59669,81.61658,"Karnali Pradesh","city"],
  [10265162,"Dalūpura","IN",28.6057,77.31901,"Delhi","city"],
  [1809879,"Guangshui","CN",31.6199,113.9978,"Hubei","city"],
  [683902,"Brăila","RO",45.27152,27.97429,"Brăila County","city"],
  [532615,"Lyubertsy","RU",55.67719,37.89322,"Moscow Oblast","city"],
  [217745,"Bumba","CD",2.18771,22.46827,"Mongala","city"],
  [8740322,"Rudrapur","IN",28.98,79.4,"Uttarakhand","city"],
  [3884373,"La Serena","CL",-29.90591,-71.25014,"Coquimbo Region","city"],
  [717582,"Miskolc","HU",48.10327,20.77806,"Borsod-Abaúj-Zemplén","city"],
  [362485,"Abū Kabīr","EG",30.72508,31.67148,"Sharqia","city"],
  [1808872,"Fu’an","CN",27.09131,119.64446,"Fujian","city"],
  [7931934,"Kitengela","KE",-1.47612,36.96144,"Kajiado County","city"],
  [4692559,"Frisco","US",33.15067,-96.82361,"Texas","city"],
  [2033168,"Zhaodong","CN",46.05223,125.9552,"Heilongjiang","city"],
  [1529085,"Wujiaqu","CN",44.16279,87.52174,"Xinjiang","city"],
  [2323090,"Shomolu","NG",6.53891,3.3742,"Lagos","city"],
  [2216349,"Janzūr","LY",32.81868,13.01727,"Al Jafarah","city"],
  [1024552,"Xai-Xai","MZ",-25.05194,33.64417,"Gaza Province","city"],
  [4951788,"Springfield","US",42.10148,-72.58981,"Massachusetts","city"],
  [1262067,"Nalgonda","IN",17.05439,79.26707,"Telangana","city"],
  [231954,"Katabi","UG",0.08411,32.46972,"Central Region","city"],
  [1884178,"Gwangyang","KR",34.9414,127.69569,"Jeollanam-do","city"],
  [543460,"Kovrov","RU",56.35752,41.31893,"Vladimir Oblast","city"],
  [298033,"Viranşehir","TR",37.22349,39.75519,"Şanlıurfa","city"],
  [1855078,"Noda","JP",35.94897,139.86793,"Chiba","city"],
  [3449948,"Santana de Parnaíba","BR",-23.44417,-46.91778,"São Paulo","city"],
  [3511540,"San Cristóbal","DO",18.41713,-70.10682,"San Cristóbal","city"],
  [4619947,"East Chattanooga","US",35.06535,-85.24912,"Tennessee","city"],
  [146384,"Limassol","CY",34.68406,33.03794,"Limassol","city"],
  [1860034,"Kariya","JP",34.98333,136.98333,"Aichi","city"],
  [4717782,"Pasadena","US",29.69106,-95.2091,"Texas","city"],
  [352181,"Mīt Ghamr","EG",30.71524,31.2592,"Dakahlia","city"],
  [1789273,"Sanshui","CN",23.15486,112.89161,"Guangdong","city"],
  [4431410,"Jackson","US",32.29876,-90.18481,"Mississippi","city"],
  [3454982,"Parelheiros","BR",-23.8275,-46.72694,"São Paulo","city"],
  [3457000,"Mogi Guaçu","BR",-22.3677,-46.94552,"São Paulo","city"],
  [2756071,"Enschede","NL",52.21833,6.89583,"Overijssel","city"],
  [1816265,"Boshan","CN",36.48333,117.83333,"Shandong","city"],
  [1270164,"Hazāribāgh","IN",23.99241,85.36162,"Jharkhand","city"],
  [1814786,"Yangchun","CN",22.16667,111.78333,"Guangdong","city"],
  [2479215,"Souk Ahras","DZ",36.28639,7.95111,"Souk Ahras","city"],
  [201521,"Musanze","RW",-1.49984,29.63497,"Northern Province","city"],
  [1263220,"Medinīpur","IN",22.42114,87.32257,"West Bengal","city"],
  [1846986,"Andong","KR",36.56636,128.72275,"Gyeongsangbuk-do","city"],
  [1277508,"Bālurghāt","IN",25.22099,88.77732,"West Bengal","city"],
  [5384170,"Pomona","US",34.05529,-117.75228,"California","city"],
  [3625515,"Valle de La Pascua","VE",9.21554,-66.00734,"Guárico","city"],
  [2884161,"Kreuzberg","DE",52.49973,13.40338,"State of Berlin","city"],
  [3943789,"Chincha Alta","PE",-13.40985,-76.13235,"Ica","city"],
  [2172797,"Cairns","AU",-16.92366,145.76613,"Queensland","city"],
  [1271976,"Fyzābād","IN",26.77549,82.15018,"Uttar Pradesh","city"],
  [1590900,"Thị Trấn Thuận Châu","VN",21.43849,103.69,"Sơn La Province","city"],
  [1273581,"Dinapore","IN",25.63705,85.04794,"Bihar","city"],
  [1812728,"Dingzhou","CN",38.51473,114.9868,"Hebei","city"],
  [4273837,"Kansas City","US",39.11417,-94.62746,"Kansas","city"],
  [98530,"As Samawah","IQ",31.33198,45.2944,"Muthanna","city"],
  [1259395,"Porbandar","IN",21.64219,69.60929,"Gujarat","city"],
  [2040959,"Sinp’o","KP",40.03971,128.1943,"South Hamgyong","city"],
  [1798919,"Pengpu","CN",31.2855,121.4367,"Shanghai","city"],
  [1162456,"Wazirabad","PK",32.44324,74.12,"Punjab","city"],
  [5143307,"Washington Heights","US",40.8501,-73.93541,"New York","city"],
  [5427946,"Lakewood","US",39.70471,-105.08137,"Colorado","city"],
  [97990,"Baqubah","IQ",33.75403,44.60518,"Diyala","city"],
  [10303650,"Simele","IQ",36.85833,42.8501,"Duhok","city"],
  [90532,"Sumayl","IQ",36.85823,42.8482,"Duhok","city"],
  [2864118,"Neuss","DE",51.19807,6.68504,"North Rhine-Westphalia","city"],
  [1815302,"Chenghua","CN",23.46132,116.77007,"Guangdong","city"],
  [1869446,"Songnim-ni","KP",38.76349,125.64096,"North Hwanghae","city"],
  [1277397,"Bānda","IN",25.47758,80.33491,"Uttar Pradesh","city"],
  [3452525,"Pouso Alegre","BR",-22.23,-45.93639,"Minas Gerais","city"],
  [1586296,"Cần Giuộc","VN",10.60857,106.67135,"Tay Ninh","city"],
  [6693228,"Balvanera","AR",-34.61032,-58.39766,"Buenos Aires F.D.","city"],
  [2035980,"Longfeng","CN",46.53168,125.1038,"Heilongjiang","city"],
  [2037201,"Beining","CN",41.59556,121.79278,"Liaoning","city"],
  [487150,"Strogino","RU",55.81838,37.41224,"Moscow","city"],
  [132938,"Gonbad-e Kāvūs","IR",37.25004,55.16721,"Golestan","city"],
  [11204106,"Etwatwa","ZA",-26.12516,28.45472,"Gauteng","city"],
  [7279570,"Higashimurayama","JP",35.75459,139.46852,"Tokyo","city"],
  [1270079,"Hindupur","IN",13.82807,77.49143,"Andhra Pradesh","city"],
  [3137115,"Stavanger","NO",58.97005,5.73332,"Rogaland","city"],
  [3471697,"Araucária","BR",-25.59306,-49.41028,"Paraná","city"],
  [1737486,"Bintulu","MY",3.16667,113.03333,"Sarawak","city"],
  [2640101,"Poole","GB",50.71429,-1.98458,"England","city"],
  [361661,"Akhmīm","EG",26.5622,31.74566,"Sohag","city"],
  [1173491,"Kohat","PK",33.58196,71.44929,"Khyber Pakhtunkhwa","city"],
  [2849483,"Regensburg","DE",49.01513,12.10161,"Bavaria","city"],
  [1172035,"Layyah","PK",30.96128,70.93904,"Punjab","city"],
  [355026,"Girga","EG",26.33721,31.89295,"Sohag","city"],
  [2299522,"Koforidua","GH",6.09408,-0.25913,"Eastern","city"],
  [1880750,"Bukit Merah Estate","SG",1.28417,103.82306,"","city"],
  [3118150,"Logroño","ES",42.46615,-2.45115,"La Rioja","city"],
  [1276634,"Beāwar","IN",26.10119,74.32028,"Rajasthan","city"],
  [693821,"Sykhiv","UA",49.79427,24.06284,"Lviv","city"],
  [1164970,"Shujaabad","PK",29.88092,71.29344,"Punjab","city"],
  [3399058,"Garanhuns","BR",-8.88202,-36.50216,"Pernambuco","city"],
  [5346827,"Escondido","US",33.11921,-117.08642,"California","city"],
  [13286467,"Ṣuwayliḥ","JO",32.0221,35.84394,"Balqa","city"],
  [315373,"Erzincan","TR",39.73919,39.49015,"Erzincan","city"],
  [307515,"Kırşehir","TR",39.14583,34.16389,"Kırşehir","city"],
  [13607718,"Zarichnyi","UA",50.90376,34.80933,"Sumy","city"],
  [2511401,"La Laguna","ES",28.4853,-16.32014,"Canary Islands","city"],
  [1522203,"Kokshetau","KZ",53.28414,69.39364,"Aqmola","city"],
  [1179406,"Eminabad","PK",32.04237,74.25996,"Punjab","city"],
  [1278667,"Anantnag","IN",33.73068,75.15418,"Jammu and Kashmir","city"],
  [1858445,"Kukichūō","JP",36.06739,139.67498,"Saitama","city"],
  [2521420,"Badajoz","ES",38.87789,-6.97061,"Extremadura","city"],
  [7302856,"Serilingampalle","IN",17.49313,78.30196,"Telangana","city"],
  [7670934,"Malatia-Sebastia","AM",40.17396,44.4457,"Yerevan","city"],
  [3870282,"Talcahuano","CL",-36.72494,-73.11684,"Biobio","city"],
  [3895088,"Chillán","CL",-36.60664,-72.10344,"Ñuble","city"],
  [1176106,"Jaranwala","PK",31.3332,73.41868,"Punjab","city"],
  [1578163,"Kỳ Anh","VN",18.06243,106.29832,"Hà Tĩnh Province","city"],
  [1608236,"Nong Khaem","TH",13.70594,100.34918,"Bangkok","city"],
  [3992619,"Piedras Negras","MX",28.70007,-100.52353,"Coahuila","city"],
  [307084,"Kızıltepe","TR",37.18836,40.57723,"Mardin","city"],
  [5107464,"Astoria","US",40.77205,-73.93014,"New York","city"],
  [1856367,"Musashino","JP",35.70611,139.55944,"Tokyo","city"],
  [579464,"Balashikha","RU",55.79479,37.94794,"Moscow Oblast","city"],
  [1259005,"Raigarh","IN",21.89764,83.3966,"Chhattisgarh","city"],
  [5962204,"Gloucester","CA",45.35,-75.63333,"Ontario","city"],
  [942470,"Vryheid","ZA",-27.76952,30.79165,"KwaZulu-Natal","city"],
  [1163198,"Tordher","PK",33.99047,72.2863,"Khyber Pakhtunkhwa","city"],
  [13118091,"Setia Alam","MY",3.10155,101.45565,"Selangor","city"],
  [13118229,"Bandar Tasik Puteri","MY",3.28531,101.4741,"Selangor","city"],
  [1842944,"Gimcheon","KR",36.12176,128.11981,"Gyeongsangbuk-do","city"],
  [462745,"Zhulebino","RU",55.7,37.85,"Moscow","city"],
  [7302828,"Malkajgiri","IN",17.44781,78.52633,"Telangana","city"],
  [7473418,"Bercham","MY",4.6411,101.1393,"Perak","city"],
  [1256639,"Shāntipur","IN",23.24723,88.43302,"West Bengal","city"],
  [1181073,"Chishtian","PK",29.79713,72.85772,"Punjab","city"],
  [3521342,"Playa del Carmen","MX",20.6274,-87.07987,"Quintana Roo","city"],
  [3389321,"Santa Rita","BR",-7.11389,-34.97806,"Paraíba","city"],
  [3190261,"Split","HR",43.50891,16.43915,"Split-Dalmatia","city"],
  [6545326,"Ursynów","PL",52.15051,21.05041,"Mazovia","city"],
  [4158928,"Hollywood","US",26.0112,-80.14949,"Florida","city"],
  [6544494,"Madrid Centro","ES",40.41831,-3.70275,"Madrid","city"],
  [11962378,"Iguatemi","BR",-23.61277,-46.42667,"São Paulo","city"],
  [1177073,"Harunabad","PK",29.61206,73.13802,"Punjab","city"],
  [11612583,"Shūnan","JP",34.08053,131.82564,"Yamaguchi","city"],
  [2448085,"Agadez","NE",16.97333,7.99111,"Agadez","city"],
  [2654264,"Burnley","GB",53.8,-2.23333,"England","city"],
  [293725,"Reẖovot","IL",31.89421,34.81199,"Central District","city"],
  [1621884,"Watampone","ID",-4.5386,120.3279,"South Sulawesi","city"],
  [2212775,"Sabha","LY",27.03766,14.42832,"Sabha District","city"],
  [358108,"Disūq","EG",31.13259,30.64784,"Kafr el-Sheikh","city"],
  [2525473,"Cagliari","IT",39.23054,9.11917,"Sardinia","city"],
  [5109790,"Borough Park","US",40.63399,-73.99681,"New York","city"],
  [2647425,"Harrow","GB",51.57835,-0.33208,"England","city"],
  [2556272,"Berrechid","MA",33.26553,-7.58754,"Casablanca-Settat","city"],
  [3452073,"Queimados","BR",-22.71611,-43.55528,"Rio de Janeiro","city"],
  [2244991,"Tambacounda","SN",13.77073,-13.66734,"Tambacounda","city"],
  [2646458,"Huddersfield","GB",53.64904,-1.78416,"England","city"],
  [343749,"Ārabī","ET",9.96278,42.49278,"Somali","city"],
  [706524,"Kerch","UA",45.35675,36.47542,"Crimea","city"],
  [6137270,"Saguenay","CA",48.41675,-71.06573,"Quebec","city"],
  [2852217,"Prenzlauer Berg","DE",52.53878,13.42443,"State of Berlin","city"],
  [6317123,"Fazenda Rio Grande","BR",-25.6575,-49.30806,"Paraná","city"],
  [1858926,"Komaki","JP",35.28333,136.91667,"Aichi","city"],
  [124721,"Marvdasht","IR",29.87407,52.80258,"Fars","city"],
  [701404,"Melitopol","UA",46.84735,35.38196,"Zaporizhzhia","city"],
  [2037534,"Dunhua","CN",43.36954,128.22861,"Jilin","city"],
  [1275812,"Bhuj","IN",23.25397,69.66928,"Gujarat","city"],
  [6544487,"Arganzuela","ES",40.40021,-3.69618,"Madrid","city"],
  [655194,"Jyväskylä","FI",62.24147,25.72088,"Central Finland","city"],
  [1848277,"Yonago","JP",35.43333,133.33333,"Tottori","city"],
  [52407,"Ruqi","SO",9.97293,43.4276,"Awdal","city"],
  [3169361,"Rimini","IT",44.05755,12.56528,"Emilia-Romagna","city"],
  [5927690,"Coquitlam","CA",49.2846,-122.78217,"British Columbia","city"],
  [108512,"Arar","SA",30.97531,41.03808,"Northern Borders Region","city"],
  [5405288,"Valencia","US",34.44361,-118.60953,"California","city"],
  [7778796,"Moreno","AR",-34.63401,-58.79138,"Buenos Aires","city"],
  [6822129,"Tama","JP",35.6436,139.46844,"Tokyo","city"],
  [4907959,"Rockford","US",42.27113,-89.094,"Illinois","city"],
  [2455914,"Kalaban Koro","ML",12.57329,-8.02907,"Koulikoro","city"],
  [3642833,"El Limón","VE",10.30589,-67.63212,"Aragua","city"],
  [2990363,"Nîmes","FR",43.83665,4.35788,"Occitanie","city"],
  [2650752,"Dundee","GB",56.46913,-2.97489,"Scotland","city"],
  [1277100,"Bārākpur","IN",22.76602,88.36336,"West Bengal","city"],
  [11962430,"Sao Rafael","BR",-23.62821,-46.45395,"São Paulo","city"],
  [3469136,"Botucatu","BR",-22.88583,-48.445,"São Paulo","city"],
  [2034638,"Sujiatun","CN",41.65917,123.33917,"Liaoning","city"],
  [1651112,"Astanajapura","ID",-6.8017,108.6311,"West Java","city"],
  [4013720,"Ciudad Delicias","MX",28.19013,-105.47012,"Chihuahua","city"],
  [2415703,"Siguiri","GN",11.42282,-9.16852,"Kankan Region","city"],
  [2239520,"Mbanza Kongo","AO",-6.26667,14.23833,"Zaire","city"],
  [4756955,"East Hampton","US",37.03737,-76.33161,"Virginia","city"],
  [2036876,"Honggang","CN",46.3974,124.88447,"Heilongjiang","city"],
  [6544102,"Sarrià-Sant Gervasi","ES",41.40104,2.1394,"Catalonia","city"],
  [192710,"Kiambu","KE",-1.17139,36.83556,"Kiambu County","city"],
  [3024635,"Clermont-Ferrand","FR",45.77969,3.08682,"Rhône-Alpes","city"],
  [4898015,"Joliet","US",41.52519,-88.0834,"Illinois","city"],
  [5894171,"Barrie","CA",44.40011,-79.66634,"Ontario","city"],
  [1619532,"Bang Kapi","TH",13.7653,100.647,"Bangkok","city"],
  [4221552,"Savannah","US",32.08354,-81.09983,"Georgia","city"],
  [5102466,"Paterson","US",40.91677,-74.17181,"New Jersey","city"],
  [6544491,"Salamanca","ES",40.42972,-3.67975,"Madrid","city"],
  [546230,"Kolomna","RU",55.07108,38.78399,"Moscow Oblast","city"],
  [1270525,"Hājīpur","IN",25.68544,85.20981,"Bihar","city"],
  [118994,"Rafsanjān","IR",30.4067,55.9939,"Kerman","city"],
  [9081327,"Hòa Thành","VN",11.28696,106.12936,"Tay Ninh","city"],
  [3173529,"Mestre","IT",45.49167,12.24538,"Veneto","city"],
  [285704,"As Sālimīyah","KW",29.33389,48.07611,"Hawalli","city"],
  [5282804,"Bridgeport","US",41.17923,-73.18945,"Connecticut","city"],
  [13561779,"Shevchenko","UA",49.5645,34.53873,"Poltava","city"],
  [539110,"Kuntsevo","RU",55.74216,37.40225,"Moscow","city"],
  [789128,"Kragujevac","RS",44.01667,20.91667,"Central Serbia","city"],
  [610612,"Aktau","KZ",43.66105,51.17392,"Mangystau","city"],
  [3567924,"Balcón de la Lisa","CU",23.05346,-82.4476,"Havana","city"],
  [1257086,"Sasarām","IN",24.94942,84.01645,"Bihar","city"],
  [711874,"Bohuniya","UA",50.27691,28.60962,"Zhytomyr Oblast","city"],
  [3456290,"Nilópolis","BR",-22.8075,-43.41389,"Rio de Janeiro","city"],
  [6822163,"Iruma","JP",35.818,139.368,"Saitama","city"],
  [3873454,"Renca","CL",-33.4019,-70.70619,"Santiago Metropolitan","city"],
  [704508,"Kramatorsk","UA",48.73106,37.56779,"Donetsk","city"],
  [4903279,"Naperville","US",41.78586,-88.14729,"Illinois","city"],
  [4013516,"Colima","MX",19.24473,-103.7127,"Colima","city"],
  [1275947,"Bhimavaram","IN",16.54078,81.52322,"Andhra Pradesh","city"],
  [258576,"Lárisa","GR",39.62847,22.42112,"Thessaly","city"],
  [2019528,"Nakhodka","RU",42.8436,132.91831,"Primorye","city"],
  [339734,"Debre Birhan","ET",9.67954,39.53262,"Amhara","city"],
  [2243173,"Cacuaco","AO",-8.7798,13.37478,"Luanda","city"],
  [3038354,"Aix-en-Provence","FR",43.5283,5.44973,"Provence-Alpes-Côte d'Azur","city"],
  [1586350,"Cam Ranh","VN",11.92144,109.15913,"Khanh Hoa","city"],
  [1176368,"Jalalpur Jattan","PK",32.64118,74.20561,"Punjab","city"],
  [3547398,"Matanzas","CU",23.04388,-81.58284,"Matanzas Province","city"],
  [1275539,"Beed","IN",18.98921,75.75634,"Maharashtra","city"],
  [446208,"Khasnahzān","IQ",36.2009,44.14235,"Erbil","city"],
  [1793092,"Taozhou","CN",30.90641,119.40865,"Anhui","city"],
  [8533870,"Saint-Quentin-en-Yvelines","FR",48.77186,2.01891,"Île-de-France","city"],
  [13118145,"Bandar Bukit Raja","MY",3.08737,101.43339,"Selangor","city"],
  [2655524,"Blackburn","GB",53.75,-2.48333,"England","city"],
  [13546323,"Rosemont–La Petite-Patrie","CA",45.53661,-73.60686,"Quebec","city"],
  [3894242,"Colina","CL",-33.20443,-70.67474,"Santiago Metropolitan","city"],
  [10261509,"Burāri","IN",28.7557,77.19941,"Delhi","city"],
  [3086800,"Ruda Śląska","PL",50.2584,18.85632,"Silesia","city"],
  [2377457,"Nouadhibou","MR",20.94188,-17.03842,"Dakhlet Nouadhibou","city"],
  [3493175,"Puerto Plata","DO",19.79344,-70.6884,"Puerto Plata","city"],
  [1680197,"Urdaneta","PH",15.97611,120.57111,"Ilocos","city"],
  [6544492,"Chamberí","ES",40.43404,-3.70379,"Madrid","city"],
  [1265859,"Krishnanagar","IN",23.40576,88.49073,"West Bengal","city"],
  [1788816,"Xinji","CN",37.92595,115.21907,"Hebei","city"],
  [3595069,"Jutiapa","GT",14.28491,-89.88798,"Jutiapa","city"],
  [3395503,"Marabá","BR",-5.38146,-49.13232,"Pará","city"],
  [1274056,"Chitradurga","IN",14.22262,76.40038,"Karnataka","city"],
  [7026776,"Bueng Kum","TH",13.78528,100.66958,"Bangkok","city"],
  [2653941,"Cambridge","GB",52.2,0.11667,"England","city"],
  [6317837,"Paço do Lumiar","BR",-2.53222,-44.1075,"Maranhão","city"],
  [1732721,"Kampung Pasir Gudang Baru","MY",1.4726,103.878,"Johor","city"],
  [1764027,"Kampung Sungai Glugur","MY",5.36966,100.31353,"Penang","city"],
  [1272648,"Dibrugarh","IN",27.47989,94.90837,"Assam","city"],
  [2488835,"Médéa","DZ",36.26417,2.75393,"Medea","city"],
  [1793700,"Taishan","CN",22.25135,112.7799,"Guangdong","city"],
  [2498392,"El Eulma","DZ",36.15281,5.69016,"Sétif","city"],
  [3046526,"Pécs","HU",46.07617,18.22814,"Baranya","city"],
  [1581755,"Giá Rai","VN",9.23444,105.45833,"Ca Mau","city"],
  [1279403,"Abohar","IN",30.14453,74.19552,"Punjab","city"],
  [1254327,"Tiruvannamalai","IN",12.22662,79.07461,"Tamil Nadu","city"],
  [6318755,"Teixeira de Freitas","BR",-17.535,-39.74194,"Bahia","city"],
  [4156404,"Gainesville","US",29.65163,-82.32483,"Florida","city"],
  [3435261,"Concordia","AR",-31.39195,-58.01706,"Entre Rios","city"],
  [1864132,"Fujieda","JP",34.86667,138.26667,"Shizuoka","city"],
  [3488465,"Spanish Town","JM",17.99107,-76.95742,"Saint Catherine Parish","city"],
  [2655459,"Blackpool","GB",53.81667,-3.05,"England","city"],
  [1512473,"Urganch","UZ",41.55177,60.63143,"Xorazm Region","city"],
  [160961,"Bukoba","TZ",-1.33167,31.81222,"Kagera","city"],
  [1268593,"Kaithal","IN",29.80153,76.39959,"Haryana","city"],
  [10627325,"Ingombota","AO",-8.81806,13.22889,"Luanda","city"],
  [3030300,"Brest","FR",48.39029,-4.48628,"Brittany","city"],
  [2656194,"Basildon","GB",51.56844,0.45782,"England","city"],
  [3462964,"Franco da Rocha","BR",-23.32167,-46.72694,"São Paulo","city"],
  [3111108,"Salamanca","ES",40.96882,-5.66388,"Castille and León","city"],
  [13546324,"Villeray–Saint-Michel–Parc-Extension","CA",45.55869,-73.60535,"Quebec","city"],
  [4710826,"Mesquite","US",32.7668,-96.59916,"Texas","city"],
  [1865005,"Ashikaga","JP",36.33333,139.45,"Tochigi","city"],
  [12217184,"Huyện Lâm Hà","VN",11.81554,108.21444,"Lam Dong","city"],
  [2038679,"Acheng","CN",45.54558,126.95191,"Heilongjiang","city"],
  [5990579,"Kelowna","CA",49.88307,-119.48568,"British Columbia","city"],
  [1162959,"Umarkot","PK",25.36329,69.74184,"Sindh","city"],
  [3618030,"León","NI",12.43527,-86.87862,"León Department","city"],
  [1860735,"Kakamigahara","JP",35.41667,136.86667,"Gifu","city"],
  [3003603,"Le Mans","FR",48.0021,0.20251,"Pays de la Loire","city"],
  [1171965,"Lodhran","PK",29.5339,71.63244,"Punjab","city"],
  [6169141,"Trois-Rivières","CA",46.34515,-72.5477,"Quebec","city"],
  [2037075,"Hailin","CN",44.57149,129.38539,"Heilongjiang","city"],
  [6822099,"Tsuchiura","JP",36.09047,140.21047,"Ibaraki","city"],
  [563523,"Elektrostal’","RU",55.78647,38.45713,"Moscow Oblast","city"],
  [1277599,"Balasore","IN",21.49266,86.93348,"Odisha","city"],
  [1786395,"Yong’an","CN",31.01894,109.45949,"Chongqing","city"],
  [12808658,"Paris 11e Arrondissement","FR",48.85834,2.37952,"Île-de-France","city"],
  [1880574,"Kampong Pasir Ris","SG",1.37833,103.93194,"","city"],
  [2516548,"Huelva","ES",37.26638,-6.94004,"Andalusia","city"],
  [1513131,"Navoiy","UZ",40.08444,65.37917,"Navoiy Region","city"],
  [5140405,"Syracuse","US",43.04812,-76.14742,"New York","city"],
  [3471335,"Atibaia","BR",-23.11694,-46.55028,"São Paulo","city"],
  [295620,"Ashkelon","IL",31.66926,34.57149,"Southern District","city"],
  [965154,"Pinetown","ZA",-29.82068,30.88674,"KwaZulu-Natal","city"],
  [2294665,"Teshi Old Town","GH",5.58365,-0.10722,"Greater Accra","city"],
  [576279,"Biryulëvo","RU",55.58635,37.67781,"Moscow","city"],
  [6418220,"Orekhovo-Borisovo","RU",55.61252,37.72639,"Moscow","city"],
  [1858067,"Kusatsu","JP",35.01667,135.96667,"Shiga","city"],
  [8417607,"Nanjin","CN",29.98497,106.26529,"Chongqing","city"],
  [5967629,"Guelph","CA",43.54594,-80.25599,"Ontario","city"],
  [8408334,"Qianjiang","CN",29.53284,108.77478,"Chongqing","city"],
  [1185240,"Ramna Maidan","BD",23.73333,90.4,"Dhaka Division","city"],
  [1271107,"Godhra","IN",22.77547,73.61488,"Gujarat","city"],
  [2558470,"Khemisset","MA",33.82404,-6.06627,"Rabat-Salé-Kénitra","city"],
  [749780,"Çanakkale","TR",40.15552,26.41271,"Canakkale","city"],
  [5403022,"Torrance","US",33.83585,-118.34063,"California","city"],
  [1689510,"San Jose","PH",12.35275,121.06761,"Mimaropa","city"],
  [984998,"Ladysmith","ZA",-28.55874,29.77896,"KwaZulu-Natal","city"],
  [6325521,"Lévis","CA",46.80326,-71.17793,"Quebec","city"],
  [11962407,"Cachoeirinha","BR",-23.45442,-46.66209,"São Paulo","city"],
  [2907911,"Heidelberg","DE",49.40768,8.69079,"Baden-Wurttemberg","city"],
  [4006163,"Fresnillo","MX",23.1749,-102.86785,"Zacatecas","city"],
  [2475475,"Touggourt","DZ",33.11083,6.07,"Touggourt","city"],
  [1256523,"Shillong","IN",25.56892,91.88313,"Meghalaya","city"],
  [5316428,"Surprise","US",33.63059,-112.33322,"Arizona","city"],
  [2641181,"Norwich","GB",52.62783,1.29834,"England","city"],
  [1564555,"Tịnh Biên","VN",10.59591,104.93669,"An Giang","city"],
  [1856584,"Moriguchi","JP",34.73333,135.56667,"Osaka","city"],
  [3037854,"Amiens","FR",49.9,2.3,"Hauts-de-France","city"],
  [1586551,"Cai Lậy","VN",10.4,106.11667,"Dong Thap","city"],
  [3458266,"Macaé","BR",-22.38484,-41.78324,"Rio de Janeiro","city"],
  [1258178,"Rewāri","IN",28.199,76.6183,"Haryana","city"],
  [1276759,"Basirhat City","IN",22.66142,88.85477,"West Bengal","city"],
  [517121,"Novyye Kuz’minki","RU",55.7,37.75,"Moscow","city"],
  [537832,"Kuz’minki","RU",55.7,37.8,"Moscow","city"],
  [2624886,"Aalborg","DK",57.048,9.9187,"North Denmark","city"],
  [1707123,"La Trinidad","PH",16.455,120.5875,"Cordillera","city"],
  [2496049,"Ghardaïa","DZ",32.49094,3.67347,"Ghardaia","city"],
  [1623834,"Timika","ID",-4.61407,136.67679,"Central Papua","city"],
  [503550,"Pyatigorsk","RU",44.05,43.05036,"Stavropol Kray","city"],
  [2312888,"Mbanza-Ngungu","CD",-5.25837,14.85838,"Bas-Congo","city"],
  [13546319,"Mercier–Hochelaga-Maisonneuve","CA",45.57194,-73.54626,"Quebec","city"],
  [1894616,"Okinawa","JP",26.33583,127.80139,"Okinawa","city"],
  [2642607,"Middlesbrough","GB",54.57623,-1.23483,"England","city"],
  [1216187,"Shahrisabz","UZ",39.05778,66.83417,"Qashqadaryo","city"],
  [1170013,"Moro","PK",26.66317,68.00016,"Sindh","city"],
  [1878458,"Ch’ŏngdan-ŭp","KP",37.97028,125.9375,"South Hwanghae","city"],
  [3110876,"Sant Andreu","ES",41.43541,2.18982,"Catalonia","city"],
  [3086586,"Rybnik","PL",50.09713,18.54179,"Silesia","city"],
  [2482572,"Saïda","DZ",34.83033,0.15171,"Saida","city"],
  [4333190,"Metairie Terrace","US",29.97854,-90.16396,"Louisiana","city"],
  [3188582,"Tuzla","BA",44.53842,18.66709,"Federation of B&H","city"],
  [13607717,"Kovpakivskyi","UA",50.92508,34.79484,"Sumy","city"],
  [1005646,"eMbalenhle","ZA",-26.53333,29.06667,"Mpumalanga","city"],
  [3446038,"Trindade","BR",-16.64944,-49.48889,"Goiás","city"],
  [1174167,"Khanpur","PK",28.64739,70.65694,"Punjab","city"],
  [4575352,"Columbia","US",34.00071,-81.03481,"South Carolina","city"],
  [1337240,"Nawābganj","BD",24.59025,88.27444,"Rajshahi Division","city"],
  [2545957,"Inezgane","MA",30.35535,-9.53639,"Souss-Massa","city"],
  [3600026,"Puerto Cortez","HN",15.82562,-87.92968,"Cortés Department","city"],
  [5381396,"Pasadena","US",34.14778,-118.14452,"California","city"],
  [2146268,"Toowoomba","AU",-27.56056,151.95386,"Queensland","city"],
  [2855745,"Paderborn","DE",51.71905,8.75439,"North Rhine-Westphalia","city"],
  [6822137,"Misato, Saitama","JP",35.84373,139.88347,"Saitama","city"],
  [1274337,"Chhatarpur","IN",24.9177,79.58871,"Madhya Pradesh","city"],
  [990930,"Kimberley","ZA",-28.73226,24.76232,"Northern Cape","city"],
  [3899887,"Alto Hospicio","CL",-20.26871,-70.1049,"Tarapacá","city"],
  [3564178,"Ciego de Ávila","CU",21.8422,-78.76034,"Ciego de Ávila Province","city"],
  [349717,"Samālūţ","EG",28.31214,30.71007,"Minya","city"],
  [6418146,"Chertanovo Yuzhnoye","RU",55.59072,37.59519,"Moscow","city"],
  [1805844,"Jieshou","CN",33.26338,115.36108,"Anhui","city"],
  [528293,"Maykop","RU",44.60789,40.10242,"Adygeya Republic","city"],
  [1184249,"Attock City","PK",33.76671,72.35977,"Punjab","city"],
  [1214882,"Kisaran","ID",2.9845,99.6158,"North Sumatra","city"],
  [1635111,"Mojokerto","ID",-7.4664,112.4338,"East Java","city"],
  [3682516,"Facatativá","CO",4.81367,-74.35453,"Cundinamarca","city"],
  [1732750,"Masai","MY",1.4907,103.8788,"Johor","city"],
  [3629576,"Punto Fijo","VE",11.69152,-70.19918,"Falcón","city"],
  [1307835,"Myingyan","MM",21.46002,95.3884,"Mandalay Region","city"],
  [41548,"Kamālshahr","IR",35.86187,50.87424,"Alborz Province","city"],
  [1263834,"Mandsaur","IN",24.07184,75.06986,"Madhya Pradesh","city"],
  [463355,"Zheleznodorozhnyy","RU",55.744,38.01684,"Moscow Oblast","city"],
  [1274553,"Chas","IN",23.63556,86.16712,"Jharkhand","city"],
  [130531,"Jahrom","IR",28.5,53.5605,"Fars","city"],
  [2972191,"Tours","FR",47.39484,0.70398,"Centre-Val de Loire","city"],
  [1260777,"Pālanpur","IN",24.17128,72.43827,"Gujarat","city"],
  [2291136,"Bondoukou","CI",8.0402,-2.80003,"Zanzan District","city"],
  [3598655,"Chichicastenango","GT",14.94333,-91.11116,"Quiché","city"],
  [3108288,"Tarragona","ES",41.11905,1.24544,"Catalonia","city"],
  [81302,"Tobruk","LY",32.08963,23.95385,"Al Butnan","city"],
  [1870648,"Sinch’ŏn-ŭp","KP",38.35323,125.48423,"South Hwanghae","city"],
  [5881791,"Abbotsford","CA",49.05798,-122.25257,"British Columbia","city"],
  [3468879,"Brusque","BR",-27.09795,-48.91281,"Santa Catarina","city"],
  [13607966,"Circoiscrizione II","IT",45.05013,7.64052,"Piedmont","city"],
  [2655237,"Bolton","GB",53.58333,-2.43333,"England","city"],
  [1281105,"Yushu","CN",33.00118,97.00893,"Qinghai","city"],
  [670609,"Piteşti","RO",44.85,24.86667,"Arges","city"],
  [1864031,"Fukayachō","JP",36.2,139.28333,"Saitama","city"],
  [3907584,"Potosí","BO",-19.58361,-65.75306,"Potosí Department","city"],
  [6544490,"Usera","ES",40.38866,-3.70035,"Madrid","city"],
  [2998286,"Limoges","FR",45.83362,1.24759,"New Aquitaine","city"],
  [11962398,"Cangaiba","BR",-23.49696,-46.52045,"São Paulo","city"],
  [1907299,"Asaka","JP",35.80472,139.60194,"Saitama","city"],
  [3455070,"Paranaguá","BR",-25.51626,-48.52537,"Paraná","city"],
  [1141269,"Ghazni","AF",33.55391,68.42096,"Ghazni","city"],
  [5379513,"Orange","US",33.78779,-117.85311,"California","city"],
  [755330,"Wola","PL",52.23477,20.96004,"Mazovia","city"],
  [8406214,"Sanhe","CN",29.86864,107.73027,"Chongqing","city"],
  [130802,"Īlām","IR",33.6374,46.4227,"Ilam Province","city"],
  [2037222,"Gongzhuling","CN",43.50075,124.81979,"Jilin","city"],
  [1907301,"Shimotoda","JP",35.815,139.6853,"Saitama","city"],
  [3860443,"Comodoro Rivadavia","AR",-45.86256,-67.494,"Chubut","city"],
  [1764160,"Kampung Sungai Ara","MY",5.32699,100.27348,"Penang","city"],
  [5351247,"Fullerton","US",33.87029,-117.92534,"California","city"],
  [4703223,"Killeen","US",31.11712,-97.7278,"Texas","city"],
  [1497337,"Norilsk","RU",69.3535,88.2027,"Krasnoyarsk Krai","city"],
  [3118514,"Lleida","ES",41.61674,0.62218,"Catalonia","city"],
  [2740637,"Coimbra","PT",40.20686,-8.41996,"Coimbra","city"],
  [877747,"Mtwara","TZ",-10.26667,40.18333,"Mtwara","city"],
  [1170989,"Manjhand","PK",25.90827,68.23683,"Sindh","city"],
  [219057,"Beni","CD",0.49113,29.47306,"North Kivu","city"],
  [339708,"Debre Mark’os","ET",10.35,37.73333,"Amhara","city"],
  [1697497,"Norzagaray","PH",14.9109,121.0493,"Central Luzon","city"],
  [92615,"Qeładizê","IQ",36.18254,45.13017,"Sulaymaniyah","city"],
  [11962432,"Vila Curuca","BR",-23.51,-46.41566,"São Paulo","city"],
  [970566,"Nigel","ZA",-26.43138,28.47713,"Gauteng","city"],
  [11111027,"Shengavit","AM",40.1557,44.4779,"Yerevan","city"],
  [3613974,"Catacamas","HN",14.85114,-85.89412,"Olancho Department","city"],
  [2233410,"Buea","CM",4.15342,9.24231,"South-West","city"],
  [1794371,"Shuizhai","CN",23.92961,115.76499,"Guangdong","city"],
  [582432,"Al’met’yevsk","RU",54.90395,52.31793,"Tatarstan Republic","city"],
  [12808663,"Paris 12e Arrondissement","FR",48.83523,2.43505,"Île-de-France","city"],
  [4709796,"McAllen","US",26.20341,-98.23001,"Texas","city"],
  [1265242,"Lakhīmpur","IN",27.94822,80.77935,"Uttar Pradesh","city"],
  [2112576,"Ishinomaki","JP",38.41667,141.3,"Miyagi","city"],
  [973111,"Mpumalanga","ZA",-29.81292,30.63646,"KwaZulu-Natal","city"],
  [1170486,"Mian Channun","PK",30.44067,72.35679,"Punjab","city"],
  [2744114,"Zaanstad","NL",52.45313,4.81356,"North Holland","city"],
  [1610538,"Kabin Buri","TH",13.95133,101.71739,"Prachin Buri","city"],
  [11468429,"Kuwana","JP",35.05192,136.66958,"Mie","city"],
  [3947019,"Ayacucho","PE",-13.1638,-74.22345,"Ayacucho","city"],
  [2034996,"Shanhaiguan","CN",40.00119,119.75395,"Hebei","city"],
  [286647,"Şaḩam","OM",24.17222,56.88861,"Al Batinah North","city"],
  [3125239,"Chamartín","ES",40.46206,-3.6766,"Madrid","city"],
  [245785,"Abéché","TD",13.82916,20.8324,"Ouadaï","city"],
  [255524,"Peristéri","GR",38.01539,23.69187,"Attica","city"],
  [2759821,"Amersfoort","NL",52.155,5.3875,"Utrecht","city"],
  [2073124,"Darwin","AU",-12.46113,130.84185,"Northern Territory","city"],
  [11695689,"Jeongeup","KR",35.60004,126.91699,"Jeollabuk-do","city"],
  [5786882,"Bellevue","US",47.61038,-122.20068,"Washington","city"],
  [554233,"Korolev","RU",55.91417,37.82556,"Moscow Oblast","city"],
  [1253468,"Valsād","IN",20.61013,72.93428,"Gujarat","city"],
  [150006,"Shinyanga","TZ",-3.66393,33.42118,"Shinyanga","city"],
  [2675408,"Sollentuna","SE",59.42804,17.95093,"Stockholm","city"],
  [1848774,"Yaizu","JP",34.86877,138.31952,"Shizuoka","city"],
  [99344,"Al Hindīyah","IQ",32.54193,44.22469,"Karbala","city"],
  [1631905,"Payakumbuh","ID",-0.2159,100.6334,"West Sumatra","city"],
  [1273587,"Damoh","IN",23.83312,79.4419,"Madhya Pradesh","city"],
  [343370,"Āsela","ET",7.95,39.13333,"Oromiya","city"],
  [1270498,"Haldwani","IN",29.22254,79.5286,"Uttarakhand","city"],
  [2337313,"Irewe","NG",6.41692,3.14058,"Lagos","city"],
  [1649881,"Batang","ID",-6.4846,110.7083,"Central Java","city"],
  [2341355,"Gbongan","NG",7.47734,4.35351,"Osun State","city"],
  [3462672,"Gama","BR",-16.02511,-48.07121,"Federal District","city"],
  [1822214,"Siem Reap","KH",13.36179,103.86056,"Siem Reap","city"],
  [3486270,"Anaco","VE",9.42958,-64.46428,"Anzoátegui","city"],
  [1630333,"Purwodadi","ID",-7.0868,110.9158,"Central Java","city"],
  [1859093,"Koga","JP",36.18333,139.71667,"Ibaraki","city"],
  [1785916,"Yuepu","CN",31.42694,121.42139,"Shanghai","city"],
  [1270568,"Hābra","IN",22.84202,88.65606,"West Bengal","city"],
  [1627253,"Sidoarjo","ID",-7.4478,112.7183,"East Java","city"],
  [13561145,"Kyivskyi","UA",48.04646,37.77571,"Donetsk","city"],
  [412800,"Şabāḩ as Sālim","KW",29.25722,48.05722,"Mubārak al Kabīr","city"],
  [3471039,"Balneário Camboriú","BR",-26.99056,-48.63472,"Santa Catarina","city"],
  [8393989,"Plaza de la Revolución","CU",23.11936,-82.39197,"Havana","city"],
  [2659994,"Lausanne","CH",46.516,6.63282,"Vaud","city"],
  [3613533,"Choloma","HN",15.61444,-87.95302,"Cortés Department","city"],
  [2473449,"Kairouan","TN",35.6781,10.09633,"Kairouan","city"],
  [2636882,"Stockport","GB",53.40979,-2.15761,"England","city"],
  [7284824,"Budapest XI. kerület","HU",47.47603,19.03605,"Budapest","city"],
  [2036776,"Huadian","CN",42.97213,126.74107,"Jilin","city"],
  [2229798,"Kousséri","CM",12.07689,15.03063,"Far North","city"],
  [1621613,"Weru","ID",-6.711,108.5037,"West Java","city"],
  [12451089,"Al-'Ubūr","EG",30.22886,31.48149,"Qalyubia","city"],
  [546105,"Kolpino","RU",59.75069,30.58856,"St.-Petersburg","city"],
  [3436077,"Belgrano","AR",-34.5627,-58.45829,"Buenos Aires F.D.","city"],
  [2425791,"Sarh","TD",9.14555,18.38331,"Moyen-Chari","city"],
  [1712875,"Gingoog","PH",8.82778,125.09972,"Northern Mindanao","city"],
  [3518692,"San Juan del Río","MX",20.38897,-99.99637,"Querétaro","city"],
  [2295458,"Sekondi-Takoradi","GH",4.92678,-1.75773,"Western","city"],
  [10020191,"Liuzhi","CN",26.2342,105.426,"Guizhou","city"],
  [1698839,"Naga","PH",10.20898,123.758,"Central Visayas","city"],
  [2037335,"Fuyu","CN",45.18333,124.81667,"Jilin","city"],
  [6180170,"Whitby","CA",43.88342,-78.93287,"Ontario","city"],
  [4333177,"Metairie","US",29.98409,-90.15285,"Louisiana","city"],
  [1815427,"Chaohu","CN",31.6,117.86667,"Anhui","city"],
  [1266305,"Kolār","IN",13.13768,78.12999,"Karnataka","city"],
  [2472706,"Bizerte","TN",37.27442,9.87391,"Bizerte Governorate","city"],
  [3626402,"Táriba","VE",7.82117,-72.22329,"Táchira","city"],
  [2343784,"Ejigbo","NG",7.90303,4.31364,"Osun State","city"],
  [2544001,"Ksar El Kebir","MA",35.00044,-5.90378,"Tanger-Tetouan-Al Hoceima","city"],
  [2986082,"Paris 11 Popincourt","FR",48.8574,2.3795,"Île-de-France","city"],
  [2290582,"Dabou","CI",5.32556,-4.37685,"Lagunes District","city"],
  [1884367,"Bukit Panjang New Town","SG",1.37972,103.76472,"","city"],
  [11962379,"Sao Lucas","BR",-23.59468,-46.54359,"São Paulo","city"],
  [2983854,"Paris 12 Reuilly","FR",48.8412,2.3876,"Île-de-France","city"],
  [3393001,"Parnaíba","BR",-2.90472,-41.77667,"Piauí","city"],
  [2234359,"Bertoua","CM",4.57728,13.68459,"East","city"],
  [3723779,"Jacmel","HT",18.23569,-72.53686,"Sud-Est","city"],
  [1255647,"Srikakulam","IN",18.2989,83.89751,"Andhra Pradesh","city"],
  [1719274,"Candelaria","PH",13.93111,121.42333,"Calabarzon","city"],
  [1562693,"Vĩnh Long","VN",10.25369,105.9722,"Vinh Long","city"],
  [3471715,"Araruama","BR",-22.87278,-42.34306,"Rio de Janeiro","city"],
  [12489673,"Liangping","CN",30.66108,107.7661,"Chongqing","city"],
  [353492,"Kirdāsah","EG",30.03103,31.11109,"Giza","city"],
  [3460535,"Itu","BR",-23.26417,-47.29917,"São Paulo","city"],
  [4566880,"Ponce","PR",18.01031,-66.62398,"Ponce","city"],
  [6559683,"Doilungdêqên","CN",29.65505,90.99177,"Tibet","city"],
  [1805857,"Jieshi","CN",22.81027,115.83058,"Guangdong","city"],
  [1808612,"Hejiang","CN",28.81161,105.83359,"Sichuan","city"],
  [1735545,"Pasir Puteh","MY",5.83333,102.4,"Kelantan","city"],
  [1263814,"Mandya","IN",12.5223,76.89746,"Karnataka","city"],
  [7845495,"Xiayang","CN",31.14967,121.11588,"Shanghai","city"],
  [866153,"Nor Nork","AM",40.19661,44.5669,"Yerevan","city"],
  [1019330,"Bhisho","ZA",-32.84721,27.44218,"Eastern Cape","city"],
  [2421820,"Dixinn","GN",9.55111,-13.67306,"Conakry","city"],
  [3456225,"Freguesia do Ó","BR",-23.49877,-46.69983,"São Paulo","city"],
  [1626444,"Subang","ID",-6.57,107.75667,"West Java","city"],
  [10834495,"Madhurampur Dehri","IN",24.96899,84.1964,"Bihar","city"],
  [1233369,"Negombo","LK",7.2083,79.8358,"Western Province","city"],
  [261745,"Irákleion","GR",35.32787,25.14341,"Crete","city"],
  [4762894,"Hampton","US",37.02987,-76.34522,"Virginia","city"],
  [1922014,"Wuyishan","CN",27.75995,118.03066,"Fujian","city"],
  [4164601,"Miramar","US",25.98731,-80.23227,"Florida","city"],
  [7303248,"Jiashan","CN",30.84918,120.92583,"Zhejiang","city"],
  [358821,"Bilqās","EG",31.21452,31.35798,"Dakahlia","city"],
  [1630058,"Rangkasbitung","ID",-6.3591,106.2494,"Banten","city"],
  [516215,"Odintsovo","RU",55.66977,37.27716,"Moscow Oblast","city"],
  [3176885,"Foggia","IT",41.45845,15.55188,"Apulia","city"],
  [1069129,"Antsiranana","MG",-12.31732,49.29188,"Diana","city"],
  [1268715,"Kānchrāpāra","IN",22.95998,88.42849,"West Bengal","city"],
  [3589885,"San Juan Sacatepéquez","GT",14.71889,-90.64417,"Guatemala","city"],
  [1857046,"Minoh","JP",34.82691,135.47057,"Osaka","city"],
  [2342490,"Funtua","NG",11.52351,7.31174,"Katsina State","city"],
  [6155721,"St. Catharines","CA",43.17126,-79.24267,"Ontario","city"],
  [1293625,"Dawei","MM",14.0823,98.19151,"Tanintharyi Region","city"],
  [2338711,"Igboho","NG",8.83784,3.75628,"Oyo State","city"],
  [1215102,"Gunungsitoli","ID",1.2888,97.6143,"North Sumatra","city"],
  [2759706,"Apeldoorn","NL",52.21,5.96944,"Gelderland","city"],
  [11962385,"Cidade Lider","BR",-23.56202,-46.4913,"São Paulo","city"],
  [124778,"Marīvān","IR",35.51829,46.18298,"Kurdistan Province","city"],
  [1570449,"Phủ Lý","VN",20.54531,105.91221,"Ninh Binh","city"],
  [2289887,"Divo","CI",5.83739,-5.35723,"Goh-Djiboua","city"],
  [1794806,"Huinong","CN",39.23333,106.76944,"Ningxia","city"],
  [6822128,"Ebina","JP",35.38121,139.39651,"Kanagawa","city"],
  [2543549,"Larache","MA",35.19321,-6.15572,"Tanger-Tetouan-Al Hoceima","city"],
  [3445487,"Varginha","BR",-21.55139,-45.43028,"Minas Gerais","city"],
  [2989781,"Paris 14 Observatoire","FR",48.8331,2.3264,"Île-de-France","city"],
  [5405693,"Van Nuys","US",34.18667,-118.44897,"California","city"],
  [358600,"Būsh","EG",29.14816,31.12733,"Beni Suweif","city"],
  [9166066,"Mlolongo","KE",-1.39639,36.94028,"Machakos County","city"],
  [3467736,"Campo Largo","BR",-25.45955,-49.53014,"Paraná","city"],
  [3986172,"San José del Cabo","MX",23.05406,-109.70367,"Baja California Sur","city"],
  [3468403,"Cachoeirinha","BR",-29.95111,-51.09389,"Rio Grande do Sul","city"],
  [5784607,"West Valley City","US",40.69161,-112.00105,"Utah","city"],
  [1859393,"Kisarazu","JP",35.38329,139.93254,"Chiba","city"],
  [1810240,"Gejiu","CN",23.36085,103.15372,"Yunnan","city"],
  [685948,"Bacău","RO",46.56718,26.91384,"Bacău County","city"],
  [2356157,"Saaba","BF",12.37136,-1.41468,"Centre","city"],
  [1309233,"Mingaladon","MM",16.92406,96.09768,"Yangon","city"],
  [1272552,"Dimāpur","IN",25.91174,93.7217,"Nagaland","city"],
  [957487,"Sasolburg","ZA",-26.81358,27.81695,"Free State","city"],
  [1777077,"Cheras","MY",3.108,101.726,"Selangor","city"],
  [1735093,"Tasek Glugor","MY",5.48032,100.49849,"Penang","city"],
  [3877949,"Osorno","CL",-40.57395,-73.13348,"Los Lagos Region","city"],
  [2036597,"Jiagedaqi","CN",50.41667,124.11667,"Inner Mongolia","city"],
  [12022102,"Tumxuk","CN",39.86984,79.06118,"Xinjiang","city"],
  [1185191,"Kushtia","BD",23.9028,89.11943,"Khulna Division","city"],
  [3672110,"Pitalito","CO",1.85371,-76.05071,"Huila Department","city"],
  [1727995,"Baliuag","PH",14.95472,120.89694,"Central Luzon","city"],
  [8616124,"Hoàn Kiếm","VN",21.02857,105.85064,"Hanoi","city"],
  [232713,"Kajansi","UG",0.21548,32.53453,"Central Region","city"],
  [1861464,"Isahaya","JP",32.84111,130.04306,"Nagasaki","city"],
  [4509884,"Dayton","US",39.75895,-84.19161,"Ohio","city"],
  [1586357,"Cẩm Phả Mines","VN",21.01667,107.3,"Quảng Ninh","city"],
  [3591415,"Petapa","GT",14.50189,-90.56196,"Guatemala","city"],
  [1264111,"Māler Kotla","IN",30.5309,75.87949,"Punjab","city"],
  [2346615,"Buguma","NG",4.73614,6.86236,"Rivers State","city"],
  [5882725,"Ahuntsic-Cartierville","CA",45.56667,-73.66667,"Quebec","city"],
  [3471758,"Araras","BR",-22.35694,-47.38417,"São Paulo","city"],
  [1299154,"Pyay","MM",18.81996,95.21562,"Bago Region","city"],
  [1795055,"Shiqiao","CN",22.9464,113.35769,"Guangdong","city"],
  [368277,"Rabak","SD",13.18087,32.73999,"White Nile","city"],
  [1566559,"Tây Ninh","VN",11.31004,106.09828,"Tay Ninh","city"],
  [13546325,"Le Vieux-Longueuil","CA",45.53721,-73.50773,"Quebec","city"],
  [267008,"Tyre","LB",33.27333,35.19389,"South Governorate","city"],
  [613607,"Kutaisi","GE",42.26791,42.69459,"Imereti","city"],
  [143420,"Andīmeshk","IR",32.4615,48.35368,"Khuzestan","city"],
  [1255927,"Siwān","IN",26.22096,84.35609,"Bihar","city"],
  [3675707,"Madrid","CO",4.73245,-74.26419,"Cundinamarca","city"],
  [1730713,"Angono","PH",14.5266,121.1536,"Calabarzon","city"],
  [3687230,"Cartago","CO",4.74639,-75.91167,"Valle del Cauca Department","city"],
  [418533,"Shahreẕā","IR",32.00877,51.86407,"Isfahan","city"],
  [1325211,"Hinthada","MM",17.64944,95.45705,"Ayeyarwady","city"],
  [3728474,"Cap-Haïtien","HT",19.75938,-72.19815,"Nord","city"],
  [1649593,"Baturaja","ID",-4.12891,104.16695,"South Sumatra","city"],
  [1861602,"Inazawa","JP",35.25,136.78333,"Aichi","city"],
  [1699296,"Rodriguez","PH",14.76011,121.19993,"Calabarzon","city"],
  [1268338,"Kalol","IN",23.24656,72.49508,"Gujarat","city"],
  [124085,"Mīāndoāb","IR",36.96667,46.10961,"West Azerbaijan","city"],
  [2491191,"Laghouat","DZ",33.8,2.86514,"Laghouat","city"],
  [522377,"Nevinnomyssk","RU",44.6333,41.9444,"Stavropol Kray","city"],
  [1689056,"San Mateo","PH",14.6982,121.1236,"Calabarzon","city"],
  [347634,"Ţahţā","EG",26.76866,31.50198,"Sohag","city"],
  [1689286,"San Juan","PH",14.6,121.0333,"National Capital Region","city"],
  [667268,"Sibiu","RO",45.8,24.15,"Sibiu County","city"],
  [4276614,"Olathe","US",38.8814,-94.81913,"Kansas","city"],
  [379302,"El Geneina Fort","SD",13.47481,22.45744,"Western Darfur","city"],
  [2338269,"Ikirun","NG",7.91283,4.66741,"Osun State","city"],
  [8419424,"Shenglilu","CN",29.35048,105.8775,"Chongqing","city"],
  [3836846,"San Nicolás de los Arroyos","AR",-33.33425,-60.2108,"Buenos Aires","city"],
  [3722286,"Léogâne","HT",18.5111,-72.63343,"Ouest","city"],
  [11962412,"Vila Jacui","BR",-23.50262,-46.46156,"São Paulo","city"],
  [1651887,"Adiwerna","ID",-6.9375,109.1325,"Central Java","city"],
  [3403697,"Cametá","BR",-2.24444,-49.49583,"Pará","city"],
  [98993,"Al Qurnah","IQ",31.01547,47.43362,"Basra","city"],
  [2353099,"Abakaliki","NG",6.32485,8.11368,"Ebonyi State","city"],
  [3384987,"Vitória de Santo Antão","BR",-8.11806,-35.29139,"Pernambuco","city"],
  [3547640,"Marianao","CU",23.07387,-82.42969,"Havana","city"],
  [5014051,"Warren","US",42.49044,-83.01304,"Michigan","city"],
  [318253,"Cizre","TR",37.33024,42.18484,"Şırnak","city"],
  [13607972,"Circoiscrizione VIII","IT",45.03789,7.67174,"Piedmont","city"],
  [1277264,"Bānkura","IN",23.23241,87.0716,"West Bengal","city"],
  [745169,"İnegol","TR",40.07806,29.51333,"Bursa Province","city"],
  [2130404,"Ebetsu","JP",43.10806,141.55056,"Hokkaido","city"],
  [2292852,"Anyama","CI",5.49462,-4.05183,"Abidjan Autonomous District","city"],
  [1805962,"Jiawang","CN",34.43278,117.44194,"Jiangsu","city"],
  [1626932,"Singaraja","ID",-8.112,115.08818,"Bali","city"],
  [1260173,"Pātan","IN",23.8507,72.12963,"Gujarat","city"],
  [2805615,"Würzburg","DE",49.79391,9.95121,"Bavaria","city"],
  [630376,"Barysaw","BY",54.2279,28.505,"Minsk","city"],
  [1582886,"Đồng Hới","VN",17.46885,106.62226,"Quang Tri","city"],
  [963230,"Randfontein","ZA",-26.1844,27.70203,"Gauteng","city"],
  [510808,"Pervouralsk","RU",56.90528,59.94361,"Sverdlovsk Oblast","city"],
  [1270996,"Gondā City","IN",27.13181,81.95332,"Uttar Pradesh","city"],
  [290247,"Madīnat Ḩamad","BH",26.11528,50.50694,"Northern","city"],
  [1854162,"Ōme","JP",35.78389,139.24306,"Tokyo","city"],
  [347907,"Sinnūris","EG",29.41345,30.86579,"Faiyum","city"],
  [3654215,"Milagro","EC",-2.13396,-79.59337,"Guayas","city"],
  [3460005,"Jaú","BR",-22.29639,-48.55778,"São Paulo","city"],
  [5441492,"Thornton","US",39.86804,-104.97192,"Colorado","city"],
  [3868707,"Valdivia","CL",-39.81422,-73.24589,"Los Ríos Region","city"],
  [1513064,"Olmaliq","UZ",40.84472,69.59833,"Tashkent Region","city"],
  [2326899,"Okrika","NG",4.74215,7.08368,"Rivers State","city"],
  [3450269,"Santa Cruz do Sul","BR",-29.7175,-52.42583,"Rio Grande do Sul","city"],
  [2646914,"High Wycombe","GB",51.62907,-0.74934,"England","city"],
  [4679195,"Carrollton","US",32.95373,-96.89028,"Texas","city"],
  [1683881,"Talisay","PH",10.24472,123.84944,"Central Visayas","city"],
  [2457163,"Gao","ML",16.27167,-0.04472,"Gao","city"],
  [1272805,"Dhaulpur","IN",26.69286,77.87968,"Rajasthan","city"],
  [149581,"Tarime","TZ",-1.35,34.36667,"Mara","city"],
  [7670941,"Kentron","AM",40.17806,44.51303,"Yerevan","city"],
  [6074377,"Milton","CA",43.51681,-79.88294,"Ontario","city"],
  [2486690,"M'Sila","DZ",35.70889,4.53722,"M'Sila","city"],
  [2111684,"Narita","JP",35.78333,140.31667,"Chiba","city"],
  [2400555,"Franceville","GA",-1.63333,13.58357,"Haut-Ogooué","city"],
  [1798473,"Puqi","CN",29.71667,113.88333,"Hubei","city"],
  [1850034,"Tondabayashichō","JP",34.50065,135.60211,"Osaka","city"],
  [1853008,"Sandachō","JP",34.88444,135.22694,"Hyōgo","city"],
  [1270990,"Gondiā","IN",21.46026,80.19205,"Maharashtra","city"],
  [2191562,"Dunedin","NZ",-45.87416,170.50361,"Otago","city"],
  [548114,"Kislovodsk","RU",43.91333,42.72083,"Stavropol Kray","city"],
  [1316574,"Kyauktan","MM",16.63736,96.32512,"Yangon","city"],
  [2787149,"Schaerbeek","BE",50.86935,4.37737,"Brussels Capital","city"],
  [2753801,"Hoofddorp","NL",52.3025,4.68889,"North Holland","city"],
  [3633444,"Machiques","VE",10.06077,-72.55212,"Zulia","city"],
  [1260728,"Palakkad","IN",10.77319,76.65366,"Kerala","city"],
  [300808,"Silifke","TR",36.37778,33.93444,"Mersin","city"],
  [4574324,"Charleston","US",32.77632,-79.93275,"South Carolina","city"],
  [6049429,"Langley","CA",49.10107,-122.65883,"British Columbia","city"],
  [5526337,"Midland","US",31.99735,-102.07791,"Texas","city"],
  [1864105,"Fujinomiya","JP",35.21667,138.61667,"Shizuoka","city"],
  [13589383,"Mingala Tangnyunt","MM",16.78855,96.17234,"Yangon","city"],
  [2775220,"Innsbruck","AT",47.26266,11.39454,"Tyrol","city"],
  [5992500,"Kingston","CA",44.22976,-76.48098,"Ontario","city"],
  [1791272,"Wugang","CN",26.7279,110.63198,"Hunan","city"],
  [2648404,"Gloucester","GB",51.86568,-2.2431,"England","city"],
  [4739526,"Waco","US",31.54933,-97.14667,"Texas","city"],
  [3564436,"Cerro","CU",23.10789,-82.38356,"Havana","city"],
  [1848004,"Zama","JP",35.4879,139.39101,"Kanagawa","city"],
  [1636308,"Manokwari","ID",-0.86291,134.06402,"West Papua","city"],
  [566199,"Dimitrovgrad","RU",54.21386,49.61838,"Ulyanovsk","city"],
  [2033225,"Zhalantun","CN",48.00945,122.73651,"Inner Mongolia","city"],
  ["historic-pompeii","Pompeii","IT",40.751,14.487,"Campania","historic"],
  ["historic-herculaneum","Herculaneum","IT",40.806,14.3482,"Campania","historic"],
  ["historic-ostia-antica","Ostia Antica","IT",41.7557,12.2916,"Lazio","historic"],
  ["historic-petra","Petra","JO",30.3285,35.4444,"Ma'an","historic"],
  ["historic-jerash","Ancient Jerash","JO",32.2811,35.8911,"Jerash","historic"],
  ["historic-palmyra","Palmyra","SY",34.5503,38.268,"Homs","historic"],
  ["historic-babylon","Babylon","IQ",32.5422,44.4211,"Babil","historic"],
  ["historic-ur","Ur","IQ",30.9633,46.1031,"Dhi Qar","historic"],
  ["historic-nineveh","Nineveh","IQ",36.3596,43.1527,"Nineveh","historic"],
  ["historic-hatra","Hatra","IQ",35.5883,42.7183,"Nineveh","historic"],
  ["historic-persepolis","Persepolis","IR",29.935,52.8916,"Fars","historic"],
  ["historic-pasargadae","Pasargadae","IR",30.1919,53.1676,"Fars","historic"],
  ["historic-susa","Susa","IR",32.1892,48.2578,"Khuzestan","historic"],
  ["historic-ephesus","Ephesus","TR",37.939,27.341,"Izmir","historic"],
  ["historic-troy","Troy","TR",39.9575,26.2389,"Canakkale","historic"],
  ["historic-aphrodisias","Aphrodisias","TR",37.7083,28.7236,"Aydin","historic"],
  ["historic-catalhoyuk","Çatalhöyük","TR",37.6667,32.8283,"Konya","historic"],
  ["historic-gobekli-tepe","Göbekli Tepe","TR",37.2231,38.9224,"Sanliurfa","historic"],
  ["historic-miletus","Miletus","TR",37.5307,27.2783,"Aydin","historic"],
  ["historic-hierapolis","Hierapolis","TR",37.9259,29.1253,"Denizli","historic"],
  ["historic-ani","Ani","TR",40.5064,43.5728,"Kars","historic"],
  ["historic-hattusa","Hattusa","TR",40.0197,34.6153,"Corum","historic"],
  ["historic-sardis","Sardis","TR",38.4889,28.0403,"Manisa","historic"],
  ["historic-pergamon","Pergamon","TR",39.1325,27.1841,"Izmir","historic"],
  ["historic-mycenae","Mycenae","GR",37.7308,22.756,"Peloponnese","historic"],
  ["historic-delphi","Delphi","GR",38.4824,22.501,"Central Greece","historic"],
  ["historic-olympia","Ancient Olympia","GR",37.6389,21.63,"Western Greece","historic"],
  ["historic-knossos","Knossos","GR",35.2989,25.1631,"Crete","historic"],
  ["historic-akrotiri","Akrotiri","GR",36.3514,25.4031,"South Aegean","historic"],
  ["historic-carthage","Carthage","TN",36.8528,10.3233,"Tunis","historic"],
  ["historic-dougga","Dougga","TN",36.4237,9.2203,"Beja","historic"],
  ["historic-leptis-magna","Leptis Magna","LY",32.6383,14.2906,"Murqub","historic"],
  ["historic-cyrene","Cyrene","LY",32.825,21.8583,"Jabal al Akhdar","historic"],
  ["historic-memphis","Memphis","EG",29.8447,31.2508,"Giza","historic"],
  ["historic-amarna","Akhetaten (Amarna)","EG",27.6459,30.8961,"Minya","historic"],
  ["historic-great-zimbabwe","Great Zimbabwe","ZW",-20.2674,30.9338,"Masvingo","historic"],
  ["historic-meroe","Meroë","SD",16.9376,33.7483,"River Nile","historic"],
  ["historic-mohenjo-daro","Mohenjo-daro","PK",27.3243,68.1357,"Sindh","historic"],
  ["historic-harappa","Harappa","PK",30.6295,72.8638,"Punjab","historic"],
  ["historic-taxila","Taxila","PK",33.7447,72.7875,"Punjab","historic"],
  ["historic-hampi","Hampi","IN",15.335,76.46,"Karnataka","historic"],
  ["historic-fatehpur-sikri","Fatehpur Sikri","IN",27.094,77.6679,"Uttar Pradesh","historic"],
  ["historic-nalanda","Nalanda","IN",25.1367,85.4437,"Bihar","historic"],
  ["historic-anuradhapura","Ancient Anuradhapura","LK",8.3114,80.4037,"North Central Province","historic"],
  ["historic-polonnaruwa","Ancient Polonnaruwa","LK",7.9403,81.0188,"North Central Province","historic"],
  ["historic-bagan","Bagan","MM",21.1717,94.8585,"Mandalay Region","historic"],
  ["historic-angkor","Angkor","KH",13.4125,103.867,"Siem Reap","historic"],
  ["historic-ayutthaya","Historic Ayutthaya","TH",14.3559,100.5683,"Phra Nakhon Si Ayutthaya","historic"],
  ["historic-sukhothai","Historic Sukhothai","TH",17.019,99.7034,"Sukhothai","historic"],
  ["historic-trowulan","Trowulan","ID",-7.559,112.373,"East Java","historic"],
  ["historic-machu-picchu","Machu Picchu","PE",-13.1631,-72.545,"Cusco","historic"],
  ["historic-chan-chan","Chan Chan","PE",-8.1069,-79.0747,"La Libertad","historic"],
  ["historic-tiwanaku","Tiwanaku","BO",-16.5547,-68.6733,"La Paz","historic"],
  ["historic-teotihuacan","Teotihuacan","MX",19.6925,-98.8438,"State of Mexico","historic"],
  ["historic-chichen-itza","Chichén Itzá","MX",20.6843,-88.5678,"Yucatan","historic"],
  ["historic-uxmal","Uxmal","MX",20.3593,-89.771,"Yucatan","historic"],
  ["historic-palenque","Ancient Palenque","MX",17.4849,-92.0468,"Chiapas","historic"],
  ["historic-monte-alban","Monte Albán","MX",17.0438,-96.7678,"Oaxaca","historic"],
  ["historic-el-tajin","El Tajín","MX",20.4481,-97.3782,"Veracruz","historic"],
  ["historic-calakmul","Calakmul","MX",18.105,-89.81,"Campeche","historic"],
  ["historic-tikal","Tikal","GT",17.222,-89.6237,"Peten","historic"],
  ["historic-copan","Copán","HN",14.8384,-89.1417,"Copan","historic"],
  ["historic-cahokia","Cahokia","US",38.6551,-90.061,"Illinois","historic"],
  ["historic-chaco-canyon","Chaco Canyon","US",36.0607,-107.9614,"New Mexico","historic"],
  ["historic-mesa-verde","Mesa Verde","US",37.2309,-108.4618,"Colorado","historic"],
  ["historic-nan-madol","Nan Madol","FM",6.844,158.335,"Pohnpei","historic"],
  ["historic-kilwa-kisiwani","Kilwa Kisiwani","TZ",-8.957,39.522,"Lindi","historic"],
  ["historic-volubilis","Volubilis","MA",34.0732,-5.555,"Fes-Meknes","historic"],
  ["historic-timgad","Timgad","DZ",35.4845,6.4688,"Batna","historic"],
  ["historic-djemila","Djémila","DZ",36.3208,5.7367,"Setif","historic"],
  ["historic-aksum","Ancient Aksum","ET",14.13,38.72,"Tigray","historic"],
  ["historic-lalibela","Historic Lalibela","ET",12.0317,39.0476,"Amhara","historic"],
  ["historic-kuelap","Kuélap","PE",-6.423,-77.924,"Amazonas","historic"],
  ["historic-ciudad-perdida","Ciudad Perdida","CO",11.0383,-73.925,"Magdalena","historic"],
  ["historic-caral","Caral","PE",-10.8933,-77.52,"Lima","historic"],
  ["historic-ugarit","Ugarit","SY",35.6022,35.7853,"Latakia","historic"],
  ["historic-ebla","Ebla","SY",35.7981,36.798,"Idlib","historic"],
  ["historic-baalbek","Ancient Baalbek","LB",34.0069,36.2039,"Baalbek-Hermel","historic"],
  ["historic-caesarea-maritima","Caesarea Maritima","IL",32.5004,34.892,"Haifa","historic"],
  ["historic-megiddo","Megiddo","IL",32.5847,35.1842,"Northern District","historic"],
  ["island-greenland","Greenland","GL",72,-40,"Arctic","island"],
  ["island-baffin","Baffin Island","CA",69,-72,"Nunavut","island"],
  ["island-victoria-canada","Victoria Island","CA",71,-110,"Northwest Territories / Nunavut","island"],
  ["island-ellesmere","Ellesmere Island","CA",79,-79,"Nunavut","island"],
  ["island-banks","Banks Island","CA",73,-121,"Northwest Territories","island"],
  ["island-devon","Devon Island","CA",75,-88,"Nunavut","island"],
  ["island-axel-heiberg","Axel Heiberg Island","CA",79.5,-91,"Nunavut","island"],
  ["island-melville-canada","Melville Island","CA",75,-111,"Northwest Territories / Nunavut","island"],
  ["island-southampton","Southampton Island","CA",64.5,-84.5,"Nunavut","island"],
  ["island-prince-of-wales-canada","Prince of Wales Island","CA",72.5,-99,"Nunavut","island"],
  ["island-somerset","Somerset Island","CA",73.2,-93.5,"Nunavut","island"],
  ["island-newfoundland","Newfoundland","CA",49,-56,"Newfoundland and Labrador","island"],
  ["island-vancouver","Vancouver Island","CA",49.7,-125,"British Columbia","island"],
  ["island-prince-edward","Prince Edward Island","CA",46.4,-63.4,"Prince Edward Island","island"],
  ["island-cape-breton","Cape Breton Island","CA",46.1,-60.8,"Nova Scotia","island"],
  ["island-anticosti","Anticosti Island","CA",49.5,-63,"Quebec","island"],
  ["island-sable","Sable Island","CA",43.93,-59.92,"Nova Scotia","island"],
  ["island-iceland","Iceland","IS",65,-18,"North Atlantic","island"],
  ["island-great-britain","Great Britain","GB",54.5,-3,"British Isles","island"],
  ["island-ireland","Ireland","",53.4,-8,"Ireland / United Kingdom","island"],
  ["island-spitsbergen","Spitsbergen","SJ",78.5,17,"Svalbard","island"],
  ["island-faroe","Faroe Islands","FO",62,-6.8,"North Atlantic","island"],
  ["island-orkney","Orkney Islands","GB",59,-3,"Scotland","island"],
  ["island-shetland","Shetland Islands","GB",60.3,-1.3,"Scotland","island"],
  ["island-isle-of-man","Isle of Man","IM",54.2,-4.5,"Irish Sea","island"],
  ["island-jersey","Jersey","JE",49.21,-2.13,"Channel Islands","island"],
  ["island-guernsey","Guernsey","GG",49.46,-2.58,"Channel Islands","island"],
  ["island-gotland","Gotland","SE",57.5,18.5,"Gotland County","island"],
  ["island-bornholm","Bornholm","DK",55.1,14.9,"Capital Region","island"],
  ["island-aland","Åland Islands","AX",60.2,20,"Baltic Sea","island"],
  ["island-lofoten","Lofoten","NO",68.2,13.8,"Nordland","island"],
  ["island-jan-mayen","Jan Mayen","SJ",71,-8.3,"Arctic Ocean","island"],
  ["island-rockall","Rockall","GB",57.6,-13.7,"North Atlantic","island"],
  ["island-sicily","Sicily","IT",37.6,14,"Sicily","island"],
  ["island-sardinia","Sardinia","IT",40,9,"Sardinia","island"],
  ["island-corsica","Corsica","FR",42.1,9.1,"Corsica","island"],
  ["island-cyprus","Cyprus","CY",35.1,33.2,"Eastern Mediterranean","island"],
  ["island-crete","Crete","GR",35.2,24.9,"Crete","island"],
  ["island-rhodes","Rhodes","GR",36.2,28,"South Aegean","island"],
  ["island-lesbos","Lesbos","GR",39.2,26.3,"North Aegean","island"],
  ["island-corfu","Corfu","GR",39.6,19.8,"Ionian Islands","island"],
  ["island-santorini","Santorini","GR",36.4,25.4,"South Aegean","island"],
  ["island-malta","Malta","MT",35.9,14.4,"Mediterranean","island"],
  ["island-gozo","Gozo","MT",36.05,14.25,"Gozo Region","island"],
  ["island-mallorca","Mallorca","ES",39.6,3,"Balearic Islands","island"],
  ["island-menorca","Menorca","ES",40,4.1,"Balearic Islands","island"],
  ["island-ibiza","Ibiza","ES",38.98,1.43,"Balearic Islands","island"],
  ["island-elba","Elba","IT",42.78,10.28,"Tuscany","island"],
  ["island-capri","Capri","IT",40.55,14.23,"Campania","island"],
  ["island-ischia","Ischia","IT",40.73,13.9,"Campania","island"],
  ["island-djerba","Djerba","TN",33.8,10.9,"Medenine","island"],
  ["island-pantelleria","Pantelleria","IT",36.78,11.99,"Sicily","island"],
  ["island-new-guinea","New Guinea","",-5,141,"Indonesia / Papua New Guinea","island"],
  ["island-borneo","Borneo","",0.7,114,"Brunei / Indonesia / Malaysia","island"],
  ["island-sumatra","Sumatra","ID",0.4,101.5,"Indonesia","island"],
  ["island-java","Java","ID",-7.5,110,"Indonesia","island"],
  ["island-sulawesi","Sulawesi","ID",-2,121,"Indonesia","island"],
  ["island-honshu","Honshu","JP",36.5,138,"Japan","island"],
  ["island-hokkaido","Hokkaido","JP",43.5,142,"Hokkaido","island"],
  ["island-kyushu","Kyushu","JP",32.7,131,"Japan","island"],
  ["island-shikoku","Shikoku","JP",33.7,133.5,"Japan","island"],
  ["island-luzon","Luzon","PH",16,121,"Philippines","island"],
  ["island-mindanao","Mindanao","PH",8,125,"Philippines","island"],
  ["island-sri-lanka","Sri Lanka","LK",7.8,80.7,"Indian Ocean","island"],
  ["island-taiwan","Taiwan","TW",23.7,121,"East Asia","island"],
  ["island-sakhalin","Sakhalin","RU",50.5,143,"Sakhalin Oblast","island"],
  ["island-hainan","Hainan","CN",19.2,109.7,"Hainan","island"],
  ["island-timor","Timor","",-9.2,124.9,"Indonesia / Timor-Leste","island"],
  ["island-new-britain","New Britain","PG",-5.7,150.7,"East New Britain / West New Britain","island"],
  ["island-new-ireland","New Ireland","PG",-3.3,152,"New Ireland","island"],
  ["island-halmahera","Halmahera","ID",1,128,"North Maluku","island"],
  ["island-seram","Seram","ID",-3.1,129,"Maluku","island"],
  ["island-buru","Buru","ID",-3.4,126.7,"Maluku","island"],
  ["island-bali","Bali","ID",-8.35,115.1,"Bali","island"],
  ["island-lombok","Lombok","ID",-8.6,116.3,"West Nusa Tenggara","island"],
  ["island-sumbawa","Sumbawa","ID",-8.7,118,"West Nusa Tenggara","island"],
  ["island-flores","Flores","ID",-8.6,121.1,"East Nusa Tenggara","island"],
  ["island-sumba","Sumba","ID",-9.7,120,"East Nusa Tenggara","island"],
  ["island-komodo","Komodo Island","ID",-8.55,119.45,"East Nusa Tenggara","island"],
  ["island-bangka","Bangka Island","ID",-2.25,106,"Bangka Belitung Islands","island"],
  ["island-belitung","Belitung","ID",-2.85,107.9,"Bangka Belitung Islands","island"],
  ["island-batam","Batam","ID",1.08,104.03,"Riau Islands","island"],
  ["island-bintan","Bintan","ID",1.05,104.48,"Riau Islands","island"],
  ["island-okinawa","Okinawa Island","JP",26.5,127.95,"Okinawa","island"],
  ["island-jeju","Jeju Island","KR",33.38,126.53,"Jeju","island"],
  ["island-tsushima","Tsushima","JP",34.42,129.33,"Nagasaki","island"],
  ["island-yakushima","Yakushima","JP",30.35,130.52,"Kagoshima","island"],
  ["island-hong-kong","Hong Kong Island","HK",22.26,114.19,"Hong Kong","island"],
  ["island-palawan","Palawan","PH",10,118.7,"Mimaropa","island"],
  ["island-negros","Negros","PH",10,123,"Western / Central Visayas","island"],
  ["island-samar","Samar","PH",12,125,"Eastern Visayas","island"],
  ["island-panay","Panay","PH",11.2,122.5,"Western Visayas","island"],
  ["island-mindoro","Mindoro","PH",13,121.1,"Mimaropa","island"],
  ["island-leyte","Leyte","PH",10.9,124.8,"Eastern Visayas","island"],
  ["island-cebu","Cebu Island","PH",10.4,123.8,"Central Visayas","island"],
  ["island-bohol","Bohol","PH",9.85,124.2,"Central Visayas","island"],
  ["island-siargao","Siargao","PH",9.85,126.05,"Caraga","island"],
  ["island-boracay","Boracay","PH",11.97,121.92,"Western Visayas","island"],
  ["island-south-andaman","South Andaman Island","IN",11.75,92.65,"Andaman and Nicobar Islands","island"],
  ["island-great-nicobar","Great Nicobar Island","IN",7,93.8,"Andaman and Nicobar Islands","island"],
  ["island-socotra","Socotra","YE",12.5,53.9,"Socotra","island"],
  ["island-tasmania","Tasmania","AU",-42,146.5,"Tasmania","island"],
  ["island-north-new-zealand","North Island","NZ",-38.5,175.5,"New Zealand","island"],
  ["island-south-new-zealand","South Island","NZ",-44,170,"New Zealand","island"],
  ["island-stewart","Stewart Island / Rakiura","NZ",-47,167.85,"Southland","island"],
  ["island-grande-terre","Grande Terre","NC",-21.3,165.5,"New Caledonia","island"],
  ["island-lifou","Lifou","NC",-20.9,167.2,"Loyalty Islands","island"],
  ["island-viti-levu","Viti Levu","FJ",-17.8,178,"Fiji","island"],
  ["island-vanua-levu","Vanua Levu","FJ",-16.6,179.2,"Fiji","island"],
  ["island-guadalcanal","Guadalcanal","SB",-9.6,160.2,"Guadalcanal Province","island"],
  ["island-malaita","Malaita","SB",-8.9,160.9,"Malaita Province","island"],
  ["island-espiritu-santo","Espiritu Santo","VU",-15.4,166.9,"Sanma","island"],
  ["island-efate","Efate","VU",-17.65,168.35,"Shefa","island"],
  ["island-isle-of-pines","Isle of Pines","NC",-22.6,167.45,"South Province","island"],
  ["island-bougainville","Bougainville","PG",-6.1,155.2,"Autonomous Region of Bougainville","island"],
  ["island-manus","Manus Island","PG",-2.05,147,"Manus","island"],
  ["island-new-georgia","New Georgia","SB",-8.25,157.4,"Western Province","island"],
  ["island-hawaii","Hawaiʻi (Big Island)","US",19.6,-155.5,"Hawaii","island"],
  ["island-oahu","Oʻahu","US",21.48,-157.96,"Hawaii","island"],
  ["island-maui","Maui","US",20.8,-156.33,"Hawaii","island"],
  ["island-kauai","Kauaʻi","US",22.05,-159.5,"Hawaii","island"],
  ["island-molokai","Molokaʻi","US",21.13,-157.03,"Hawaii","island"],
  ["island-bora-bora","Bora Bora","PF",-16.5,-151.74,"Leeward Islands","island"],
  ["island-tahiti","Tahiti","PF",-17.65,-149.45,"Windward Islands","island"],
  ["island-moorea","Moʻorea","PF",-17.54,-149.83,"Windward Islands","island"],
  ["island-raiatea","Raiatea","PF",-16.82,-151.45,"Leeward Islands","island"],
  ["island-huahine","Huahine","PF",-16.75,-151,"Leeward Islands","island"],
  ["island-rangiroa","Rangiroa","PF",-15.12,-147.65,"Tuamotu Archipelago","island"],
  ["island-nuku-hiva","Nuku Hiva","PF",-8.87,-140.13,"Marquesas Islands","island"],
  ["island-mangareva","Mangareva","PF",-23.12,-134.97,"Gambier Islands","island"],
  ["island-easter","Easter Island / Rapa Nui","CL",-27.12,-109.35,"Valparaíso","island"],
  ["island-cook-islands","Cook Islands","CK",-21.2,-159.77,"South Pacific","island"],
  ["island-aitutaki","Aitutaki","CK",-18.85,-159.78,"Cook Islands","island"],
  ["island-tongatapu","Tongatapu","TO",-21.2,-175.2,"Tonga","island"],
  ["island-vavau","Vavaʻu","TO",-18.65,-174,"Tonga","island"],
  ["island-upolu","Upolu","WS",-13.92,-171.75,"Samoa","island"],
  ["island-savaii","Savaiʻi","WS",-13.6,-172.45,"Samoa","island"],
  ["island-tutuila","Tutuila","AS",-14.3,-170.7,"American Samoa","island"],
  ["island-niue","Niue","NU",-19.05,-169.87,"South Pacific","island"],
  ["island-funafuti","Funafuti","TV",-8.52,179.2,"Tuvalu","island"],
  ["island-nauru","Nauru","NR",-0.52,166.93,"Micronesia","island"],
  ["island-pitcairn","Pitcairn Island","PN",-25.07,-130.1,"South Pacific","island"],
  ["island-henderson","Henderson Island","PN",-24.37,-128.32,"Pitcairn Islands","island"],
  ["island-norfolk","Norfolk Island","NF",-29.03,167.95,"South Pacific","island"],
  ["island-lord-howe","Lord Howe Island","AU",-31.55,159.08,"New South Wales","island"],
  ["island-guam","Guam","GU",13.45,144.78,"Micronesia","island"],
  ["island-saipan","Saipan","MP",15.18,145.75,"Northern Mariana Islands","island"],
  ["island-tinian","Tinian","MP",15,145.63,"Northern Mariana Islands","island"],
  ["island-babeldaob","Babeldaob","PW",7.5,134.6,"Palau","island"],
  ["island-pohnpei","Pohnpei","FM",6.87,158.23,"Pohnpei","island"],
  ["island-chuuk","Chuuk Lagoon","FM",7.45,151.85,"Chuuk","island"],
  ["island-yap","Yap","FM",9.53,138.12,"Yap","island"],
  ["island-kosrae","Kosrae","FM",5.32,162.98,"Kosrae","island"],
  ["island-majuro","Majuro Atoll","MH",7.1,171.38,"Marshall Islands","island"],
  ["island-kwajalein","Kwajalein Atoll","MH",8.72,167.73,"Marshall Islands","island"],
  ["island-tarawa","Tarawa","KI",1.45,173,"Gilbert Islands","island"],
  ["island-kiritimati","Kiritimati","KI",1.87,-157.4,"Line Islands","island"],
  ["island-rotuma","Rotuma","FJ",-12.5,177.08,"Rotuma","island"],
  ["island-wallis","Wallis Island","WF",-13.28,-176.2,"Wallis and Futuna","island"],
  ["island-futuna","Futuna","WF",-14.28,-178.15,"Wallis and Futuna","island"],
  ["island-tokelau","Tokelau","TK",-9.2,-171.85,"South Pacific","island"],
  ["island-cuba","Cuba","CU",21.5,-79.5,"Caribbean","island"],
  ["island-hispaniola","Hispaniola","",19,-71,"Dominican Republic / Haiti","island"],
  ["island-puerto-rico","Puerto Rico","PR",18.25,-66.5,"Caribbean","island"],
  ["island-jamaica","Jamaica","JM",18.1,-77.3,"Caribbean","island"],
  ["island-trinidad","Trinidad","TT",10.45,-61.25,"Trinidad and Tobago","island"],
  ["island-tobago","Tobago","TT",11.25,-60.67,"Trinidad and Tobago","island"],
  ["island-new-providence","New Providence","BS",25.03,-77.4,"Bahamas","island"],
  ["island-grand-bahama","Grand Bahama","BS",26.65,-78.32,"Bahamas","island"],
  ["island-andros-bahamas","Andros","BS",24.5,-77.9,"Bahamas","island"],
  ["island-barbados","Barbados","BB",13.17,-59.55,"Caribbean","island"],
  ["island-grenada","Grenada","GD",12.12,-61.68,"Caribbean","island"],
  ["island-saint-lucia","Saint Lucia","LC",13.9,-60.98,"Caribbean","island"],
  ["island-saint-vincent","Saint Vincent","VC",13.25,-61.2,"Saint Vincent and the Grenadines","island"],
  ["island-martinique","Martinique","MQ",14.65,-61,"Lesser Antilles","island"],
  ["island-guadeloupe","Guadeloupe","GP",16.2,-61.55,"Lesser Antilles","island"],
  ["island-dominica","Dominica","DM",15.42,-61.35,"Caribbean","island"],
  ["island-antigua","Antigua","AG",17.08,-61.8,"Antigua and Barbuda","island"],
  ["island-barbuda","Barbuda","AG",17.63,-61.8,"Antigua and Barbuda","island"],
  ["island-aruba","Aruba","AW",12.52,-69.97,"Leeward Antilles","island"],
  ["island-curacao","Curaçao","CW",12.18,-69,"Leeward Antilles","island"],
  ["island-bonaire","Bonaire","BQ",12.18,-68.25,"Caribbean Netherlands","island"],
  ["island-grand-cayman","Grand Cayman","KY",19.32,-81.25,"Cayman Islands","island"],
  ["island-saint-kitts","Saint Kitts","KN",17.33,-62.75,"Saint Kitts and Nevis","island"],
  ["island-nevis","Nevis","KN",17.15,-62.58,"Saint Kitts and Nevis","island"],
  ["island-saint-martin","Saint Martin / Sint Maarten","",18.07,-63.05,"France / Sint Maarten","island"],
  ["island-saint-croix","Saint Croix","VI",17.73,-64.74,"U.S. Virgin Islands","island"],
  ["island-saint-thomas","Saint Thomas","VI",18.34,-64.93,"U.S. Virgin Islands","island"],
  ["island-tortola","Tortola","VG",18.43,-64.63,"British Virgin Islands","island"],
  ["island-montserrat","Montserrat","MS",16.74,-62.2,"Lesser Antilles","island"],
  ["island-providenciales","Providenciales","TC",21.78,-72.28,"Turks and Caicos Islands","island"],
  ["island-grand-turk","Grand Turk","TC",21.47,-71.14,"Turks and Caicos Islands","island"],
  ["island-bermuda","Bermuda","BM",32.3,-64.75,"North Atlantic","island"],
  ["island-cozumel","Cozumel","MX",20.43,-86.92,"Quintana Roo","island"],
  ["island-margarita","Margarita Island","VE",11,-64,"Nueva Esparta","island"],
  ["island-anguilla","Anguilla","AI",18.22,-63.05,"Lesser Antilles","island"],
  ["island-saint-barthelemy","Saint Barthélemy","BL",17.9,-62.83,"Lesser Antilles","island"],
  ["island-madagascar","Madagascar","MG",-19,47,"Indian Ocean","island"],
  ["island-mauritius","Mauritius","MU",-20.28,57.57,"Mascarene Islands","island"],
  ["island-reunion","Réunion","RE",-21.12,55.53,"Mascarene Islands","island"],
  ["island-rodrigues","Rodrigues","MU",-19.72,63.42,"Rodrigues","island"],
  ["island-mahe","Mahé","SC",-4.68,55.48,"Seychelles","island"],
  ["island-praslin","Praslin","SC",-4.32,55.74,"Seychelles","island"],
  ["island-male-atoll","Malé Atoll","MV",4.42,73.5,"Maldives","island"],
  ["island-addu-atoll","Addu Atoll","MV",-0.63,73.15,"Maldives","island"],
  ["island-zanzibar","Zanzibar / Unguja","TZ",-6.13,39.35,"Zanzibar","island"],
  ["island-pemba","Pemba Island","TZ",-5.2,39.75,"Zanzibar","island"],
  ["island-grande-comore","Grande Comore","KM",-11.65,43.35,"Comoros","island"],
  ["island-mayotte","Mayotte","YT",-12.83,45.17,"Mozambique Channel","island"],
  ["island-christmas","Christmas Island","CX",-10.5,105.63,"Indian Ocean","island"],
  ["island-cocos","Cocos (Keeling) Islands","CC",-12.16,96.87,"Indian Ocean","island"],
  ["island-diego-garcia","Diego Garcia","IO",-7.32,72.42,"Chagos Archipelago","island"],
  ["island-kerguelen","Kerguelen Islands","TF",-49.35,69.2,"French Southern Territories","island"],
  ["island-amsterdam","Amsterdam Island","TF",-37.83,77.55,"French Southern Territories","island"],
  ["island-saint-paul","Saint Paul Island","TF",-38.72,77.52,"French Southern Territories","island"],
  ["island-heard","Heard Island","HM",-53.1,73.52,"Southern Indian Ocean","island"],
  ["island-sao-miguel","São Miguel","PT",37.78,-25.5,"Azores","island"],
  ["island-terceira","Terceira","PT",38.72,-27.22,"Azores","island"],
  ["island-madeira","Madeira","PT",32.75,-17,"Madeira","island"],
  ["island-tenerife","Tenerife","ES",28.3,-16.6,"Canary Islands","island"],
  ["island-gran-canaria","Gran Canaria","ES",27.95,-15.6,"Canary Islands","island"],
  ["island-lanzarote","Lanzarote","ES",29.03,-13.63,"Canary Islands","island"],
  ["island-fuerteventura","Fuerteventura","ES",28.4,-14,"Canary Islands","island"],
  ["island-la-palma","La Palma","ES",28.68,-17.86,"Canary Islands","island"],
  ["island-santiago-cape-verde","Santiago","CV",15.05,-23.63,"Cape Verde","island"],
  ["island-sao-vicente","São Vicente","CV",16.85,-25,"Cape Verde","island"],
  ["island-sal","Sal","CV",16.73,-22.93,"Cape Verde","island"],
  ["island-sao-tome","São Tomé","ST",0.25,6.6,"São Tomé and Príncipe","island"],
  ["island-principe","Príncipe","ST",1.62,7.4,"São Tomé and Príncipe","island"],
  ["island-bioko","Bioko","GQ",3.5,8.7,"Bioko","island"],
  ["island-saint-helena","Saint Helena","SH",-15.95,-5.72,"South Atlantic","island"],
  ["island-ascension","Ascension Island","SH",-7.95,-14.37,"South Atlantic","island"],
  ["island-tristan-da-cunha","Tristan da Cunha","SH",-37.1,-12.28,"South Atlantic","island"],
  ["island-east-falkland","East Falkland","FK",-51.8,-58.8,"Falkland Islands","island"],
  ["island-south-georgia","South Georgia","GS",-54.4,-36.7,"South Atlantic","island"],
  ["island-bouvet","Bouvet Island","BV",-54.42,3.35,"South Atlantic","island"],
  ["island-tierra-del-fuego","Tierra del Fuego","",-54,-69,"Argentina / Chile","island"],
  ["island-marajo","Marajó","BR",-0.9,-49.6,"Pará","island"],
  ["island-bananal","Bananal Island","BR",-11.3,-50.5,"Tocantins","island"],
  ["island-isabela-galapagos","Isabela Island","EC",-0.45,-91.1,"Galápagos","island"],
  ["island-santa-cruz-galapagos","Santa Cruz Island","EC",-0.63,-90.36,"Galápagos","island"],
  ["island-robinson-crusoe","Robinson Crusoe Island","CL",-33.64,-78.84,"Valparaíso","island"],
  ["island-chiloe","Chiloé Island","CL",-42.6,-73.95,"Los Lagos","island"],
  ["island-alexander","Alexander Island","AQ",-71,-69,"Antarctica","island"],
  ["island-berkner","Berkner Island","AQ",-79.5,-47,"Antarctica","island"],
  ["island-kodiak","Kodiak Island","US",57.5,-153.4,"Alaska","island"],
  ["island-unalaska","Unalaska Island","US",53.9,-166.53,"Alaska","island"],
  ["island-baranof","Baranof Island","US",57,-135,"Alaska","island"],
  ["island-prince-of-wales-alaska","Prince of Wales Island (Alaska)","US",55.6,-132.7,"Alaska","island"],
  ["island-attu","Attu Island","US",52.85,173.2,"Alaska","island"],
].map(([id, name, countryCode, lat, lng, admin1Name, type]) => ({
  id,
  name,
  countryCode,
  admin1Name,
  type,
  coordinates: { lat, lng },
}));
